export const messages: Object = {
    "LABEL_LOGO":"WaveMaker",
    "LABEL_PROJECT_UPDATES":"Project Notifications",
    "LABEL_SOURCE_CODE_UPDATES":"Source-code Regeneration Required",
    "MESSAGE_SOURCE_CODE_UPDATES":"Please update the application to re-generate sources for the '${0}' service.",
    "LABEL_VCS_UPDATES":"VCS Update",
    "LABEL_ARTIFACT_UPDATES":"Artifact Updates",
    "MESSAGE_ARTIFACT_UPDATES":"Newer version for themes and prefabs are available. Check details to know more about the updates",
    "LABLE_SHOW_DETAILS":"Show Details",
    "LABLE_DISMISS":"Dismiss",
    "LABEL_ASK_AUTOCODE": "Ask Autocode",
    "MESSAGE_NEW_UPDATES":"New updates are available for this project that require your action",
    "MESSAGE_WARN_PROPER_SWAGGER":"Please check if the proper swagger is uploaded",
    "LABEL_FEATURE_UNAVAILABLE" : "Feature Unavailable",
    "LABEL_EDITABLE": "Editable",
    "LABEL_READONLY": "ReadOnly",
    "MESSAGE_FEATURE_UNAVAILABLE" : "This feature is available only in the WaveMaker Enterprise. Find more information regarding the features on WaveMaker Enterprise at",
    "LABEL_INDEX_PAGE_APP_LANGUAGE":"App language",
    "LABEL_INDEX_PAGE_CONSOLE":"Console",
    "LABEL_INDEX_PAGE_DEBUG":"Debug mode",
    "LABEL_INDEX_PAGE_NO_DEBUG":"Normal mode",
    "LABEL_INDEX_PAGE_LOGS":"Logs",
    "LABEL_INDEX_PAGE_LOGS_TITLE":"Logs (ALT+C)",
    "LABEL_CLIENT":"Client",
    "LABEL_SERVER":"Server",
    "LABEL_CLEAR_CONSOLE":"Clear Console",
    "LABEL_CLOSE_CONSOLE":"Close Console",
    "LABEL_REFRESH_CONSOLE":"Refresh",
    "LABEL_DOWNLOAD_SERVER_LOGS":"Download Server and Application Logs",
    "PROJECT_PAGE_RESOURCES":"-----------PROJECTS LIST PAGE RESOURCES-------",
    "LABEL_PROVATAR_TITLE": "Select Project Avatar",
    "LABEL_CHOOSE_TEMPLATE": "Choose Template",
    "LABEL_WIDGET_TEMPLATE": "Component Template",
    "LABEL_NEW_PAGE_LAYOUT_HELP": "We've selected a default page layout for you. You can always change it using the \"Change Layout\" section in studio.",
    "LABEL_CREATE": "Create",
    "LABEL_CREATE_PROJECT": "Create",
    "LABEL_CREATE_PROJECT_WEB_APPLICATION": "New Web Application",
    "LABEL_CREATE_PROJECT_MOBILE_APPLICATION": "New Mobile Application",
    "LABEL_CREATE_PROJECT_DEFAULT_PREFAB": "New Prefab",
    "LABEL_CREATE_PROJECT_WEB_TEMPLATEBUNDLE": "New Web Template bundle",
    "LABEL_CREATE_PROJECT_MOBILE_TEMPLATEBUNDLE": "New Mobile Template bundle",
    "LABEL_CREATE_PROJECT_NAME": "Name",
    "LABEL_CREATE_PROJECT_SHELL": "Project Shell",
    "LABEL_CREATE_PROJECT_SHELL_TOOLTIP": "Choose the project shell type",
    "LABEL_CREATE_PROJECT_AVATAR": "Proavatar",
    "LABEL_CREATE_PROJECT_DESCRIPTION": "Description",
    "LABEL_CREATE_NEW_PAGE":"Create New Page",
    "LABEL_CREATE_EXISTING_PAGE_MESSAGE":"To work with an existing Page, select it from the left side panel.",
    "LABEL_CREATE_NEW_PAGE_MESSAGE":"To work on a new Page, choose the below action.",
    "LABEL_REQUEST_EVALUATION": "Request Evaluation",
    "LABEL_REQUEST_WM_CAPTION": "Request WaveMaker Enterprise Evaluation",
    "LABEL_REQUEST_WM_ON_PREMISE_CAPTION": "On-Premise Trial",
    "LABEL_REQUEST_WM_CONTENT": "WaveMaker Enterprise is ideal for enterprises looking for on-premise software to develop and deploy their business apps. Pricing starts at $7,500 per year for 5 developers.",
    "LABEL_REQUEST_WM_HELP_INFO": "Fill out this form to request a 30-day evaluation of WaveMaker Enterprise. We will contact you and later send you instructions to download and set up the virtual machine.",
    "LABEL_ATTEND_DEMO": "Free Training",
    "LABEL_INPUT_WORK_EMAIL": "Please enter your work email",
    "LABEL_COMMENTS": "Comments",
    "LABEL_PROJECTS_LIST_CREATE_PROJECT_TITLE": "Create Application",
    "LABEL_PROJECTS_LIST_CREATE_PREFAB_TITLE": "Create Prefab",
    "LABEL_PROJECTS_LIST_CREATE_TEMPLATEBUNDLE_TITLE": "Create Template Bundle",
    "LABEL_PROJECTS_LIST_MY_PROJECTS":"Projects",
    "LABEL_SWITCH_ORGANIZATION": "Switch Organization",
    "MSG_SWITCHED_ORG_SUCCESSFULLY": "Switched Organization successfully",
    "MSG_CURRENT_ORGANIZATION": "Your current logged-in organization",
    "LABEL_OWN": "OWN",
    "LABEL_PERSONAL": "Personal",
    "LABEL_MY_PROJECTS": "My Projects",
    "LABEL_WHATS_NEW":"What's new in 10.0",
    "LABEL_CURRENT_VERSION": "Current Version of WaveMaker",
    "LABEL_PROJECTS_LIST_APPLICATION":"Application",
    "LABEL_PROJECTS_LIST_MOBILE":"Mobile",
    "LABEL_PROJECTS_LIST_WEB":"Web",
    "LABEL_PROJECTS_LIST_PREFAB":"Prefab",
    "LABEL_PROJECTS_LIST_TEMPLATEBUNDLE":"Template Bundle",
    "LABEL_PROJECTS_LIST_ACCOUNT":"Account",
    "LABEL_PROJECTS_LIST_ALERTS":"Alerts",
    "LABEL_PROJECTS_LIST_TEAM":"Team",
    "LABEL_PROJECTS_LIST_WAVESTORE":"WaveStore",
    "LABEL_PROJECTS_LIST_GREET_HI":"Hi",
    "LABEL_PROJECTS_LIST_PROFILE":"profile",
    "LABEL_PROJECTS_LIST_LOGOUT":"logout",
    "LABEL_PROJECTS_LIST_NEW_PROJECT":"New Project",
    "LABEL_PROJECTS_LIST_E_COMMERCE":"E-commerce",
    "LABEL_PROJECTS_LIST_WEBSITE":"Website",
    "LABEL_PROJECTS_LIST_BUSINESS_APPLICATION":"Business Application",
    "LABEL_PROJECTS_LIST_INTRANET_PORTAL":"Intranet Portal",
    "LABEL_PROJECTS_LIST_CREATE":"Create",
    "LABEL_PROJECTS_LIST_CREATE_APPLICATION": "Create App",
    "LABEL_PROJECTS_LIST_CREATE_PREFAB": "Create Prefab",
    "LABEL_PROJECTS_LIST_CREATE_TEMPLATEBUNDLE": "Create Template bundle",
    "LABEL_PROJECTS_LIST_OR":"or",
    "LABEL_PROJECTS_LIST_IMPORT_PROJECT":"Import App",
    "LABEL_DROP_FILES": "Drop your files here",
    "LABEL_PROJECTS_LIST_CREATED":"Created",
    "LABEL_PROJECTS_LIST_UPDATED":"Updated",
    "LABEL_PROJECTS_LIST_LATEST_UPDATES":"Latest Updates",
    "LABEL_FETCHING_PROJECTS_LIST":"Fetching Projects",
    "LABEL_PROJECTS_CREATED_ON":"Created On",
    "LABEL_PROJECTS_LAST_ACCESSED":"Last Accessed",
    "LABEL_PROJECTS_COPY":"Copy Project",
    "LABEL_PROJECTS_DELETE":"Delete Project",
    "LABEL_PROJECTS_RESTORE":"Restore Project",
    "LABEL_PROJECTS_RESTORE_TITLE":"Restore Project",
    "LABEL_PROJECTS_FROM_SNAPSHOT": "Last stable state",
    "LABEL_PROJECTS_FROM_ZIP": "Project source(.zip)",
    "LABEL_PROJECTS_RESTORE_MESSAGE":"Use restore from option to update the project source to last working state. Note that it will override the local changes made",
    "LABEL_PROJECTS_RESTORE_TITLE_DESC":"Restores your project",
    "MESSAGE_PROJECTS_RESTORE":"This action will restore the project source to state before pull action. This will work when the project is in corrupted (merge conflicts) state.",
    "LABEL_PROJECTS_LEAVE_PROJECT":"Leave Project",
    "MESSAGE_PROJECTS_LEAVE_PROJECT":"Leave this project",
    "MESSAGE_ENTER_PROJECT_NAME":"Enter project name (Max length 32)",
    "MESSAGE_ENTER_PROJECT_DESCRIPTION":"Enter description (Max length 255)",
    "MESSAGE_OVERWRITE_EXISTING_VARIABLE":"A Variable with the name '${0}' exist in ${1} Variables. Saving will update the ${1} Variable. Do you want to continue?.",
    "MESSAGE_ENTER_DESCRIPTION":"Enter Description",
    "MESSAGE_ENTER_NAME": "Enter Name",
    "MESSAGE_ENTER_PROP_NAME": "enter property name",
    "MESSAGE_WEBSERVICES_DUPLICATE_PARAM":"Parameter '${0}' already exists.",
    "MESSAGE_WEBSERVICES_EMPTY_PARAM":"Parameter name cannot be empty.",
    "MESSAGE_EMPTY_PARAM_TYPE":"Parameter '${0}' Type cannot be empty.",
    "MESSAGE_EMPTY_PARAM_VALUE_TYPE":"Parameter '${0}' Value Type cannot be empty.",
    "MESSAGE_WEBSERVICES_INVALID_PARAM_TYPE": "App Environment Property not found.",
    "MESSAGE_REIMPORT_DIALOG":"Some functionality in your application may be broken. The report will contain precise locations in your application pages where the issues are so you can address them.",
    "MESSAGE_ENDPOINTS_MODIFIED":"In-use Endpoints Modified",
    "LABEL_APP_ERRORS":"App Errors",
    "LABEL_PROJECTS_GREETING":"Need help?",
    "LABEL_PROJECTS_SUGGEST_ACTION":"Explore WaveMaker",
    "LABEL_PROJECTS_LIST_COMMUNITY":"Community",
    "LABEL_PROJECTS_LIST_DEMOS":"Showcase",
    "LABEL_PROJECTS_LIST_SCREENCASTS":"Screencasts",
    "LABEL_PROJECTS_LIST_TUTORIALS":"Tutorials",
    "LABEL_PROJECTS_LIST_DOCUMENTATION":"Documentation",
    "LABEL_PROJECTS_LIST_SHARE":"Share",
    "LABEL_PROJECTS_LIST_CONNECT":"Connect",
    "LABEL_PROJECTS_LIST_TEMPLATE":"Template",
    "LABEL_SANITIZE_LAYER": "Sanitization Layer",
    "LABEL_XSS_SANITIZATION_LAYER_INPUT" : "INPUT",
    "LABEL_XSS_SANITIZATION_LAYER_OUTPUT" : "OUTPUT",
    "LABEL_XSS_SANITIZATION_LAYER_BOTH" : "BOTH",
    "MESSAGE_HELP_XSS_SANITIZATION_LAYER_INPUT": "Applies sanitization to the incoming data",
    "MESSAGE_HELP_XSS_SANITIZATION_LAYER_OUTPUT": "Applies sanitization to the outgoing data",
    "MESSAGE_HELP_XSS_SANITIZATION_LAYER_BOTH": "Applies both input and output sanitization",
    "LABEL_PROJECTS_LIST_BUY_PLAN":"BUY",
    "LABEL_PROJECTS_LIST_PAID_PLAN":"PAID",
    "LABEL_PROJECTS_LIST_TRIAL_PLAN":"TRIAL",
    "LABEL_PROJECTS_LIST_EXPIRED_PLAN":"EXPIRED",
    "LABEL_PROJECTS_LIST_CANCELLED_PLAN":"CANCELLED",
    "LABEL_PROJECTS_LIST_REACTIVATE_PLAN":"REACTIVATE",
    "LABEL_PROJECTS_LIST_PENDING_PLAN":"PENDING",
    "LABEL_PROJECTS_LIST_FAILED_PLAN":"FAILED",
    "LABEL_PROJECTS_LIST_RENEW_PLAN":"RENEW",
    "LABEL_PROJECTS_LIST_RETRY_PLAN":"RETRY",
    "LABEL_SUBSCRIPTION_LIST_PAID_PLAN":"Paid",
    "LABEL_SUBSCRIPTION_LIST_TRIAL_PLAN":"Trial",
    "LABEL_SUBSCRIPTION_LIST_EXPIRED_PLAN":"Expired",
    "LABEL_SUBSCRIPTION_LIST_CANCELLED_PLAN":"Cancelled",
    "LABEL_SUBSCRIPTION_LIST_REACTIVATE_PLAN":"Reactivate",
    "LABEL_SUBSCRIPTION_LIST_PENDING_PLAN":"Pending",
    "LABEL_SUBSCRIPTION_LIST_FAILED_PLAN":"Failed",
    "LABEL_SUBSCRIPTION_LIST_RENEW_PLAN":"Renew",
    "LABEL_SUBSCRIPTION_LIST_RETRY_PLAN":"Retry",
    "LABEL_PROJECTS_LIST_SELECT_PLAN":"Select Plan",
    "LABEL_PROJECTS_LIST_DAY_LEFT_PLAN":"day left",
    "LABEL_PROJECTS_LIST_DAYS_LEFT_PLAN":"days left",
    "LABEL_PROJECTS_LIST_DAY_PLAN":"day plan",
    "LABEL_PROJECTS_LIST_DAY_AGO_PLAN":"day ago",
    "LABEL_PROJECTS_LIST_DAYS_AGO_PLAN":"days ago",
    "LABEL_PROJECTS_LIST_WAVEMAKER_SUPPORT":"Support",
    "SESSION_TIMEOUT_DIALOG_RESOURCES":"-----------SESSION TIMEOUT DIALOG RESOURCES-------",
    "LABEL_LOGIN":"Login",
    "PLACEHOLDER_ENTER_USERNAME":"Enter Your Username",
    "PLACEHOLDER_ENTER_PASSWORD":"Enter Your Password",
    "PLACEHOLDER_PARAMETER_NAME":"parameter name",
    "LABEL_WORKSPACE_PREPARE":"Add ${0}",
    "MESSAGE_WORKSPACE_PREPARE":"Hold on while we create workspace for your ${0}.",
    "MESSAGE_WORKSPACE_PROJECT_SUCCESS":"Project \"${0}\" created successfully.",
    "MESSAGE_ERROR_WORKSPACE_PREPARE": "Your workspace is taking time to load. Please try again.",
    "LABEL_SESSION_TIMEOUT":"Session Timeout",
    "SESSION_TIMEOUT_MESSAGE":"Your Session has expired. Enter your credentials to re-login.",
    "COMMENT_SHARE_PROJECT_RESOURCES":"---------------SHARE PROJECT-----------------",
    "LABEL_INVITE":"Invite",
    "LABEL_OFF":"Off",
    "LABEL_ON":"On",
    "MESSAGE_EVENTS_READONLY":"These events are readonly",
    "LABEL_CLOSE": "close",
    "LABEL_SHARE_PROJECT":"Share Project",
    "LABEL_INVITE_USERS":"Invite Users",
    "LABEL_ENABLE_XFRAME": "Enable",
    "LABEL_PEOPLE_WORKING_ON_THIS_PROJECT":"People working on",
    "LABEL_ALONE_WORKING_ON_PROJECT":"You are working on this project alone. Invite people to share the project.",
    "PLACEHOLDER_INVITE_USER_TO_PROJECT":"Enter an email address to invite a user",
    "MESSAGE_NO_USER_FOUND_WITH_THE_EMAIL": "No user found with the given email",
    "PROJECT_MSG_RESOURCES":"-----------Project Message Resources----------",
    "MESSAGE_ERROR_HTTP_ERROR_TITLE":"Error!",
    "MESSAGE_ERROR_HTTP_STATUS_ERROR_DESC":"Service call failed",
    "MESSAGE_ERROR_HTTP_CONFIG_ERROR_DESC":"Error in $http service configuration parameters",
    "MESSAGE_WARN_LOGIN_ID_EMPTY":"Enter your email",
    "MESSAGE_WARN_LOGIN_ID_INVALID":"Enter a valid email",
    "MESSAGE_WARN_PASSWORD_EMPTY":"Enter your password",
    "MESSAGE_WARN_BRANCH_EMPTY": "Enter your branch",
    "MESSAGE_ERROR_LOGIN_ID_PASSWORD_COMBINATION_MISMATCH":"Enter valid credentials",
    "MESSAGE_ERROR_PROJECT_NAME_INVALID_TITLE":"Project name invalid",
    "MESSAGE_WARN_PROJECT_NAME_SPACE_DESC":"Project name can not have space(s)",
    "MESSAGE_WARN_PROJECT_NAME_UNDERSCORE_DESC":"Project name can not have only underscores",
    "MESSAGE_WARN_PROJECT_NAME_NUMBER_DESC":"Project name can not start with a number",
    "MESSAGE_WARN_PROJECT_NAME_EMPTY_DESC":"Project name can not be empty",
    "MESSAGE_ERROR_NO_FILE_SELECTED_DESC":"Please select a file",
    "MESSAGE_ERROR_PROJECT_NAME_INVALID_DESC":"A project name can contain only letters or digits",
    "MESSAGE_ERROR_SELECT_TEMPLATE_TITLE":"Template not selected",
    "MESSAGE_ERROR_SELECT_TEMPLATE":"Please select the template",
    "MESSAGE_ERROR_TEMPLATE_NAME_INVALID_TITLE":"Template name invalid",
    "MESSAGE_WARN_TEMPLATE_NAME_EMPTY_DESC":"Template name can not be empty",
    "MESSAGE_WARN_TEMPLATE_NAME_DUPLICATE_DESC":"Template already exists by name \"${0}\". Template would be overwritten.",
    "MESSAGE_WARN_TEMPLATE_NAME_SPACE_DESC":"A template name can not have space(s)",
    "MESSAGE_WARN_TEMPLATE_NAME_UNDERSCORE_DESC":"A template name can not have only underscores",
    "MESSAGE_ERROR_TEMPLATE_NAME_INVALID_DESC":"A template name can contain only letters or digits",
    "MESSAGE_ERROR_SELECT_PROJECT_SHELL_TITLE":"Project Shell not selected",
    "MESSAGE_ERROR_SELECT_PROJECT_SHELL":"Please select the project shell",
    "MESSAGE_ERROR_PROJECT_SHELL_NAME_INVALID_TITLE":"Project Shell name invalid",
    "MESSAGE_WARN_PROJECT_SHELL_NAME_EMPTY_DESC":"Project Shell name can not be empty",
    "MESSAGE_WARN_PROJECT_SHELL_NAME_DUPLICATE_DESC":"Project Shell already exists by name \"${0}\". Project Shell would be overwritten.",
    "MESSAGE_WARN_PROJECT_SHELL_NAME_SPACE_DESC":"Project Shell name can not have space(s)",
    "MESSAGE_WARN_PROJECT_SHELL_NAME_UNDERSCORE_DESC":"Project Shell name can not have only underscores",
    "MESSAGE_ERROR_PROJECT_SHELL_NAME_INVALID_DESC":"Project Shell name can contain only letters or digits",
    "MESSAGE_ERROR_PROJECT_LIST_EMPTY_TITLE":"Projects list empty",
    "MESSAGE_ERROR_PROJECT_LIST_EMPTY_DESC":"Projects list not found",
    "MESSAGE_ERROR_PROJECT_NAME_EXISTS_TITLE":"Project name already exists",
    "MESSAGE_ERROR_DUPLICATE_VARIABLE":"There is duplication of variable names. Please maintain variables with unique names to prevent issues.",
    "MESSAGE_ERROR_PROJECT_NAME_EXISTS_DESC":"Try with a different project name",
    "MESSAGE_ERROR_NAME_INVALID_TITLE":"${0} name invalid",
    "MESSAGE_WARN_NAME_SPACE_DESC":"${0} name can not have space(s)",
    "MESSAGE_WARN_NAME_UNDERSCORE_DESC":"${0} name can not have only underscores",
    "MESSAGE_WARN_NAME_NUMBER_DESC":"${0} name can not start with a number",
    "MESSAGE_WARN_NAME_EMPTY_DESC":"${0} name can not be empty",
    "MESSAGE_WARN_CLASS_NAME_EMPTY": "${0} can not be empty",
    "MESSAGE_ERROR_NAME_INVALID_DESC":"A ${0} name can contain only letters or digits",
    "MESSAGE_ERROR_LIST_EMPTY_TITLE":"${0}s list empty",
    "MESSAGE_ERROR_LIST_EMPTY_DESC":"${0}s list not found",
    "MESSAGE_ERROR_NAME_EXISTS_TITLE":"${0} name already exists",
    "MESSAGE_ERROR_NAME_EXISTS_DESC":"Try with a different ${0} name",
    "MESSAGE_SUCCESS_PROJECT_DELETE_DESC":"${1} \"${0}\" deleted successfully.",
    "MESSAGE_SUCCESS_PROJECT_DELETE_BRANCH_DESC":"${1} \"${0} (${2})\" deleted successfully.",
    "MESSAGE_SUCCESS_PROJECT_FINISH_UPGRADE_DESC":"Project upgrade finished successfully.",
    "MESSAGE_SUCCESS_PROJECT_LEAVE_DESC":"You left ${1} \"${0}\" successfully.",
    "MESSAGE_SUCCESS_PROJECT_LEAVE_BRANCH_DESC":"You left ${1} \"${0} (${2})\" successfully.",
    "MESSAGE_SUCCESS_PREFERENCES_UPDATED_TITLE":"Success!",
    "MESSAGE_SUCCESS_PREFERENCES_UPDATED_DESC":"Preferences updated successfully",
    "MESSAGE_SUCCESS_PREFERENCES_FAILED_TITLE":"Error!",
    "MESSAGE_SUCCESS_PREFERENCES_FAILED_DESC":"Preferences updated failed",
    "MESSAGE_NEW_PREFERENCES_EMPTY":"New Preference location can't be empty",
    "MESSAGE_SUCCESS_SAVE_FILE_DESC":"File saved successfully",
    "MESSAGE_OFFLINE_CONFIG_SAVED": "Offline Configuration is saved successfully",
    "MESSAGE_MOBILE_HELP_DEPENDENT_TABLES_UNSELECT": "The  table \"${0}\" has dependency on the following tables. On Ok click, the dependent tables will also get removed for offline.",
    "MESSAGE_MOBILE_HELP_REQUIRED_TABLES_SELECTION": "The  table \"${0}\" requires the following tables. On Ok click, the required tables will also get added for offline.",
    "MESSAGE_ON_THEME_CHANGE": "Theme changed to ${0}",
    "MESSAGE_ERROR_SAVE_FILE_DESC":"Error while saving file.",
    "MESSAGE_ERROR_INVALID_JSON":"Cannot save invalid JSON.",
    "MESSAGE_ERROR_FILE_NOT_EDITABLE":"The file - \"${0}\" is not editable",
    "MESSAGE_ERROR_FILE_NOT_READABLE":"The file - \"${0}\" is not readable",
    "MESSAGE_SUCCESS_DELETE_FILE_DESC":"File deleted successfully",
    "MESSAGE_ERROR_DELETE_FILE_DESC":"Error while deleting file.",
    "MESSAGE_ERROR_DELETE_SELECT_RESOURCE":"Select an appropriate folder/file to delete.",
    "MESSAGE_ERROR_DELETE_NOT_ALLOWED":"Cannot delete a system folder.",
    "MESSAGE_ERROR_DELETE_DEFAULT_LANGUAGE_NOT_ALLOWED":"Default Language of the project cannot be deleted",
    "MESSAGE_ERROR_UPLOAD_NOT_ALLOWED":"Cannot upload file into system folder",
    "MESSAGE_SUCCESS_SAVE_PROJECT_DESC":"Project saved successfully",
    "MESSAGE_SUCCESS_RUN_PROJECT_DESC":"Project deployed successfully",
    "MESSAGE_SUCCESS_IMPORT_PROJECT_DESC":"Project imported successfully",
    "MESSAGE_SUCCESS_PROJECT_SOURCE_DESC":"Project source updated successfully",
    "MESSAGE_SUCCESS_EXPORT_PROJECT_DESC":"Project exported successfully",
    "MESSAGE_SUCCESS_DOWNLOAD_PROJECT_DESC":"Project downloaded successfully",
    "MESSAGE_SUCCESS_SHARE_PROJECT_DESC":"Project shared with the user successfully ",
    "MESSAGE_SUCCESS_UNSHARE_PROJECT_DESC":"User removed from the project successfully",
    "MESSAGE_SUCCESS_PREFAB_IMPORT_DESC":"Prefab imported successfully",
    "MESSAGE_ERROR_PREFAB_IMPORT_DESC":"Prefab import failed",
    "MESSAGE_SUCCESS_TEMPLATEBUNDLE_IMPORT_DESC":"Template bundle imported successfully",
    "MESSAGE_ERROR_TEMPLATEBUNDLE_IMPORT_DESC":"Template bundle import failed",
    "MESSAGE_SUCCESS_THEME_IMPORT_DESC":"Theme imported successfully",
    "MESSAGE_ERROR_THEME_IMPORT_DESC":"Theme import failed",
    "MESSAGE_SUCCESS_IMPORT":" imported successfully",
    "MESSAGE_SUCCESS_IMAGE_IMPORT_DESC":"Image imported successfully",
  "MESSAGE_SUCCESS_ICON_IMPORT_DESC":"Icon imported successfully",
    "MESSAGE_ERROR_IMAGE_IMPORT_DESC":"Image import failed",
  "MESSAGE_ERROR_ICON_IMPORT_DESC":"Icon import failed",
  "LABEL_UPLOAD_ICON_FONTS": "Upload Icon Fonts",
  "LABEL_UPLOAD_ICON_FONT": "Upload Icon Font",
  "MESSAGE_UPLOAD_ICON_FOMTS": "Upload TTF and CSS file to use any custom icon font library in the studio",
  "LABEL_UPLOAD_TTF_FILE": "Upload .ttf file",
  "LABEL_UPLOAD_CSS_FILE": "Upload .css file",
    "MESSAGE_SUCCESS_RESOURCE_IMPORT_DESC":"Resource imported successfully",
    "MESSAGE_ERROR_RESOURCE_IMPORT_DESC":"Resource import failed",
    "MESSAGE_SUCCESS_JAR_IMPORT_DESC":"JAR imported successfully",
    "MESSAGE_ERROR_JAR_IMPORT_DESC":"JAR import failed",
    "MESSAGE_SUCCESS_AUDIO_IMPORT_DESC":"Audio imported successfully",
    "MESSAGE_ERROR_AUDIO_IMPORT_DESC":"Audio import failed",
    "MESSAGE_SUCCESS_VIDEO_IMPORT_DESC":"Video imported successfully",
    "MESSAGE_SUCCESS_CONNECTOR_IMPORT_DESC":"Connector imported succesfully",
    "MESSAGE_ERROR_VIDEO_IMPORT_DESC":"Video import failed",
    "MESSAGE_ERROR_CONNECTOR_IMPORT_DESC":"Connector import failed",
    "MESSAGE_ERROR_IMPORT_GENERIC": "Import failed",
    "MESSAGE_ERROR_PREFAB_REGISTER_FAILED_DESC":"Prefab registration failed",
    "MESSAGE_ERROR_PROJECT_PREFAB_LIST_FAILED_DESC":"Fetch Project Prefabs list failed",
    "MESSAGE_ERROR_FILE_UPLOAD_WIDGET_REGISTER_FAILED_DESC":"File upload component registration failed",
    "MESSAGE_ERROR_NO_FILE_SELECTED_TITLE":"No File Selected",
    "MESSAGE_ERROR_NO_JKS_FILE_SELECTED_DESC":"Please select a JKS file",
    "MESSAGE_ERROR_NO_METADATA_FILE_SELECTED_DESC":"Please select a Metadata file",
    "MESSAGE_ERROR_NO_FOLDER_SELECTED_DESC":"Please select a folder",
    "MESSAGE_FOLDERNAME_NOT_SET": "Please enter folder name",
    "MESSAGE_FOLDERNAME_INVALID": "Special characters are not allowed.",
    "MESSAGE_ERROR_NO_FILE_OR_FOLDER_SELECTED_DESC":"Please select a file or folder",
    "MESSAGE_ERROR_ZIP_INVALID_FILE":"Select a valid ZIP file",
    "MESSAGE_ERROR_IMAGE_INVALID_FILE":"Select a valid Image file",
    "MESSAGE_ERROR_IMAGE_INVALID_SIZE":"Please provide the image with \"${0}\"px.",
    "MESSAGE_ERROR_PNG_INVALID_FILE":"Select a valid PNG file",
    "MESSAGE_ERROR_JSON_INVALID_FILE":"Select a valid JSON file",
    "MESSAGE_ERROR_UNSUPPORTED_RESOURCE_FILE":"Upload of selected file is not allowed",
    "MESSAGE_ERROR_SWAGGER_UNSUPPORTED_RESOURCE_FILE": "Please upload a json or yaml file",
    "PAGE_MSG_RESOURCES":"-----------PAGE Message Resources----------",
    "MESSAGE_WARN_PAGE_NAME_EMPTY_TITLE":"Page name empty",
    "MESSAGE_WARN_PAGE_NAME_EMPTY_DESC":"Enter the page name",
    "MESSAGE_ERROR_PAGE_NAME_EXISTS_TITLE":"Page already exists",
    "MESSAGE_WARN_ENTITY_EMPTY_DESC": "Please select Table/Entity",
    "MESSAGE_WIDGET_TEMPLATE": "can be used for repetitive section in a component like Search, Checkboxset, Radioset, etc. Click",
    "LABEL_FOR_MORE_INFO": "for more info",
    "LABEL_NEW_WIDGET_TEMPLATE": "New Component Template",
    "MESSAGE_SELECT_TEMPLATE_ENTITY": "Select an entity to bind data to the template",
    "MESSAGE_ERROR_PAGE_NAME_EXISTS_DESC":"Page with this name already exists. Try with a different page name",
  "MESSAGE_ERROR_ICONFILE_NAME_EXISTS_DESC":"File with this name already exists. Try with a different page name",
    "MESSAGE_ERROR_PAGE_NAME_INVALID_TITLE":"Page name invalid",
    "MESSAGE_ERROR_PAGE_NAME_INVALID_DESC":"A page name can contain only letters, digits, or hyphens (-) ",
    "MESSAGE_ERROR_PAGE_NAME_INVALID_NUMBER_DESC":"A page name should not start with a number",
    "MESSAGE_ERROR_PREFAB_NAME_INVALID_DESC":"A prefab name can contain only letters or digits",
    "MESSAGE_DELETE_PAGE":"Are you sure you want to delete page - \"${0}\"?",
    "MESSAGE_DELETE_TEMPLATE":"Are you sure you want to delete template - \"${0}\"?",
    "MESSAGE_DELETE_PARTIAL_PAGE":"Deleting a partial- \"${0}\" may cause error on the pages where it has been used. Do you want to continue?",
    "MESSAGE_RENAME_PAGE":"Rename Page and its usage to:",
    "MESSAGE_RENAME_TEMPLATE":"Rename Template and its usage to:",
    "MESSAGE_RENAME_PARTIAL_PAGE":"Rename Partial and its usage to:",
    "MESSAGE_DUPLICATE_PAGE":"Duplicate Page to:",
    "MESSAGE_DUPLICATE_TEMPLATE":"Duplicate Template to:",
    "MESSAGE_DUPLICATE_PARTIAL_PAGE":"Duplicate Partial to:",
    "MESSAGE_DELETE_RESOURCE":"Are you sure you want to delete \"${0}\"?",
    "MESSAGE_DISCARD_CHANGES":"There are unsaved changes in the workspace, do you want to discard the changes?",
    "MESSAGE_DISCARD_CHANGES_MODULE_SETTINGS":"Verify that both name and script fields are entered for modules.",
    "MESSAGE_DISCARD_JAVASERVICE_CHANGES":"Cannot save the changes as there are compilation errors. Do you want to discard the changes?",
    "MESSAGE_SUCCESS_PAGE_DELETE":"\"${0}\" page deleted successfully",
    "MESSAGE_SUCCESS_PAGE_RENAME":"\"${0}\" page renamed successfully",
    "MESSAGE_SUCCESS_PAGE_DUPLICATE":"\"${0}\" page duplicated successfully",
    "REGISTRATION_PAGE_RESOURCES":"---------Registration Page Resources----------",
    "DATABSE_DOESNT_EXIST": "The database \"${0}\" doesn't exist.",
    "TABLE_DOESNT_EXIST": "The table \"${0}\" doesn't exist in the database \"${1}\".",
    "SERVICE_DOESNT_EXIST": "The service \"${0}\" doesn't exist.",
    "METHOD_DOESNT_EXIST": "The method \"${0}\" doesn't exist in the service \"${1}\".",
    "LABEL_EMAIL":"Email",
    "LABEL_MORE":"More",
    "LABEL_PASSWORD":"Password",
    "LABEL_CONFIRM_PASSWORD":"Confirm Password",
    "LABEL_USERNAME":"User Name",
    "LABEL_CURRENT_PASSWORD":"Current Password",
    "LABEL_NEW_PASSWORD":"New Password",
    "LABEL_CONFIRM_NEW_PASSWORD":"Confirm New Password",
    "LABEL_FIRST_NAME":"First Name",
    "LABEL_LAST_NAME":"Last Name",
    "USERS_PAGE_RESOURCES":"-----------Users Page Resources----------",
    "LABEL_ADD":"Add",
    "LABEL_USER_NAME":"Username",
    "LABEL_ACCESS_TOKEN_HELP_TEXT": "Checkout how to create an access token",
    "LABEL_ORGANIZATION": "Organization",
    "LABEL_GROUP": "Group",
    "LABEL_BY": "By",
    "LABEL_NEW_VERSION_HINT": "New update available",
    "LABEL_ADD_USERS":"Add Users",
    "MSG_ERR_USER_VCS_UPDATE_FAILED": "Invalid or expired code repository credentials.",
    "MSG_USER_VCS_DETAILS_UPDATED": "Code repository credentials are updated successfully.",
    "LABEL_ADD_DEMO_USER":"Add User",
    "LABEL_NEW_USER":"New User",
    "LABEL_ADD_NEW_USER":"Add New User",
    "LABEL_CONTINUE":"Continue",
    "LABEL_PROCEED":"Proceed",
    "LABEL_JOIN":"Join",
    "LABEL_REJECT":"Reject",
    "LABEL_SEARCH_USERS":"Search Users",
    "LABEL_ADD_USER_TO_WAVEMAKER":"Add User to WaveMaker",
    "LABEL_REMOVE":"Remove",
    "LABEL_MODIFY":"Modify",
    "LABEL_DESIGNATION":"Designation",
    "LABEL_DESIGNER":"Designer",
    "LABEL_DEVELOPER":"Developer",
    "LABEL_ACTIVITY_FEED":"Activity Feed",
    "LABEL_IN_WAVEMAKER":"IN WAVEMAKER",
    "LABEL_PENDING":"PENDING",
    "LABEL_BACK":"Back",
    "LABEL_SKIP":"Skip",
    "LABEL_UPDATE":"Update",
    "LABEL_DISPLAY_NAME":"Display Name",
    "LABEL_CHANGE_CURRENT_PASSWORD":"Change current password",
    "LABEL_CHANGE_PASSWORD":"Change Password",
    "LABEL_TO_START_USING_WAVEMAKER":"to start WaveMaker",
    "LABEL_ADDED_TO_WAVEMAKER":"was added to WaveMaker",
    "LABEL_CLOUDJEE_LOGIN":"WaveMakerCloud Login",
    "LABEL_CLOUDJEE_PASSWORD":"Cloud Password",
    "LABEL_UPDATE_PROFILE":"Update Profile",
    "LABEL_OBSELETE_THEME_INFO_1": "Some of the themes have been removed. ",
    "LABEL_OBSELETE_THEME_INFO_2": " to see the obsolete themes.",
    "LABEL_CLICK_HERE": "Click here",
    "LABEL_CLICK_HERE_FOR_MORE_INFO":"Click here for more info",
    "LABEL_ADD_THEME_TO_PROJECT":"Add theme to project",
    "LABEL_REMOVE_THEME_TO_PROJECT":"Remove theme from project",
    "LABEL_CLICK_HERE_TO_EDIT":"Click here to edit.",
    "LABEL_OPEN_IN_STUDIO":"Open in Studio",
    "LABEL_WM": "WM",
    "LABEL_MIGRATE":"Upgrade to WM ",
    "LABEL_SUCCESSFULLY_MIGRATED":"Successfully migrated ${0}",
    "LABEL_VERSIONS": "Versions",
    "LABEL_FINISH_UPGRADE": "Finish Upgrade",
    "LABEL_CLOUD_DEPLOY_DIALOG_TEXT":"To link your existing WaveMaker Cloud Account, create new account or update your profile ",
    "LABEL_NO_USERS_FOUND":"No people found. Please import them using Account -> User Configuration or Add people manually",
    "LABEL_LINK_WAVEMAKER_ACCOUNT":"Link your existing WaveMaker Cloud Account or",
    "LABEL_CREATE_NEW_ACCOUNT":"Create one",
    "LABEL_LINK_WAVEMAKER_ACCOUNT_DESC":"A WaveMaker Cloud Account enables you to deploy WaveMaker Apps to cloud",
    "LABEL_LOCALE_CHANGE_SAVE_TEXT":"To apply these changed you need to login again. Do you want to continue?",
    "MESSAGE_USERNAME_CHAR_LIMIT":"Username must contain min of 6 characters and max of 15 characters",
    "MESSAGE_SUCCESS_UPDATE_PROFILE_DESC":"Profile updated successfully",
    "MESSAGE_SUCCESS_UPDATE_WAVEMAKER_CLOUD_DETAILS_DESC":"WaveMaker Cloud Details updated successfully",
    "MESSAGE_SUCCESS_PASSWORD_CHANGE_DESC": "Password updated successfully",
    "MESSAGE_ERROR_USERNAME_MISSING":"Please enter username",
    "MESSAGE_ERROR_DISPLAYNAME_MISSING":"Please enter display name",
    "PLACEHOLDER_ENTER_DISPLAY_NAME":"Enter display name",
    "MESSAGE_ERROR_FISRTNAME_MISSING":"Please enter first name",
    "MESSAGE_ERROR_CURRENT_PASSWORD_MISSING":"Please enter your current password",
    "MESSAGE_ERROR_NEW_PASSWORD_MISSING":"Please enter your new password",
    "MESSAGE_ERROR_CONFIRM_PASSWORD_MISSING":"Please confirm your password",
    "MESSAGE_ERROR_PASSWORDS_DONOT_MATCH":"Passwords don't match",
    "MESSAGE_ERROR_PASSWORD_CHAR_LIMIT":"Password must contain min of 8 characters and max of 32 characters",
    "MESSAGE_ERROR_NEW_PASSWORD_SAME_AS_CURRENT_PASSWORD":"New password is same as current password",
    "ACCOUNTS_PAGE_RESOURCES":"-----------Accounts Page Resources----------",
    "LABEL_ACCOUNT_SETTINGS":"Account Settings",
    "LABEL_USER_CONFIGURATION":"Security Providers",
    "LABEL_USER_CONFIGURATION_TOOLTIP":"Configure User",
    "LABEL_PRODUCT_LICENSING":"Product Licensing",
    "LABEL_WAVEMAKER_CLOUD":"WaveMaker Cloud",
    "LABEL_WAVEMAKER_CLOUD_DETAILS":"WaveMaker Cloud Details",
    "LABEL_IMPORT_PEOPLE":"Import people using",
    "LABEL_LDAP":"LDAP",
    "LABEL_PORT":"Port",
    "LABEL_BACKUP_SERVER":"Backup Server",
    "LABEL_BACKUP_PORT":"Backup Port",
    "LABEL_BASE":"Base",
    "LABEL_SEARCH_VARIABLE":"Search for a Variable",
    "LABEL_SEARCH_EXISTING_VARIABLE":"Search for an existing Variable",
    "LABEL_SEARCH_PASSWORD":"Search Password",
    "LABEL_SEARCH_DN":"Search DN",
    "LABEL_LDAP_SETTINGS_SUCCESSFUL":"LDAP settings saved successfully. People are automatically added based on your LDAP Settings",
    "LABEL_MESSAGES":"Messages",
    "COMMENT_WEB_SERVICE_MESSAGES":"-----------Web Service Message Resources----------",
    "MESSAGE_ERROR_TITLE":"Error",
    "MESSAGE_WARNING_TITLE":"Warning",
    "MESSAGE_SUCCESS_TITLE":"Success",
    "MESSAGE_DANGER_TITLE":"Danger",
    "MESSAGE_INFO_TITLE":"Info",
    "MESSAGE_WEB_SERVICE_SUCCESS":"Successfully updated the service.",
    "MESSAGE_ERROR_COPY_WIDGET_NOT_ALLOWED":"Copy action not permitted for the selected component.",
    "MESSAGE_ERROR_CUT_WIDGET_NOT_ALLOWED":"Cut action not permitted for the selected component.",
    "MESSAGE_ERROR_WEB_SERVICE_TEST":"An error occurred while testing the REST Service, please try again or check server logs for more info.",
    "MESSAGE_ERROR_WEB_SERVICE_POPULATE":"An error occurred while populating the web service, please try again.",
    "MESSAGE_ERROR_WEB_SERVICE_EXISTS_ONE":"A service named",
    "MESSAGE_ERROR_WEB_SERVICE_EXISTS_TWO":"already exists. Please check the name of the service.",
    "MESSAGE_SUCCESS_WEB_SERVICE_REST_BUILD":"REST service built successfully.",
    "MESSAGE_SUCCESS_WEB_SERVICE_REST_UPDATE":"REST service updated successfully.",
    "MESSAGE_SUCCESS_WEB_SERVICE_REST_UPDATE_FAILED":"REST service failed to update.",
    "MESSAGE_SUCCESS_WEB_SERVICE_WEBSOCKET_BUILD":"WebSocket service imported successfully.",
    "MESSAGE_SUCCESS_DATABASE_DELETED":"Database deleted successfully.",
    "MESSAGE_SUCCESS_MODEL_DELETED":"DataModel deleted successfully.",
    "MESSAGE_SUCCESS_WEB_SERVICE_SOAP_UPDATE":"SOAP service updated successfully.",
    "MESSAGE_ERROR_WEB_SERVICE_REST_BUILD":"An error occurred while building the REST service, please try again.",
    "MESSAGE_ERROR_WEB_SERVICE_REST_UPDATE":"An error occurred while updating the REST service, please try again.",
    "MESSAGE_SUCCESS_WEB_SERVICE_SOAP_URL":"SOAP service imported successfully from provided URL",
    "MESSAGE_ERROR_WEB_SERVICE_SOAP_URL":"An error occurred while importing SOAP service from provided URL, please try again.",
    "LABEL_USE_MOCK_DATA":"Mock APIs",
    "LABEL_KNOW_MORE": "Know more",
    "LABEL_BASIC_CONFIG": "Basic configuration",
    "LABEL_IN": "in",
    "TITLE_LAUNCH_MOCK_API":"Launching Mock APIs",
    "MSG_MOCK_SERVER_CREATION_IN_PROGRESS":"Mock Server is being created...",
    "LABEL_MOCK":"Mock",
    "LABEL_MOCK_API":"Mock APIs",
    "TITLE_MOCK_SERVICE_LAUNCH_SUCCESS": "Successfully launched Mock Service",
    "MESSAGE_MOCK_SERVICE_LAUNCH_SUCCESS": "Mock Service for the \"${0}\" API launched successfully.",
    "TITLE_MOCK_SERVICE_LAUNCH_FAILURE": "Mock Service launch Failed",
    "MESSAGE_MOCK_SERVICE_LAUNCH_FAILURE": "Error occurred while launching the Mock Service for the \"${0}\" API.",
    "TITLE_MOCK_SERVICE_CREATE_SUCCESS": "Successfully Created Mock Service",
    "MESSAGE_MOCK_SERVICE_CREATE_SUCCESS": "Mock Service for the \"${0}\" API created successfully.",
    "TITLE_MOCK_SERVICE_CREATE_FAILURE": "Mock Service Creation Failed",
    "MESSAGE_MOCK_SERVICE_CREATE_FAILURE": "Error occurred while creating the Mock Service for the \"${0}\" API.",
    "TITLE_MOCK_SERVICE_STOP_SUCCESS": "Successfully Stopped Mock Service",
    "MESSAGE_MOCK_SERVICE_STOP_SUCCESS": "Mock Service for the \"${0}\" API stopped successfully.",
    "LABEL_AVAILABLE_AUTHORIZATIONS":"Available authorizations",
    "MESSAGE_MOCK_API_DESCRIPTION":"One click away to mock your APIs with accurate mock responses.",
    "BUTTON_CREATE_MOCK_SERVER":"Create Mock Server",
    "MESSAGE_MOCK_DATA_BEING_USED":"Mock APIs being used",
    "MESSAGE_SUCCESS_WEB_SERVICE_SOAP_FILE":"SOAP service imported successfully from provided WSDL file",
    "MESSAGE_ERROR_WEB_SERVICE_SOAP_FILE":"An error occurred while importing SOAP service from provided WSDL file, please try again.",
    "MESSAGE_ERROR_WEB_SERVICE_BINDING_PROPERTIES_GET":"An error occurred while fetching binding properties for a service, please try again",
    "MESSAGE_ERROR_WEB_SERVICE_BINDING_PROPERTIES_SET":"An error occurred while updating binding properties for the service, please try again",
    "MESSAGE_SUCCESS_WEB_SERVICE_BINDING_PROPERTIES_SET":"Binding Properties updated successfully for the web service",
    "MESSAGE_ERROR_WEB_SERVICE_WSDL_GET":"An error occurred while fetching WSDL for the service",
    "MESSAGE_ERROR_WEB_SERVICE_GET_METHODS":"An error occurred while fetching methods for the service",
    "MESSAGE_ERROR_WEB_SERVICE_LIST_SERVICES":"An error occurred while fetching available services for the project",
    "MESSAGE_ERROR_WEB_SERVICE_LIST_TYPES":"An error occurred while fetching available data types for the project",
    "MESSAGE_ERROR_FETCH_SERVICE_METHODS_DESC":"Error while fetching methods for service",
    "MESSAGE_ERROR_FETCH_SERVICE_METHOD_PARAMS_DESC":"Error while fetching params for a service operation",
    "MESSAGE_ERROR_FETCH_SERVICE_WSDL_DESC":"Error while fetching WSDL for service",
    "MESSAGE_ERROR_WEB_SERVICE_REST_READ_SCHEMA":"An error occurred while reading the provided xml schema resource, please check and try again",
    "MESSAGE_SUCCESS_WEB_SERVICE_FEED_REGISTER":"Successfully registered Feed service",
    "MESSAGE_ERROR_WEB_SERVICE_FEED_REGISTER":"An error occurred while registering the Feed service, please try again",
    "MESSAGE_ERROR_WEB_SERVICE_FEED_REGISTERED":"Feed service has already been imported",
    "MSG_CORS_FAILURE":"It seems the target service does not allow Cross Origin Resource Sharing.\n\nPlease use proxy instead (Enable \"Use Proxy\" option above)\n\nOR\n\nMake sure the target service allows Cross Origin Resource Sharing.",
    "LABEL_WIDGET_SUCCESS_TITLE": "success",
    "LABEL_WIDGET_DANGER_TITLE":"danger",
    "LABEL_WIDGET_WARNING_TITLE": "warning",
    "LABEL_WIDGET_INFO_TITLE": "info",
    "LABEL_WEB_SERVICE_DIALOG_TITLE":"New Web Service",
    "LABEL_WEB_SERVICE_BACK":"BACK",
    "LABEL_IMPORT":"Import",
    "LABEL_CONTINUE_IMPORT": "Proceed and Import",
    "LABEL_CONTINUE_REIMPORT": "Proceed and ReImport",
    "LABEL_CONTINUE_CREATE": "Proceed and Create",
    "LABEL_VPK_CONFIGURATION": "Configure",
    "LABEL_GENERATE_CODE": "Update",
    "MESSAGE_GENERATE_CODE": " Please \"update\" application to re-generate sources for the database service.",
    "LABEL_FOLDER_NAME": "Folder Name: ",
    "LABEL_UPLOAD_FILES": "Upload Files",
    "LABEL_NEXT":"Next",
    "LABEL_PREV": "Prev",
    "LABEL_PREVIOUS": "Previous",
    "LABEL_WEB_SERVICE_FEED_TITLE":"Feed Service Information",
    "LABEL_WEB_SERVICE_FEED_DESC":"Selecting Import below will add the generic Feed Service to your application. To use this service, add a ServiceVariable to your page, and configure it to use this service, supplying the URL for your service in the feedURL property of the getFeed operation.",
    "LABEL_FILE":"File",
    "LABEL_WSDL_SOURCE":"WSDL Source",
    "LABEL_SWAGGER_SOURCE": "Swagger Source",
    "LABEL_AUTO":"Auto",
    "LABEL_SAMPLE":"Sample",
    "LABEL_MANUAL":"Manual",
    "LABEL_WEB_SERVICE_XHR_SERVICE_URL":"XHR Service URL:",
    "LABEL_WEB_SERVICE_XHR_REQUEST_TYPE":"Request Type:",
    "LABEL_WEB_SERVICE_USE_PROXY":"Use Proxy:",
    "LABEL_WEB_SERVICE_WITH_CREDENTIALS":"With Credentials:",
    "LABEL_WEB_SERVICE_XHR_SERVICE_INPUTS":"Service Inputs",
    "LABEL_WEB_SERVICE_XHR_PATH_INPUTS":"Path Inputs",
    "LABEL_WEB_SERVICE_XHR_HEADER_INPUTS":"Header Inputs",
    "LABEL_WEB_SERVICE_XHR_TABLE_INPUT_NAME":"Input Name",
    "LABEL_WEB_SERVICE_XHR_TABLE_DEFAULT_VALUE":"Default Value",
    "LABEL_WEB_SERVICE_XHR_TABLE_DONOT_ENCODE_VALUE":"Do not Encode Value",
    "LABEL_WEB_SERVICE_XHR_TABLE_NOT_SHOWN_VALUE":"Not shown in SVar",
    "LABEL_WEB_SERVICE_XHR_RETURN_TYPE":"Return type:",
    "LABEL_WEB_SERVICE_REST_SERVICE_URL":"Service URL",
    "LABEL_WEB_SERVICE_REST_OPERATION_NAME":"Operation Name",
    "LABEL_WEB_SERVICE_REST_METHOD_NAME":"Method",
    "LABEL_WEB_SERVICE_REST_CONTENT_TYPE":"Content Type",
    "LABEL_WEB_SERVICE_REST_REQUEST_BODY":"Request Body",
    "LABEL_WEB_SOCKET_REQUEST_BODY":"Sample Request Body",
    "LABEL_MORE_INFO":"More info",
    "LABEL_BODY":"Body",
    "LABEL_QUERY_PARAMS":"Query Params",
    "LABEL_PATH_PARAMS":"Path Params",
    "LABEL_HEADERS_PARAMS":"Header Params",
    "LABEL_BODY_PARAMS":"Body Params",
    "LABEL_AUTH_PARAMS":"Auth Params",
    "LABEL_AUTHORIZATION_PARAMS": "Authorization",
    "LABEL_WEB_SERVICE_REST_HTTP_HEADER":"HTTP Header",
    "LABEL_NAME":"Name",
    "LABEL_DETAILS": "Details",
    "LABEL_PARAMS": "Parameters",
    "LABEL_GENERAL":"General",
    "LABEL_PROFILE_CONFIGURATION":"Profile Configuration",
    "LABEL_PREFAB_CONFIGURATION":"Prefab Configuration",
    "LABEL_USERS_PERMISSIONS":"Users & Permissions",
    "LABEL_BUILD_PREFERENCES":"Build Preferences",
    "LABEL_APP_CONFIGURATIONS":"App Configurations",
    "LABEL_CODE_EDITOR":"Code-Editor",
    "LABEL_QUERY_EDITOR":"Query Editor",
    "LABEL_CANVAS":"Canvas",
  "LABEL_WIDGET":"Component",
    "LABEL_EXPAND_COLLAPSE_CANVAS":"Expand/Collapse Canvas",
    "LABEL_DATA":"Data",
    "LABEL_VALUE":"Value",
    "LABEL_OUTPUT":"Output",
    "LABEL_XML_SCHEMA":"XML Schema",
    "LABEL_WEB_SERVICE_REST_FILE_PATH":"File Path",
    "LABEL_WEB_SERVICE_REST_MANUAL_ENTRY":"Manual Entry",
    "LABEL_WEB_SERVICE_REST_REREAD_SCHEMA":"Reread Schema",
    "LABEL_WEB_SERVICE_REST_SAMPLE_XML":"Sample XML",
    "LABEL_WEB_SERVICE_REST_SERVICE_OUTPUT_TYPE":"Service Output Type",
    "LABEL_WEB_SERVICE_REST_URL":"URL",
    "LABEL_WEB_SERVICE_RESPONSE_TYPE": "Response Type",
    "LABEL_HTTP_AUTHENTICATION":"HTTP Authentication",
    "LABEL_HTTP_AUTHENTICATION_PROVIDER_OAUTH":"OAuth Provider",
    "LABEL_WEB_SERVICE_NO_OAUTH_PROVIDER_SELECTED":"No Provider Selected yet",
    "LABEL_WEB_SERVICE_ADD_OAUTH_PROVIDER_TITLE":"OAuth Provider Configuration",
    "LABEL_WEB_SERVICE_ADD_OAUTH_PROVIDER_ID":"Provider ID",
    "MESSAGE_WEB_SERVICE_SET_CALLBACK_URL": "Set this as the callback URL in OAuth Provider app settings page",
    "LABEL_WEB_SERVICE_OAUTH_ACCESS_TOKEN": "Send AccessToken As",
    "LABEL_WEB_SERVICE_SELECT_PROVIDER":"Select/Add Provider",
    "LABEL_WEB_SERVICE_CHANGE_PROVIDER":"Change Provider",
    "LABEL_WEB_SERVICE_REST_USER_NAME":"User Name",
    "LABEL_WEB_SERVICE_REST_PASSWORD":"Password",
    "LABEL_WEB_SERVICE_WSDL_USER_NAME":"HTTP Basic Auth Username",
    "LABEL_WEB_SERVICE_WSDL_PASSWORD":"HTTP Basic Auth Password",
    "LABEL_WEB_SERVICE_WSDL_CONNECTION_TIMEOUT": "Connection Timeout (milliseconds)",
    "LABEL_WEB_SERVICE_WSDL_REQUEST_TIMEOUT": "Request Timeout (milliseconds)",
    "LABEL_WEB_SERVICE_WSDL_ENDPOINT_ADDRESS": "Endpoint Address",
    "LABEL_WEB_SERVICE_REST_RESPONSE":"Response",
    "LABEL_WEB_SERVICE_REST_TEST":"Test",
    "LABEL_SAMPLE_RESPONSE":"Sample Response",
    "LABEL_SELECT_RESPONSE_FORMAT":"Select message as sample response format",
    "LABEL_TEST_SERVICE":"Test Service",
    "LABEL_CONFIGURE_SERVICE":"Configure Service",
    "LABEL_ACCESS_TOKEN_URL":"Access Token URL",
    "LABEL_AUTHORIZATION_URL":"Authorization URL",
    "LABEL_FLOW": "Flow",
    "LABEL_PKCE_SUPPORTED": "Use PKCE?",
    "LABEL_CODE_CHALLENGE_METHOD": "Code Challenge Method",
    "LABEL_CLIENT_ID":"Client ID",
    "LABEL_CLIENT_SECRET":"Client Secret",
    "LABEL_STEP":"Step",
    "LABEL_OF":"of",
    "LABEL_NEW":"New",
    "LABEL_SCOPES":"Scopes",
    "LABEL_SCOPE":"Scope",
    "LABEL_SCOPE_KEY": "Scope Key",
    "LABEL_SCOPE_VALUE": "Scope Value",
    "LABEL_ENTER_KEY": "Enter Key",
    "LABEL_ENTER_VALUE": "Enter Value",
    "LABEL_PROPERTY_ADDPROPERTY":"Add Property",
    "LABEL_RE_IMPORT_APIS": "Re-import API",
    "LABEL_REQUEST_BODY": "RequestBody",
    "PLACEHOLDER_AUTHORIZATION_URL":"Enter Authorization URL",
    "PLACEHOLDER_ACCESS_TOKEN_URL": "Enter AccessToken URL",
    "PLACEHOLDER_CLIENT_ID":"Enter Client ID",
    "PLACEHOLDER_CLIENT_SECRET": "Enter Client Secret",
    "PLACEHOLDER_SELECT_VALUE": "Select value",
    "PLACEHOLDER_ENTER_PROVIDER_ID": "Enter Provider ID",
    "google": "Google",
    "facebook": "Facebook",
    "linkedin": "LinkedIn",
    "LABEL_GRID_ACTION_NEW": "This action will create a New button at the bottom of the table to add an empty record",
    "LABEL_GRID_ACTION_UPDATEROW": "This action will  add an edit action for each row  in the last column to edit the selected row",
    "LABEL_GRID_ACTION_DELETEROW": "This action will add a delete action for each row  in the last column to delete the selected row",
    "LABEL_ACTION_SAVE": "Save button will be added to the form which will allow user to save the record in the database in edit mode",
    "LABEL_ACTION_RESET": "When checked, a Reset button will be added to the form which will allow user to reset the user entries.",
    "LABEL_ACTION_CANCEL": "When checked, a Cancel button will be added to the form which will allow user to cancel the edit and go back to view mode.",
    "LABEL_ACTION_EDIT": "When checked, an Edit button will be added to the form which will allow user to edit the record in view mode.",
    "LABEL_ACTION_NEW": "When checked, a New button will be added to the form at the bottom which will allow user to add a record in view mode.",
    "LABEL_ACTION_DELETE": "When checked, a Delete button will be added to the form which will allow user to  delete the record  in view mode",
    "LABEL_ACTION_FILTER": "Filter button added to the Live Filter will filter the records based on the input value given by the user that can be bound to a Component like chart",
    "LABEL_ACTION_CLEAR": "A Clear button will be added to the Live Filter. This action will clear the user inputs for filter.",
    "LABEL_LOCALE": "Locale",
    "MESSAGE_APP_MESSAGES_DIALOG_ADDTOLIST": "Add the newly created message to list",
    "MESSAGE_APP_MESSAGES_DIALOG_PREFAB_MESSAGE": "This is a prefab message and is only editable.",
    "MESSAGE_APP_MESSAGES_DIALOG_SYSTEM_MESSAGE": "This is a system message and is only editable.",
    "MESSAGE_APP_MESSAGES_DIALOG_DELETE_MESSAGE": "Delete this message",
    "MESSAGE_APP_MESSAGES_DIALOG_ADDNEW_MESSAGE": "Add new message",
    "MESSAGE_APP_MESSAGES_DIALOG_ADDNEW_SUCCESS": "Message Added Successfully!",
    "MESSAGE_APP_MESSAGES_DIALOG_ADD_UNSTABLE_ERROR": "Add/discard the new message to edit the existing message",
    "PREPARING_MESSAGES" : "Preparing messages...",
    "LABEL_EMPTY_PREFAB_LIST_SCREEN": "No prefabs found",
    "LABEL_EMPTY_PREFAB_MESSAGES_SCREEN": "The selected prefab does not include any modified system messages or user messages",
    "LABEL_APP_MESSAGES": "Localized Messages",
    "LABEL_APP_I18N": "I18N",
    "LABEL_APP_MESSAGES_TOOLTIP": "Create,View,Delete Localized Messages",
    "LABEL_LANG_ENGLISH": "English",
    "LABEL_APP_MESSAGE_KEY": "Message Key",
    "LABEL_APP_ADD_LANGUAGES": "Add Languages",
    "LABEL_APP_SELECTED_LANGUAGE": "Selected Language",
    "LABEL_ALREADY_EXISTS": "Already Exists",
    "LABEL_APP_MESSAGE_ERROR_EMPTY": "Cannot be Empty",
    "LABEL_APP_DEFAULT_MESSAGE_VALUE": "Message Value",
    "LABEL_APP_MESSAGES_DIALOG_TITLE": "Localized Messages",
    "LABEL_APP_MESSAGES_LANGUAGES_TITLE": "Languages",
    "LABEL_LOCALIZED_MESSAGE": "Localized Message",
    "MESSAGE_ERROR_NO_SELECTED_OAUTH_PROVIDER": "Please Select OAuth Provider!",
    "MESSAGE_ERROR_CONTENT_DISPLAY": "Can not load insecure content for url: ",
    "MESSAGE_ERROR_DATA_DISPLAY": "Cannot load data in design mode for ",
    "MESSAGE_RE_IMPORT_APIS": "You are re-importing existing API service '${0}'. Enter the new swagger URL or file to procced.",
    "MESSAGE_APP_MESSAGES_SAVE_SUCCESS_TITLE": "Save Success",
    "MESSAGE_APP_MESSAGES_SAVE_ERROR_TITLE": "Save Error",
    "MESSAGE_APP_MESSAGES_SAVE_SUCCESS_DESC": "Application Locale files saved successfully.",
    "MESSAGE_APP_MESSAGES_SAVE_ERROR_DESC": "Unable to save. Please try again!.",
    "COMMENT_DATA_SERVICE_MESSAGES":"-----------Database Service Message Resources----------",
    "MESSAGE_SUCCESS_SAMPLE_DATABASE_IMPORT_DESC":"Sample database imported successfully.",
    "MESSAGE_ERROR_SAMPLE_DATABASE_IMPORT_DESC":"Error in importing sample database",
    "MESSAGE_TEST_DATABASE_CONNECTION":"Connecting to database",
    "MESSAGE_CONNECTION_SUCCESSFUL":"Connection successful.",
    "MESSAGE_CONNECTING":"Connecting...",
    "MESSAGE_ERROR_TEST_DATABASE_CONNECTION_DESC":"Error in connecting to database.",
    "MESSAGE_ERROR_TEST_DATAMODEL_CONNECTION_DESC": "Error in connecting to the Meta Data Service",
    "MESSAGE_SUCCESS_IMPORT_DATABASE_DESC":"Database imported successfully.",
    "MESSAGE_ERROR_IMPORT_DATABASE_DESC":"Error in importing database",
    "MESSAGE_SUCCESS_CREATE_DATAMODEL": "DataModel created successfully",
    "MESSAGE_SUCCESS_IMPORT_DATAMODEL": "DataModel imported successfully",
    "MESSAGE_SUCCESS_REIMPORT_DATABASE_DESC":"Database re-imported successfully.",
    "MESSAGE_SUCCESS_REIMPORT_DATAMODEL_DESC":"DataModel re-imported successfully.",
    "MESSAGE_SUCCESS_REVERT_DATAMODEL_DESC":"DataModel reverted successfully.",
    "MESSAGE_SUCCESS_REFRESHED_MODEL_DESIGNER": "DataModel refreshed successfully.",
    "MESSAGE_ERROR_REIMPORT_DATABASE_DESC":"Error in re-importing database.",
    "MESSAGE_PROGRESS_CODEGEN_DATABASE_DESC":"Please wait while sources re-generation is in progress.",
    "MESSAGE_PROGRESS_PREFAB_UPGRADE":"Please wait while prefab update is in progress.",
    "MESSAGE_PROGRESS_THEME_UPGRADE":"Please wait while theme update is in progress.",
    "MESSAGE_ERROR_CODEGEN_DATABASE_DESC":"Sources re-generation failed.",
    "MESSAGE_CODEGEN_RE_GENERATION_SUCCESS":"Sources re-generated successfully.",
    "MESSAGE_WARNING_EXPORT_DATABASE": "Ensure that the database does not exists in the target database provider. If the database exists it should be empty else the export might fail.",
    "MESSAGE_SUCCESS_EXPORT_DATABASE_DESC":"Database exported successfully.",
    "MESSAGE_ERROR_EXPORT_DATABASE_DESC":"Error in exporting database.",
    "MESSAGE_SUCCESS_CREATE_DATABASE_DESC":"Database created successfully.",
    "MESSAGE_SUCCESS_CREATE_TABLE_DESC":"Table created successfully.",
    "MESSAGE_SUCCESS_SAVE_DATABASE_DESC":"Database schema saved. Click on \"Update DB\" to update the database with the schema changes.",
    "MESSAGE_SUCCESS_APPLY_DATABASE_DESC":"Database updated successfully.",
    "MESSAGE_SUCCESS_SAVE_MODEL_DESC":"DataModel schema saved. Click on \"Update Model\" to update the Model with the schema changes.",
    "MESSAGE_SUCCESS_APPLY_MODEL_DESC":"DataModel updated successfully.",
    "MESSAGE_ERROR_DATAMODEL_PRECISION_NOT_ALLOWED":"Precision cannot be greater than ${0}.",
    "MESSAGE_ERROR_SAVE_DATABASE_DESC":"Error in saving database schema.",
    "MESSAGE_ERROR_SAVE_MODEL_DESC":"Error in saving Model schema",
    "MESSAGE_ERROR_APPLY_DATABASE_DESC":"Error in exporting database schema",
    "MESSAGE_ERROR_EXPORT_EMPTY_DATABASE_DESC":"Unable to export empty database",
    "MESSAGE_SUCCESS_DELETE_OBJECT_DESC":"${0}-\"${1}\" deleted successfully.",
    "MESSAGE_ERROR_ENTER_REQUIRED_FIELDS":"Please enter all the mandatory fields.",
    "MESSAGE_ERROR_ENTER_ALL_FIELDS":"Please enter all the fields.",
    "MESSAGE_ERROR_NEWID_FIELDS":"Unique id should have 'javatype' as string and length must be  >= 128 characters.",
    "MESSAGE_ERROR_DUPLICATE_FIELDS":"Please provide unique names.",
    "MESSAGE_ERROR_ATTRIBUTE_NAME_LENGTH": "Attribute name should be less than 48 characters.",
    "MESSAGE_ERROR_DUPLICATE_PATH_FIELDS":"Path Entry with this name already exists, try with different name",
    "MESSAGE_ERROR_INVALID_NAME": "Please provide valid name",
    "MESSAGE_ERROR_INVALID_PATH":"Path cannot be empty.",
    "MESSAGE_ERROR_INVALID_ORIGIN":"Allowed origins cannot be empty.",
    "MESSAGE_ERROR_INVALID_NAMES":"Names can only contain alphanumerics and underscore.",
    "MESSAGE_ERROR_INVALID_COLUMN_TYPE": "Columns cannot have SQL or Java types as 'unknown'. Please provide valid types.",
    "MESSAGE_ERROR_NO_PK_COLUMNS": "Please provide columns for virtual primary key",
    "MESSAGE_ERROR_NOTHING_TO_SAVE":"No changes detected.",
    "MESSAGE_INFO_NO_CHANGES_DETECTED":"No changes detected.",
    "MESSAGE_SUCCESS_UPDATE_PROJECT_PAGES_DESC":"Project pages fetched successfully.",
    "MESSAGE_ERROR_UPDATE_PROJECT_PAGES_DESC":"Error in fetching project pages.",
    "MESSAGE_SUCCESS_FETCH_TABLE_NAMES_DESC":"Table names fetched successfully.",
    "MESSAGE_ERROR_FETCH_TABLE_NAMES_DESC":"Error in fetching table names.",
    "MESSAGE_ERROR_FETCH_CONNECTION_SETTINGS_DESC":"Error in fetching connection settings.",
    "MESSAGE_SUCCESS_SAVE_CONNECTION_SETTINGS_DESC":"Connection settings saved successfully.",
    "MESSAGE_ERROR_SAVE_CONNECTION_SETTINGS_DESC":"Error in saving connection settings.",
    "MESSAGE_SUCCESS_SAVE_QUERY_DESC": "Query saved successfully.",
    "MESSAGE_SUCCESS_SAVE_PROCEDURE_DESC": "Procedure saved successfully.",
    "MESSAGE_SUCCESS_NEW_QUERY_NEW_PROCEDURE": "Please create a variable for this ${0}.",
    "MESSAGE_ERROR_RUN_QUERY_DESC": "Error in fetching query results.",
    "MESSAGE_ERROR_IN_COUNT_QUERY_GENERATION": "Count query doesn't generated properly. Please re-check the executed query.",
    "MESSAGE_ERROR_OUTPARAMS_BLOB":"Only one OUT param is allowed in case of procedure response is of BLOB type",
    "MESSAGE_ERROR_EXECUTE_PROCEDURE_DESC": "Error in executing procedure.",
    "MESSAGE_ERROR_NO_QUERY_DESC": "Please enter a query to run/save.",
    "MESSAGE_ERROR_INVALID_NATIVE_QUERY": "Please check the syntax of the native query.",
    "MESSAGE_ERROR_PROVIDE_TEST_VALUES": "Please provide valid test values for parameters.",
    "MESSAGE_ERROR_PROVIDE_VALID_VALUES": "Please provide test values that matches the selected parameter type.",
    "MESSAGE_ERROR_INVALID_QUERY_DESC": "Error in query.",
    "MESSAGE_ERROR_INVALID_QUERY_NAME": "Query with this name already exists. ",
    "MESSAGE_ERROR_INVALID_PROCEDURE": "Please check the syntax for procedure.",
    "MESSAGE_ERROR_INVALID_PROCEDURE_NAME": "Procedure with this name already exists. ",
    "MESSAGE_ERROR_INVALID_PROCEDURE_DESC": "Error in procedure.",
    "MESSAGE_SUCCESS_QUERY_EXECUTE":"Query executed successfully.",
    "MESSAGE_SUCCESS_PROCEDURE_INVOKE":"Procedure invoked successfully.",
    "MESSAGE_ERROR_INVALID_PROCEDURE_LIST": "Failed to get procedures list from database.",
    "MESSAGE_DATA_NOT_FOUND_RUN_QUERY":"No data found. Please run the query.",
    "MESSAGE_DATA_NOT_FOUND_RUN_PROCEDURE":"No data found. Please execute the procedure.",
    "MESSAGE_DATA_NOT_FOUND_RUN_QUERY_AGAIN":"No data found. Please run a query returning atleast one record to save the query.",
    "MESSAGE_DATA_NO_ALIASES_FOUND":"The returned data doesn't have name so you will not be able to use bindings for this query. Provide alias to aggregate function so that it returns response with given alias name. ",
    "MESSAGE_ERROR_NO_PARAMETER_VALUES":"Test values are required during Test Run. Please enter valid values for the parameters.",
    "MESSAGE_NO_DATA_FOUND": "No data found.",
    "MESSAGE_NO_DATA_RETURNED": "No data returned.",
    "MESSAGE_NO_HEADER_PARAM_FOUND": "No header param found.",
    "MESSAGE_NO_QUERY_PARAM_FOUND": "No query param found.",
    "MESSAGE_NO_PATH_PARAM_FOUND": "No path param found. A path param is used against certain entity of the URL that is required to change dynamically. A path param can be set by enclosing an entity in the URL in a curly bracket \"{}\".<br/>e.g. For URL \"http:wavemaker.com/projects/{pid}/?mode=json\", \"pid\" is the path param. ",
    "MESSAGE_ERROR_RELATION_NONMATCHING_COLUMN_TYPES":"Relation cannot be created as the column types do not match.",
    "MESSAGE_ERROR_RELATION_NONKEY_COLUMN":"Relation cannot be created as \"${0}\" in \"${1}\" is not a primary key.",
    "MESSAGE_ERROR_HARD_RELATION_COLUMN":"Hard Relation cannot be created as \"${0}\" in \"${1}\" is a virtual primary key.",
    "MESSAGE_ERROR_RELATION_NON_UNIQUE_KEY_COLUMN":"Relation cannot be created as \"${1}\" does not have a primary key.",
    "MESSAGE_ERROR_RELATION_BOTH_KEY_COLUMNS":"Relation cannot be created as both the selected columns are primary keys.",
    "MESSAGE_ERROR_RELATION_UNIQUE_KEY_COLUMN":"One to Many relation cannot be created for the unique key column.",
    "MESSAGE_ERROR_FETCH_WEB_DATA_SERVICES_DESC":"Error in fetching available web/data services",
    "MESSAGE_ERROR_LIST_TYPES_DESC":"Error occurred while fetching types",
    "MESSAGE_ERROR_FETCH_SERVICE_BINDING_PROPERTIES_DESC":"Error occurred while fetching binding properties for service",
    "MESSAGE_SUCCESS_FETCH_TABLE_DATA_DESC":"Table data read successfully.",
    "MESSAGE_ERROR_FETCH_TABLE_DATA_DESC":"Error in reading table data.",
    "MESSAGE_ERROR_FETCH_DB_METADATA_DESC":"Error in reading database details.",
    "MESSAGE_SUCCESS_FILE_WRITE_DESC":"File write successful.",
    "MESSAGE_ERROR_FILE_READ_DESC":"Error while reading from file.",
    "MESSAGE_ERROR_FILE_WRITE_DESC":"Error while writing to file.",
    "MESSAGE_ERROR_FETCH_SERVICE":"Error occurred while fetching issues for '${0}' service",
    "MESSAGE_SUCCESS_CONFIGFILE_WRITE_DESC":"Successfully updated the config.json with new prefab name.",
    "MESSAGE_ERROR_CONFIGFILE_WRITE_DESC":"Error in updating the config.json file.",
    "MESSAGE_SUCCESS_SCRIPTFILE_WRITE_DESC":"Successfully updated the script file with new prefab name.",
    "MESSAGE_ERROR_SCRIPTFILE_WRITE_DESC":"Error in updating the script file.",
    "MESSAGE_ERROR_CONTROLLER_NAME_DESC":"The new prefab name and the controller name are different.",
    "MESSAGE_SUCCESS_SERVICE_BINDING_UPDATE_DESC":"Successfully updated the bindings for service",
    "MESSAGE_ERROR_SERVICE_BINDING_UPDATE_DESC":"Error occurred while updating binding properties for service",
    "MESSAGE_PROVIDE_USERNAME_PASSWORD_BOTH":"Please provide username and password both or provide none",
    "MESSAGE_ERROR_DATABASENAME_ALREADY_EXISTS":"Database already exists with the given name.",
    "MESSAGE_ERROR_ENTER_DATABASENAME":"Please enter database name.",
    "MESSAGE_ERROR_ENTER_VALID_DATAMODELNAME":"Please enter valid schema name.",
    "MESSAGE_ERROR_ENTER_VALID_DATAMODELREGION": "Please select any region",
    "MESSAGE_ERROR_ENTER_VALID_DATAMODELSCOPE": "Please select scope",
    "MESSAGE_ERROR_ENTER_VALID_DATAMODEL_NEW_REGION": "Please enter region name",
    "MESSAGE_ERROR_ENTER_DATAMODELNAME":"Please enter schema name.",
    "MESSAGE_ERROR_SELECT_DATABASENAME":"Please select database",
    "MESSAGE_ERROR_INVALID_DATABASENAME_ALL_NUMERIC":"The data-model name contains all numerals. Please try with a different value.",
    "MESSAGE_ERROR_INVALID_DATAMODELNAME_ALL_NUMERIC":"The data-model name contains all numerals. Please try with a different value.",
    "MESSAGE_ERROR_INVALID_DATABASENAME_INVALID":"The data-model name can only contain alphanumerics and underscore. Please try with a different value.",
    "MESSAGE_EVENT_NAME_PATTERN":"Name of the event(lowercase alphanumerics only)",
    "MESSAGE_EVENT_DISPLAY_NAME":"Display Name of the event",
    "MESSAGE_ERROR_ENTER_SID":"Please enter SID(Service id).",
    "MESSAGE_ERROR_ENTER_HOST":"Please enter host name.",
    "MESSAGE_ERROR_ENTER_PORT":"Please enter a valid number for port.",
    "MESSAGE_ERROR_ENTER_FILENAME":"Please enter file name.",
    "MESSAGE_ERROR_ENTER_USERNAME":"Please enter user name.",
    "MESSAGE_ERROR_ENTER_SCHEMANAME":"Please enter schema name.",
    "MESSAGE_ERROR_ENTER_SERVICEID":"Please enter service name.",
    "MESSAGE_ERROR_ENTER_QUERY_NAME":"Please enter query name.",
    "MESSAGE_ERROR_ENTER_QUERY_COMMENT":"Please enter query description.",
    "MESSAGE_ERROR_ENTER_QUERY_IDENTIFIERS":"Please select atleast one identifier",
    "MESSAGE_ERROR_ENTER_PROCEDURE_NAME": "Please enter procedure name",
    "MESSAGE_ERROR_ENTER_PROCEDURE_COMMENT": "Please enter procedure description",
    "MESSAGE_ERROR_ENTER_QUERY":"Please enter a valid query.",
    "MESSAGE_ERROR_PARAM_NAME_CLASH":"Reserved keyword, please use a different name",
    "MESSAGE_ERROR_INVALID_QUERY_IDENTIFIER_NAME":"Please enter a valid query name. Query name must be a valid Java identifier",
    "MESSAGE_ERROR_INVALID_PROCEDURE_IDENTIFIER_NAME":"Please enter a valid procedure name. Procedure name must be a valid Java identifier",
    "MESSAGE_ERROR_ENTER_PROCEDURE":"Please enter a valid procedure",
    "MESSAGE_ERROR_SECURITY_METHODS":"Error occurred while fetching operations for Security service.",
    "MESSAGE_COPY_PROJECT":"Copying Project..",
    "MESSAGE_IMPORT_PROJECT":"Importing Project..",
    "MESSAGE_RESTORE_PROJECT":"Restoring Project..",
    "MESSAGE_DELETE_MESSAGE_PROJECT" : "Deleting Project...",
    "MESSAGE_FINISH_UPGRADE_MESSAGE_PROJECT" : "Finishing Project Upgrade...",
    "MESSAGE_UPGRADE_MESSAGE_PROJECT" : "Creating Project Version...",
    "MESSAGE_LEAVE_MESSAGE_PROJECT" : "Leaving Project...",
    "MESSAGE_IMPORT_DATABASE":"Importing database..",
    "MESSAGE_EXPORT_DATABASE":"Exporting database...",
    "MESSAGE_IMPORT_RESOURCE":"Importing file...",
    "MESSAGE_CREATE_DATAMODEL":"Creating datamodel...",
    "MESSAGE_IMPORT_WEBSERVICE":"Importing Web Service...",
    "MESSAGE_SERVICE_INFO_LOADING": "Loading Service Info...",
    "MESSAGE_UPDATING_WEBSERVICE":"Updating Web Service...",
    "MESSAGE_WEB_SERVICE_TEST":"Testing Rest Service...",
    "MESSAGE_WEB_SERVICE_POPULATE":"Populating Rest Service...",
    "MESSAGE_SAVE_VARIABLE":"Saving variables...",
    "MESSAGE_CREATE_PAGE":"Creating page...",
    "MESSAGE_WARNING_DB_FIELD_UPDATE":"This change might result in data loss on exporting the datamodel",
    "MESSAGE_WARNING_MULTIPLE_PAGINATION":"Query returns single record.",
    "MESSAGE_WARNING_SINGLE_PAGINATION":"Single record option has been selected but the Query returns multiple records. ",
    "MESSAGE_WARNING_BLOB_FOR_HQL":"Query is returning blob, which is not supported right now, remove blob type column or use nativeSql",
    "MESSAGE_REVERT_CHANGE":"Revert Change",
    "MESSAGE_LOADING": "Loading ...",
    "LABEL_VARIABLE_SELECT_QUERY": "Select Query",
    "LABEL_VARIABLE_SELECT_PROCEDURE": "Select Procedure",
    "LABEL_FONT_SIZE": "Font Size",
    "LABEL_LIST":"List",
    "LABEL_TEST_VALUE":"Test Value",
    "LABEL_PARAM_TYPE":"Param Type",
    "LABEL_VALUE_TYPE":"Value Type",
    "LABEL_SERVER_SIDE_PROPERTIES": "Server Side Properties",
    "LABEL_SELECT_DATABASE": "Select Database",
    "LABEL_SELECT_DATAMODEL": "Select Data Model",
    "LABEL_IMPORT_DRIVER": "Import Driver",
    "LABEL_HINT_HOW_TO_IMPORT_DRIVER":"How to",
    "LABEL_HINT_IMPORT_DRIVER":"the driver",
    "LABEL_DRIVER_JAR": "Driver Jar",
    "LABEL_SKIP_JAR": "Skip to use an existing jar",
    "LABEL_CONFIGURE_SETTINGS": "Configure Settings",
    "LABEL_SELECT_TABLES": "Select Tables",
    "LABEL_CONFIGURE_MAPPING_SEQUENCES": "Map Sequences(Optional)",
    "LABEL_CONFIGURE_MAPPING_VIRTUAL_PK": "Virtual PrimaryKeys",
    "LABEL_CONFIGURE_ENTITY_VARIABLES": "CONFIGURE VARIABLES",
    "LABEL_DATABASE_VERSIONS": "Database Versions",
    "LABEL_RECOMMENDED_DRIVER_VERSION": "Recommended Driver Version",
  "LABEL_DRIVER_VERSION": "Driver Version",
    "LABEL_CHOOSE_FILE": "Choose file",
    "LABEL_CHOOSE_PNG_FILE": "Choose PNG file",
    "MESSAGE_ERROR_SELECT_DATABASE_VERSION": "Please select the database version.",
    "MESSAGE_UPLOADING_JAR": "Uploading jar...",
    "MESSAGE_IMPORT_DRIVER": "The selected database requires the JDBC driver for connecting to the database. JDBC driver implements the protocol for transferring the query and result between application and database.",
    "MESSAGE_SELECT_DATABASE_VERSION": "Select the appropriate database version and import the required driver.",
    "MESSAGE_TEST_CONNECTION_TO_PROCEED": "Test connection to proceed",
    "MESSAGE_ERROR_DATAMODEL_ALREADY_EXISTS": "DataModel already exists",
    "MESSAGE_ERROR_DATABASE_ALREADY_EXISTS": "Cannot create database as it already exists in the selected database provider. Import the database to work with it.",
    "MESSAGE_ERROR_DATABASE_NAME_LOWER_CASE": "Database name should consists only lower case letters.",
    "MESSAGE_SELECT_DESIRED_ENTITIES": "Select the tables you want to import. ",
    "MESSAGE_SELECT_DEFAULT_GENERATOR_VALUE": "Select Default Sequence name for all the tables",
    "MESSAGE_SELECT_TABLE_GENERATOR_VALUE": "Based on the selected tables, we have identified few of these tables may require generator sequence mapping. Map the tables with the generator types and provide Sequence names if required. This is an ",
    "MESSAGE_OPTIONAL_STEP": "OPTIONAL ",
    "MESSAGE_SELECT_TABLE_VIRTUAL_PRIMARYKEY_1": "Listed Tables/Views do not have a primary key.",
    "MESSAGE_SELECT_TABLE_VIRTUAL_PRIMARYKEY_2": "Please select at least one column to be assigned as a Virtual Primary Key per Table/View",
    "MESSAGE_SELECT_TABLE_VIRTUAL_PRIMARYKEY_3": "such that there are no duplicate values.",
    "MESSAGE_SELECT_TABLE_VIRTUAL_PRIMARYKEY_NOTE": "Note: The Virtual Primary Key assignment will not impact the Database.",
    "MESSAGE_NO_OF_ENTITIES_SELECTED": "Total Selected tables: ",
    "MESSAGE_OUT_OF": " out of ",
    "MESSAGE_HELP_AUTO_SELECT_REFERENCED_ENTITIES": "Selecting a table automatically selects it's referenced tables if it has any.",
    "ERROR_MESSAGE_DUPLICATE_ENTITIES":"Please select tables with unique names.",
    "LABEL_SELECT_SCHEMA": "Default Schema Name:",
    "LABEL_TABLE_NAME":"Table Name",
    "LABEL_TABLE_OR_VIEW_NAME": "Table/View Name",
    "LABEL_SEQUENCE_MAPPING":"Sequence Mapping",
    "LABEL_GENERATOR_TYPE":"Generator Type",
    "LABEL_PRIMARY_COLUMN": "Primary Column",
    "LABEL_SCHEMA_NAME":"Schema Name",
    "LABEL_DATABASE_COLUMN": "COLUMN",
    "LABEL_DATABASE_TABLE": "TABLE" ,
    "LABEL_CREATE_RELATIONSHIP":"Create Relationship",
    "LABEL_VIRTUAL_RELATIONSHIP": "Virtual Relationship",
    "LABEL_SOURCETABLE":"Source Table",
    "LABEL_TARGETTABLE":"Target Table",
    "LABEL_ADD_RELATIONSHIP": "Add Relationship",
    "MESSAGE_ADD_RELATIONSHIP": "(This creates a composite relationship)",
    "MESSAGE_ERROR_MISMATCH_COLUMNS": "Please provide appropriate values to create a relation",
    "LABEL_PREVIEW_CHANGES": "Preview Changes",
    "LABEL_SCHEMA_CHANGES": "Schema Changes",
    "LABEL_CHANGES_MESSAGE": "Following are the changes in the Database.",
    "LABEL_SCRIPTS_MESSAGE": "Following are the scripts generated for the changes in the Database.",
    "LABEL_DB_SCRIPT": "DB Script",
    "LABEL_ADDED": "Added",
    "LABEL_CONFLICTED": "Conflicted",
    "LABEL_DELETED": "Deleted",
    "LABEL_CHANGES": "Changes",
    "LABEL_STATUS": "Status",
    "LABEL_MODIFIED": "Modified",
    "LABEL_TABLE_REFERENCES": "References",
    "LABEL_VARIABLE_NAME": "Variable Name",
    "LABEL_FILTER_TABLE_NAME": "Filter",
    "LABEL_FIELD":"Field",
    "LABEL_SCRIPT":"Script",
    "MESSAGE_HELP_ENTITIES_FILTER_NAME": "Filter the entities list with a table name",
    "LABEL_VARIABLE_PREFIX": "Variable Prefix",
    "MESSAGE_VARIABLE_PREFIX": "Enter the desired prefix for variables",
    "MESSAGE_HELP_DATABASE_SCHEMA_FILTER": "Select a schema to filter the entities",
    "LABEL_HELP_RELATIONSHIP": "Relationship",
    "LABEL_SELECTED_VIRTUAL_PRIMARY_KEY": "Selected Virtual Primary Keys",
    "MESSAGE_HELP_TEST_DB_CONNECTION": "Test the connection to verify your database details",
    "MESSAGE_HELP_CONNECTING_DATABASE": "Connecting to Database",
    "MESSAGE_HELP_LOADING_SEQUENCES": "Loading Table metadata and sequences",
    "MESSAGE_HELP_LOADING_NO_PK_TABLES": "Loading Tables information ",
    "MESSAGE_HELP_JAR_CHECK": "Checking for Jar requirement",
    "MESSAGE_HELP_JAR_CHECK_FAILED": "Check for Jar requirement failed, Please try again.",
    "MESSAGE_HELP_TABLE_FILTER_NOT_FOUND": "No tables found in the database",
    "MESSAGE_HELP_NO_TABLES_FOUND": "No tables found",
    "MESSAGE_HELP_NO_TABLES_FOUND_FOR_SEQUENCE_MAPPING": "No tables found for Sequence Mapping, proceed to Import/Re-import",
    "MESSAGE_HELP_NO_TABLES_FOUND_FOR_VIRTUAL_KEY_MAPPING": "No tables found for Virtual key Mapping, proceed to Import/Re-import",
    "MESSAGE_HELP_DB_IMPORT_GENERATE_ENTITIES": "Reading & Generating Entities",
    "MESSAGE_HELP_DB_IMPORT_GENERATE_VARIABLES": "Generating Variables > ",
    "MESSAGE_HELP_DB_DESIGNER": "View & Modify the DB Schema of the imported database in our awesome Database Designer.",
    "LABEL_OPEN_DB_DESIGNER": "Open Database Designer",
    "MESSAGE_HELP_DB_WIDGETS": "A component is created for each imported entity. Simply drag and drop a DB Component to use it.",
    "MESSAGE_HELP_WIDGET_BINDING": "Create variables and use them by selecting a component and clicking on the BIND icon in the properties panel.",
    "LABEL_USE_DB_WIDGETS": "Use DB Components",
    "LABEL_RETRY": "Retry",
    "LABEL_SHOW_LOGS": "Show Logs",
    "MESSAGE_SUCCESS_DB_IMPORT": "Your Database is ready for use. Here are some cool things you can do with them.",
    "COMMENT_SERVICE_ERROR_MESSAGES":"-----------Service Error Message Resources----------",
    "COMMENT_HEADER_RESOURCES":"-----------Header Localization Resources----------",
    "LABEL_SAVED":"Saved",
    "LABEL_SYNC":"Saving..",
    "LABEL_BACK_TO_PROJECTS":"Back to projects",
    "LABEL_HEADER_ACTIONS":"Actions",
    "LABEL_HEADER_IMPORT":"Import",
    "LABEL_HEADER_IMPORT_TOOLTIP":"Import Resources",
     "LABEL_BUILD":"Build",
    "LABEL_EXPORT":"Export",
    "LABEL_EXPORT_PROJECT":"Export Project",
    "LABEL_JOBS":"Jobs",
    "LABEL_EMPTY_JOBS":"No Jobs",
    "LABEL_JOBS_IN_PROCESS":"In Process",
    "LABEL_JOBS_RECENT":"Recent",
    "TITLE_JOBS_POPUP": "Job Status",
    "LABEL_JOBS_INVALID_RESPONSE_MSG":"Invalid Job information",
    "LABEL_JOBS_TOOLTIP_DOWNLOAD":"Download the file",
    "LABEL_JOBS_TOOLTIP_OPEN_LINK":"Open the link",
    "LABEL_JOBS_TOOLTIP_DOWNLOAD_LOG":"Download the log",
    "LABEL_DOWNLOAD_AS_PDF": "DataModel as PDF",
    "LABEL_DOWNLOAD_AS_JSON": "DataModel as JSON",
    "LABEL_DOWNLOAD_AS_XSD": "DataModel as XSD",
    "LABEL_REIMPORT":"Re-import",
    "LABEL_PROJECT_SRC":"Update source",
    "MESSAGE_PROJECT_SRC":"Note: Updating the ${0} source will replace project content and you will lose all the local changes.",
    "LABEL_DELETE_DATABASE":"Delete Database",
    "LABEL_DELETE_DATAMODEL":"Delete Data Model",
    "LABEL_DELETE_DATAMODEL_IN_REMOTE": "Delete in remote server",
    "MESSAGE_DELETE_DATAMODEL_IN_REMOTE": "(Check the box below to delete datamodel on remote server)",
    "LABEL_DELETE_QUERY":"Delete Query",
    "LABEL_SAVE_QUERY": "Save Query",
    "LABEL_SAVE_PROCEDURE": "Save Procedure",
    "LABEL_DELETE_PROCEDURE":"Delete Procedure",
    "LABEL_DELETE_FOLDER":"Delete selected folder",
    "LABEL_ADD_NEW_FOLDER":"Add a new folder in selected folder",
    "LABEL_ADD_FOLDER": "Add folder",
    "LABEL_ADD_FOLDER_TITLE": "To create nested folders, separate names with a \"/\". E.g. \"com/hrdb/employee\"",
    "LABEL_PLACEHOLDER_ENTER_FOLDER_NAME": "Enter the folder name",
    "LABEL_HEADER_SETTINGS":"Settings",
    "LABEL_HEADER_ARTIFACTS":"Artifacts",
    "LABEL_OTHER_ARTIFACTS": "Other Artifacts",
    "LABEL_OTHER_ARTIFACTS_INFO": "Project Shells, Template Bundles and Themes",
    "LABEL_UPDATE_AVAILABLE": "Update available",
    "LABEL_PROJECT_PREFAB_DESC": "All prefabs in the project that are in use or not in use are listed below.",
    "LABEL_TEAM_PREFAB_DESC": "All approved prefabs in the team portal are listed below.",
    "LABEL_EDN_PREFAB_DESC": "All approved prefabs in the EDN portal are listed below.",
    "LABEL_SYSTEM_PREFAB_DESC": "All prefabs available by default by the platform are listed below.",
    "LABEL_PREFAB_VERSION_UPDATE_MSG": "1 Prefab has a new version update available.",
    "LABEL_PREFABS_VERSION_UPDATE_MSG": "${0} Prefabs have a new version update available.",
    "LABEL_NO_PROJECT_PREFAB_USED": "No published prefab is being used in this project.",
    "LABEL_NO_APPROVED_PREFAB": "No approved prefab was found.",
    "LABEL_NO_MARKETPLACE_PREFAB": "No marketplace prefab was found.",
    "LABEL_NO_SYSTEM_PREFAB": "No default prefab was found.",
    "LABEL_WORKSPACE_PREFAB_INFO_TEAM": "This is a workspace prefab. To view this prefab details please publish it to Team. Once your Team Admin approves this prefab you can view the prefab details here.",
    "LABEL_WORKSPACE_PREFAB_INFO_EDN": "This is a workspace prefab. To view this prefab details please publish it to EDN. Once your EDN Admin approves this prefab you can view the prefab details here.",
    "LABEL_HEADER_SETTINGS_TOOLTIP":"Edit Project Settings",
    "LABEL_APPLICATION_LOADER_TOOLTIP":"Skeleton loader is an animated placeholder that simulates the layout of a website while data is being loaded.",
    "LABEL_HEADER_FLOW":"Flow",
    "LABEL_HEADER_RUN":"Run",
    "LABEL_HEADER_EXECUTE": "Execute",
    "LABEL_TOOLTIP_RUN_QUERY": "Execute Query (Ctrl + Enter)",
    "LABEL_TOOLTIP_RUN_PROCEDURE": "Execute Procedure (Ctrl + Enter)",
    "LABEL_TOOLTIP_RUN": "Test-drive your App (Ctrl + Alt + R) or Run without toolbar (Ctrl + Alt + Q)",
    "LABEL_HEADER_DEPLOY":"Deploy",
    "LABEL_HEADER_DEPLOY_TOOLTIP":"Deploy your App (Ctrl + Alt + D)",
    "LABEL_HEADER_DEPLOYING_TOOLTIP":"Deploying App",
    "LABEL_HEADER_CHECKING_DEPLOY_TOOLTIP":"Checking Deployment Status",
    "LABEL_DEPLOY_MESSAGE":"Once Deployed, your app will be made public. Are you sure you want to deploy your App?",
    "LABEL_CONFIGURE_PUBLISH":"Publish all APIs to Team",
    "LABEL_DEPLOY_PROGRESS_HEADER": "Deploying ${0} App ${1} on ${2}",
    "LABEL_DEPLOY_PROGRESS_FIRST_AWS": "Initializing Instance and Configuring App Stack",
    "LABEL_DEPLOY_PROGRESS_FIRST_WM_CLOUD": "Provisioning Container",
    "LABEL_DEPLOY_PROGRESS_FIRST_AZURE": "Initializing the instance",
    "LABEL_DEPLOY_PROGRESS_SECOND_AWS": "Building ${0} App ${1} version ${2}",
    "LABEL_DEPLOY_PROGRESS_SECOND_WM_CLOUD": "Activating Container",
    "LABEL_DEPLOY_PROGRESS_SECOND_AZURE": "Configuring the application",
    "LABEL_DEPLOY_PROGRESS_THIRD": "Deploying ${0} App",
    "LABEL_DEPLOY_PROGRESS_FOURTH": "Deployed App Successfully",
    "LABEL_PUBLISH_APIS":"Publishing the API's",
    "LABEL_ENDPOINT_URL_EXISTS":"Endpoint with URL \"${0}\" and Method Type \"${1}\" already exists",
    "LABEL_OPERATION_METHOD_EXISTS":"Operation with method ${0} already exists",
    "LABEL_LAUNCH_APPLICATION":"View Deployed App",
    "LABEL_DEPLOYMENTS" : "Deployments",
    "LABEL_DEPLOYMENTS_MESSAGE" : "The Application deployments for the cloud provider can now be managed from the Deploy Apps portal. \"OK\"  will deploy the application in  WaveMaker Cloud Demo phase.",
    "LABEL_OPEN_LOGS":"Click here to open logs",
    "LABEL_DEPLOYMENT_LOGS":"Click here to view deployment logs",
    "LABEL_DEPLOYMENT_WRAPPER_LOGS":"Click here to view deployment wrapper logs",
    "LABEL_HEADER_LAUNCH_APPLICATION": "Launch Deployed App",
    "LABEL_MANAGE_APP": "Manage App",
    "LABEL_HEADER_PREFERENCES":"Preferences",
    "LABEL_HOME_PREFERENCES":"WaveMaker Home",
    "LABEL_HEADER_ALERTS":"Alerts",
    "LABEL_HEADER_MY_PROFILE":"My Profile",
    "LABEL_HEADER_USER_PROFILE":"profile",
    "LABEL_HEADER_RESEND_EMAIL_VERIFICATION":"Resend Email Verification",
    "MESSAGE_RESEND_EMAIL_SUCCESS":"Verification email sent successfully",
    "LABEL_HEADER_USER_LOGOUT":"Logout",
    "LABEL_ABOUT_STUDIO":"About Studio",
    "LABEL_HEADER_USERS":"Users",
    "LABEL_HEADER_ACCOUNT":"Account",
    "LABEL_HEADER_VALIDATE": "Validate",
    "MESSAGE_HEADER_USER_GREETING":"Hi",
    "COMMENT_HEADER_SERVICES_RESOURCES":"----------Header Services Localization Resources-----------",
    "LABEL_JAVA_SERVICE":"Java Service",
    "LABEL_FILE_SERVICE_INTIALIZATION":"Intializing File Service...",
    "LABEL_JAVA_SERVICE_TOOLTIP":"Create a new Java Service",
    "LABEL_SERVICES_QUERY":"Query",
    "LABEL_SERVICES_DESIGN_DATAMODEL":"Design Data Model",
    "LABEL_SERVICES_IMPORT_DATAMODEL":"Import Data Model",
    "LABEL_SERVICES_DESIGN_DATAMODEL_TOOLTIP":"Design a new DataModel",
    "LABEL_SERVICES_DESIGN_DATAMODEL_MESSAGE":"Connect your Apps with the database through components, without any code.",
    "LABEL_SERVICES_DESIGN_MODEL_MESSAGE":"Connect your Apps with the Data Model through components, without any code.",
    "LABEL_WEB_SERVICE":"Web Service",
    "LABEL_IMPORT_WEB_SERVICE":"Import Web Service",
    "LABEL_CONFIGURE_WEB_SERVICE":"Configure WebService",
    "LABEL_CONFIGURE_WEB_SOCKET":"Configure WebSocket",
    "LABEL_IMPORT_WEB_SOCKET_SERVICE":"Importing WebSocket Service...",
    "LABEL_UPDATING_WEB_SOCKET_SERVICE":"Updating WebSocket Service...",
    "LABEL_CONFIGURING_SOCKET_SERVICE":"Configuring Socket Service...",
    "LABEL_IMPORT_WEB_SERVICE_MESSAGE":"Bring the power of third party APIs into your applications.",
    "LABEL_WEB_SERVICE_TOOLTIP":"Import Web Service in your application",
    "LABEL_SECURITY_SERVICE":"Security Service",
    "LABEL_SERVICES_SECURITY":"Security",
    "COMMENT_HEADER_ACTIONS_RESOURCES":"----------Header Actions Localization Resources-----------",
    "LABEL_ACTIONS_INSERT_LIVE_VARIABLE":"Insert Live Variable",
    "LABEL_ACTIONS_IMPORT_PROJECT":"Import ${0}",
    "LABEL_ACTIONS_COPY_PROJECT":"Copy Project",
    "LABEL_ZIP_PROJECT":"Project Sources as Zip",
    "LABEL_ZIP_PROJECT_AS_ANGULAR":"Project as Angular ZIP",
    "LABEL_ZIP_PROJECT_AS_REACT":"Project as React ZIP",
    "LABEL_ZIP_CORDOVA":"Cordova Build As ZIP",
    "LABEL_EXPORT_ZIP_PROJECT":"Export Project Sources as Zip",
    "LABEL_AS_WEB_COMPONENT_PROJECT":"As WebComponent",
    "LABEL_WEB_COMPONENT_PROJECT":"Project as WebComponent",
    "LABEL_WAR_PROJECT":"Project as WAR",
    "LABEL_EXPORT_PROJECT_SUMMARY_REPORT_DIALOG_TEXT":"Successfully exported the project summary report to pdf file - ",
    "LABEL_EXPORT_PROJECT_SUMMARY_REPORT_PDF":"Export Project Summary Report As PDF",
    "LABEL_EXPORT_REPORTS":"Export Reports",
    "LABEL_SELECT_REPORT":"Select Report",
    "LABEL_DEPENDENCIES_REPORT": "Dependencies Report",
    "LABEL_PROJECT_SUMMARY_REPORT":"Project Summary Report",
    "LABEL_ZIP_REACTNATIVE":"ReactNative Build As ZIP",
    "LABEL_EXPORT_WAR_PROJECT":"Export Project As WAR",
    "LABEL_ZIP_PREFAB":"Prefab as ZIP",
    "LABEL_ZIP_TEMPLATEBUNDLE":"Template Bundle as ZIP",
    "LABEL_EXPORT_ZIP_PREFAB":"Export Prefab As ZIP",
    "LABEL_EXPORT_ZIP_TEMPLATEBUNDLE":"Export Template Bundle As ZIP",
    "LABEL_EXPORT_ZIP_CORDOVA":"Export Cordova Build As ZIP",
    "LABEL_ACTIONS_DELETE_PROJECT":"Delete ${0} - ${1}",
    "LABEL_ACTIONS_FINISH_UPGRADE_PROJECT":"Finish Upgrade",
    "LABEL_ACTIONS_EXPORT_PROJECT":"Export ${0}",
    "LABEL_ACTIONS_LEAVE_PROJECT":"Leave ${0}",
    "LABEL_ACTIONS_CLOSE_PROJECT": "Close Project",
    "COMMENT_HEADER_IMPORT_RESOURCES":"----------Header Import Localization Resources-----------",
    "LABEL_IMPORT_IMAGE":"Import Image",
    "LABEL_IMPORT_AUDIO":"Import Audio",
    "LABEL_IMPORT_VIDEO":"Import Video",
    "LABEL_IMPORT_FILE":"Import File",
    "LABEL_IMPORT_CONNECTOR":"Import Connector",
    "LABEL_IMPORT_RESOURCE":"Import Resource",
    "LABEL_IMPORT_RESOURCE_EXISTING_FILE_MESSAGE":"To work with an existing File, select it from the left side panel.",
    "LABEL_IMPORT_NEW_RESOURCE_MESSAGE":"To import new resources into the application, select the below import action.",
    "LABEL_IMPORT_JAR":"Import Jar",
    "LABEL_IMPORT_PREFAB":"Import Prefab",
    "LABEL_IMPORT_PREFAB_TOOLTIP":"Upload a Prefab .zip file",
    "LABEL_IMPORT_TEMPLATEBUNDLE":"Import Template Bundle",
    "LABEL_IMPORT_THEME":"Import Theme",
    "LABEL_INUSE":"In-Use",
  "LABEL_PROJECT_THEME":"Project Theme",
    "LABEL_IMPORT_TEMPLATE":"Import Template",
    "COMMENT_TREE_PANEL_RESOURCES":"--------Tree Panel Localization Resources-----------",
    "LABEL_FILES":"Files",
    "LABEL_PROJECT_FILES":"Project Resource Files",
    "LABEL_TEMPLATE":"Template",
    "LABEL_TEMPLATES":"Templates",
    "LABEL_DEVELOPMENT":"Development",
    "LABEL_DEPLOYMENT":"Deployment",
    "LABEL_AVAIL_SERVICES":"Avail WaveMaker Services",
    "LABEL_IMPORTED_SERVICES":"Imported Project Services",
    "LABEL_IMPORTED_APIS": "Imported APIs",
    "LABEL_IMPORT_APIS": "Import APIs",
    "LABEL_IMPORT_NEW_API": "Import a new API",
    "LABEL_SERVICES":"Services",
    "LABEL_API_DESIGNER":"API Designer",
    "LABEL_API_DESIGNER_MESSAGE":"Import third-party APIs and bind to components.",
    "LABEL_APIS":"APIs",
    "LABEL_SAVE_CHANGES":"Save changes",
    "LABEL_API_DESIGNER_TOOLTIP_TEAM":"View Project and Team published APIs",
    "LABEL_API_DESIGNER_TOOLTIP_EDN":"View Project and EDN published APIs",
    "MESSAGE_API_DESIGNER_SAVE_CHANGES":"There are unsaved changes in the \"${0}\" API, do you want to save them?",
    "MESSAGE_NO_METHODS": "No methods to show",
    "MESSAGE_ERROR_MULTIPLE_BODY_PARAM":"Body type parameters cannot be more than one.",
    "MESSAGE_ERROR_ENTER_VALID_URL":"Enter a valid URL.",
    "LABEL_PROJECT": "Project",
    "LABEL_SERVICE": "Service",
    "LABEL_PREFAB": "Prefab",
    "LABEL_TEMPLATEBUNDLE": "Template Bundle",
    "LABEL_JAR": "Jar",
    "LABEL_THEME": "Theme",
    "LABEL_SELECT_THEME": "Select Theme",
    "LABEL_IMAGE": "Image",
    "LABEL_PAGES_ADD_NEW":"New Page",
    "LABEL_TEMPLATE_SELECTION":"Template Selection",
    "LABEL_LAYOUT_SELECTION":"Layout Selection",
    "LABEL_DIALOG_HEADER_ADD_PAGE":"New Page",
    "LABEL_DIALOG_HEADER_ADD_TEMPLATE":"New Template",
    "LABEL_DIALOG_HEADER_WIDGET_CONFIG":"Component Configuration Wizard",
    "LABEL_RENAME": "Rename",
    "LABEL_DUPLICATE": "Duplicate",
    "LABEL_PAGE_DELETE": "Delete",
    "LABEL_OPTION":"Options",
    "LABEL_CONFIRM_DELETE_PROVIDER": "Delete Provider",
    "LABEL_INCORRECT_PROVIDER_ID": "Provider ID that consist only of letters, digits, and underscores, cannot begin with a digit, and is required to contain at least one letter.",
    "LABEL_CONFIRM_DELETE_PAGE":"Delete Page",
    "LABEL_CONFIRM_DELETE_PARTIAL_PAGE":"Delete Partial",
    "LABEL_CONFIRM_DELETE_TEMPLATE":"Delete Template",
    "LABEL_CONFIRM_RENAME_PAGE":"Rename Page",
    "LABEL_CONFIRM_RENAME_PARTIAL_PAGE":"Rename Partial",
    "LABEL_CONFIRM_RENAME_TEMPLATE":"Rename Template",
    "LABEL_CONFIRM_RENAME_PAGE_INFO":"Please note that the workspace will be refreshed on renaming the page.",
    "LABEL_CONFIRM_RENAME_MESSAGE":"Renaming...",
    "LABEL_CONFIRM_RENAME_SUCCESSFUL_MESSAGE":"Rename Successful",
    "LABEL_CONFIRM_RENAME_PAGE_PLACEHOLDER": "New Page Name",
    "LABEL_CONFIRM_DUPLICATE_PAGE":"Duplicate Page",
    "LABEL_CONFIRM_DUPLICATE_PARTIAL_PAGE":"Duplicate Partial",
    "LABEL_CONFIRM_DUPLICATE_TEMPLATE":"Duplicate Template",
    "LABEL_CONFIRM_DUPLICATE_MESSAGE":"Duplicating...",
    "LABEL_CONFIRM_DELETE_RESOURCE":"Delete Resource",
    "LABEL_CONFIRM_UNSAVED_CHANGES":"Unsaved Changes",
    "LABEL_BINDINGS":"Bindings",
    "LABEL_VARIABLES":"Variables",
    "LABEL_ACTIONS":"Actions",
    "LABEL_NO_PAGE_VARIABLES": "No Page Variables found",
    "LABEL_NO_APP_VARIABLES": "No Application Variables found",
    "LABEL_VARIABLES_TOOLTIP":"Create,View,Delete Variables",
    "LABEL_CREATE_VARIABLE":"Create Variable",
    "LABEL_CALL_VARIABLES_TOOLTIP":"Create,View,Delete Call Variables",
    "LABEL_NEW_VARIABLE":"New Variable",
    "LABEL_NEW_ACTION":"New Action",
    "LABEL_VARIABLE_ADD_NEW":"Add Variable",
    "LABEL_VARIABLE_ADD_CALL":"Add Call",
    "LABEL_SELECT_VARIABLE_ACTION": "Choose the type of action",
    "LABEL_SELECT_VARIABLE_SERVICE": "Choose the target action for Variable ",
    "LABEL_SECURITY":"Security",
    "LABEL_POLICY":"Policy",
    "LABEL_SELECT_POLICY":"Upload Policy file",
    "LABEL_REMOVE_HELP_TEXT":"Behavior when the tag-rule action is set to 'remove' for given tag. Tag is deleted with all of its child text.",
    "LABEL_VALIDATE_HELP_TEXT":"Behavior when the tag-rule action is set to 'validate' for given tag. Verify that its attributes and children elements follow rules defined in policy file.",
    "LABEL_FILTER_HELP_TEXT":"Behavior when the tag-rule action is set to 'filter' for given tag. Delete tag, but keep its child text.",
    "LABEL_TRUNCATE_HELP_TEXT":"Behavior when the tag-rule action is set to 'truncate' for given tag. Keep the element, but remove all attributes.",
    "MESSAGE_POLICY_FILE_NOT_SET": "Policy File is not chosen",
    "LABEL_UNKNOWN_TAG":"Unknown Tags",
    "LABEL_TAG_RULES":"Tag Rules",
    "LABEL_NAMES":"Names",
    "MESSAGE_DUPLICATE_TAGS": "Tag Name '${0}' already exists in ${1}",
    "LABEL_TAG_PLACEHOLDER":"Enter Tag Name",
    "LABEL_ROLE_CONFIGURATION":"Role Configuration",
    "LABEL_ROLE_COLUMN_MESSAGE":"Auto-generated role selection query",
    "LABEL_QUERY_TYPES_MESSAGE":"Note: Switching between query types, clears the query",
    "LABEL_ROLE_CUSTOM_CONFIGURATION":"Note: To edit the query, switch to Custom configuration",
    "LABEL_CAS_TEST_CONNECTION":"Note: Clicking on Test Connection will open a new window and redirect to cas login",
    "MESSAGE_CONNECTION_ERROR": "Connection Failed",
    "MESSAGE_CAS_FETCH_ROLE_MESSAGE": "Do Test Connection to fetch role attributes",
    "MESSAGE_TESTING_PROGRESS": "Testing in Progress",
    "LABEL_INVALID_QUERY": "Cannot generate role selection query. The '${0}' is referenced value from the table '${1}' Select Custom Configuration to define the query.",
    "LABEL_SECURITY_TOOLTIP":"Enable/Disable Authentication in your application",
    "LABEL_FILES_TREE_PAGES":"Pages",
    "LABEL_FILES_TREE_RESOURCES":"Resources",
    "LABEL_FILES_TREE_LIB":"Lib",
    "LABEL_FILES_TREE_SERVICES":"Services",
    "LABEL_COMPONENTS_TREE_VARIABLES":"Variables",
    "LABEL_TREE_PANEL_CLOSE":"Close Panel",
    "LABEL_TREE_PANEL_REFRESH_SERVICES":"Refresh Services Panel",
    "LABEL_TREE_PANEL_REFRESH_FILES":"Refresh Files Panel",
    "LABEL_TREE_PANEL_REFRESH_THEMES":"Refresh Themes Panel",
    "COMMENT_WORKSPACE_RESOURCES":"---------Workspace Localization Resources----------",
    "LABEL_WORKSPACE_DESIGN":"Design",
    "LABEL_WORKSPACE_FLOW":"FLOW",
    "LABEL_WORKSPACE_SCRIPT":"Script",
    "LABEL_WORKSPACE_STYLE":"Style",
    "LABEL_WORKSPACE_MARKUP":"Markup",
    "LABEL_WORKSPACE_VARIABLES":"VARIABLES",
    "LABEL_WORKSPACE_VIEW":"View",
    "LABEL_WORKSPACE_SELECT_VIEW":"Select view",
    "MESSAGE_VIEW_ADDITION_SUCCESS":"View added successfully",
    "LABEL_WORKSPACE_WEB_SERVICE_WSDL_FILE":"WSDL File",
    "LABEL_WORKSPACE_SOAP_SERVICE_REIMPORT":"Re-import Soap Service",
    "LABEL_WORKSPACE_JAVA_SERVICE":"Java Service",
    "LABEL_WORKSPACE_WEB_SERVICE_SETTINGS":"Service Settings",
    "LABEL_WORKSPACE_WEB_SERVICE_INFO":"Service Info",
    "LABEL_WORKSPACE_DATABASE_DESIGN":"Design",
    "LABEL_WORKSPACE_DATABASE_CONNECTION_SETTINGS":"Settings",
    "LABEL_WORKSPACE_DATABASE_QUERY":"Query",
    "LABEL_WORKSPACE_DATABASE_PROCEDURE":"Procedure",
    "LABEL_WORKSPACE_DATABASE_OFFLINE":"Offline",
    "LABEL_WORKSPACE_VERSION":"Workspace Version",
    "LABEL_API_BUNDLES":"API Bundles",
    "LABEL_REST_APIS":"Rest APIs",
    "LABEL_WEBSOCKET":"WebSocket",
    "LABEL_PROJECT_STATUS":"Status",
    "FILE_PATH":"File Path",
    "FOLDER_PATH": "Folder Path",
    "FILE_NAME":"File Name",
    "FOLDER_NAME":"Folder Name",
    "LABEL_DOWNLOAD":"Download",
    "LABEL_DOWNLOAD_MODEL_SCHEMA": "Download Data Model Schema",
    "LABEL_UPDATE_MODEL_TO_DOWNLOAD_SCHEMA": "Update Data Model to download the schema",
    "PREVIEW_NOT_AVAILABLE":"The preview is not available for the selected resource.",
    "ICONTITLE_CONST_LINE_SHOWHIDE":"Show/Hide table lines",
    "ICONTITLE_SHOW_HIDDENELEMENTS":"Show hidden components",
    "ICONTITLE_HIDE_HIDDENELEMENTS":"Hide hidden components",
    "ICONTITLE_NO_HIDDEN_WIDGETS" : "No hidden components",
    "ICONTITLE_PROPERTIES_EXPANDCOLLAPSE":"Expand/Collapse Property and Component Panels",
    "ICONTITLE_WORKSPACE_HIDE":"Hide",
    "ICONTITLE_WORKSPACE_LOCK":"Lock",
    "ICONTITLE_WORKSPACE_SAVE":"Save",
    "ICONTITLE_WORKSPACE_EDIT":"Edit",
    "ICONTITLE_DB_WORKSPACE_SAVE":"Save Database",
    "ICONTITLE_WORKSPACE_REFRESH":"REFRESH",
    "ICONTITLE_WORKSPACE_DELETE":"Delete",
    "ICONTITLE_WORKSPACE_CUT":"Cut",
    "ICONTITLE_WORKSPACE_COPY":"Copy",
    "ICONTITLE_WORKSPACE_PASTE":"Paste",
    "ICONTITLE_WORKSPACE_UNDO":"Undo",
    "ICONTITLE_WORKSPACE_REDO":"Redo",
    "ICONTITLE_DATABASE_REIMPORT":"Re-import database",
    "ICONTITLE_DATABASE_EXPORT":"Export to external database",
    "ICONTITLE_DATABASE_REVERT":"Revert changes",
    "ICONTITLE_DATABASE_REFRESH":"Refresh",
    "ICONTITLE_DATABASE_QUERY_RUN":"Run Query",
    "ICONTITLE_DATABASE_QUERY_VALIDATE":"Validate Query",
    "ICONTITLE_DATABASE_PROCEDURE_EXECUTE":"Execute Procedure",
    "ICONTITLE_DATABASE_PROCEDURE_EXECUTE_TO_SAVE":"Run the procedure/query to return atleast 1 record for enabling save.",
    "ICONTITLE_DATABASE_QUERY_CONTAINS_BLOB":"Please run a HQL query which does not return blob for enabling save",
    "ICONTITLE_DATAMODEL_REVERT":"Revert changes",
    "ICONTITLE_DATAMODEL_REIMPORT":"Re-import Data Model",
    "ICONTITLE_DATAMODEL_WORKSPACE_SAVE":"Save Data Model",
    "ICONTITLE_DATAMODEL_EXPORT": "Export the Model",
    "ICONTITLE_NETWORK_STATUS_OFFLINE":"Not connected to the network",
    "ICONTITLE_NETWORK_STATUS_ONLINE":"Connected to the network",
    "ICONTITLE_COPY_CLIPBOARD":"Copy to clipboard",
    "ICONTITLE_EDIT_PROVIDER": "Edit Provider",
    "MESSAGE_API_SETTINGS_SAVE_SUCCESS": "\"${0}\" API settings saved successfully.",
    "ICONTITLE_LOADING_URL":"Loading Url...",
    "ICONTITLE_CODE_EDITOR_CONFIG":"Configure Code Editor Settings",
    "ICONTITLE_REST_SERVICE_TEST_TO_SAVE": "You have made some changes to the service, test it before saving.",
    "LABEL_NO_PROPERTIES_FOUND": "No properties found",
    "LABEL_CODE_EDITOR_CHANGES": "Code Editor Settings",
    "MESSAGE_WORKSPACE_AUTOSAVED":"Autosaved",
    "MESSAGE_WORKSPACE_LAST_SAVE":"mins ago",
    "LABEL_PREFAB_VERSION_MISMATCH_TITLE": "Prefab Version Mismatch",
    "LABEL_PREFAB_VERSION_MISMATCH_OK_LABEL": "Force Register",
    "LABEL_PREFAB_VERSION_MISMATCH_CANCEL_LABEL": "Cancel",
    "LABEL_UPGRADE_PREFAB_DIALOG_TITLE":"Update Prefab",
    "LABEL_UPGRADE_PREFAB_DIALOG_CONTENT": "Updated version of '${0}' prefab is available.",
    "LABEL_UPGRADE_PREFAB_DIALOG_UPDATE_RELOAD":"${0} & Reload",
    "LABEL_SKIP_UPGRADE_PREFAB_DIALOG":"Skip",
    "LABEL_ADD_PAGE_DIALOG_TITLE":"Add new page",
    "LABEL_IMPORT_PAGE_DIALOG_TITLE":"Import",
    "LABEL_ADD_PAGE_NAME":"Name: ",
    "LABEL_ADD_PAGE_CREATE_A":"Create a",
    "LABEL_ADD_PAGE_TYPE":"Type: ",
    "LABEL_ADD_PAGE_LAYOUT":"Layout: ",
    "LABEL_ADD_PAGE_SELECT_LAYOUT":"Select a Layout",
    "LABEL_PAGE_PREVIEW":"Preview",
    "LABEL_CLEAN_PREVIEW":"Clean Preview",
    "LABEL_REBUILD_PREVIEW":"Rebuild Preview",
    "LABEL_PAGE_PREVIEW_TITLE":"Page Preview (Ctrl + Alt + P)",
    "LABEL_CURRENT_PAGE":"Current Page",
    "LABEL_PAGE_PREVIEW_APP":"App",
    "LABEL_CHANGE_LAYOUT":"Change Layout",
    "LABEL_WIDGET_LAYOUT": "Component Layout",
    "LABEL_ADD_PAGE_SELECT_LAYOUT_PREVIEW":"Preview",
    "LABEL_ADD_PAGE_SELECT_TEMPLATE":"Select a Template",
    "LABEL_ADD_PAGE_TEMPLATE_SEARCH":"Search:",
    "LABEL_ADD_PAGE_TEMPLATE_SEARCH_PLACEHOLDER":"Search the library",
    "LABEL_ADD_PAGE_TEMPLATE_CATEGORY":"Choose Category:",
    "LABEL_ADD_PAGE_CREATE_IN":"Create in: ",
    "LABEL_OK":"Ok",
    "LABEL_CANCEL":"Cancel",
    "LABEL_UPDATE_SCHEMA_CHANGES": "Proceed to Update",
    "LABEL_CANCEL_UPDATE": "Cancel Update",
    "LABEL_DOWNLOAD_NOW":"Download Now",
    "LABEL_BIND":"Bind",
    "LABEL_UNBIND":"Unbind",
    "LABEL_APPLY_FORMAT":"Apply Format",
    "LABEL_ANCHOR_READ_MORE":"Read more",
    "LABEL_PROCEED_ANYWAY": "Proceed Anyway",
    "LABEL_CATEGORY_LIST_PLACEHOLDER_TEXT": "Last accessed resources will be displayed here",
    "MESSAGE_PREFAB_VERSION_CONFLICT": "The Prefab <strong>${0}</strong> can not be used in this project as the Prefab (or its dependencies) has conflicts with other Prefabs used in this project.",
    "MESSAGE_PREFAB_VERSION_CONFLICT_RESOLUTION": "Below are the conflicts, please make sure they are resolved.",
    "MESSAGE_DELETE_PROJECT": "Are you sure you want to delete ${1} - \"${0}\"?",
    "MESSAGE_DELETE_PROJECT_BRANCH": "Are you sure you want to delete ${1} - \"${0} (${2})\"?",
    "MESSAGE_DELETE_APP_PROJECT_BRANCH_AGREE": "I understand that by deleting this project, it will also be deleted from all the members’ workspaces. Deleting this project does not affect the VCS project branch.",
    "MESSAGE_DELETE_PREFAB_PROJECT_BRANCH_AGREE": "I understand that by deleting this prefab, it will also be deleted from all the members’ workspaces. Deleting this prefab does not affect the VCS project branch.",
    "MESSAGE_DELETE_TEMPBUNDLE_PROJECT_BRANCH_AGREE": "I understand that by deleting this template bundle, it will also be deleted from all the members’ workspaces. Deleting this template bundle does not affect the VCS project branch.",
    "MESSAGE_DELETE_APPLICATION_PROJECT_AGREE":"I understand that by deleting the project, it's source code/repository will be deleted from the version control system and also from all the members' workspaces. All the existing deployments across all phases will be undeployed and I will not be able to deploy any more.",
    "MESSAGE_DELETE_PREFAB_PROJECT_AGREE":"I understand that by deleting the Prefab, it's source code/repository will be deleted from the version control system and also from all the members' workspaces. I will not be able to make any changes and release newer versions of this Prefab.",
    "MESSAGE_DELETE_TEMPLATEBUNDLE_PROJECT_AGREE":"I understand that by deleting the Template Bundle, it's source code/repository will be deleted from the version control system and also from all the members' workspaces. I will not be able to make any changes and release newer versions of this Template Bundle.",
    "MESSAGE_FINISH_UPGRADE_PROJECT":"Make sure you are ready to finish the upgrade by verifying the following check list.",
    "MESSAGE_CAUTION_FINISH_UPGRADE_PROJECT_1":"Deployed the application and tested its functionality thoroughly.",
    "MESSAGE_CAUTION_FINISH_UPGRADE_PROJECT_2":"All your team's changes are pushed to VCS.",
    "MESSAGE_CAUTION_FINISH_UPGRADE_PROJECT_3":"Fixed all errors pointed out by product's code inspection tool.",
    "MESSAGE_CAUTION_FINISH_UPGRADE_PROJECT_4":"I understand that after finishing upgrade WaveMaker ${0} project will be archived and all your team will start working on the WaveMaker ${1} project.",
    "MESSAGE_ALERT_PROJECT_VERS_FOLDER": "Important: Before you click \"Finish Upgrade\", test project thoroughly and fix any errors.",
    "LABEL_ARCHIVED": "Archived",
    "TITLE_MIGRATE_PROJECT_ALERT": "Upgrade project",
    "MESSAGE_MIGRATE_PROJECT_ALERT": "A copy of ‘${0}’ for WM ${1} version will be created.",
    "MESSAGE_CAUTION_MIGRATE_PROJECT_ALERT": "You can continue to work in the ${0} version until the upgrade is in process.",
    "LABEL_UPGRADE_FLOW_STEP_1": "Current Dev ${0}",
    "LABEL_UPGRADE_FLOW_STEP_2": "Start Upgrade",
    "LABEL_UPGRADE_FLOW_STEP_3": "Inspect & Fix",
    "LABEL_UPGRADE_FLOW_STEP_4": "Verify Functionality",
    "LABEL_UPGRADE_FLOW_STEP_5": "Bring/Re-do Changes any in ${0}",
    "LABEL_UPGRADE_FLOW_STEP_6": "Finish Upgrade",
    "LABEL_UPGRADE_FLOW_STEP_7": "Archived",
    "LABEL_UPGRADE_FLOW_STEP_8": "Upgrade Complete",
    "LABEL_UPGRADE_FLOW_VER": "WM ${0}",
    "MESSAGE_UPGRADE_FLOW_STEP_2_1": "Ensure that all your project members have pushed their changes to VCS.",
    "MESSAGE_UPGRADE_FLOW_STEP_2_2": "Your project's functionality should be well tested at this time, so any issues caused because of migration can be clearly isolated.",
    "MESSAGE_UPGRADE_FLOW_STEP_3_1": "With the upgrade to Angular 7, custom javascript code that is using AngularJS 1.X API needs to be fixed.",
    "MESSAGE_UPGRADE_FLOW_STEP_3_2": "Use the code inspection tool to identify potential problems and fix them.",
    "MESSAGE_UPGRADE_FLOW_STEP_3_3": "Deploy the application and test its functionality thoroughly.",
    "MESSAGE_UPGRADE_FLOW_STEP_6_1": "Make sure all your team's changes are pushed to VCS.",
    "MESSAGE_UPGRADE_FLOW_STEP_6_2": "After finishing of WaveMaker upgrade older-version project will be archived and all your team will start working on the newer version of WaveMaker project.",
    "MESSAGE_UPGRADE_FLOW_STEP_8_1": "Congratulations. At this state your application is successfully upgraded to latest version of WaveMaker",
    "LABEL_MIGRATE_PROJECT_NAME": "Name of the Project:",
    "LABEL_SELECT_ALL": "Select all",
    "TITLE_STOP_MOCK_SERVER":"Stop using Mock APIs",
    "MESSAGE_STOP_MOCK_SERVER_CONFIRMATION":"Are you sure you want to stop using mock APIs and switch back to real APIs ?",
    "MESSAGE_DIALOG_LEAVE_PROJECT":"Are you sure you want to leave the ${1} \"${0}\"? \n The source code will be removed from your Studio and project access will be revoked.",
    "MESSAGE_DIALOG_LEAVE_BRANCH_PROJECT":"Are you sure you want to leave the ${1} \"${0} (${2})\"? \n The source code will be removed from your Studio and project access will be revoked.",
    "LABEL_EXPORT_PROJECT_ZIP_DIALOG_TEXT":"Successfully exported the project sources to ZIP file - ",
    "LABEL_EXPORT_PROJECT_WAR_DIALOG_TEXT":"Successfully exported the project to WAR file - ",
    "LABEL_EXPORT_PROJECT_ZIP_FAILED": "Failed to export project zip. Please check server logs for more information",
    "LABEL_EXPORT_PROJECT_WAR_FAILED": "Failed to export project war. Please check server logs for more information",
    "LABEL_EXPORT_TEMPLATE_FAILED": "Failed to export template. Please check server logs for more information",
    "LABEL_EXPORT_PREFAB_FAILED": "Failed to export prefab.  Please check server logs for more information",
    "MESSAGE_SUCCESS_SAVE_PROJECT_AS_TEMPLATE_DESC":"Successfully saved the project as template.",
    "MESSAGE_ERROR_SAVE_PROJECT_AS_TEMPLATE_DESC":"Error in saving the project as template.",
    "MESSAGE_SUCCESS_SAVE_PROJECT_AS_PROJECT_SHELL_DESC":"Successfully saved the project as project shell.",
    "MESSAGE_ERROR_SAVE_PROJECT_AS_PROJECT_SHELL_DESC":"Error in saving the project as project shell.",
    "LABEL_DOWNLOAD_PROJECT_DIALOG_TEXT":"You are about to download the project - ",
    "MESSAGE_PUBLISH_SUCCESS": "Published Successfully",
    "LABEL_ARTIFACT_ALL_CATEGORIES": "All Categories",
    "LABEL_ARTIFACT_DEPENDENCIES": "Dependant Artifacts",
    "LABEL_ARTIFACT_NO_DEPENDENCIES": "No Dependencies",
    "LABEL_ARTIFACT_NO_METADATA": "No Metadata",
    "LABEL_ARTIFACT_NO_DOCUMENTATION": "No Documentation found",
    "LABEL_ARTIFACT_FILTER_ALL_PREFABS": "All Prefabs",
    "LABEL_ARTIFACT_FILTER_ALL_ENTERPRISE_PREFABS": "Enterprise Prefabs",
    "LABEL_ARTIFACT_FILTER_ALL_SYSTEM_PREFABS": "System Prefabs",
    "LABEL_ARTIFACT_FILTER_ALL_PROJECTSHELLS": "All Project shells",
    "LABEL_ARTIFACT_FILTER_ALL_ENTERPRISE_PROJECTSHELLS": "Enterprise Project shells",
    "LABEL_ARTIFACT_FILTER_ALL_SYSTEM_PROJECTSHELLS": "System Project shells",
    "LABEL_ARTIFACT_FILTER_ALL_TEMPLATEBUNDLES": "All Template Bundles",
    "LABEL_ARTIFACT_FILTER_ALL_ENTERPRISE_TEMPLATEBUNDLES": "Enterprise Template Bundles",
    "LABEL_ARTIFACT_FILTER_ALL_SYSTEM_TEMPLATEBUNDLES": "System Template Bundles",
    "LABEL_ARTIFACT_FILTER_ALL_THEMES": "All Themes",
    "LABEL_ARTIFACT_FILTER_ALL_ENTERPRISE_THEMES": "Enterprise Themes",
    "LABEL_ARTIFACT_FILTER_ALL_SYSTEM_THEMES": "System Themes",
    "LABEL_ARTIFACT_IMPORT": "Import",
    "LABEL_ARTIFACT_IMPORTED": "Imported",
    "LABEL_ARTIFACT_PUBLISHED_BY": "Published By",
    "LABEL_ARTIFACT_SYSTEM": "SYSTEM",
    "LABEL_ARTIFACT_VERSION": "Version",
    "LABEL_ARTIFACT_INFO": "Info",
    "LABEL_ARTIFACT_NAME": "Name",
    "LABEL_ARTIFACT_PUBLISH_INFO": "Information",
    "LABEL_ARTIFACT_PUBLISH_INFO_DESCRIPTION": "Enter the details of ${0}",
    "LABEL_ARTIFACT_PUBLISHER": "Publisher",
    "LABEL_ARTIFACT_VERSION_HISTORY": "Version History",
    "LABEL_ARTIFACT_LAST_MODIFIED_DATE": "Last modified date",
    "LABEL_ARTIFACT_MODIFIED_BY": "Modified by",
    "LABEL_ARTIFACT_DATE": "Date",
    "LABEL_ARTIFACT_METADATA": "Metadata",
    "LABEL_ARTIFACT_CATEGORY_EXISTS": "Artifact category with the name \"${0}\" already exists.",
    "LABEL_ARTIFACT_CATEGORY_VALIDATION": "The category name should always start with an alphabet and can contain 3-39 characters. Note that only alphabets, digits, hyphen(-), underscore(_), dot(.), and spaces are allowed.",
    "LABEL_ADD_NEW": "Add New",
    "LABEL_CONFIG": "Configuration",
    "LABEL_CONFIG_DESCRIPTION": "Add Tags that best describe the functionality to help discovery of the ${0}",
    "LABEL_DOCUMENTATION_DESCRIPTION": "Review the relevant documentation details. Any changes to this need to be done while developing the ${0}",
    "LABEL_PREFAB_DETAILS": "Prefab Details",
    "LABEL_PROJECT_SHELL_DETAILS": "Project Shell Details",
    "LABEL_TEMPLATEBUNDLE_DETAILS": "Template Bundle Details",
    "LABEL_THEME_DETAILS": "Theme Details",
    "LABEL_ARTIFACT_TAG": "Tags",
    "LABEL_ARTIFACT_ADD_TAG": "Add this as tag",
    "LABEL_ARTIFACT_DELETE_TAG": "Delete this tag",
    "LABEL_ARTIFACT_ADD_TAG_TITLE": "Enter a Tag here",
    "LABEL_ARTIFACT_CATEGORY": "Category",
    "LABEL_ARTIFACT_CHANGE_LOG": "Change Log",
    "LABEL_ARTIFACT_CURRENT_VERSION": "Current Version",
    "LABEL_ARTIFACT_DESCRIPTION": "Description",
    "LABEL_ARTIFACT_DISPLAYNAME": "Artifact Name",
    "LABEL_ARTIFACT_EDIT": "Edit",
    "LABEL_ARTIFACT_NEW_VERSION": "New Version",
    "LABEL_ARTIFACT_LATEST_VERSION": "Latest Version",
    "LABEL_ARTIFACT_SUCCESS_MESSAGE_TEAM": "${0} is submitted to Team admin for approval. After this version is approved, it will be available for use in the projects. You will be notified of the Team admin's decision via the activity feed.",
    "LABEL_ARTIFACT_SUCCESS_MESSAGE_EDN": "${0} is submitted to EDN admin for approval. After this version is approved, it will be available for use in the projects. You will be notified of the EDN admin's decision via the activity feed.",
    "LABEL_ARTIFACT_NOT_YET_PUBLISHED": "Not yet Published",
    "LABEL_ARTIFACT_FILTERS_HEADING": "Filters",
    "LABEL_ARTIFACT_PLATFORM": "Platform",
    "LABEL_ARTIFACT_OTHERS": "Other(s)",
    "LABEL_PROJECT_AS_SHELL": "Project as Shell",
    "LABEL_PROJECT_AS_SHELL_TO_TEAM": "Project as Shell to Team",
    "LABEL_PROJECT_AS_SHELL_TO_EDN": "Project as Shell to EDN",
    "LABEL_PROJECT_AS_THEME_TO_TEAM": "Theme to Team",
    "LABEL_PROJECT_AS_THEME_TO_EDN": "Theme to EDN",
    "LABEL_PROJECT_AS_SHELL_TO_WORKSPACE": "Project as Shell to Workspace",
    "LABEL_PUBLISH_ARTIFACT_AS_DRAFT_ALERT":"New version of this artifact cannot be published as there is already another version awaiting approval.",
    "LABEL_PUBLISH_ARTIFACT_AS_DRAFT_ALERT_HEADER":"Draft Artifact",
    "LABEL_PUBLISH_PREFAB_WORKSPACE":"Publish Prefab to your Workspace",
    "LABEL_PUBLISH_PREFAB_WORKSPACE_NOT_SUPPORTED": "Publish Prefab to Workspace is not supported for the project branch",
    "LABEL_PUBLISH_PREFAB_TEAM":"Publish Prefab to Team",
    "LABEL_PUBLISH_PREFAB_EDN": "Publish Prefab to EDN",
    "LABEL_PUBLISH_THEME_TEAM":"Publish Theme to Team",
    "LABEL_PUBLISH_THEME_EDN":"Publish Theme to EDN",
    "LABEL_PUBLISH_TEMPLATEBUNDLE_WORKSPACE":"Publish Template Bundle to your Workspace",
    "LABEL_PUBLISH_TEMPLATEBUNDLE_TEAM":"Publish Template Bundle to Team",
    "LABEL_PUBLISH_TEMPLATEBUNDLE_EDN":"Publish Template Bundle to EDN",
    "LABEL_PUBLISH_TO_TEAM":"Publish Prefab to Team",
    "LABEL_PUBLISH_TO_EDN":"To EDN",
    "LABEL_PUBLISH_TO_WORKSPACE":"Publish Prefab To Workspace",
    "LABEL_PUBLISH_PREFAB_PROJECT":"Publish Prefab to Project",
    "LABEL_PUBLISH_TO_PROJECT":"To Project",
    "LABEL_PUBLISH_PROJECTSHELL_TEAM":"Export Project as Shell",
    "LABEL_PUBLISH_PREFAB":"Publish Prefab",
    "LABEL_PUBLISH_TEMPLATEBUNDLE":"Publish Template Bundle",
    "LABEL_PUBLISH":"Publish",
    "LABEL_PUBLISH_PREFAB_TO_PROJECT":"Update Prefab in Project",
    "MESSAGE_INFO_PUBLISH_PREFAB_PROJECT": "The prefab changes can be updated to a selected project in your Workspace. However, these changes will be applied only to the project specified. In order to use these changes across projects please publish the changes to Workspace.",
    "MESSAGE_INFO_PUBLISH_TESTING_PREFAB_PROJECT": "To test your prefab, select a project to publish the prefab to. However, until the prefab is published to the EDN and is approved, it will not be available for other users to import into their project.",
    "MESSAGE_WARNING_PUBLISH_PREFAB_PROJECT": "Warning: Published Changes cannot be reverted.",
    "MESSAGE_ERROR_PUBLISH_PREFAB_VERSION": "The new version should be higher than the current version.",
    "MSG_PUBLISH_PREFAB_VERSION_CONFLICT_1": "The new version cannot be the same as the current version.",
    "MSG_PUBLISH_PREFAB_VERSION_CONFLICT_2": "Please enter valid version details.",
    "MSG_PUBLISH_PREFAB_VERSION_CONFLICT_3": "Version length cannot exceed 40 characters.",
    "MSG_PUBLISH_PREFAB_VERSION_CONFLICT_4": "Build metadata does not affect the version precedence. Hence, \"${0}\" is considered equal to  \"${1}\".",
    "PLACEHOLDER_NEW_VERSION": "Major.Minor.Patch",
    "MSG_HELP_SEMANTIC_VERSION": "Semantic Versioning uses <br><b>\"Major.Minor.Patch-prerelease+build\"</b> format <br><br>Examples:<br>1.0.0,&nbsp; 1.1.1-beta,&nbsp; 1.2.0+build.1,&nbsp; 2.1.0-rc.3+25",
    "SEMANTIC_VERSION_DOC_LINK": "https://semver.org/#semantic-versioning-200/",
    "LABEL_SEMANTIC_VERSIONING": "Semantic Versioning",
    "LABEL_SUGGESTED_VERSIONS": "Suggested Versions",
    "MESSAGE_INFO_PUBLISH_PREFAB_WORKSPACE": "The prefab will be updated only to your Workspace with the new version specified. However, this will not update the existing project using the older version of prefab.",
    "LABEL_EXPORT_PREFAB_DIALOG_TEXT":"Successfully exported the prefab to ZIP file - ",
    "LABEL_EXPORT_TEMPLATEBUNDLE_DIALOG_TEXT":"Successfully exported the template bundle to ZIP file - ",
    "LABEL_EXPORT_CORDOVA_DIALOG_TEXT":"Successfully exported the cordova build as ZIP file",
    "LABEL_CLOSE_PROJECT_DIALOG_TEXT": "There are unsaved changes in the project. \n Do you want to save them before closing?",
    "LABEL_WINDOW_RELOAD_CLOSE_TEXT": "Please note, there are unsaved changes in the project which will be lost.",
    "LABEL_UPLOAD_RESOURCE":"Upload Resource",
    "LABEL_UPLOAD_NEW":"Upload New",
    "LABEL_UPLOAD":"Upload",
    "LABEL_FILE_UPLOAD_FILE":"Choose a file: ",
    "LABEL_FILE_UPLOAD_FILE_ZIP":"Choose a zip file: ",
    "LABEL_FILE_UPLOAD_FOLDER":"Selected folder: ",
    "COMMENT_CREATE_JAVA_SERVICE": "----------Create Java Service Resources----------------------",
    "LABEL_CREATE_JAVA_SERVICE":"Create Java Service",
    "LABEL_CREATE_JAVA_SERVICE_MESSAGE":"Convert your code into APIs and connect to components.",
    "LABEL_NEW_JAVA_SERVICE":"New Java Service",
    "LABEL_PACKAGE":"Package",
    "PLACEHOLDER_SERVICE_NAME":"Enter Service Name",
    "PLACEHOLDER_SERVICE_NAME_TOOLTIP":"Enter Java Service Name (aplhanumeric characters)",
    "PLACEHOLDER_PACKAGE":"Enter Package",
    "PLACEHOLDER_PACKAGE_TOOLTIP":"Target Package Name for the Java Service class",
    "MESSAGE_SERVICE_NAME_MISSING": "Please enter Service Name",
    "MESSAGE_CLASS_NAME_MISSING": "Please enter Class Name",
    "MESSAGE_CLASS_NAME_INVALID": "Invalid Class Name",
    "MESSAGE_CREATE_JAVA_SERVICE": "Creating Java Service..",
    "MESSAGE_JAVA_SERVICE_ALREADY_EXISTS": "Java Service already exists with the given name",
    "MESSAGE_INVALID_SERVICE_NAME": "Class name can contain characters a-z, A-Z, 0-9, _",
    "MESSAGE_INVALID_JAVA_CLASS": "Package name must consist of characters a-z, A-Z, 0-9, -, _ and '.' and can not end in '.'",
    "MESSAGE_SUCCESS_CREATE_JAVA_SERVICE_DESC": "JavaService created successfully",
    "MESSAGE_ERROR_CREATE_JAVA_SERVICE_FAILED_DESC": "Creation or compile failed. Check server logs",
    "COMMENT_PROJECT_SETTINGS_RESOURCES":"----------Project Settings Resources----------",
    "LABEL_STUDIO_ARTIFACTS_DIALOG_HEADER":"Studio Artifacts",
    "LABEL_ERROR_MESSAGE_ON_DELETE_ARTIFACT_ITEM": " could not be deleted. This may be because the item(s) are registered for use in a project.",
    "LABEL_SUCCESS_MESSAGE_ON_DELETE_ARTIFACT_ITEM": "Item(s) deleted successfully.",
    "LABEL_SUCCESS_MESSAGE_ON_IMPORT_ARTIFACT_ITEM": "${0} imported successfully.",
    "LABEL_SUCCESS_MESSAGE_ON_UPDATE_ARTIFACT_ITEM": "${0} updated successfully.",
    "LABEL_PROJECT_SETTINGS_DIALOG_HEADER": "Project Settings",
    "LABEL_PREFAB_CONFIG_DIALOG_HEADER": "Prefab Configuration",
    "LABEL_PROJECT_SETTINGS_NAME": "Name",
    "LABEL_TEMPLATE_CONFIG_DIALOG_HEADER": "Template Configuration",
    "LABEL_PROJECT_SETTINGS_ID": "ID",
    "LABEL_PROJECT_APPLICATION_LOADER": "Application Loader",
    "LABEL_PROJECT_APPLICATION_LOADER_SKELETON": "Skeleton Loader",
    "LABEL_PROJECT_APPLICATION_LOADER_SPINNER": "Progress Loader",
    "LABEL_PROJECT_PROVATAR": "Provatar",
    "LABEL_PROJECT_SETTINGS_DESCRIPTION": "Description",
    "LABEL_PROJECT_SETTINGS_TYPE": "Type",
    "LABEL_PROJECT_SETTINGS_PROJECTSHELL": "Project Shell",
    "LABEL_PROJECT_SETTINGS_OWNER": "Owners",
    "LABEL_PROJECT_SETTINGS_CONTRIBUTOR": "Contributors",
    "LABEL_PROJECT_SETTINGS_CREATED_DATE": "Created Date",
    "LABEL_PROJECT_SETTINGS_LAST_ACCESSED_DATE": "Last Accessed Date",
    "LABEL_PROJECT_SETTINGS_PROJECT_NAME": "Project Name",
    "LABEL_PROJECT_SETTINGS_PREFER_BROWSER_LANG": "Prefer Browser Language",
    "MSSAGE_HELP_ALLOW_PREFER_BROWSER_LANG": "This flag decides whether to give preference to browser set language or to the default language set in the project",
    "LABEL_PROJECT_SETTINGS_ENABLE_WEB_PREVIEW": "Enable Web Preview",
    "LABEL_RUNTIME_SERVICE_VERSION": "Runtime Service Version",
    "LABEL_RUNTIME_SETTING":"Runtime Settings",
    "MSG_RUNTIME_UI_VERSION_UPDATE_SUCCESS": "Runtime UI version updated successfully",
    "MSG_JAVA_VERSION_UPDATE_SUCCESS": "Java version updated successfully",
    "LABEL_RUNTIME_UI_VERSION": "Runtime UI Version",
    "MSSAGE_HELP_ENABLE_WEB_PREVIEW": "This flag decides whether to generate web preview.",
    "MSSAGE_HELP_JAVA_VERSION": "The selected java version will be used for the compilation of java classes and it will also be the minimum required java version where the application is deployed.",
    "MSSAGE_HELP_ENABLE_API_COMPOSITION": "This flag decides whether to generate services and model classes for Rest and Imported APIs",
    "MESSAGE_HELP_FILE_EXTENSIONS": "Default allowed file extensions and MIME types for file upload component. Other file extensions will not be allowed to upload.",
    "LABEL_PROJECT_SETTINGS_ALLOWED_FILE_UPLOAD_EXTENSIONS": "Allowed File Upload Extensions",
    "LABEL_PROJECT_SETTINGS_PACKAGE_PREFIX": "Package Prefix",
    "LABEL_PROJECT_SETTINGS_ENABLE_API_COMPOSITION": "Enable API Composition",
    "LABEL_PROJECT_SETTINGS_PACKAGE_PREFIX_REQ": "Package Prefix information is required.",
    "LABEL_PROJECT_PROJECT_SETTINGS_COPYRIGHT":"Copyright",
    "LABEL_PROJECT_PROJECT_SETTINGS_COPYRIGHT_REQ":"Copyright information is required.",
    "LABEL_PROJECT_SETTINGS_INVALID_PACKAGE_PREFIX":"Invalid input for Package prefix.",
    "LABEL_PROJECT_SETTINGS_INVALID_VERSION":"Invalid input for Version.",
    "MESSAGE_ENTER_COPYRIGHT_DESC": "Enter Copyright Information.",
    "LABEL_PROJECT_SETTINGS_VERSION": "Version",
    "LABEL_PROJECT_SETTINGS_DEFAULT_LANGUAGE": "Default Language",
  "LABEL_PROJECT_SETTINGS_JAVA_VERSION": "Java Version",
    "LABEL_PROJECT_SETTINGS__HOME_PAGE": "Home Page",
    "LABEL_PROJECT_SETTINGS_DEFAULT_TIMEZONE": "Default Timezone",
    "LABEL_STUDIO_SETTINGS_INVALID_INPUT":"Please enter valid values",
    "LABEL_PROJECT_SETTINGS_PREFAB_ICON": "Prefab Icon",
    "LABEL_PROJECT_SETTINGS_PREFAB_ICON_SIZE": "Recommended image dimensions are 128x128 px. Maximum upload file size: 50KB",
    "LABEL_PROJECT_SETTINGS_PREFAB_ICON_SIZE_ERROR_MSG": "File size exceeds 50KB",
    "LABEL_STUDIO_SETTINGS_PREFABS": "Prefabs",
    "LABEL_STUDIO_SETTINGS_THEMES": "Themes",
    "LABEL_LOCALIZED_MESSAGES":"Localized Messages",
    "LABEL_PROJECT_BASIC_INFO":"Basic Info",
    "LABEL_PROJECT_NAME":"Project Name",
    "LABEL_PROJECT_AVATAR":"Add Icon",
    "MESSAGE_COMPLETE_APP_IN_FEW_STEPS":"Complete your application in just few steps",
    "MESSAGE_NEW_TO_WM":"New to WaveMaker? Check ",
    "LABEL_WM_ACADEMY":"WaveMaker Academy",
    "LABEL_ONBOARD_DATA_SOURCE":"Onboard Data Source",
    "LABEL_BIND_UI":"Bind UI with your Data",
    "LABEL_GOT_IT":"Got it!",
    "LABEL_REPO_NAME":"Repo Name",
    "LABEL_TEMPLATE_NAME":"Template Name",
    "LABEL_PROJECT_SHELL_NAME":"Project Shell Name",
    "LABEL_PROJECT_TEMPLATE":"Template",
    "LABEL_PROJECT_DESCRIPTION":"Description",
    "LABEL_PROJECT_VERSION":"Version",
    "LABEL_URL": "URL",
    "LABEL_REPO_URL": "Repository Url",
    "LABEL_GIT_ACCESS_TOKEN": "Access Token",
    "MESSAGE_GIT_TOKEN_NOTE": "Checkout how to create git access token",
    "GIT_TOKEN_DOC_LINK": "https://docs.github.com/en/github/authenticating-to-github/creating-a-personal-access-token#creating-a-token",
    "LABEL_REPO_BRANCH": "Branch",
    "MESSAGE_REPO_CREDENTIALS_NOTE": "We don't store your credentials, they will be discarded after the push.",
    "MESSAGE_BRANCH_DETAILS": "If the branch doesn't exists, new branch will be created",
    "MESSAGE_REPO_URL_NOTE": "Provide an existing private repository url",
    "MESSAGE_REPO_DETAILS_HINT": "Provide ${0} Account details",
    "LABEL_ROOT_DN": "Root DN",
    "LABEL_PROJECT_VCS": "Version Control",
    "MESSAGE_ENTER_PROJECT_VCS_URL": "Enter Version Control Url",
    "MESSAGE_ENTER_USERNAME":"Please enter the user name",
    "MESSAGE_ENTER_PASSWORD":"Please enter the password",
    "MESSAGE_CHOOSE_APP_ROLE":"Please choose app role",
    "LABEL_ACTIONS_DELETE_RESOURCES": "Delete Resources",
    "MESSAGE_DELETE_RESOURCES" : "Are you sure you want to delete all the selected resources ? \"${0}\"",
    "MESSAGE_PREFAB_INFO" : "Click here for \"${0}\" info",
    "MESSAGE_RESOURCE_EXISTS":"Resource \"${0}\" already exists. Click OK to overwrite ",
    "COMMENT_PROJECT_NOT_FOUND": "----------Project Not Found----------------------",
    "LABEL_PROJECT_NOT_FOUND":"Project Not found",
    "LABEL_PROJECT_500":"Internal Server Error",
    "LABEL_PROJECT_ACCESS_DENIED":"Access Denied",
    "LABEL_PROJECT_ACCESS_DENIED_MESSAGE": "You don't have permission to view the requested resource",
    "LABEL_PROJECT_500_MESSAGE": "Internal server error occurred while displaying the requested page. Try again after sometime.",
    "LABEL_PROJECT_500_ERROR_HELP_CONTACT": "For help contact us at ",
    "LABEL_PROJECT_500_HELP_MESSAGE": " from your registered email address with project name.",
    "LABEL_PROJECT_NOT_FOUND_MESSAGE":"Sorry, the project you were trying to view does not exist",
    "LABEL_PROJECT_NOT_FOUND_REASONS_HEADER":"It looks like",
    "LABEL_PROJECT_NOT_FOUND_REASON_DELETED":"project is deleted",
    "LABEL_PROJECT_NOT_FOUND_REASON_DOESNT_EXIST":"project doesn't exist",
    "LABEL_PROJECT_NOT_FOUND_MESSAGE_GO_BACK":"Go back to projects list",
    "COMMENT_WIDGETS_RESOURCES":"----------Components Localization Resources----------",
    "LABEL_SELECT_WIDGET_MESSAGE":"Select an element in the canvas to display properties.",
    "LABEL_COLLAPSE":"Collapse",
    "LABEL_EXPAND":"Expand",
    "LABEL_LANGUAGE":"Language",
    "LABEL_CLEAR":"Clear",
    "LABEL_LAYOUTS":"Layouts",
    "LABEL_DATABASE_COMPONENTS":"Components",
    "LABEL_DEVICE":"Device",
    "LABEL_WIDGETS":"Components",
    "LABEL_MY_WIDGETS":"My Components",
    "LABEL_WMX_WIDGETS":"WMX Components",
    "LABEL_WM_EXT_WIDGETS":"WM Extension Components",
    "LABEL_M3_WIDGETS":"Material-3 Components",
    "LABEL_MODES": "Modes",
    "LABEL_COLOR": "Color",
    "LABEL_DB_WIDGETS":"DB Components",
    "LABEL_DB_WIDGETS_EMPTY_MESSAGE": "DB components will be available after database import.",
    "LABEL_IMPORT_DATABASE": "Click here to import DB",
    "LABEL_DATABASE_ALREADY_IMPORTED":"Database already imported",
    "LABEL_THEMES":"Themes",
    "LABEL_THEMES_VIEW":"View available Themes",
    "LABEL_PROJECT_SHELLS":"Project Shells",
    "LABEL_TEMPLATE_BUNDLES":"Template Bundles",
    "LABEL_PREFABS":"Prefabs",
    "LABEL_PROJECT_PREFABS": "Project Prefabs",
    "LABEL_TEAM_PREFABS": "Team Prefabs",
    "LABEL_EDN_PREFABS": "EDN Prefabs",
    "LABEL_SYSTEM_PREFABS": "System Prefabs",
    "LABEL_SELECTED_PREFAB": "Selected Prefab",
    "LABEL_PREFABS_VIDEOS":"Videos",
    "LABEL_PREFABS_OAUTH":"Oauth",
    "LABEL_PREFABS_SOCIAL":"Social",
    "LABEL_PREFABS_BASIC":"Basic",
    "LABEL_PREFABS_LOCATION":"Location",
    "LABEL_PREFABS_MEDIA":"Media",
    "LABEL_PREFABS_IN_USE": "In Use",
    "LABEL_PREFABS_NOT_IN_USE": "Not in use",
    "LABEL_NO_UPDATE": "No update",
    "LABEL_NO_UPDATES_AVAILABLE": "No Updates Available",
    "LABEL_FREQUENTLY_USED":"Frequently Used",
    "LABEL_DATABASE":"Database",
    "LABEL_MODEL_DESIGNER": "Model Designer",
    "LABEL_SCHEMA_READONLY_MODE": "Read-Only Mode",
    "LABEL_THE_VCS": "The",
    "LABEL_EXTERNAL_REPOSITORY_NOT_FOUND": "Repository Not Found",
    "LABEL_EXTERNAL_REPO_INFO": " associated with this project no longer exists. You can continue editing the project, but version control and collaboration no longer work.  To continue your work or share it with others, export the project sources.",
    "LABEL_EXTERNAL_BRANCH_NOT_FOUND": "Branch Not Found",
    "LABEL_EXTERNAL_USER_VCS_CREDENTIALS_REQUIRED": "Authentication Failed",
    "MESSAGE_VCS_USER_CREDENTIALS_NOT_FOUND1": "Authentication to the",
    "MESSAGE_VCS_USER_CREDENTIALS_NOT_FOUND2": "repository failed, likely due to expired or invalid credentials. You can continue editing the project, but version control and collaboration won't work until valid credentials are provided.",
    "MESSAGE_VCS_USER_CREDENTIALS_NOT_FOUND_CONTACT": "Contact your Team Administrator to update the credentials of",
    "MESSAGE_VCS_USER_CREDENTIALS_NOT_FOUND_UPDATE": "credentials are invalid/expired. Please update to continue.",
    "LABEL_TABLE":"Table",
    "LABEL_NEW_TABLE": "Add Table",
    "LABEL_NEW_COLUMN":"Add Column",
    "LABEL_NEW_QUERY":"Add New Query",
    "LABEL_NEW_PROCEDURE":"Add New Procedure",
    "LABEL_NEW_ATTRIBUTE": "Add Attribute",
    "LABEL_DATABASE_RELATIONS":"Relations",
    "LABEL_ENTITY_ISLIST": "Collection",
    "LABEL_IS_EXISTS": "Is Exists",
    "LABEL_SOURCE_TABLE": "Source Table",
    "LABEL_TARGET_TABLE": "Target Path",
    "LABEL_PROPERTY_MODELSCOPE": "Scope",
    "LABEL_PROPERTY_CONFIGSCOPE": "Scope",
    "LABEL_PROPERTY_SORTORDER": "Sort Order",
    "LABEL_PROPERTY_SORTORDER_ASCENDING": "Ascending",
    "LABEL_PROPERTY_SORTORDER_DECENDING": "Descending",
    "LABEL_REF": "Reference",
    "LABEL_PROPERTY_REF": "Reference",
    "LABEL_PROPERTY_KEYORDER": "Key Order",
    "LABEL_PROPERTY_KEY": "Is Key",
    "LABEL_PROPERTY_BASICINFO":"Basic info",
    "LABEL_DEVICE_WIDGET": "Device Components",
    "LABEL_DEVICE_WIDGET_CAMERA": "Camera",
    "LABEL_DEVICE_WIDGET_BARCODESCANNER": "Barcode Scanner",
    "LABEL_DEVICE_WIDGET_BOTTOMSHEET": "Bottom Sheet",
    "LABEL_LAYOUTS_PAGELAYOUTS":"Page Layouts",
    "LABEL_LAYOUTS_1_COLUMN":"1 Column",
    "LABEL_LAYOUTS_2_COLUMN":"2 Column",
    "LABEL_LAYOUTS_3_COLUMN":"3 Column",
    "LABEL_LAYOUTS_BLANK":"Blank",
    "LABEL_THEMES_BASICTHEMES":"Basic Themes",
    "LABEL_THEMES_DEFAULT":"Default",
    "LABEL_THEMES_VINTAGE":"Vintage",
    "LABEL_THEMES_COOLBLUE":"Cool Blue",
    "LABEL_WIDGETS_STRUCTURE":"Structure",
    "LABEL_WIDGETS_CONTAINER":"Container",
    "LABEL_WIDGETS_NAVIGATION":"Navigation",
    "LABEL_WIDGETS_FORMWIDGETS":"Form Components",
    "LABEL_WIDGETS_BASICWIDGETS":"Basic Components",
    "LABEL_WIDGETS_COMMONLY_USED":"Commonly Used",
    "LABEL_WIDGETS_GRIDS":"Grids",
    "LABEL_WIDGETS_CHARTS":"Charts",
    "LABEL_WIDGETS_DATABASEWIDGETS":"Database Components",
    "LABEL_WIDGETS_DIALOGS":"Modal Windows / Dialogs",
    "LABEL_WIDGET_ACCORDION": "Accordion",
    "LABEL_WIDGET_ACCORDIONPANE": "Accordion Pane",
    "LABEL_WIDGET_TABS": "Tabs",
    "LABEL_WIDGET_WIZARD": "Wizard",
    "LABEL_WIDGET_CAROUSEL": "Carousel",
    "LABEL_WIDGET_CUSTOM": "Custom",
    "LABEL_WIDGET_CARD": "Cards",
    "LABEL_WIDGET_RATING":"Rating",
    "LABEL_WIDGET_CHIPS": "Chips",
    "LABEL_WIDGET_TABPANE": "Tab pane",
    "LABEL_WIDGET_WIZARD_STEP": "Step",
    "LABEL_WIDGET_LINEARLAYOUT":"Layout",
    "LABEL_WIDGET_LINEAR_FLEX_LAYOUT": "Flex Layout",
    "LABEL_WIDGET_LAYOUTGRID":"Grid Layout",
    "LABEL_WIDGET_NAV":"Nav",
    "LABEL_WIDGET_NAVBAR":"Nav bar",
    "LABEL_WIDGET_FORM":"Form",
    "LABEL_WIDGET_LIVEFORM":"Live form",
    "LABEL_WIDGET_LIST":"List",
    "LABEL_WIDGET_LISTITEM":"List Item",
    "LABEL_WIDGET_PANEL":"Panel",
    "LABEL_WIDGET_CONTAINER":"Container",
    "LABEL_WIDGET_CUSTOM_CONTAINER":"Custom Component Container",
    "LABEL_WIDGET_TILE":"Tile",
    "LABEL_WIDGET_SEGMENTED_CONTROL":"Segmented Control",
    "LABEL_WIDGET_MEDIA_LIST":"Media List",
    "LABEL_WIDGET_TABBAR":"Tab Bar",
    "LABEL_WIDGET_MOBILE_NAVBAR":"Nav Bar",
    "LABEL_WIDGET_BREADCRUMB":"Breadcrumb",
    "LABEL_WIDGET_ICON":"Icon",
    "LABEL_WIDGET_LABEL":"Label",
    "LABEL_WIDGET_MARQUEE":"Marquee",
    "LABEL_WIDGET_PROGRESS_BAR":"Progress bar",
    "LABEL_WIDGET_PROGRESS_CIRCLE":"Progress Circle",
    "LABEL_WIDGET_TEXT":"Text",
    "LABEL_WIDGET_NUMBER": "Number",
    "LABEL_WIDGET_BUTTON":"Button",
    "LABEL_WIDGET_BUTTON_GROUP":"Button Group",
    "LABEL_WIDGET_MENU":"Dropdown Menu",
    "LABEL_WIDGET_TREE":"Tree",
    "LABEL_WIDGET_SLIDER":"Slider",
    "LABEL_WIDGET_SELECT":"Select",
    "LABEL_WIDGET_SELECTLOCALE":"Select Locale",
    "LABEL_WIDGET_TEXTAREA":"Textarea",
    "LABEL_WIDGET_CHECKBOX":"Checkbox",
    "LABEL_WIDGET_SWITCH":"Switch",
    "LABEL_WIDGET_TOGGLE":"Toggle",
    "LABEL_WIDGET_CHECKBOXSET":"CheckboxSet",
    "LABEL_WIDGET_RADIO":"Radio",
    "LABEL_WIDGET_RADIOSET": "Radioset",
    "LABEL_WIDGET_PICTURE":"Picture",
    "LABEL_WIDGET_ANCHOR":"Anchor",
    "LABEL_WIDGET_POPOVER":"Popover",
    "LABEL_WIDGET_TABLE":"Data Table",
    "LABEL_WIDGET_FILEUPLOAD":"FileUpload",
    "LABEL_WIDGET_SPINNER":"Spinner",
    "LABEL_WIDGET_COLORPICKER":"Color Picker",
    "LABEL_WIDGET_HTML":"HTML",
    "LABEL_WIDGET_IFRAME":"Iframe",
    "LABEL_WIDGET_DESIGN_DIALOG":"Design Dialog",
    "LABEL_WIDGET_PAGE_DIALOG":"Page Dialog",
    "LABEL_WIDGET_IFRAME_DIALOG":"Iframe Dialog",
    "LABEL_WIDGET_ALERT_DIALOG":"Alert Dialog",
    "LABEL_WIDGET_CONFIRM_DIALOG":"Confirm Dialog",
    "LABEL_WIDGET_LOGIN_DIALOG":"Login Dialog",
    "LABEL_WIDGET_POPUPLINK":"Popup Link",
    "LABEL_WIDGET_YOUTUBE":"Youtube Link",
    "LABEL_WIDGET_DATE": "Date",
    "LABEL_WIDGET_CALENDAR": "Calendar",
    "LABEL_WIDGET_TIME": "Time",
    "LABEL_WIDGET_CURRENCY": "Currency",
    "LABEL_WIDGET_MESSAGE": "Message",
    "LABEL_WIDGET_LIVELIST": "List",
    "LABEL_WIDGET_LIVEFILTER": "Live Filter",
    "LABEL_WIDGET_SEARCH": "Search",
    "LABEL_WIDGET_RICHTEXTEDITOR": "Richtext Editor",
    "LABEL_WIDGET_LINECHART": "Line",
    "LABEL_WIDGET_COLUMNCHART": "Column",
    "LABEL_WIDGET_BARCHART": "Bar",
    "LABEL_WIDGET_AREACHART": "Area",
    "LABEL_WIDGET_PIECHART": "Pie",
    "LABEL_WIDGET_CUMULATIVELINECHART": "Cumulative Line",
    "LABEL_WIDGET_DONUTCHART": "Donut",
    "LABEL_WIDGET_BUBBLECHART": "Bubble",
    "LABEL_WIDGET_DATANAVIGATOR": "Pagination",
    "LABEL_WIDGET_PAGINATION":"Pagination",
    "LABEL_WIDGET_LOGIN": "Login",
    "LABEL_WIDGET_VIDEO": "Video",
    "LABEL_WIDGET_AUDIO": "Audio",
    "LABEL_WIDGET_DATETIME": "Datetime",
    "LABEL_LIVE_WIDGETS": "Data Components",
    "LABEL_ADVANCED_WIDGETS": "Advanced Components",
    "LABEL_TABLE_LAYOUT": "Table layout",
    "LABEL_LIST_LAYOUT": "List layout",
    "LABEL_CARD_LAYOUT": "Card layout",
    "LABEL_SELECT_PAGINATION": "Pagination",
    "LABEL_DB_COMPONENTS_DATABASE":"Database",
    "LABEL_DB_COMPONENTS_COLUMN":"Column",
    "LABEL_DB_COMPONENTS_RELATION_ONE_TO_ONE":"One to One",
    "LABEL_DB_COMPONENTS_RELATION_ONE_TO_MANY":"One to Many",
    "LABEL_DB_COMPONENTS_RELATION_MANY_TO_ONE":"Many to One",
    "LABEL_DB_COMPONENTS_CREATE_RELATION":"Create relation using advanced options",
    "MESSAGE_LAYOUTS_SEARCH":"Search Layouts",
    "MESSAGE_COMPONENTS_SEARCH":"Search Components",
    "MESSAGE_THEMES_SEARCH":"Search Themes",
    "LABEL_SAVE":"Save",
    "LABEL_DONE":"Done",
    "LABEL_LOAD":"Load",
    "LABEL_DONTSAVE": "Don't Save",
    "LABEL_SEARCH":"Search",
    "LABEL_SEARCH_TITLE":"Enter search term",
    "LABEL_SELECT":"Select",
    "LABEL_HELP":"Help",
    "LABEL_BORDER_STYLE_PROPERTY_DASHED":"dashed",
    "LABEL_BORDER_STYLE_PROPERTY_DOTTED":"dotted",
    "LABEL_BORDER_STYLE_PROPERTY_DOUBLE":"double",
    "LABEL_BORDER_STYLE_PROPERTY_GROOVE":"groove",
    "LABEL_BORDER_STYLE_PROPERTY_INHERIT":"inherit",
    "LABEL_BORDER_STYLE_PROPERTY_INITIAL":"initial",
    "LABEL_BORDER_STYLE_PROPERTY_INSET":"inset",
    "LABEL_BORDER_STYLE_PROPERTY_NONE":"none",
    "LABEL_BORDER_STYLE_PROPERTY_OUTSET":"outset",
    "LABEL_BORDER_STYLE_PROPERTY_RIDGE":"ridge",
    "LABEL_BORDER_STYLE_PROPERTY_SOLID":"solid",
    "LABEL_INLINE_CONTENT":"Inline Content",
    "LABEL_PARTIALS": "PARTIALS",
    "LABEL_DEFAULT_CONTENT":"Default Content",
    "LABEL_BLUR":"blur",
    "LABEL_KEYPRESS":"keypress",
    "LABEL_FIRSTNODE":"FirstNode",
    "LABEL_LASTNODE":"LastNode",
    "LABEL_BACK_TO_DASHBOARD":"Dashboard",
    "LABEL_SAVE_PROJECT_SHELL":"Save as Project Shell",
    "LABEL_UPDATE_SOURCE":"Update Source",
    "LABEL_CLOSE_PROJECT":"Close Project",
    "LABEL_ABOUT":"About",
    "LABEL_SELECT_LOCALE": "Select Locale",
    "LABEL_SAVE_AS_TEMPLATE":"Save as Template",
    "LABEL_SAVE_PROJECT_AS_TEMPLATE":"Save Project as Template",
    "LABEL_BOUND_TO":"Bound to",
    "LABEL_VARIABLE_BOUND_SUCCESS_MESSAGE": "Types do not match, this may cause issues in the app.",
    "LABEL_VARIABLE_BOUND_ERROR_MESSAGE": "The ${0} can be bound",
    "LABEL_SAVE_AS_PROJECT_SHELL":"Save as Project Shell",
    "LABEL_SAVE_PROJECT_AS_PROJECT_SHELL":"Save Project as Project Shell",
    "LABEL_WIDGET_ONCLICK":"On Click",
    "LABEL_WIDGET_ONTAP":"On Tap",
    "LABEL_WIDGET_ONMOUSEENTER":"On Mouse Enter",
    "LABEL_WIDGET_ONMOUSELEAVE":"On Mouse Leave",
    "LABEL_WIDGET_ONFOCUS":"On Focus",
    "LABEL_WIDGET_ONBLUR":"On Blur",
    "LABEL_WIDGET_ONCHANGE":"On Change",
    "LABEL_WIDGET_ONKEYPRESS":"On Key Press",
    "LABEL_WIDGET_ONKEYDOWN":"On Key Down",
    "LABEL_WIDGET_ONKEYUP":"On Key Up",
    "LABEL_WIDGET_ONSUBMIT": "On Submit",
    "LABEL_WIDGET_ONSELECT": "On Select",
    "LABEL_WIDGET_ONBEFORESERVICECALL": "On Before Service Call",
    "LABEL_PROPERTY_ONBEFORELOAD": "On Before Load",
    "LABEL_PROPERTY_ONDATECLICK": "On Date Click",
    "LABEL_PROPERTY_ONDATASETREADY": "On Dataset Ready",
    "MESSAGE_HELP_PROPERTY_ADDPROPERTY": "This adds props to custom components",
    "MESSAGE_UNSAVED_CHANGES": "The ${0} settings have been modified. Do you want to save the changes?",
    "WIDGET_HELP_TEXT_WM-PAGE": "Each page has a Page Container which contains the layout elements and layout definitions for the page. Page Container is the main container of the page and can have Views as child containers, as in the case of a dialog.",
    "WIDGET_HELP_TEXT_WM-PAGE-CONTENT": "A container component to hold the main content of the page.",
    "WIDGET_HELP_TEXT_WM-HEADER": "Header of the page",
    "WIDGET_HELP_TEXT_WM-TOP-NAV": "Top navigation bar for the page",
    "WIDGET_HELP_TEXT_WM-CONTENT": "Content of the page",
    "WIDGET_HELP_TEXT_WM-ROW": "Container in a content having 100% width",
    "WIDGET_HELP_TEXT_WM-LEFT-PANEL": "Left panel in the content",
    "WIDGET_HELP_TEXT_WM-COLUMN": "Container in a content having 100% height",
    "WIDGET_HELP_TEXT_WM-RIGHT-PANEL": "Right panel in the content",
    "WIDGET_HELP_TEXT_WM-FOOTER": "Footer of the page",
    "WIDGET_HELP_TEXT_WM-PARTIAL": "The partial pages are loaded asynchronously on the page. They are loaded on-demand when the content is required to be rendered. For example, components like Panel, Tabs and Accordion can load partial pages as their content. Partial Pages can be used for header, topNav, leftNav, footer, rightNav and popover content.",
    "WIDGET_HELP_TEXT_WM-ACCORDION": "Stacked list of Containers, with only one container expanded or viewed at any point in time, and the rest collapsed.",
    "WIDGET_HELP_TEXT_WM-ACCORDIONPANE": "SubComponent of Accordion, contains accordion header and accordion content",
    "WIDGET_HELP_TEXT_WM-ACCORDIONHEADER": "SubComponent of Accordion, to hold the accordion title",
    "WIDGET_HELP_TEXT_WM-ACCORDIONCONTENT": "SubComponent of Accordion, to hold the accordion content",
    "WIDGET_HELP_TEXT_WM-TABS": "Multiple Containers placed in a single window, with only one active container and headings allow navigation to other containers.",
    "WIDGET_HELP_TEXT_WM-WIZARD": "This component allows to group multiple steps.",
    "WIDGET_HELP_TEXT_WM-WIZARD-STEP": "SubComponent of Wizard, stores content of wizard.",
    "WIDGET_HELP_TEXT_WM-TABPANE": "SubComponent of Tabs, contains tab header and tab content",
    "WIDGET_HELP_TEXT_WM-TABHEADER": "SubComponent of Tabs, to hold the tab header",
    "WIDGET_HELP_TEXT_WM-TABCONTENT": "SubComponent of Tabs, to hold the tab content",
    "WIDGET_HELP_TEXT_WM-CAROUSEL": "Displays two or more items either images, text or any content, that transitions in a cyclic order.",
    "WIDGET_HELP_TEXT_WM-CAROUSEL-CONTENT": "SubComponent of Carousel to hold a slide content",
    "WIDGET_HELP_TEXT_WM-FORM": "Form is a group of input elements put together to post data, typically updating data through a web service call.",
    "WIDGET_HELP_TEXT_WM-LAYOUTGRID": "Division of content area into cells or grids based on the 12-column fluid grid system, which helps in proper placement of the components for responsive design.",
    "WIDGET_HELP_TEXT_WM-GRIDROW": "A subcomponent of the layout grid, contains grid columns. Is direct child of layout grid.",
    "WIDGET_HELP_TEXT_WM-GRIDCOLUMN": "A subcomponent of layout grid, is direct child of grid row.",
    "WIDGET_HELP_TEXT_WM-LIST": "Grouping of containers as a list arrangement i.e. in a <ul><li> structure",
    "WIDGET_HELP_TEXT_WM-PANEL": "A panel is an auxiliary window that contains controls and options that affect the active document or selection",
    "WIDGET_HELP_TEXT_WM-CONTAINER": "Container is an enclosing element that wraps the components placed within, mostly used for embedding partial pages",
    "WIDGET_HELP_TEXT_WM-TILE": "A form of container to group a set of components together and to apply a uniform style to the content",
    "WIDGET_HELP_TEXT_WM-MOBILE-TABBAR": "Tabbar control for defining navigation in mobile applications",
    "WIDGET_HELP_TEXT_WM-SEGMENTED-CONTROL": "This allows setting the layout for the content of the pages",
    "WIDGET_HELP_TEXT_WM-SEGMENT-CONTENT": "A subcomponent of segmented control",
    "WIDGET_HELP_TEXT_WM-MEDIA-LIST": "A component for creating a list of media. The media can be viewed either in single-row mode or grid mode and can be opened in full-screen on the device by touching the media.",
    "WIDGET_HELP_TEXT_WM-MEDIA-TEMPLATE": "This is child container in Media List for which the width and height can be set. By default, thumbnail will be shown in media template. Additional components can be added by drag and drop.",
    "WIDGET_HELP_TEXT_WM-MOBILE-NAVBAR": "Use this component to create header navigation in mobile applications",
    "WIDGET_HELP_TEXT_WM-BREADCRUMB": "Indicator or nav link to the current page’s location within the app’s hierarchy",
    "WIDGET_HELP_TEXT_WM-ICON": "A component for displaying a comprehensible symbol or graphic",
    "WIDGET_HELP_TEXT_WM-BUTTON": "Button is a control that can be clicked to perform an action",
    "WIDGET_HELP_TEXT_WM-RATING": "Component allowing users to input ratings as data",
    "WIDGET_HELP_TEXT_WM-CHIPS": "Component allowing users to search data and add, delete and edit them",
    "WIDGET_HELP_TEXT_WM-CAMERA":"This component is used for capturing the photos and videos in device.",
    "WIDGET_HELP_TEXT_WM-BARCODESCANNER":"This component is used for scanning the barcode",
    "WIDGET_HELP_TEXT_WM-BUTTONGROUP": "Button group is arrangement of buttons grouped together",
    "WIDGET_HELP_TEXT_WM-MENU": "A pull-down menu interface used for defining navigation structure within the app or for external links",
    "WIDGET_HELP_TEXT_WM-COMPOSITE": "A container for form components, contains a label and a form component(like text, textarea).",
    "WIDGET_HELP_TEXT_WM-TEXT": "Allows input of a single line of text",
    "WIDGET_HELP_TEXT_WM-TEXTAREA": "Textarea allows for multiple rows of data to be shown and entered",
    "WIDGET_HELP_TEXT_WM-SELECT": "A drop down list bound to a fixed dataset limited to a maximum of 500 list items.",
    "WIDGET_HELP_TEXT_WM-RADIO": "A radio button allows the user to choose only one of a predefined set of options",
    "WIDGET_HELP_TEXT_WM-RADIOSET": "Radioset is arrangement of radio components grouped together",
    "WIDGET_HELP_TEXT_WM-SWITCH": "A component that can help switching between 3 or more different options by pressing a single key",
    "WIDGET_HELP_TEXT_WM-CHECKBOX": "A checkbox allows the user to choose one or multiple of a predefined set of options",
    "WIDGET_HELP_TEXT_WM-CHECKBOXSET": "Checkboxset is arrangement of checkbox components grouped together",
    "WIDGET_HELP_TEXT_WM-CURRENCY": "A special text component to input the currency type data, with the display format based on the currency type.",
    "WIDGET_HELP_TEXT_WM-DATE": "A component that helps selecting a date from a calendar within the date range",
    "WIDGET_HELP_TEXT_WM-CALENDAR": "A component that allows user to select date from the calendar displayed",
    "WIDGET_HELP_TEXT_WM-TIME": "A component that helps selecting time from within a specified time range",
    "WIDGET_HELP_TEXT_WM-COLORPICKER": "Component to select the color and translate to hex value",
    "WIDGET_HELP_TEXT_WM-FILEUPLOAD": "A component that pops up a file browsing window to select files and upload",
    "WIDGET_HELP_TEXT_WM-SLIDER": "A component control with a handle that can be moved right and left (horizontal slider) on a bar to select a value from within the range of allowed values",
    "WIDGET_HELP_TEXT_WM-LABEL": "Uneditable text as a heading or to describe another component",
    "WIDGET_HELP_TEXT_WM-MARQUEE": "A container to keep scrolling content. The scrolling can be in horizontal or in vertical direction.",
    "WIDGET_HELP_TEXT_WM-ANCHOR": "Navigation link within the app or an external URL",
    "WIDGET_HELP_TEXT_WM-POPOVER": "A container-type graphical control element that opens in its parent window and blocks any other interaction until selected.",
    "WIDGET_HELP_TEXT_WM-PICTURE": "A component to display images in the project",
    "WIDGET_HELP_TEXT_WM-TREE": "A component that can be used to display data in a hierarchical format",
    "WIDGET_HELP_TEXT_WM-VIDEO": "A component to embed a media player into the project",
    "WIDGET_HELP_TEXT_WM-AUDIO": "A component to embed an audio player into the project",
    "WIDGET_HELP_TEXT_WM-HTML": "A component to display HTML content or to render the text content using HTML",
    "WIDGET_HELP_TEXT_WM-IFRAME": "A component to display a web page content in a separate frame, without affecting the current page content or styles.",
    "WIDGET_HELP_TEXT_WM-MESSAGE": "A component to display success, info, loading, error or warning messages to the user.",
    "WIDGET_HELP_TEXT_WM-SPINNER": "A component for visual indicator of activity in progress",
    "WIDGET_HELP_TEXT_WM-SEARCH": "Search within a data source and give results",
    "WIDGET_HELP_TEXT_WM-RICHTEXTEDITOR": "Input control for formatted text content, optionally including media (WYSIWYG).",
    "WIDGET_HELP_TEXT_WM-PAGINATION": "A component allowing user to traverse paginated set of data",
    "WIDGET_HELP_TEXT_WM-TABLE": "A component that presents a tabular view of data and allow actions",
    "WIDGET_HELP_TEXT_WM-LIVEFORM": "Live Form is a group of input elements put together to submit data, typically resulting in creating or updating a database row.",
    "WIDGET_HELP_TEXT_WM-FORM-FIELD": "This container represents the properties of the respective field of the Live Form",
    "WIDGET_HELP_TEXT_WM-LIVETABLE": "A component to present a tabular view of database data and allows CRUD operation to be performed",
    "WIDGET_HELP_TEXT_WM-FILTER-FIELD": "This container represents the properties of the respective field of the Filter",
    "WIDGET_HELP_TEXT_WM-LISTTEMPLATE": "Subcomponent of livelist, which is repeated based on the datset",
    "WIDGET_HELP_TEXT_WM-LIVEFILTER": "Live Filter is a component that allows user to filter the database results, usually used in combination with List or Table to display the filtered results.",
    "WIDGET_HELP_TEXT_WM-LOGIN": "A login form used for taking credentials for authentication, embedded within a page.",
    "WIDGET_HELP_TEXT_WM-VIEW": "View is a container which can be added onto the page. Views are containers with flexible and efficient navigation possibilities. Only one view is visible at a time and there is no visual cue about the other views that exist. Navigation between views is triggered by events, such as a user clicking a button or link. You can find the Add View button and Views listed on the Canvas Toolbar.",
    "WIDGET_HELP_TEXT_WM-DIALOG": "This component gives a pop-up window. It can be used to gather information from user for example, reconfirm your login details.",
    "WIDGET_HELP_TEXT_WM-DESIGN-DIALOG": "A small window that communicates information to the user and prompts them for a response. The content of the dialog is customizable.",
    "WIDGET_HELP_TEXT_WM-DIALOGHEADER": "Header of the dialog, for title of the dialog",
    "WIDGET_HELP_TEXT_WM-DIALOGCONTENT": "Content of the dialog",
    "WIDGET_HELP_TEXT_WM-DIALOGACTIONS": "Footer of the dialog for actions. Example: ok, cancel",
    "WIDGET_HELP_TEXT_WM-ALERTDIALOG": "A special dialog that is displayed, when user needs to take an immediate action.",
    "WIDGET_HELP_TEXT_WM-CONFIRMDIALOG": "A special dialog box that is displayed which requires user’s consent to complete the action",
    "WIDGET_HELP_TEXT_WM-IFRAMEDIALOG": "A dialog box that loads external web page",
    "WIDGET_HELP_TEXT_WM-PAGEDIALOG": "A dialog box that loads the partial page content",
    "WIDGET_HELP_TEXT_WM-LOGINDIALOG": "A dialog box that allows user to customize the login dialog",
    "WIDGET_HELP_TEXT_WM-CHART": "<b>Line Chart:</b> <br> This component allows one to represent data in a graphical format. Use this type of chart to represent trends for example popluation growth over a time period. <br><b>Column Chart:</b> <br> This component allows one to represent data in a graphical format. Use this type of chart to represent usage levels for example sales figures over a period of three years. <br><b>Area Chart:</b> <br> This component allows one to represent data in a graphical format. Use this type of chart to represent trends for example popluation growth over a time period. It is a filled up line chart. <br><b>Pie Chart:</b> <br> This component allows one to represent data in a graphical format. Use this type of chart to represent composition of data for example, usage over a geographic area. <br><b>Bar Chart:</b> <br> This component allows one to represent data in a graphical format. Use this type of chart to represent comparison analysis for example sales figures of ten different brands. <br>",
    "WIDGET_HELP_TEXT_WM-CHART-LINE": "A line chart displays information as a series of data points called ‘markers’ connected by straight line segments",
    "WIDGET_HELP_TEXT_WM-CHART-COLUMN": "Column charts display vertical bars going across the horizontal axis",
    "WIDGET_HELP_TEXT_WM-CHART-AREA": "An area chart is a line chart with the areas below the lines filled",
    "WIDGET_HELP_TEXT_WM-CHART-PIE": "A type of graph in which a circle is divided into sectors that each represent a proportion of the whole",
    "WIDGET_HELP_TEXT_WM-CHART-BAR": "A bar chart presents grouped data with horizontal bars with lengths proportional to the values that they represent",
    "WIDGET_HELP_TEXT_WM-CHART-CUMULATIVELINE": "A line chart displays information as a series of data points, each data point is a cumulative sum of the data points of the preceding series",
    "WIDGET_HELP_TEXT_WM-CHART-DONUT": "A type of graph in which a circle is divided into sectors that each represent a proportion of the whole, with an inner circle showing summary.",
    "WIDGET_HELP_TEXT_WM-CHART-BUBBLE": "A bubble chart is a type of chart that displays three dimensions of data",
    "WIDGET_HELP_TEXT_WM-CARD": "A single unit of content or functionality, presented in a concise visual package, to easily update, maintain, and personalize content area.",
    "WIDGET_HELP_TEXT_WM-NAV": "Component represents navigation link or anchor, typically used for building navigation for multi-page apps.",
    "WIDGET_HELP_TEXT_WM-NAVBAR": "Grouping of nav components for navigation capabilities",
    "WIDGET_HELP_TEXT_WM-NUMBER": "Allows to enter a single line of numbers",
    "WIDGET_HELP_TEXT_WM-COMPOSITE-TOGGLE": "A component that can help switching between two different options by pressing a single key",
    "WIDGET_HELP_TEXT_WM-COMPOSITE-DATETIME": "A composite component of date and time components",
    "WIDGET_HELP_TEXT_WM-COMPOSITE-SELECTLOCALE": "Component for Language selection from the list of support languages",
    "WIDGET_HELP_TEXT_WM-PROGRESS-BAR": "Actual indicator of activity progress with time/percentage",
    "WIDGET_HELP_TEXT_WM-PROGRESS-CIRCLE": "It is typically a circular bar which is gradually filled with a color as the process completes.",
    "MESSAGE_HELP_PROPERTY_WM-TABS_TYPE": "This property specifies the type of tabs component. <br> 1. Static: The tabpanes will be static(current behaviour). <br> 2. Dynamic: The tabpanes will be generated based on the dataset bound to the component.",
    "MESSAGE_HELP_PROPERTY_WM-ACCORDION_TYPE": "This property specifies the type of accordion component. <br> 1. Static: The accordionpanes will be static(current behaviour). <br> 2. Dynamic: The accordionpanes will be generated based on the dataset bound to the component.",
    "MESSAGE_HELP_PROPERTY_WM-BUTTON_TYPE": "Specify the type of button - Button, Reset or Submit",
    "MESSAGE_HELP_PROPERTY_WM-TEXT_TYPE": "This property specifies the type of the input. It can be of type date, email, number, password, text or url.",
    "MESSAGE_HELP_PROPERTY_WM-TEXT_DISPLAYFORMAT": "The keys in display format represent the special tokens/characters used to delimit acceptable ranges of inputs.<br>For example, we use '9' here to accept any numeric values for a phone number: displayformat='(999) 999-9999'. The values associated with each token are regexen. Each regex defines the ranges of values that will be acceptable as inputs in the position of that token.<br>Tokens:<br>A Any letter.<br>9 Any number.<br>* Any letter or number.<br>? Make any part of the mask optional.",
    "MESSAGE_HELP_PROPERTY_INPUTTYPE": "This property specifies the type of the input. It can be of type date, email, number, password, text or url.",
    "MESSAGE_HELP_PROPERTY_WM-MESSAGE_TYPE": "This property specifies the type of the variable – error, info, loading, success or warn",
    "MESSAGE_HELP_PROPERTY_WM-CHART_TYPE": "Defines the type of chart which could be of the following. line, column, bar, area , cumulative line, pie and donut",
    "MESSAGE_HELP_PROPERTY_WM-NAV_TYPE": "Defines the display style, choose between pills or tabs.",
    "MESSAGE_HELP_PROPERTY_WM-LISTTEMPLATE_LAYOUT": "This property specifies the type of the variable. It can be set to blank, inline, thumbnail, panel or gridlayout.",
    "MESSAGE_HELP_PROPERTY_WM-LIVEFORM_LAYOUT": "This property controls how contained components are displayed within this component container. Choose from one-column, two-column, three-column or four-column layout.",
    "MESSAGE_HELP_PROPERTY_WM-LIVEFILTER_LAYOUT": "This property controls how contained components are displayed within this component container. Choose from one-column, two-column, three-column or four-column layout.",
    "MESSAGE_HELP_PROPERTY_WM-SELECT_DATASET":"Select:<br>Set this property to a variable to populate the list of values to display.<br>Select Locale:<br>By default it is bound to the supportedLocale variable which gets created when &lta href='/docs/studio/localization/' title='Localization'&gtLocalization &lt/a&gtis enabled.",
    "MESSAGE_HELP_PROPERTY_WM-RATING_DATASET":"This property is used to map a caption value against the value of the component. It can accept:<br>1. comma separated string containing the caption values (mappped to rating value in ascending order).<br>2. array of strings (mapped as above).<br>3. Array of objects, needs selection of DataField(to map to rating value) and DisplayField(to map to caption against the rating value).",
    "MESSAGE_HELP_PROPERTY_WM-SELECT_ONCHANGE": "Select:<br>This event handler is called each time your element's value changes. <br>Select Locale:<br>By default it is set to invoke $root.changeLocale which would change the language rendered in the application.",
    "COMMENT_PROPERTY_PANEL_RESOURCES":"---------Property Panel Localization Resources-----------",
    "MESSAGE_VIEW_LOCKED":"The View is locked. Unlock it to modify further. You can unlock the view from the components tree in the left file tab",
    "LABEL_PROPERTY_PROPERTIES":"Properties",
    "LABEL_PROPERTY_STYLES":"Styles",
    "LABEL_PROPERTY_EVENTS":"Events",
    "LABEL_PROPERTY_MOBILE":"Mobile",
    "LABEL_PROPERTY_DEVICE":"Device",
    "LABEL_PROPERTY_SETTINGS":"Settings",
    "LABEL_PROPERTY_NAME":"Name",
    "LABEL_PROPERTY_NODEACTION":"Node Action",
    "LABEL_PROPERTY_NODECLICK":"Node Click",
    "MESSAGE_HELP_PROPERTY_NODECLICK":"Set this property to expand the node when it is clicked",
    "MESSAGE_HELP_PROPERTY_NODEACTION":"This property sets the actions for the component.",
    "MESSAGE_HELP_PROPERTY_NAME":"The name is a unique identifier for your component. Each page element and component must be uniquely identified. WaveMaker automatically renames any non-unique element. Special characters and spaces are not allowed in component name.",
    "LABEL_PROPERTY_PAGETITLE":"Page Title",
    "MESSAGE_HELP_PROPERTY_PAGETITLE":"Page title will be set as the document title in run mode",
    "LABEL_PROPERTY_PAGINATIONCLASS":"Pagination Class",
    "MESSAGE_HELP_PROPERTY_PAGINATIONCLASS":"This property allows user style pagination class.",
    "LABEL_PROPERTY_DEBUGURL":"Debug Url",
    "MESSAGE_HELP_PROPERTY_DEBUGURL":"Deployed/run url of the prefab application",
    "LABEL_PROPERTY_TABINDEX":"Tab Index",
    "LABEL_PROPERTY_HEADINGLEVEL": "Heading Level",
    "LABEL_PROPERTY_SHOWAMPMBUTTONS":"Show AM PM Buttons",
    "MESSAGE_HELP_PROPERTY_SHOWAMPMBUTTONS":"This property will allow you to show different buttons for AM PM if set to true.",
    "MESSAGE_HELP_PROPERTY_HEADINGLEVEL": "This property allows you to select the HTML heading level for the dialog title. Choose from the options h1 to h6 based on the context and hierarchy of your content.",
    "LABEL_PROPERTY_MINCHARS":"Min Chars",
    "LABEL_PROPERTY_TABORDER": "Tab Order",
    "MESSAGE_HELP_PROPERTY_TABINDEX": "The tabindex attribute specifies the tab order of an element. The value can range from 0 to 32767. Default is 0 and -1 makes the element non-focusable.",
    "MESSAGE_HELP_PROPERTY_MINCHARS": "The minchars attribute specifies the number of characters that need to be entered before the query is triggered. It must be greater than or equal to 0.",
    "MESSAGE_HELP_PROPERTY_TABORDER":"The order of the Tabs can be changed using the arrow icons next to the tab names.",
    "LABEL_PROPERTY_HINT":"Hint",
    "MESSAGE_HELP_PROPERTY_HINT":"Any text or html you enter for this property will be shown as a tooltip if the mouse hovers over this component for 1.5 seconds.",
    "MESSAGE_HELP_PROPERTY_HINT_MOBILE":"Any text or html you enter for this property will be used for accessibility WAI-ARIA labels.",
    "MESSAGE_HELP_PROPERTY_ACCESSIBLE_MOBILE":"Indicates whether the component is an accessible element that can be focused by screen readers.",
    "MESSAGE_HELP_PROPERTY_ACCESSIBLE_LABEL_MOBILE":"Sets a custom label that screen readers will read instead of the visual text content",
    "MESSAGE_HELP_PROPERTY_ACCESSIBLE_ROLE_MOBILE":"Helps screen readers understand what this element does, like whether it’s a button, link, or image.",
    "MESSAGE_HELP_PROPERTY_ARIALABEL":"Any text you enter for this property will be used for accessibility WAI-ARIA labels.",
    "MESSAGE_HELP_PROPERTY_ALTTEXT":"Any text you enter for this property will be used as an alternate text for the image, if the image for some reason cannot be displayed",
    "LABEL_PROPERTY_URL":"URL",
    "MESSAGE_HELP_PROPERTY_URL":"Any url entered for this property will be shown in the dialogcontent",
    "LABEL_PROPERTY_WIDTH":"Width",
    "MESSAGE_HELP_PROPERTY_WIDTH":"The width of your component can be specified in px or % (i.e 50px, 75%).",
    "LABEL_PROPERTY_FILELISTHEIGHT":"Files List Height",
    "MESSAGE_HELP_PROPERTY_FILELISTHEIGHT":"This property specifies the height of the list containing the selected files.This value can be specified in px or % (i.e 50px, 75%).",
    "LABEL_PROPERTY_HEIGHT":"Height",
    "MESSAGE_HELP_PROPERTY_HEIGHT":"The height of your component can be specified in px or % (i.e 50px, 75%).",
    "LABEL_PROPERTY_MENULAYOUT":"Menu Layout",
    "MESSAGE_HELP_PROPERTY_MENULAYOUT": "Vertical layout arranges the menu items vertically. Horizontal layout arranges the menu items horizontally.",
    "LABEL_PROPERTY_MINWIDTH":"Min Width",
    "MESSAGE_HELP_PROPERTY_MINWIDTH":"minWidth allows components that aren't of fixed width to specify that they should never shrink down below a minimum width. If left at 0, the component will calculate for itself what it thinks is the smallest possible width.",
    "LABEL_PROPERTY_MINHEIGHT":"Min Height",
    "MESSAGE_HELP_PROPERTY_MINHEIGHT":"minHeight allows components that aren't of fixed height to specify that they should never shrink down below a minimum height. If left at 0, the component will calculate for itself what it thinks is the smallest possible height.",
    "LABEL_PROPERTY_MESSAGE":"Message",
    "LABEL_PROPERTY_MESSAGELAYOUT":"Message Layout",
    "MESSAGE_HELP_PROPERTY_MESSAGELAYOUT":"Select the value to decide the appearance of the success/error message after CRUD operation. If no message is required for any operation, clear the respective message(below).",
    "LABEL_PROPERTY_TITLE":"Title",
    "LABEL_PROPERTY_DISPLAYNAME":"Title",
    "LABEL_PROPERTY_WIDGET":"Component",
    "LABEL_PROPERTY_OKTEXT":"Ok Text",
    "LABEL_PROPERTY_CANCELTEXT":"Cancel Text",
    "LABEL_PROPERTY_SUBTITLE":"Subtitle",
    "MESSAGE_HELP_PROPERTY_SUBTITLE":"Set the subtitle of the component",
    "LABEL_PROPERTY_DELETEOKTEXT":"Confirm Action Text",
    "MESSAGE_HELP_PROPERTY_DELETEOKTEXT": "This text will be displayed on confirm button for delete dialog",
    "LABEL_PROPERTY_DELETECANCELTEXT":"Cancel Action Text",
    "MESSAGE_HELP_PROPERTY_DELETECANCELTEXT": "This text will be displayed on cancel button for delete dialog",
    "LABEL_PROPERTY_CONTENTSOURCE":"Content Source",
    "LABEL_PROPERTY_CONTENT":"Content",
    "LABEL_PROPERTY_INLINECONTENT":"Content",
    "MESSAGE_HELP_PROPERTY_CONTENTSOURCE":"Select from the content source as Partial or Inline. In case of Partial, the partial page is selected. In case of Inline, the inline content is compiled.",
    "MESSAGE_HELP_PROPERTY_CONTENT":"Html content(in case of html component) or Page's content(in case of page container components) will be included in the component. In case of Page content, on switching from inline content the component content is lost and cannot be undone. onLoad callback will be triggered only when the content is a partial",
    "MESSAGE_HELP_PROPERTY_INLINECONTENT": "Type or Include the wm markup or html markup to show up as content",
    "LABEL_PROPERTY_IFRAMESRC": "Source",
    "LABEL_IFRAMESRC_ERRORMSG": "Unable to load the requested iframe content due to an exception",
    "LABEL_IFRAMESRC_HINTMSG": "This might be due to restrictions set by the content provider",
    "LABEL_IFRAMESRC_RESTRICTION_MSG": "Iframe cannot be loaded in studio mode",
    "MESSAGE_HELP_PROPERTY_IFRAMESRC": "This property can be used to define the source attribute of the iframe. Example Source: '//wavemaker.com', 'http://wavemaker.com' or 'http://www.wavemaker.com'",
    "LABEL_PROPERTY_MODAL":"Modal",
    "MESSAGE_HELP_PROPERTY_MODAL":"When the modal property is enabled, the dialog can only be closed using the Cancel button. If it is disabled, it can be closed from anywhere.",
    "LABEL_PROPERTY_KEYBOARD":"Keyboard",
    "MESSAGE_HELP_PROPERTY_KEYBOARD":"The value selected will be on ESC key press closes the dialog",
    "LABEL_PROPERTY_ONDEMANDMESSAGE":"On Demand Message",
    "MESSAGE_HELP_PROPERTY_ONDEMANDMESSAGE":"The property can be used to customize the on demand navigation message.",
    "LABEL_PROPERTY_PAGE":"Page",
    "MESSAGE_HELP_PROPERTY_PAGE":"The selected project page is included in the component.",
    "LABEL_PROPERTY_CAPTIONKEY":"Caption Key",
    "MESSAGE_HELP_PROPERTY_CAPTIONKEY":"The caption key is the text that the end user sees on your label when some caption key is selected.",
    "LABEL_PROPERTY_CAPTION":"Caption",
    "MESSAGE_HELP_PROPERTY_CAPTION":"The caption is the text that the end user sees on your label.",
    "LABEL_PROPERTY_SCROLLDELAY":"Scroll Delay",
    "MESSAGE_HELP_PROPERTY_SCROLLDELAY":"Sets the delay in scroll of the Marquee.",
    "LABEL_PROPERTY_SCROLLAMOUNT":"Scroll Amount",
    "MESSAGE_HELP_PROPERTY_SCROLLAMOUNT":"Increasing scroll amount, increases the speed of the scroll",
    "LABEL_PROPERTY_DIRECTION":"Direction",
    "MESSAGE_HELP_PROPERTY_DIRECTION":"Changes the direction of the scroll",
    "LABEL_PROPERTY_DROPPOSITION":"Position",
    "MESSAGE_HELP_PROPERTY_DROPPOSITION":"Position of the dropdown - up/down",
    "LABEL_PROPERTY_BARCODEFORMAT":"Bar Code Format",
    "MESSAGE_HELP_PROPERTY_BARCODEFORMAT":"Format of  bar code to scan.",
    "LABEL_PROPERTY_CAPTURETYPE":"Capture Type",
    "MESSAGE_HELP_PROPERTY_CAPTURETYPE":"This specifies whether the image or video that is to be captured.",
    "LABEL_PROPERTY_IMAGEQUALITY":"Image Quality",
    "MESSAGE_HELP_PROPERTY_IMAGEQUALITY":"Quality of the saved image, expressed as a range of 0-100, where 100 is typically full resolution with no loss from file compression",
    "LABEL_PROPERTY_IMAGETARGETWIDTH":"Target Width",
    "MESSAGE_HELP_PROPERTY_IMAGETARGETWIDTH":"This property specifies the width in px to resize the image.",
    "LABEL_PROPERTY_IMAGETARGETHEIGHT":"Target Height",
    "MESSAGE_HELP_PROPERTY_IMAGETARGETHEIGHT":"This property specifies the height in px to resize the image.",
    "LABEL_PROPERTY_IMAGEENCODINGTYPE":"Encoding Type",
    "MESSAGE_HELP_PROPERTY_IMAGEENCODINGTYPE":"Choose the returned image file's encoding. Default is JPEG.",
    "LABEL_PROPERTY_OFFLINE":"Save For Offline",
    "MESSAGE_HELP_PROPERTY_OFFLINE":"If checked, then picture is saved for offline.",
    "MESSAGE_HELP_PROPERTY_THUMBNAILURL":"This contains the url for the picture’s thumbnail url",
    "MESSAGE_HELP_PROPERTY_MEDIAURL":"This contains the url for the picture.",
    "LABEL_PROPERTY_CORRECTORIENTATION":"Correct Orientation",
    "MESSAGE_HELP_PROPERTY_CORRECTORIENTATION":"Rotate the image to correct for the orientation of the device during capture.",
    "LABEL_PROPERTY_SAVETOGALLERY":"Save To Gallery",
    "MESSAGE_HELP_PROPERTY_SAVETOGALLERY":"Save the image to the photo album on the device after capture",
    "LABEL_PROPERTY_ALLOWEDIT":"Edit",
    "MESSAGE_HELP_PROPERTY_ALLOWEDIT":"Allow simple editing of image before selection. ",
    "LABEL_PROPERTY_SOURCETYPE":"Source Type",
    "MESSAGE_HELP_PROPERTY_SOURCETYPE":" Set the source of the picture. The default is CAMERA.",
    "LABEL_PROPERTY_MENUPOSITION":"Menu Position",
    "MESSAGE_HELP_PROPERTY_MENUPOSITION":"Position of the menu list items - inline, down-right, down-left, up-left, up-right ",
    "LABEL_PROPERTY_LINKTARGET":"Target",
    "MESSAGE_HELP_PROPERTY_LINKTARGET":"For every option in the dropdownlist there is separate content, <br> _blank: Opens the linked document in a new window or tab <br> _self:Opens the linked document in the same frame as it was clicked (this is default) <br> _parent: Opens the linked document in the parent frame <br> _top : Opens the linked document in the full body of the window.",
    "LABEL_PROPERTY_SHOW":"Show",
    "LABEL_PROPERTY_HIDE":"Hide",
    "MESSAGE_HELP_PROPERTY_SHOW":"Showing determines whether or not a component is visible. A page element that is not showing has its css display style set to none; it is still a part of the DOM model of the page, but no longer affects the layout of other components.",
    "LABEL_PROPERTY_DEFERLOAD":"Load On Demand",
    "MESSAGE_HELP_PROPERTY_DEFERLOAD":"When this property is set and show property is bound, the initialization of the component will be deferred till the component becomes visible. This behavior improves the load time. Use this feature with caution, as it has a downside (as we will not be able to interact with the component through script until the component is initialized). When show property is not bound the component will be initialized immediately, irrespective of this property setting.",
    "LABEL_PROPERTY_ISDEFAULTTAB":"Is Default Tab",
    "MESSAGE_HELP_PROPERTY_ISDEFAULTTAB":"This property determines if the tab is the default tab",
    "LABEL_PROPERTY_DISABLENEXT":"Disable Next Step",
    "MESSAGE_HELP_PROPERTY_DISABLENEXT":"Set this property to disable next step button for current step",
    "LABEL_PROPERTY_ENABLEDONE":"Enable Done",
    "MESSAGE_HELP_PROPERTY_ENABLEDONE":"Set this property to enable done button on current step",
    "LABEL_PROPERTY_ENABLESKIP":"Enable Skip",
    "MESSAGE_HELP_PROPERTY_ENABLESKIP":"Set this property to enable skip option on current step",
    "LABEL_PROPERTY_CANCELABLE":"Cancelable",
    "MESSAGE_HELP_PROPERTY_CANCELABLE":"Set this property to allow wizard cancel",
    "LABEL_PROPERTY_ENABLENEXT":"Enable Next",
    "MESSAGE_HELP_PROPERTY_ENABLENEXT": "Set this property to enable next button irrespective of form validation in the current step.",
    "LABEL_PROPERTY_TABSPOSITION":"Tabs Position",
    "MESSAGE_HELP_PROPERTY_TABSPOSITION":"This property determines where tabs should be placed w.r.t content.",
    "LABEL_PROPERTY_ALIGN":"Align",
    "MESSAGE_HELP_PROPERTY_ALIGN":"Use this property to set the left/right/center alignment for this text.",
    "LABEL_PROPERTY_DISABLED":"Disabled",
    "MESSAGE_HELP_PROPERTY_DISABLED":"If the disabled property is true (checked) the value of the editor cannot change. The component becomes display-only.",
    "LABEL_PROPERTY_DISABLEITEM":"Disable Item",
    "MESSAGE_HELP_PROPERTY_DISABLEITEM":"If the disable selection property is true (checked), selection of List item won't happen on the component.",
    "LABEL_PROPERTY_SHORTCUTKEY": "Shortcut Key",
    "MESSAGE_HELP_PROPERTY_SHORTCUTKEY":"The shortcut key property specifies a shortcut key to activate/focus an element. <br>The way of accessing the shortcut key is varying in different browsers <br>Internet Explorer - [Alt] + shortcutkey, <br>Chrome - [Alt] + shortcutkey (Windows/Linux) [Control] [Alt] + shortcutkey (MAC),<br>Firefox - [Alt] [Shift] + shortcutkey (Windows/Linux) [Control] [Alt] + shortcutkey (MAC),<br>Safari - [Alt] + shortcutkey (Windows) [Control] [Alt] + shortcutkey (MAC)",
    "LABEL_PROPERTY_LAYOUTKIND":"Arrangement",
    "MESSAGE_HELP_PROPERTY_LAYOUTKIND":"This property controls how contained components are displayed within this component container. \n top-to-bottom: each components inside this container will be displayed below the other components inside the container \n left-to-right: each component inside this container will be displayed to the right of other components inside the container.",
    "LABEL_PROPERTY_LAYOUT":"Layout",
    "MESSAGE_HELP_PROPERTY_LAYOUT":"This property controls how contained components are displayed within this component container.",
    "LABEL_PROPERTY_FORMLAYOUT":"Form Layout",
    "MESSAGE_HELP_PROPERTY_FORMLAYOUT":"This property controls how the form appears, whether inline or in a dialog.",
    "LABEL_PROPERTY_ITEMSPERROW":"Items per Row",
    "MESSAGE_HELP_PROPERTY_ITEMSPERROW":"This property controls the number of components that are displayed within this component container in a horizontal layout.",
    "LABEL_PROPERTY_RESPONSIVE": "Responsive",
    "MESSAGE_HELP_PROPERTY_RESPONSIVE": "This property enables the Items per Row configuration configured in the above section. In future versions it will be enabled by default",
    "LABEL_PROPERTY_FALLBACK":"Fallback",
    "MESSAGE_HELP_PROPERTY_FALLBACK":"This property controls how the system handles missing breakpoint values in responsive configurations",
    "LABEL_PROPERTY_REQUIRED":"Required",
    "MESSAGE_HELP_PROPERTY_REQUIRED":"A required editor in wm.LiveForm may refuse to save without a required field.",
    "LABEL_PROPERTY_PLACEHOLDER":"Placeholder",
    "MESSAGE_HELP_PROPERTY_PLACEHOLDER":"A placeholder is text to show in the editor when there is no value. A common use of this is a search box that says in faint gray italicized text \"Search...\" which disappears as soon as the user starts to edit the text box. This is a useful alternative to a caption if you are constrained in space and asking for something simple of the user.",
    "LABEL_PROPERTY_CURRENCY":"Currency",
    "MESSAGE_HELP_PROPERTY_CURRENCY":"Currency determines which currency symbol should be shown for the currency component.",
    "LABEL_PROPERTY_INPUTMODE":"Input Mode",
    "MESSAGE_HELP_PROPERTY_INPUTMODE":"This property determines how to handle numbers as the user types them. <br><br> <b>FINANCIAL</b> - Numbers start at the highest precision decimal. Numbers will be shifted to the left on the type. Most cash registers work this way.<br><br> Examples: <br> - Typing 12 results in 0.12 <br> - Typing 1234 results in 12.34 <br> - Typing 1.234 results in 12.34 <br> <br> <b>NATURAL</B> - This mode will act as a regular number field. Most text inputs and spreadsheets work this way. <br><br> Examples: <br> - Typing 1234 results in 1234 <br> - Typing 1.234 results in 1.234",
    "LABEL_PROPERTY_DECIMALPLACES":"No of Decimal Places",
    "MESSAGE_HELP_PROPERTY_DECIMALPLACES":"This property specifies the maximum number of decimal places allowed in the input",
    "LABEL_PROPERTY_VALUE":"Value",
    "MESSAGE_HELP_PROPERTY_VALUE":"This is the default value to display for an editor component.",
    "LABEL_PROPERTY_DISPLAYLABEL":"Label Value",
    "MESSAGE_HELP_PROPERTY_DISPLAYLABEL":"This is the default value to display value for an editor component. Note that the display value is just what the user sees initially, and is not always the dataValue returned by the component.",
    "LABEL_PROPERTY_DISPLAYIMAGESRC":"Picture Source",
    "MESSAGE_HELP_PROPERTY_DISPLAYIMAGESRC":"This property sets the image to be displayed in the search results.",
    "LABEL_PROPERTY_DATAVALUE":"Value",
    "MESSAGE_HELP_PROPERTY_DATAVALUE":"This is the default value to display value for an editor component. Note that the display value is just what the user sees initially, and is not always the dataValue returned by the component.",
    "LABEL_PROPERTY_SELECTEDITEM":"Selected Item",
    "MESSAGE_HELP_PROPERTY_SELECTEDITEM":"This property contains the selected row object in the table. This will also be returned by the component's 'selecteditem' property",
    "LABEL_PROPERTY_DATATYPE":"Data Type",
    "MESSAGE_HELP_PROPERTY_DATATYPE":"Determines the type of value that is accepted within the checkedValue property",
    "LABEL_PROPERTY_BINDVARIABLE":"Bind Variable",
    "MESSAGE_HELP_PROPERTY_BINDVARIABLE":"This property enables a particular value to get bound with a scope or live variable. If it is checked, provided value will be searched in scope and its value will be assigned to the component, else empty value will be given",
    "LABEL_PROPERTY_DATACHECKVALUE":"Data Check Value",
    "MESSAGE_HELP_PROPERTY_DATACHECKVALUE":"This property identifies the value that should be assigned to the checked and unchecked states of the element.",
    "LABEL_PROPERTY_CAPTIONWIDTH":"Width",
    "MESSAGE_HELP_PROPERTY_CAPTIONWIDTH":"Accepts integer(x) between 1-12 and adds class col-xs-(x) for mobile, col-sm-(x) for Tablet Potrait, col-md-(x) for Laptop Tablet Landscape , col-lg-(x) for Large screen to suit bootstrap fluid grid system.",
    "LABEL_PROPERTY_CAPTIONALIGN":"Align",
    "MESSAGE_HELP_PROPERTY_CAPTIONALIGN":"The caption for your component can be left, center or right aligned",
    "LABEL_PROPERTY_CAPTIONPOSITION":"Position",
    "MESSAGE_HELP_PROPERTY_CAPTIONPOSITION":"This property determines where your caption appears with respect to the edit field. It is up to you to insure that there is sufficient height or width for the caption to fit in the selected position.",
    "LABEL_PROPERTY_MAXHEIGHT":"Max Height",
    "MESSAGE_HELP_PROPERTY_MAXHEIGHT":"This property determines where your caption appears with respect to the edit field. It is up to you to insure that there is sufficient height or width for the caption to fit in the selected position.",
    "LABEL_PROPERTY_AUTOFOCUS":"Auto Focus",
    "MESSAGE_HELP_PROPERTY_AUTOFOCUS":"This property makes the element get focused automatically when the page loads.",
    "LABEL_PROPERTY_READONLY":"Read Only",
    "MESSAGE_HELP_PROPERTY_READONLY":"Selecting this checkbox property prevents the user from being able to change the data value of a component.",
    "LABEL_PROPERTY_TRAILINGZERO":"Allow Trailing Zeros",
    "MESSAGE_HELP_PROPERTY_TRAILINGZERO":"This property specifies whether to keep trailing zeros after decimal point or not. <br> Ex: <br> 1) trailingzero = false <br> entered text = '12.340' then displayvalue = '12.34' <br> 2) trailingzero = true <br> entered text = '12.340' then displayvalue = '12.340' <br> Note: The output value of the component will not be affected by this property" ,
    "LABEL_PROPERTY_MAXCHARS":"Maximum Characters",
    "MESSAGE_HELP_PROPERTY_MAXCHARS":"Defines the maximum number of characters that can be entered in the editor.",
    "LABEL_PROPERTY_LIMITDISPLAYTEXT":"Help text (character count)",
    "MESSAGE_HELP_PROPERTY_LIMITDISPLAYTEXT":"Shows the number of characters entered against the maximum number of characters.",
    "LABEL_PROPERTY_ICONNAME":"Icon Name",
    "MESSAGE_HELP_PROPERTY_ICONNAME":"This property defines the name of the icon that is applied to the button.",
    "LABEL_PROPERTY_ICONCLASS":"Icon Class",
    "LABEL_PROPERTY_DONEICONCLASS":"Done Icon Class",
    "LABEL_PROPERTY_EXPANDEDICONCLASS":"Expanded Icon Class",
    "LABEL_PROPERTY_COLLAPSEDICONCLASS":"Collapsed Icon Class",
    "MESSAGE_HELP_PROPERTY_ICONCLASS":"This property defines the class of the icon that is applied to the button.",
    "MESSAGE_HELP_PROPERTY_WM-ACCORDION_EXPANDEDICONCLASS":"Icon class to display for the expanded header toggle in Accordion.",
    "MESSAGE_HELP_PROPERTY_WM-ACCORDION_COLLAPSEDICONCLASS":"Icon class to display for the collapsed header toggle in Accordion.",
    "MESSAGE_HELP_PROPERTY_WM-PANEL_EXPANDEDICONCLASS":"Icon class to display for the expanded header toggle in Panel.",
    "MESSAGE_HELP_PROPERTY_WM-PANEL_COLLAPSEDICONCLASS":"Icon class to display for the collapsed header toggle in Panel.",
    "LABEL_PROPERTY_ICONSIZE":"Icon Size",
    "MESSAGE_HELP_PROPERTY_ICONSIZE":"This property defines the size of the icon. Value has to be specified along with the units (em or px).",
    "LABEL_PROPERTY_SKELETONWIDTH":"Width",
    "MESSAGE_HELP_PROPERTY_SKELETONWIDTH":"This property defines the width of the skeleton. Value has to be specified along with the units (px).",
    "LABEL_PROPERTY_SKELETONHEIGHT":"Height",
    "MESSAGE_HELP_PROPERTY_SKELETONHEIGHT":"This property defines the height of the skeleton. Value has to be specified along with the units (px).",
    "LABEL_PROPERTY_MULTILINESKELETON":"Multiline",
    "MESSAGE_HELP_PROPERTY_MULTILINESKELETON":"If this property is enabled, multi line skeleton is show for label component.",
    "LABEL_PROPERTY_ICONCOLOR":"Icon Color",
    "MESSAGE_HELP_PROPERTY_ICONCOLOR":"This property defines the color of the icon.",
    "LABEL_PROPERTY_ICONURL":"Icon Url",
    "MESSAGE_HELP_PROPERTY_ICONURL":"This optional property allows you to add an icon to the left side of your button. User can give url of the image",
    "LABEL_PROPERTY_ICONWIDTH":"Icon Width",
    "MESSAGE_HELP_PROPERTY_ICONWIDTH":"Optional property; but you will need this if you are using the button's iconUrl. Please enter the width of your icon. WARNING: Its best to specify size in pixels, not percent.",
    "LABEL_PROPERTY_ICONHEIGHT":"Icon Height",
    "MESSAGE_HELP_PROPERTY_ICONHEIGHT":"Optional property; but you will need this if you are using the button's iconUrl. Please enter the height of your icon. WARNING: Its best to specify size in pixels, not percent.",
    "LABEL_PROPERTY_ICONMARGIN":"Icon Margin",
    "MESSAGE_HELP_PROPERTY_ICONMARGIN":"Optional property; only has meaning if you specify the button's iconUrl. Values should all have \"px\" next to them. Use this to adjust the space between the icon and the button text.",
    "LABEL_PROPERTY_ICONPOSITION":"Icon Position",
    "MESSAGE_HELP_PROPERTY_ICONPOSITION":"Optional property; Property to set the position of icon in the component",
    "LABEL_PROPERTY_IMAGELIST":"Image List",
    "MESSAGE_HELP_PROPERTY_IMAGELIST":"Setting this property enables an icon image to be displayed in the button. By default, this property is set to the variable, app.silkIconList.",
    "LABEL_PROPERTY_IMAGEINDEX":"Image Index",
    "MESSAGE_HELP_PROPERTY_IMAGEINDEX":"This is an advanced property for displaying icons in buttons. This property specifies which icon to display from the list of icons stored in the imageList for this button. See editImageIndex for easier approach for setting this value.",
    "LABEL_PROPERTY_SELECTOPTIONS":"Options",
    "MESSAGE_HELP_PROPERTY_SELECTOPTIONS":"This property accepts a comma separated string which will be used to create the options for a select element.",
    "LABEL_PROPERTY_RADIOGROUP":"Radio Group",
    "MESSAGE_HELP_PROPERTY_RADIOGROUP":"This property allows you to assign several radioButton components to the same group. Only one radioButton in a group can be checked at any given time. The groupValue property will be the same for all the radioButtons that have the same radioGroup property value.",
    "LABEL_PROPERTY_VIEWGROUP":"View Group",
    "MESSAGE_HELP_PROPERTY_VIEWGROUP":"This property allows you to assign several view components to the same group. Only one view in a group can be shown at any given time.",
    "LABEL_PROPERTY_PICTURELINK":"Link",
    "MESSAGE_HELP_PROPERTY_PICTURELINK":"This property allows you to specify a url to navigate to when a user clicks on the picture component.",
    "LABEL_PROPERTY_IMAGE":"Source",
    "MESSAGE_HELP_PROPERTY_IMAGE":"This property allows you to set a particular image as the loading icon.",
    "LABEL_PROPERTY_VIDEOPOSTER":"Poster",
    "MESSAGE_HELP_PROPERTY_VIDEOPOSTER":"This property allows you to set an image to be shown while the video is downloading, or until the user hits the play button",
    "LABEL_PROPERTY_MP4FORMAT":"MP4 Source Path",
    "MESSAGE_HELP_PROPERTY_MP4FORMAT":"This property allows you to set an video/mp4 format of the video",
    "LABEL_PROPERTY_OGGFORMAT":"OGG Source Path",
    "MESSAGE_HELP_PROPERTY_OGGFORMAT":"This property allows you to set an video/ogg source of the video",
    "LABEL_PROPERTY_WEBMFORMAT":"WEBM Source Path",
    "MESSAGE_HELP_PROPERTY_WEBMFORMAT":"This property allows you to set an video/webm source of the video",
    "LABEL_PROPERTY_MP3FORMAT":"MP3 Source Path",
    "MESSAGE_HELP_PROPERTY_MP3FORMAT":"This property allows you to set the file path of an mp3 file.",
    "LABEL_PROPERTY_WEBVIEWSRC":"Webview Src",
    "MESSAGE_HELP_PROPERTY_WEBVIEWSRC":"This property is used to specify the source URL or path of the content to be displayed inside the WebView.",
    "LABEL_PROPERTY_AUDIOSUPPORTMESSAGE":"Support Message",
    "MESSAGE_HELP_PROPERTY_AUDIOSUPPORTMESSAGE":"This property allows you to set the message when the audio file is not supported by the HTML5 media player",
    "LABEL_PROPERTY_CALENDARTYPE":"Type",
    "MESSAGE_HELP_PROPERTY_CALENDARTYPE":"This property allows you to set the type(agenda/basic) of the calendar component.",
    "LABEL_PROPERTY_AUTOTABACTIVATION":"Auto Tab Activation",
    "MESSAGE_HELP_PROPERTY_AUTOTABACTIVATION":"This property controls tab activation behavior during keyboard navigation. In automatic activation, a tab and its panel are activated as soon as the tab gains focus (e.g., via arrow keys). In manual activation, users can move focus with arrow keys, but press Enter to activate a tab and display its panel.",
    "LABEL_PROPERTY_ENABLEGESTURES":"Enable Gestures",
    "MESSAGE_HELP_PROPERTY_ENABLEGESTURES":"This property controls whether the swipe gestures are enabled for the widget.",
    "LABEL_PROPERTY_VIEW":"View",
    "MESSAGE_HELP_PROPERTY_VIEW":"This property allows you to set the default view of the calendar component.",
    "LABEL_PROPERTY_CONTROLS":"Enable Controls",
    "MESSAGE_HELP_PROPERTY_CONTROLS":"This property allows you to enable the controls for the selected component (such as a play/pause button for audio/video and header controls for calendar component).",
    "LABEL_PROPERTY_AUTOPLAY":"Enable Autoplay",
    "MESSAGE_HELP_PROPERTY_AUTOPLAY":"This property allows you to enable if and how the author thinks the video should be loaded when the page loads",
    "LABEL_PROPERTY_LOOP":"Loop",
    "MESSAGE_HELP_PROPERTY_LOOP":"This property allows you to enable the loop for the component",
    "LABEL_PROPERTY_MUTED":"Mute",
    "MESSAGE_HELP_PROPERTY_MUTED":"This property allows you to enable that the audio output of the audio/video should be muted",
    "LABEL_PROPERTY_VIDEOPRELOAD":"Video Preload",
    "MESSAGE_HELP_PROPERTY_VIDEOPRELOAD":"This property allows if and how the author thinks the video should be loaded when the page loads",
    "LABEL_PROPERTY_AUDIOPRELOAD":"Audio Preload",
    "MESSAGE_HELP_PROPERTY_AUDIOPRELOAD":"This property allows if and how the author thinks the audio should be loaded when the page loads",
    "LABEL_PROPERTY_VIDEOSUPPORTMESSAGE":"Support Message",
    "MESSAGE_HELP_PROPERTY_VIDEOSUPPORTMESSAGE":"This property allows to set the message when Html 5 video is not supported",
    "LABEL_PROPERTY_SUBTITLELANG":"Subtitle Language",
    "MESSAGE_HELP_PROPERTY_SUBTITLELANG":"This property allows to set the language for the subtitle",
    "LABEL_PROPERTY_SUBTITLESOURCE":"Subtitle Source",
    "MESSAGE_HELP_PROPERTY_SUBTITLESOURCE":"This property allows to set the source url for the subtitle in the .vtt format",
    "LABEL_PROPERTY_IMAGEWIDTH":"Picture Width",
    "MESSAGE_HELP_PROPERTY_IMAGEWIDTH":"This property allows you to set the width of the picture.",
    "LABEL_PROPERTY_IMAGEHEIGHT":"Height",
    "MESSAGE_HELP_PROPERTY_IMAGEHEIGHT":"This property allows you to set the height of the picture.",
    "LABEL_PROPERTY_SERVICEVARIABLETOTRACK":"Track Variable",
    "MESSAGE_HELP_PROPERTY_SERVICEVARIABLETOTRACK":"This property allows you to bind to the service variable for which you want to show the loading dialog.",
    "LABEL_PROPERTY_PASSWORD":"Password",
    "MESSAGE_HELP_PROPERTY_PASSWORD":"If True (checked) then an asterisk ('*') is displayed as each character is typed, obfuscating the contents of the editor.",
    "LABEL_PROPERTY_PICTURESOURCE":"Source",
    "MESSAGE_HELP_PROPERTY_PICTURESOURCE":"This property specifies the source for the picture. The source can be either a file or a url:\r\n File: enter the directory and filename for the image to display (supported filetypes include .jpg, .gif and .png). By default, WaveMaker looks for images in the src/main/webapp directory of the project. Every WaveMaker project has a data directory under src/main/webapp, so this is a good place to put pictures.\r\n URL: enter a url to any internet-accessible image. \r\n  To display the file, foo.jpg, in the project directory src/main/webapp/resources/images/imagelists/, enter the following into the source property:resources/images/imagelists/foo.jpg or simply foo.jpg",
    "LABEL_PROPERTY_PICTUREPLACEHOLDER":"Placeholder",
    "MESSAGE_HELP_PROPERTY_PICTUREPLACEHOLDER":"This property specifies the placeholder source for the picture when picturesource is not defined.",
    "LABEL_PROPERTY_PICTURETITLE":"Title",
    "MESSAGE_HELP_PROPERTY_AVATAR":"This property specifies the source for the avatar. The source can be either a file or a url:\r\n File: enter the directory and filename for the image to display (supported filetypes include .jpg, .gif and .png). By default, WaveMaker looks for images in the src/main/webapp directory of the project. Every WaveMaker project has a data directory under src/main/webapp, so this is a good place to put pictures.\r\n URL: enter a url to any internet-accessible image. \r\n  To display the file, foo.jpg, in the project directory src/main/webapp/resources/images/imagelists/, enter the following into the source property:resources/images/imagelists/foo.jpg or simply foo.jpg",
    "LABEL_PROPERTY_AVATAR":"Avatar",
    "MESSAGE_HELP_PROPERTY_PICTURETITLE":"This property specifies the title on the picture",
    "LABEL_PROPERTY_IMGSRC":"Image Source",
    "MESSAGE_HELP_PROPERTY_IMGSRC":"This property specifies the source for the brand image. The source can be either a file or a url:\r\n File: enter the directory and filename for the image to display (supported filetypes include .jpg, .gif and .png). By default, WaveMaker looks for images in the src/main/webapp directory of the project. Every WaveMaker project has a data directory under src/main/webapp, so this is a good place to put pictures.\r\n URL: enter a url to any internet-accessible image. \r\n  To display the file, foo.jpg, in the project directory src/main/webapp/resources/images/imagelists/, enter the following into the source property:resources/images/imagelists/foo.jpg or simply foo.jpg",
    "LABEL_PROPERTY_HOMELINK": "Home Link",
    "MESSAGE_HELP_PROPERTY_HOMELINK": "This property specifies the url for the home link. By default it redirects to home page if no link is given.",
    "LABEL_PROPERTY_PICTUREASPECT":"Aspect",
    "MESSAGE_HELP_PROPERTY_PICTUREASPECT":"This property can automatically size an image to the height or width of the picture component. The options are: \r\n none: the image is displayed at its default size \r\n h: the image is resized so that the width of the image is the same as the width of the picture component \r\n v: the image is resized so that the height of the image is the same as the height of the picture component \r\n Both: the image is resized so that the height and width of the image is the same as the height of the picture component ",
    "LABEL_PROPERTY_GRIDFIRSTROWSELECT":"Select First Record",
    "MESSAGE_HELP_PROPERTY_GRIDFIRSTROWSELECT":"If this property is enabled, the first record of the data table will be selected automatically when the data table is displayed.",
    "LABEL_PROPERTY_FORMPOSITION":"New row position",
    "MESSAGE_HELP_PROPERTY_FORMPOSITION":"This property defines where to display the new row form on click of the new button",
    "LABEL_PROPERTY_ROWACTIONSPOSITION":"Position",
    "MESSAGE_HELP_PROPERTY_ROWACTIONSPOSITION":"This property determines the position at which row actions column has to be rendered.",
    "LABEL_PROPERTY_GRIDACTIONSPOSITION":"Position",
    "MESSAGE_HELP_PROPERTY_GRIDACTIONSPOSITION":"This property determines the position at which action has to be rendered.",
    "LABEL_PROPERTY_SELECTFIRSTITEM":"Select First Item",
    "MESSAGE_HELP_PROPERTY_SELECTFIRSTITEM":"If this property is enabled, the first item of the livelist will be selected automatically when the livelist is displayed.",
    "LABEL_PROPERTY_INFSCROLL":"Fetch records on scroll",
    "MESSAGE_HELP_PROPERTY_INFSCROLL":"Fetch the items of the list on scroll.",
    "LABEL_PROPERTY_ENABLESORT": "Enable Sort",
    "MESSAGE_HELP_PROPERTY_ENABLESORT": "If this property is enabled, data table can be sorted by clicking the column header cells.",
    "LABEL_PROPERTY_ENABLECOLUMNSELECTION": "Column Selection",
    "MESSAGE_HELP_PROPERTY_ENABLECOLUMNSELECTION": "If this property is enabled, columns in data table can be selected by clicking the column header cells.",
    "LABEL_PROPERTY_FILTERMODE":"Filter Mode",
    "MESSAGE_HELP_PROPERTY_FILTERMODE":"Enable filter in Data Table component.",
    "LABEL_PROPERTY_FILTERONKEYPRESS":"Filter on key press",
    "MESSAGE_HELP_PROPERTY_FILTERONKEYPRESS": "Enable filter on keypress",
    "LABEL_PROPERTY_ROWCLASS": "Row Class",
    "MESSAGE_HELP_PROPERTY_ROWCLASS": "The CSS class provided will be applied on the table row.",
    "LABEL_PROPERTY_ROWNGCLASS": "Row Conditional Class",
    "MESSAGE_HELP_PROPERTY_ROWNGCLASS": "The CSS class provided in first textbox will be applied on the table row, if it satisfies the condition provided in the second textbox (for more info click on the 'Help' link above).",
    "MESSAGE_HELP_PROPERTY_FILTERMODE_SEARCH":"Search box is displayed at top of the Data Table component for filtering data.",
    "MESSAGE_HELP_PROPERTY_FILTERMODE_MULTICOLUMN":"This option enables multi-filtering for rows. <br>In columns tab, filter can be disabled/ enabled for specific columns.",
    "MESSAGE_HELP_NOT_ON_ENTIRE_DATASET": "Note: Filtering is performed at the page level, not on the entire dataset",
    "LABEL_PROPERTY_SEARCHLABEL":"Search Placeholder",
    "MESSAGE_HELP_PROPERTY_SEARCHLABEL":"The placeholder to show for the search box.",
    "LABEL_PROPERTY_SHOWROWINDEX":"Show row index",
    "MESSAGE_HELP_PROPERTY_SHOWROWINDEX":"Show row index column in the data table component. Adds a serial number column for display.",
    "LABEL_PROPERTY_EXPORTFORMAT": "Export Format",
    "MESSAGE_HELP_PROPERTY_EXPORTFORMAT": "Export menu is shown in the header with selected export format options. Data will be downloaded in respective format selected in the export menu by user.",
    "LABEL_PROPERTY_EXPORTDATASIZE": "Export Data Size",
    "MESSAGE_HELP_PROPERTY_EXPORTDATASIZE": "This property specifies the number of records to be exported.",
    "LABEL_PROPERTY_MULTISELECT": "Multiselect",
    "MESSAGE_HELP_PROPERTY_MULTISELECT": "On checking this property users can select multiple items.",
    "LABEL_PROPERTYGROUP_GRIDSTYLES": "Styles",
    "LABEL_PROPERTY_RADIOSELECT": "Radio column",
    "MESSAGE_HELP_PROPERTY_RADIOSELECT": "Show a radio column in data table component. This enables the user to select single row.",
    "LABEL_PROPERTY_GRIDCAPTION": "Caption",
    "MESSAGE_HELP_PROPERTY_GRIDCAPTION": "The caption for the data table",
    "LABEL_PROPERTY_NODATAMESSAGE":"No Data Message",
    "MESSAGE_HELP_PROPERTY_NODATAMESSAGE":"This message will be displayed when there is no data to display.",
    "LABEL_PROPERTY_LOADINGDATAMSG": "Data Loading Message",
    "MESSAGE_HELP_PROPERTY_LOADINGDATAMSG": "This message will be displayed when waiting for data to load.",
    "LABEL_PROPERTY_DATACOMPLETEMSG": "Data Complete Message",
    "MESSAGE_HELP_PROPERTY_DATACOMPLETEMSG": "This message will be displayed when there there is no more data to load.",
    "LABEL_PROPERTY_INSERTMESSAGE":"Message On Add",
    "MESSAGE_HELP_PROPERTY_INSERTMESSAGE":"This message will be displayed, when data is inserted by liveform",
    "LABEL_PROPERTY_UPDATEMESSAGE":"Message On Update",
    "MESSAGE_HELP_PROPERTY_UPDATEMESSAGE":"This message will be displayed, when data is updated by liveform",
    "LABEL_PROPERTY_DELETEMESSAGE":"Message On Delete",
    "MESSAGE_HELP_PROPERTY_DELETEMESSAGE":"This message will be displayed, when data is deleted by liveform",
    "LABEL_PROPERTY_ERRORMESSAGE":"Message On Error",
    "MESSAGE_HELP_PROPERTY_ERRORMESSAGE":"This message will be displayed, if there is an error during the CRUD operation",
    "LABEL_PROPERTY_FORMDATA":"Form data",
    "MESSAGE_HELP_PROPERTY_FORMDATA":"Data to show in the form.",
    "LABEL_PROPERTY_METADATA":"Form Metadata",
    "MESSAGE_HELP_PROPERTY_METADATA":"Data source of the form fields to be generated in run time",
    "LABEL_PROPERTY_ACCEPT":"Accept",
    "MESSAGE_HELP_PROPERTY_ACCEPT":"The accept attribute specifies the types of files that can be submitted through a file upload.To specify more than one value, separate the values with a comma. Example 'audio/*,video/*,image/*'",
    "LABEL_PROPERTY_OPERATION":"operation",
    "MESSAGE_HELP_PROPERTY_OPERATION":"This property specifies the operation associated with the variable.",
    "LABEL_PROPERTY_SELECTIONMODE":"Selection Mode",
    "MESSAGE_HELP_PROPERTY_WM-CALENDAR_SELECTIONMODE":"single: only one day can be selected at a time \r\n multiple: many days can be selected at a time. Each click selects or deselects another day \r\n none: no day can be selected",
    "MESSAGE_HELP_PROPERTY_WM-CHIPS_SELECTIONMODE":"single: only one chip can be selected at a time multiple: multiple chips can be selected simultaneously",
    "LABEL_PROPERTY_SELECTEDICONCLASS":"Selected Icon Class",
    "MESSAGE_HELP_PROPERTY_WM-CHIPS_SELECTEDICONCLASS":"Icon class to display on selected chips to indicate selection",
    "LABEL_PROPERTY_LEFTICONCLASS":"Left Icon Class",
    "MESSAGE_HELP_PROPERTY_WM-CHIPS_LEFTICONCLASS":"Icon class to display on the left side of each chip",
    "LABEL_PROPERTY_LEFTBADGE":"Left Badge",
    "MESSAGE_HELP_PROPERTY_WM-CHIPS_LEFTBADGE":"Text badge to display on the left side of each chip",
    "LABEL_PROPERTY_RIGHTICONCLASS":"Right Icon Class",
    "MESSAGE_HELP_PROPERTY_WM-CHIPS_RIGHTICONCLASS":"Icon class to display on the right side of each chip",
    "LABEL_PROPERTY_RIGHTBADGE":"Right Badge",
    "MESSAGE_HELP_PROPERTY_WM-CHIPS_RIGHTBADGE":"Text badge to display on the right side of each chip",
    "LABEL_PROPERTY_DELETEROW":"Allow Delete",
    "MESSAGE_HELP_PROPERTY_DELETEROW":"Adds a button in the row to enable delete",
    "LABEL_PROPERTY_UPDATEROW":"Allow Edit",
    "MESSAGE_HELP_PROPERTY_UPDATEROW":"Adds a button in the row to enable edit, liveform is set to updatemode.",
    "LABEL_PROPERTY_INSERTROW":"Allow Add",
    "MESSAGE_HELP_PROPERTY_INSERTROW":"Adds a button to the data table footer to add new record",
    "LABEL_PROPERTY_CONFIRMDELETE":"Delete Message",
    "MESSAGE_HELP_PROPERTY_CONFIRMDELETE":"A message to show in a confirm dialog so that the user can confirm that they want to delete this row. Leave blank to delete without asking the user to confirm.",
    "LABEL_PROPERTY_LIVEVARIABLETYPE":"Type",
    "MESSAGE_HELP_PROPERTY_LIVEVARIABLETYPE":"This property defines the type of the variable.",
    "LABEL_PROPERTY_LIVEVARIABLEOPERATION":"Operation",
    "MESSAGE_HELP_PROPERTY_LIVEVARIABLEOPERATION":"This property defines the operation of the variable.",
    "LABEL_PROPERTY_AUTOSIZE":"Auto Size",
    "MESSAGE_HELP_PROPERTY_AUTOSIZE":"Use this property to select whether your readonly editor should automatically resize to fit its content",
    "LABEL_PROPERTY_VALIDATIONEXP":"Validation Expression",
    "LABEL_PROPERTY_REGEXP":"Regular Expression",
    "MESSAGE_HELP_PROPERTY_REGEXP":"Enter any regular expression to be used for client-side input validation",
    "MESSAGE_HELP_PROPERTY_STEP": "Use the stepper to increment/decrement the input value by the specified step interval.<br>Example: if step='3', legal numbers could be -3, 0, 3, 6, etc.",
    "LABEL_PROPERTY_HELPTEXT":"Help Text",
    "MESSAGE_HELP_PROPERTY_HELPTEXT":"If this property has a value, a \"?\" icon is added next to your editor. If the user points the mouse at this icon, the text you put into this helpText property will popup for the user.",
    "LABEL_PROPERTY_SELECTIONCLICK":"Selection Click",
    "MESSAGE_HELP_PROPERTY_SELECTIONCLICK":"This property defines whether clicking on the data table row allow selection.",
    "LABEL_PROPERTY_RESETBUTTON":"Reset Button",
    "MESSAGE_HELP_PROPERTY_RESETBUTTON":"Checking this will add a clear button to the right edge of the editor. As this is most commonly used for a search box, we also increase the rounding of the borders (rounding only visible in modern browsers).",
    "LABEL_PROPERTY_LABELALIGN":"Label Alignment",
    "MESSAGE_HELP_PROPERTY_LABELALIGN":"This property defines the alignment of the label.",
    "LABEL_PROPERTY_POPUPCONTENT":"Popup Content",
    "MESSAGE_HELP_PROPERTY_POPUPCONTENT":"This property defines if there is any content for the popup",
    "LABEL_PROPERTY_ISPOPUPTEXT":"Is Popup text?",
    "MESSAGE_HELP_PROPERTY_ISPOPUPTEXT":"This property defines if the popup is a text",
    "LABEL_PROPERTY_POPOVERWIDTH":"Popover Width",
    "MESSAGE_HELP_PROPERTY_POPOVERWIDTH":"This property defines the width of the popover.",
    "LABEL_PROPERTY_POPOVERHEIGHT":"Popover Height",
    "MESSAGE_HELP_PROPERTY_POPOVERHEIGHT":"This property defines the height of the popover.",
    "LABEL_PROPERTY_CHECKEDICONCLASS":"Checked Icon Class",
    "LABEL_PROPERTY_POPOVERPLACEMENT":"Popover Placement",
    "MESSAGE_HELP_PROPERTY_POPOVERPLACEMENT":"This property defines the placement of the popover.",
    "LABEL_PROPERTY_CONTENTANIMATION":"Popover Animation",
    "MESSAGE_HELP_PROPERTY_CONTENTANIMATION":"This property defines the animation of the popover content.",
    "LABEL_PROPERTY_POPUPIDENTIFIER":"Popup Identifier",
    "MESSAGE_HELP_PROPERTY_POPUPIDENTIFIER":"This property defines the identifier for the popup.",
    "LABEL_PROPERTY_POPOVERARROW":"Popover Arrow",
    "MESSAGE_HELP_PROPERTY_POPOVERARROW":"This property defines the arrow for the popover.",
    "LABEL_PROPERTY_POPOVERAUTOCLOSE":"Popover Auto Close",
    "MESSAGE_HELP_PROPERTY_POPOVERAUTOCLOSE":"This property defines whether the popover should close automatically.",
    "LABEL_PROPERTY_INTERACTION":"Interaction",
    "MESSAGE_HELP_PROPERTY_INTERACTION":"This property defines which action should trigger popover to open or close.",
    "LABEL_PROPERTY_AUTOCLOSE":"Auto Close",
    "MESSAGE_HELP_PROPERTY_AUTOCLOSE":"This property defines whether behaviour of menu to auto close always or click on outside or disabled.",
    "LABEL_PROPERTY_AUTOOPEN":"Auto Open",
    "MESSAGE_HELP_PROPERTY_AUTOOPEN":"Decides whether to auto open the menu on page load.\n'Never': By default menu will be closed on page load.\n'Always': Menu is always open on page load.\n'Active Page': Menu will be opened if it has an item pointing to the current page.",
    "LABEL_PROPERTY_SHOWONHOVER": "Show On Hover",
    "MESSAGE_HELP_PROPERTY_SHOWONHOVER": "Enable this property to display sub-menu items when hovering over the primary menu item.",
    "LABEL_PROPERTY_ANIMATIONINTERVAL":"Animation Interval",
    "MESSAGE_HELP_PROPERTY_ANIMATIONINTERVAL":"This property defines the animation interval in seconds.",
    "LABEL_PROPERTY_DISCRETEVALUES":"Discrete Values",
    "MESSAGE_HELP_PROPERTY_DISCRETEVALUES":"By default, the slider returns a real number representing the relative position of the slider between the minimum and the maximum. \r\n If you want the slider to return discrete integer values, set the discreteValues property to the number of discrete values between the minimum slider position and the maximum slider position. \r\n\r\n Here are some examples:\r\ndiscreteValues = 3 means only allow three \"positions\" on the slider: start, middle, stop.\r\n To set the slider to count by tens between zero and 100, set maximum = 100, minimum = 0, discreteValues = 11.\r\n\r\n To set the slider to count by fives between 5 and 20, set maximum = 20, minumum = 5, discreteValues = 4.",
    "LABEL_PROPERTY_INTEGERVALUES":"Integer Values",
    "MESSAGE_HELP_PROPERTY_INTEGERVALUES":"This property defines the values in integers.",
    "LABEL_PROPERTY_SHOWBUTTONS":"Show Buttons",
    "MESSAGE_HELP_PROPERTY_SHOWBUTTONS":"This property controls whether there are arrow buttons on either end of the slider to move the slider to the left or right.",
    "LABEL_PROPERTY_DYNAMICSLIDER":"Dynamic Slider",
    "MESSAGE_HELP_PROPERTY_DYNAMICSLIDER":"Enable this property to have bindings fire as the slider moves rather than only when the user finishes positioning the slider.",
    "LABEL_PROPERTY_SHOWTOOLTIP":"Show Tooltip",
    "MESSAGE_HELP_PROPERTY_SHOWTOOLTIP":"This property determines whether a tooltip is displayed for the component.",
    "LABEL_PROPERTY_TOOLTIPPOSITION": "Tooltip Position",
    "MESSAGE_HELP_PROPERTY_TOOLTIPPOSITION": "Tooltip position determines which side the tooltip will be visible.",
    "LABEL_PROPERTY_ONTOOLTIPTEXT":"On Tooltip Text",
    "MESSAGE_HELP_PROPERTY_ONTOOLTIPTEXT": "This event handler is used to get the tooltip text.",
    "LABEL_PROPERTY_SINGLELINE":"Single Line",
    "MESSAGE_HELP_PROPERTY_SINGLELINE":"The singleLine property determines whether your label's text will be forced to fit on one line (any text not fitting gets truncated) or if the text in your label should be allowed to wrap around to as many lines as needed. Note that text can still be truncated if the height of your label is insufficient for the number of lines of text.",
    "LABEL_PROPERTY_MINEDITORWIDTH":"Minimum Editor Width",
    "MESSAGE_HELP_PROPERTY_MINEDITORWIDTH":"This property defines the minimum width of the editor components.",
    "LABEL_PROPERTY_READONLYFORMATTER":"Readonly Formatter",
    "MESSAGE_HELP_PROPERTY_READONLYFORMATTER":"The formatter lets you setup a custom formatter that controls how the editor will display its data when showing its readonly display. \r\n WARNING: This has no affect on the display of the editor's data when the editor is editable; this is readonly ONLY.",
    "LABEL_PROPERTY_IGNOREPARENTREADONLY":"Ignore Parent Readonly",
    "MESSAGE_HELP_PROPERTY_IGNOREPARENTREADONLY":"This property defines if the readonly property applied to the parent should be ignored or not.",
    "LABEL_PROPERTY_FORMFIELD":"Form field",
    "MESSAGE_HELP_PROPERTY_FORMFIELD":"This property defines the form field.",
    "LABEL_PROPERTY_DEFAULTINSERT":"Default Insert",
    "MESSAGE_HELP_PROPERTY_DEFAULTINSERT":"This property defines the default value to be inserted.",
    "LABEL_PROPERTY_DATAVALUEBINDINGEVALUATED":"Data Value Binding Evaluated",
    "MESSAGE_HELP_PROPERTY_DATAVALUEBINDINGEVALUATED":"This property defines whether the component has been evaluated for data binding.",
    "LABEL_PROPERTY_EMPTYVALUE":"Empty Value",
    "MESSAGE_HELP_PROPERTY_EMPTYVALUE":"This property specifies the dataValue to be returned by the editor if the user does not enter any value (e.g., the null value to return from the getDataValue() function call). \n null: calling getDataValue() returns null if there is no value set for this editor \n  emptyString: calling getDataValue() returns  if there is no value set for this editor \n  false: call to getValue returns false if there is no value set for this editor \n unset: calling getDataValue() returns no value if there is no value set for this editor (not particularly useful)",
    "LABEL_PROPERTY_STARTCHECKED":"Start Checked",
    "MESSAGE_HELP_PROPERTY_STARTCHECKED":"When set to True then initial state of the Checkbox is checked. This property should be used to set an initial value. Examples:\r\n In a form to set the default state when a new record is created.In a page where the checkbox controls visible elements in the page.\r\nIf the Checkbox component's dataValue is also set, the dataValue will override the startChecked value",
    "LABEL_PROPERTY_SCOPEDATASET":"Script Variable",
    "MESSAGE_HELP_PROPERTY_SCOPEDATASET":"Set this property in the script, to populate the scopedataset to component. To define the variable in script use '$scope.VariableName'. Type here as 'VariableName'",
    "LABEL_PROPERTY_SELECTEDVALUE":"Value",
    "MESSAGE_HELP_PROPERTY_SELECTEDVALUE":"This property can be used to set the value of the radioset component.",
    "LABEL_PROPERTY_USEKEYS": "Use Keys",
    "MESSAGE_HELP_PROPERTY_USEKEYS": "Use the keys of the live variable object as checkboxset options.",
    "LABEL_PROPERTY_SELECTEDVALUES":"Value",
    "MESSAGE_HELP_PROPERTY_SELECTEDVALUES": "Provide a comma separated string of values that need to selected by default when the checkboxset is created.",
    "LABEL_PROPERTY_DATASET":"Value",
    "MESSAGE_HELP_PROPERTY_DATASET":"Set this property to a variable to populate the list of values to display.",
    "LABEL_PROPERTY_OPTION":"Options",
    "MESSAGE_HELP_PROPERTY_OPTIONS":"Set this property to populate the select editor with a simple static list of options. \r\n Note: setting the options parameter will cause some other select menu parameters to be ignored. These include: dataSet, startUpdate, dataField and displayField.",
    "LABEL_PROPERTY_DATAFIELD":"Data field",
    "MESSAGE_HELP_PROPERTY_DATAFIELD":"This property is useful when the dataSet is an array of objects. It decides the dataValue to be returned by the component. If set to \"All Fields\", the whole object is returned against user selection. If set to a particular field, the returned value will be the value of that field in the selected object. In case of select component with multiselect or checkbox set component, the returned dataValue will also be an array.",
    "MESSAGE_HELP_PROPERTY_WM-RATING_DATAFIELD":"This property indicates the field (in DataSet) to represent selected value for the rating component. It should be mapped to an integer field in DataSet.",
    "LABEL_PROPERTY_DISPLAYFIELD":"Display field",
    "MESSAGE_HELP_PROPERTY_DISPLAYFIELD":"This property sets the displayValue to show in the select editor when the list is populated using the dataSet property.",
    "MESSAGE_HELP_PROPERTY_WM-RATING_DISPLAYFIELD":"This property indicates the field (in DataSet) that represents caption against the selected value(mapped as DataField) of the rating component.",
    "LABEL_PROPERTY_DISPLAYEXPRESSION":"Display Expression",
    "MESSAGE_HELP_PROPERTY_DISPLAYEXPRESSION":"This is an advanced property that gives more control over what is displayed in the drop-down select list. A Display Expression uses a Javascript expression to format exactly what is shown",
    "MESSAGE_HELP_PROPERTY_WM-RATING_DISPLAYEXPRESSION":"This is an advanced property that gives more control over what values are to be displayed for rating component. A Display Expression uses a Javascript expression to format exactly what is shown <br> For readonly mode, If dataset is null then the caption can be bound directly to display expression. ",
    "LABEL_PROPERTY_DISPLAYTYPE":"Display Type",
    "MESSAGE_HELP_PROPERTY_DISPLAYTYPE":"This property defines the displaytype attribute for the component",
    "LABEL_PROPERTY_ICON":"Symbol",
    "MESSAGE_HELP_PROPERTY_ICON":"Change the icon property for the button component.",
    "LABEL_PROPERTY_ALLOWNONE":"Allow None",
    "MESSAGE_HELP_PROPERTY_ALLOWNONE":"If checked, a blank menu item will be added to the top of the select menu; otherwise, some value must always be selected.",
    "LABEL_PROPERTY_HASDOWNARROW":"Has Down Arrow",
    "MESSAGE_HELP_PROPERTY_HASDOWNARROW":"This property defines if the select has a down arrow.",
    "LABEL_PROPERTY_RESTRICTVALUES":"Restrict Values",
    "MESSAGE_HELP_PROPERTY_RESTRICTVALUES":"If checked then SelectMenu will only allow values selected from the dataSet provided.\r\n \rf unchecked then SelectMenu will allow other values beyond those defined in the dataSet.",
    "LABEL_PROPERTY_AUTOCOMPLETE":"Auto Complete",
    "MESSAGE_HELP_PROPERTY_AUTOCOMPLETE":"Enabling this property turns on auto-completion in the editor. As the user types into the pull-down select editor, the choices change dynamically",
    "LABEL_PROPERTY_ENABLEEMPTYFILTER":"Empty Filter Options",
    "MESSAGE_HELP_PROPERTY_ENABLEEMPTYFILTER":"This property enables 'No Value' option for select and radioset components in Live Filter.\n'No Value' option can be used for filtering null or empty records.\nThe options are:\nNULL: Filtering on 'No Value' returns null records.\nEMPTY: Filtering on 'No Value' returns empty records.\nNULL AND EMPTY: Filtering on 'No Value' returns both null and empty records.",
    "LABEL_PROPERTY_AUTOUPDATE":"Filter on input change",
    "MESSAGE_HELP_PROPERTY_AUTOUPDATE":"Check this if you want to trigger the filter automatically on change of any input field inside the live filter",
    "LABEL_PROPERTY_SHOWPREVIEW":"Show Preview",
    "MESSAGE_HELP_PROPERTY_SHOWPREVIEW":"Checking this box turns to show the preview section of the editor",
    "LABEL_PROPERTY_PAGESIZE":"Page Size",
    "MESSAGE_HELP_PROPERTY_PAGESIZE":"This property sets the maximum number of items to show in the drop-down list. For example, setting the pageSize property to 10 will cause the select menu list to show ten items, with an 11th item labelled \"more choices.\" Selecting the \"more choices\" option will display an item labelled \"previous choices\" followed by the next 10 items",
    "MESSAGE_HELP_PROPERTY_WM-LIVEFILTER_PAGESIZE":"This property sets the number of records to be fetched by the live filter",
    "LABEL_PROPERTY_METHOD":"Method",
    "MESSAGE_HELP_PROPERTY_METHOD":"http request form method (i.e get, post etc.).",
    "LABEL_PROPERTY_ACTION":"Action",
    "MESSAGE_HELP_PROPERTY_ACTION":"The action property specifies where to send the form-data when a form is submitted.",
    "LABEL_PROPERTY_ENCTYPE":"Encoding Type",
    "MESSAGE_HELP_PROPERTY_ENCTYPE":"The encoding type property specifies how the form-data should be encoded when submitting it to the server.",
    "LABEL_PROPERTY_SEARCHKEY":"Search Key",
    "MESSAGE_HELP_PROPERTY_SEARCHKEY":"Property to be searched upon, in the list object",
    "LABEL_PROPERTY_VALIDATIONTYPE": "Validation Type",
    "MESSAGE_HELP_PROPERTY_VALIDATIONTYPE": "This property defines the type of validation applied on the form",
    "MESSAGE_HELP_PROPERTY_VALIDATIONTYPE_NONE": "No validations are performed on form submit.",
    "MESSAGE_HELP_PROPERTY_VALIDATIONTYPE_DEFAULT": "On form submit, Validation messages will be shown under the form fields.",
    "MESSAGE_HELP_PROPERTY_VALIDATIONTYPE_HTML": "On form submit, the HTML and inline validations will be applied.",
    "LABEL_PROPERTY_SUBMITBUTTON":"Submit Button",
    "MESSAGE_HELP_PROPERTY_SUBMITBUTTON":"If true adds a submit button to the selected form",
    "LABEL_PROPERTY_AUTOWIDTH":"Auto Width",
    "MESSAGE_HELP_PROPERTY_AUTOWIDTH":"This property defines the component's width to be applied automatically.",
    "LABEL_PROPERTY_AUTOHEIGHT":"Auto Height",
    "MESSAGE_HELP_PROPERTY_AUTOHEIGHT":"This property defines the component's height to be applied automatically.",
    "LABEL_PROPERTY_HEADERHEIGHT":"Header Height",
    "MESSAGE_HELP_PROPERTY_HEADERHEIGHT":"This property defines the component's header height to be applied.",
    "LABEL_PROPERTY_HEADERWIDTH":"Header Width",
    "MESSAGE_HELP_PROPERTY_HEADERWIDTH":"This property defines the component's header width to be applied.",
    "LABEL_PROPERTY_VERTICALBUTTONS":"Vertical Buttons",
    "MESSAGE_HELP_PROPERTY_VERTICALBUTTONS":"This property defines if the component will have vertical buttons.",
    "LABEL_PROPERTY_LAYERBORDER":"Layer Border",
    "MESSAGE_HELP_PROPERTY_LAYERBORDER":"This property defines the border property for the layer element.",
    "LABEL_PROPERTY_LAYERBORDERCOLOR":"Layer Border Color",
    "MESSAGE_HELP_PROPERTY_LAYERBORDERCOLOR":"This property defines the border color to be applied to the layer element.",
    "LABEL_PROPERTY_LAYERSTYPE":"Layers Type",
    "MESSAGE_HELP_PROPERTY_LAYERSTYPE":"This property defines the type of the layer element.",
    "LABEL_PROPERTY_DNDTARGETNAME":"Drag-n-Drop Target Name",
    "MESSAGE_HELP_PROPERTY_DNDTARGETNAME":"This property defines the target name for the element.",
    "LABEL_PROPERTY_CONDITIONALTABBUTTONS":"Conditional Tab Buttons",
    "MESSAGE_HELP_PROPERTY_CONDITIONALTABBUTTONS":"This property defines the conditional buttons for the tab component.",
    "LABEL_PROPERTY_TRANSITION":"Transition",
    "MESSAGE_HELP_PROPERTY_TRANSITION":"This property defines the transition effect to be applied when switching tabs.",
    "LABEL_PROPERTY_DEFAULTLAYER":"Default Layer",
    "MESSAGE_HELP_PROPERTY_DEFAULTLAYER":"This property defines the default layer.",
    "LABEL_PROPERTY_HORIZONTALALIGN":"Horizontal Align",
    "MESSAGE_HELP_PROPERTY_HORIZONTALALIGN":"This property specifies how the elements should be aligned horizontally.",
    "LABEL_PROPERTY_ROWS":"Rows",
    "MESSAGE_HELP_PROPERTY_ROWS":"Number of rows for layout grid component. Rows are not droppable.",
    "LABEL_PROPERTY_COLUMNS":"Columns",
    "MESSAGE_HELP_PROPERTY_COLUMNS":"Number of columns in each row of the layout grid component. Columns are droppable. Number of columns restricted to a range, to suit bootstrap fluid grid system",
    "LABEL_PROPERTY_COLUMNWIDTH":"Column Width",
    "MESSAGE_HELP_PROPERTY_COLUMNWIDTH":"Accepts integer(x) between 1-12 and adds class col-md-(x), to suit bootstrap fluid grid system",
    "LABEL_PROPERTY_XSCOLUMNWIDTH":"Column Width",
    "MESSAGE_HELP_PROPERTY_XSCOLUMNWIDTH":"Accepts integer(x) between 1-12 and adds class col-md-(x), to suit bootstrap fluid grid system",
    "LABEL_PROPERTY_LOCK":"Lock",
    "LABEL_PROPERTY_UNLOCK":"Unlock",
    "LABEL_MTLS_KEYSTORE_FILE_TYPE": "Keystore File Type",
    "LABEL_PROPERTY_HEADERSELECTALL":"HeaderSelectAll",
    "MESSAGE_HELP_PROPERTY_HEADERSELECTALL":"In a DataTable bound to a model variable, enabling this property allows selecting all rows across all pages when the header checkbox is clicked.",
    "LABEL_PROPERTY_MULTISELECTTITLE": "Multiselect hint",
    "MESSAGE_HELP_PROPERTY_MULTISELECTTITLE": "This message will be displayed, when hover the multiselect.",
    "LABEL_PROPERTY_MULTISELECTARIALABEL": "Multiselect aria-label",
    "MESSAGE_HELP_PROPERTY_MULTISELECTARIALABEL": "Any text you enter for this property will be used for accessibility WAI-ARIA labels.",
    "LABEL_PROPERTY_RADIOSELECTTITLE": "Radio column hint",
    "LABEL_PROPERTY_RADIOSELECTARIALABEL": "Radio column aria-label",
    "MESSAGE_HELP_PROPERTY_RADIOSELECTTITLE": "This message will be displayed, when hover the radio column.",
    "MESSAGE_HELP_PROPERTY_RADIOSELECTARIALABEL": "Any text you enter for this property will be used for accessibility WAI-ARIA labels.",
    "MESSAGE_HELP_PROPERTY_LOCK":"This property defines if the tab should be locked.",
    "LABEL_PROPERTY_FREEZE":"Freeze",
    "MESSAGE_HELP_PROPERTY_FREEZE":"This property defines if the tab should be frozen.",
    "LABEL_PROPERTY_AUTOSCROLL":"Auto Scroll",
    "MESSAGE_HELP_PROPERTY_AUTOSCROLL":"This property defines if the element should be allowed to scroll automatically.",
    "LABEL_PROPERTY_CLOSABLE":"Enable Default Close Action",
    "MESSAGE_HELP_PROPERTY_CLOSABLE":"This property allows user to access close action from header as well as enables close through ESC key press.",
    "LABEL_PROPERTY_SHOWACTIONS":"Show Actions",
    "MESSAGE_HELP_PROPERTY_SHOWACTIONS":"This property shows/hides actions section of the component.",
    "LABEL_PROPERTY_DESTROYABLE":"Destroyable",
    "MESSAGE_HELP_PROPERTY_DESTROYABLE":"This property defines if the tab should be destroyable.",
    "LABEL_PROPERTY_SHOWDIRTYFLAG":"Show Dirty Flag",
    "MESSAGE_HELP_PROPERTY_SHOWDIRTYFLAG":"This property defines if the tab should show the asterisk symbol for unsaved content within it.",
    "LABEL_PROPERTY_MINVALUE":"Minimum Value",
    "MESSAGE_HELP_PROPERTY_MINVALUE":"Enter minimum number. This property applies when the type is number.",
    "LABEL_PROPERTY_MARKERLABELTEXT":"Marker Text",
    "MESSAGE_HELP_PROPERTY_MARKERLABELTEXT":"Titles can be used in markers for the slider. This property applies when showmarkers is true.",
    "LABEL_PROPERTY_MAXVALUE":"Maximum Value",
    "LABEL_PROPERTY_RATING_MAXVALUE":"Maximum Rating",
    "MESSAGE_CUSTOM_PIPES_NOT_FOUND":"Add custom formatter",
    "MESSAGE_HELP_PROPERTY_MAXVALUE":"Enter maximum number. This property applies when the type is number.",
    "MESSAGE_HELP_PROPERTY_WM-RATING_MAXVALUE":"Maximum value (number of stars) of Rating.It should be less than or equal to 10.",
    "MESSAGE_HELP_PROPERTY_WM-RATING_DATAVALUE":"Default value (number of active stars) of Rating.It should always be less than or equal to maximum value of Rating.",
    "LABEL_PROPERTY_SHOWCAPTIONS":"Show Captions",
    "MESSAGE_HELP_PROPERTY_SHOWCAPTIONS":"Captions for Rating component are shown only when this property is set",
    "LABEL_PROPERTY_POSTMESSAGE":"Message On Success",
    "MESSAGE_HELP_PROPERTY_POSTMESSAGE":"This message will be displayed, when data is posted by form(Applicable only for service variable)",
    "LABEL_PROPERTY_ASPECTRATIO":"Aspect Ratio",
    "MESSAGE_HELP_PROPERTY_ASPECTRATIO":"Enter the aspect ratio of the image based on which the given width or height provided in the image styes",
    "LABEL_PROPERTY_SHOWDEFAULTVIDEOPOSTER":"Show Default Video Poster",
    "MESSAGE_HELP_PROPERTY_SHOWDEFAULTVIDEOPOSTER":"This property defines if the video component should show the default image for the thumbnail",
    "LABEL_PROPERTY_DATEPATTERN": "Date Pattern",
    "LABEL_PROPERTY_TIMEPATTERN": "Time Pattern",
    "LABEL_PROPERTY_SHOWBUTTONBAR": "Show Button Bar",
    "LABEL_PROPERTY_FORMATPATTERN": "Format Type",
    "LABEL_PROPERTY_SECURITYTYPE": "App Roles",
    "LABEL_PROPERTY_SYMBOL": "Symbol",
    "LABEL_PROPERTY_FRACTION_SIZE": "Fraction Size",
    "LABEL_PROPERTY_CUSTOM_PIPE":"Custom Pipe",
    "LABEL_PROPERTY_SUFFIX": "Suffix",
    "LABEL_PROPERTY_PREFIX": "Prefix",
    "LABEL_PROPERTY_TRUSTAS": "trustAs",
    "LABEL_PROPERTY_SANITIZE": "sanitize",
    "LABEL_PROPERTY_TEMPLATEREPLACE": "templateReplace",
    "LABEL_PROPERTY_SECURITY_CONTEXT": "Security context",
    "LABEL_WIDGET_PROPERTY": {
        "wm-date": {
            "SHOWDROPDOWNON": "Show DatePicker On",
            "DATAENTRYMODE": "Date Entry Mode"
        },
        "wm-datetime": {
            "SHOWDROPDOWNON": "Show DateTimePicker On",
            "DATAENTRYMODE": "DateTime Entry Mode"
        },
        "wm-time": {
            "SHOWDROPDOWNON": "Show TimePicker On",
            "DATAENTRYMODE": "Time Entry Mode"
        },
        "wm-timestamp": {
            "SHOWDROPDOWNON": "Show TimeStampPicker On",
            "DATAENTRYMODE": "TimeStamp Entry Mode"
        }
    },
    "MESSAGE_HELP_PROPERTY_WM-POPOVER_AUTOCLOSE": "This property defines when to close the popover. It behaves as follows: <br><br><u>Outside Click</u>: popover will close when user clicks anywhere outside the popover content.<br><br><u>Always</u>: the popover will close when user clicks anywhere on the page.<br><br><u>Disabled</u>: popover will close only when user clicks on the popover link.",
    "MESSAGE_HELP_PROPERTY_WM-BOTTOMSHEET_AUTOCLOSE": "This property defines when to close the bottomsheet. It behaves as follows:<br><br><u>Outside Click</u>: Closes the bottomsheet when the user taps outside the bottomsheet.<br><br><u>Disabled</u>: Tapping outside bottomsheet has no effect; the bottomsheet stays open.",
    "MESSAGE_HELP_PROPERTY_WM-COLORPICKER_AUTOCLOSE": "This property defines when to close the colorpicker popover. It behaves as follows: <br><br><u>Outside Click</u>: picker popover will close when user clicks anywhere outside the picker area.<br><br><u>Always</u>: picker popover will close when user clicks anywhere on the page.<br><br><u>Disabled</u>: picker popover will close only when user press enter key on the picker input field.",
    "MESSAGE_HELP_PROPERTY_SHOWDROPDOWNON": "If the Value is set to default Date/Datetime/time picker will be opened on both input click and button click, else picker will be opened only button click.",
    "MESSAGE_HELP_PROPERTY_DATAENTRYMODE": "This property specifies how the user can enter data.<br><br><u>option 1</u>: Default (Date/DateTime/Time Picker & Input): Data entry can be done either by selecting from the Date/DateTime/Time Picker or by entering  manually using the keyboard.<br><br><u>option 2</u>: Date/DateTime/Time Picker Only: Data entry can be done only by selecting from the Date/DateTime/Time Picker.<br><u>Note</u>: Use option 2 when you don't want the user to enter data manually.",
    "MESSAGE_PROPERTY_FORMAT_TODATE": "Formats date to a string based on the given date pattern. Eg: If date pattern is yyyy, MMM dd, then the formatted value is 2001, Jan 01",
    "MESSAGE_PROPERTY_FORMAT_TOCURRENCY": "If value is 12345.6789, fraction size is 3 and currency symbol is USD, then formatted value is $12,345.679",
    "MESSAGE_PROPERTY_FORMAT_PREFIX": "A prefix is prepended to the value. Eg: If value is aaa and prefix is AAA- then formatted value is AAA-aaa",
    "MESSAGE_PROPERTY_FORMAT_SUFFIX": "A suffix is appended to the value. . Eg: If value is aaa and suffix is -AAA then formatted value is aaa-AAA",
    "MESSAGE_PROPERTY_FORMAT_NUMBERTOSTRING": "Formats NUMBER to a STRING. Eg: If value is 12345.6789 and fraction size is 3, then formatted value is 12,345.679",
    "MESSAGE_PROPERTY_FORMAT_STRINGTONUMBER": "Formats STRING to a NUMBER. Eg: If value is '123', then formatted value is 123",
    "MESSAGE_PROPERTY_FORMAT_TIMEFROMNOW": "Formats date and time to a relative time. Eg: If value is 5 PM and the current time is 6 PM, formatted value is 'an hour ago'",
    "MESSAGE_PROPERTY_FORMAT_TRUSTAS": "Disables built-in sanitization for the value passed with the given security context(html, url)",
    "MESSAGE_PROPERTY_FORMAT_SANITIZE": "Sanitizes the value passed with the given security context(html, url)",
    "MESSAGE_PROPERTY_FORMAT_TEMPLATEREPLACE": "Replaces the template in the format <code>${key}</code> with values from the given object. <br> Usage: <code>\"${amount} is sent to ${receiver}\" | templateReplace: { \"amount\": \"1000\", \"receiver\": \"John Doe\" }</code> <br> Output: 1000 is sent to John Doe. <br> The object should contain key-value pairs matching the templates in the string.",
    "MESSAGE_HELP_PROPERTY_DATEPATTERN": "Date pattern lets you override how dates are displayed. Common options are 'dd-MMMM-yyyy', 'yyyy/MM/dd' ",
    "MESSAGE_HELP_PROPERTY_TIMEPATTERN": "Time pattern lets you override how time is displayed. Common options are 'hh-mm-ss' ",
    "MESSAGE_HELP_PROPERTY_SHOWBUTTONBAR": "Enables the date component footer with Today, Clear and Close buttons",
    "MESSAGE_HELP_PROPERTY_FORMAT_OPTIONS": "Customize the display value of a column by specifying a format",
    "MESSAGE_HELP_PROPERTY_FORMATPATTERN": "Specify a formatter to customize how its displayed. Common options are 'numberToString', 'stringToNumber', 'toCurrency','toDate', 'prefix', 'suffix'",
    "MESSAGE_HELP_PROPERTY_DISABLE_FORMATPATTERN": "Format cannot be applied, if value expression is set on column",
    "MESSAGE_HELP_PROPERTY_SYMBOL": "Specify the currency code such as USD",
    "MESSAGE_HELP_PROPERTY_FRACTION_SIZE": "Set the number of decimal places that are displayed",
    "MESSAGE_HELP_PROPERTY_SUFFIX": "Text to append to the end of each column data",
    "MESSAGE_HELP_PROPERTY_PREFIX": "Text to append to the start of each column data",
    "MESSAGE_HELP_PROPERTY_SECURITY_CONTEXT": "Provide security context such as html, url",
    "LABEL_PROPERTY_HOURSTEP": "Hour step",
    "MESSAGE_HELP_PROPERTY_HOURSTEP": "Number of hours to increase or decrease.",
    "LABEL_PROPERTY_MINUTESTEP": "Minute step",
    "LABEL_PROPERTY_OUTPUTFORMAT": "Output Format",
    "MESSAGE_HELP_PROPERTY_WM-DATE_OUTPUTFORMAT": "Defines the format of output datavalue returned by the date component. Default output format is 'yyyy-MM-dd', which returns the equivalent data value. E.g data value for '19/06/2015' is '2015-06-19'. If the output format is given as 'MMM dd, yyyy', component returns datavalue as 'Jun 19, 2015'.",
    "MESSAGE_HELP_PROPERTY_WM-TIME_OUTPUTFORMAT": "Defines the format of output datavalue returned by the time component. Default output format is 'timestamp', which returns the equivalent timestamp integer. E.g timestamp value for '10:10:00 AM' is '16800000'. If the output format is given as 'hh:mm a', component returns datavalue as '10:10 AM'.",
    "MESSAGE_HELP_PROPERTY_WM-DATETIME_OUTPUTFORMAT": "Defines the format of output datavalue returned by the date time component. Default output format is 'timestamp', which returns the equivalent timestamp integer. E.g timestamp value for '2012-12-12 12:12 PM' is '1355294520000'. If the output format is given as 'yyyy-MM-dd hh:mm a', component returns datavalue as '2012-12-12 12:12 PM'.",
    "MESSAGE_HELP_PROPERTY_MINUTESTEP": "Number of minutes to increase or decrease.",
    "LABEL_PROPERTY_LIMIT":"Limit",
    "MESSAGE_HELP_PROPERTY_LIMIT":"Limits the data to be displayed in the component",
    "LABEL_PROPERTY_SHOWWEEKS": "Show Week Number",
    "MESSAGE_HELP_PROPERTY_SHOWWEEKS": "When set, week number will be displayed in the date picker UI.",
    "LABEL_PROPERTY_MINDATE": "Min Date",
    "MESSAGE_HELP_PROPERTY_MINDATE": "User will not be allowed to enter a date value below the value mentioned here.",
    "MESSAGE_HELP_PROPERTY_MOBILE_APPLICATION_MINDATE": "User will not be allowed to enter a date value below the value mentioned here. Min date has to be given in yyyy-MM-dd format.",
    "MESSAGE_HELP_PROPERTY_MOBILE_APPLICATION_WM-DATETIME_MINDATE": "User will not be allowed to enter a date value below the value mentioned here. Min date has to be given in yyyy-MM-ddTHH:mm:ss format.",
    "LABEL_PROPERTY_MAXDATE": "Max Date",
    "MESSAGE_HELP_PROPERTY_MAXDATE": "User will not be allowed to enter a date value above the value mentioned here.",
    "MESSAGE_HELP_PROPERTY_MOBILE_APPLICATION_MAXDATE": "User will not be allowed to enter a date value above the value mentioned here. Max date has to be given in yyyy-MM-dd format.",
    "MESSAGE_HELP_PROPERTY_MOBILE_APPLICATION_WM-DATETIME_MAXDATE": "User will not be allowed to enter a date value above the value mentioned here. Max date has to be given in yyyy-MM-ddTHH:mm:ss format.",
    "LABEL_PROPERTY_MINTIME": "Min Time",
    "MESSAGE_HELP_PROPERTY_MINTIME": "User will not be allowed to enter a time value below the value mentioned here.",
    "MESSAGE_HELP_PROPERTY_MOBILE_APPLICATION_MINTIME": "User will not be allowed to enter a time value below the value mentioned here. Min time has to be given in HH:mm:ss format.",
    "LABEL_PROPERTY_MAXTIME": "Max Time",
    "MESSAGE_HELP_PROPERTY_MAXTIME": "User will not be allowed to enter a time value above the value mentioned here.",
    "MESSAGE_HELP_PROPERTY_MOBILE_APPLICATION_MAXTIME": "User will not be allowed to enter a time value above the value mentioned here. Max time has to be given in HH:mm:ss format.",
    "LABEL_PROPERTY_EXCLUDEDAYS": "Exclude Days",
    "MESSAGE_HELP_PROPERTY_EXCLUDEDAYS": "Select days which are to be excluded from the date picker.",
    "LABEL_PROPERTY_EXCLUDEDATES": "Exclude Dates",
    "MESSAGE_HELP_PROPERTY_EXCLUDEDATES": "Accepts string and variable containing dates which are to be excluded from the date picker.",
    "LABEL_PROPERTY_SHOWCUSTOMPICKER": "Show custom picker",
    "MESSAGE_HELP_PROPERTY_SHOWCUSTOMPICKER": "If set to true, custom date/time picker will be shown instead of native picker in the respective mobile/tablet device.",
    "LABEL_PROPERTY_MINIMUM":"Minimum",
    "LABEL_PROPERTY_STEP":"Step",

    "LABEL_PROPERTY_SHOWDATEFORMATASPLACEHOLDER": "Show Date Format as Placeholder",
    "MESSAGE_HELP_PROPERTY_SHOWDATEFORMATASPLACEHOLDER": "Show Display Format as placeholder in Date Component.",
    "MESSAGE_HELP_PROPERTY_VIEWMODE": "Show Date Component in day or month mode.",

    "MESSAGE_HELP_PROPERTY_MINIMUM":"Enter minimum number. This applies when the type is number.",
    "LABEL_PROPERTY_MAXIMUM":"Maximum",
    "MESSAGE_HELP_PROPERTY_MAXIMUM":"Enter maximum number. This applies when the type is number.",
    "MESSAGE_HELP_PROPERTY_DATABASE":"This refers to the data-model in the project.",
    "MESSAGE_HELP_PROPERTY_TABLE":"This refers to a table in the data-model.",
    "MESSAGE_HELP_PROPERTY_COLUMN":"This refers to a column in a table in the data-model.",
    "MESSAGE_HELP_PROPERTY_RELATION":"This refers to a relation between columns of a table.",
    "MESSAGE_HELP_PROPERTY_CREATE_RELATION":"Click successively; on the 2 columns between which a relation needs to be created.",
    "LABEL_PROPERTY_TABLE":"TABLE",
    "LABEL_PROPERTY_COLUMN":"COLUMN",
    "LABEL_PROPERTY_RELATION":"RELATION",
    "LABEL_PROPERTY_ENTITY":"ENTITY",
    "LABEL_PROPERTY_ATTRIBUTE":"ATTRIBUTE",
    "LABEL_PROPERTY_REFERENCE":"REFERENCE",
    "LABEL_PROPERTY_DATABASENAME":"Name",
    "LABEL_DATABASE_SEARCH_PLACEHODLER":"Search Table/Column",
    "LABEL_DATAMODEL_SEARCH_PLACEHODLER": "Search Entity/Attribute",
    "MESSAGE_HELP_PROPERTY_DATABASENAME":"This property defines the name of the database.",
    "LABEL_PROPERTY_PACKAGE":"Package",
    "MESSAGE_HELP_PROPERTY_PACKAGE":"This property defines the package that the database is available in.",
    "LABEL_PROPERTY_SCHEMA":"Schema",
    "MESSAGE_HELP_PROPERTY_SCHEMA":"This property sets the database schema container for the table such as public or dbo. It is not used with all DB systems.",
    "LABEL_PROPERTY_CATALOG":"Catalog",
    "MESSAGE_HELP_PROPERTY_CATALOG":"This property sets the database catalog for the table. It can be the same as database name. It is not used with all DB systems. This property should not be used when deploying to CloudFoundry with MySQL.",
    "LABEL_PROPERTY_DBOBJECTNAME":"Name",
    "MESSAGE_HELP_PROPERTY_DBOBJECTNAME":"This property corresponds to the name in the database.",
    "LABEL_PROPERTY_ENTITYNAME":"Entity Name",
    "MESSAGE_HELP_PROPERTY_ENTITYNAME":"This property corresponds to the name of the table in the project datamodel. It is same as the name of the Java class for the table. It can be different from the table name in the database.",
    "LABEL_PROPERTY_SOURCETABLE":"Child Table",
    "MESSAGE_HELP_PROPERTY_SOURCETABLE":"This property corresponds to the name of the table from which relation is created.",
    "LABEL_PROPERTY_FIELDNAME":"Field Name",
    "MESSAGE_HELP_PROPERTY_FIELDNAME":"This property corresponds to the field name of the column in the Java class corresponding to the table.",
    "LABEL_PROPERTY_PKTYPE": "Type",
    "MESSAGE_HELP_PROPERTY_PKTYPE":"This property corresponds to the type of primary key for the table",
    "LABEL_PROPERTY_PKCOLUMNS":"Select Column",
    "MESSAGE_HELP_PROPERTY_PKCOLUMNS":"This property is used to select the columns for primary key; if selected",
    "LABEL_PROPERTY_TYPE": "Type",
    "LABEL_PROPERTY_INPUTTYPE": "Input Type",
    "MESSAGE_HELP_PROPERTY_TYPE": "This property shows if the table is of type view or table.",
    "MESSAGE_HELP_PROPERTY_WM-PROGRESS_TYPE": "This property shows the type of the bar to be displayed.",
    "LABEL_PROPERTY_ISPARTOFPK":"Primary key",
    "MESSAGE_HELP_PROPERTY_ISPARTOFPK":"This property sets the column as primary key; if enabled.",
    "MESSAGE_ISPARTOFPK_DISABLED":"Primary key property can only be edited at table level",
    "LABEL_PROPERTY_VPK":"Virtual",
    "MESSAGE_HELP_PROPERTY_VPK":"This property sets the column as virtual primary key; if enabled.",
    "LABEL_PROPERTY_ISTEMPORAL": "Is Temporal",
    "LABEL_PROPERTY_ISFK":"Foreign key",
    "LABEL_PROPERTY_UNIQUE":"Unique",
    "LABEL_PROPERTY_PARTOFUNIQUEKEY":"Unique",
    "MESSAGE_HELP_PROPERTY_UNIQUE":"This property sets the column as unique; if enabled.",
    "MESSAGE_HELP_PROPERTY_ISFK":"This property is enabled if the column is a foreign key in the table. This will be automatically set if the column has a relationship and is the foreign key.",
    "LABEL_PROPERTY_NULLABLE":"Nullable",
    "MESSAGE_HELP_PROPERTY_NOTNULL":"This property is enabled if the column values can be null.",
    "LABEL_PROPERTY_ISHIDDEN":"Hidden",
    "LABEL_PROPERTY_LENGTH":"Length",
    "MESSAGE_HELP_PROPERTY_LENGTH":"This property sets the length of the column values. The minimum value is 1.",
    "LABEL_PROPERTY_PRECISION":"Precision",
    "MESSAGE_HELP_PROPERTY_PRECISION":"This property sets the precision of the column values.",
    "LABEL_PROPERTY_SCALE":"Scale",
    "MESSAGE_HELP_PROPERTY_SCALE":"This property sets the scale of the column values.",
    "LABEL_PROPERTY_DEFAULTFILTER":"Default Filter Expression",
    "LABEL_PROPERTY_TEMPORALTYPE":"Temporal Type",
    "LABEL_PROPERTY_TEMPORALCOLUMNTYPE":"Temporal Column Type",
    "LABEL_PROPERTY_TEMPORAL_PERIOD_START":"Period Start",
    "LABEL_PROPERTY_TEMPORAL_PERIOD_END":"Period End",
    "LABEL_PROPERTY_TEMPORAL_APPLICATION_PERIOD_START":"Application Period Start",
    "LABEL_PROPERTY_TEMPORAL_APPLICATION_PERIOD_END":"Application Period End",
    "LABEL_PROPERTY_TEMPORAL_SYSTEM_PERIOD_START":"System Period Start",
    "LABEL_PROPERTY_TEMPORAL_SYSTEM_PERIOD_END":"System Period End",
    "LABEL_PROPERTY_GENERATORTYPE":"Generator Type",
    "MESSAGE_HELP_PROPERTY_GENERATORTYPE":"This property sets the generator type for the column. This is applicable only if the column is a primary key.",
    "LABEL_PROPERTY_GENERATORVALUE":"Generator Value",
    "MESSAGE_HELP_PROPERTY_GENERATORVALUE":"This property refers to the generator value that already exists or needs to be created in the database.",
    "LABEL_PROPERTY_SQLTYPE":"SQL Type",
    "MESSAGE_HELP_PROPERTY_SQLTYPE":"This property sets the SQL type of the column. The default value is \"integer\" when the generator type is \"identity\".",
    "LABEL_PROPERTY_JAVATYPE":"Java Type",
    "MESSAGE_HELP_PROPERTY_JAVATYPE":"This property sets the Java type of the column. The default value is \"integer\" when the generator type is \"identity\".",
    "LABEL_PROPERTY_DEFAULTVALUE":"Value",
    "MESSAGE_HELP_PROPERTY_DEFAULTVALUE":"This property sets the default value of the column. When no data is provided for the column during insert/update, default value is taken. This property is mandatory when the \"notNull\" is set for the column.",
    "LABEL_PROPERTY_VALUETYPE":"Value Type",
    "MESSAGE_HELP_PROPERTY_VALUETYPE":"This property is used to define the type of value for the column.",
    "LABEL_PROPERTY_SERVERPROPERTY":"Server Properties",
    "MESSAGE_HELP_PROPERTY_SERVERPROPERTY":"This property sets the value for the column depending on the value chosen.",
    "LABEL_PROPERTY_APPENVPROPERTY":"App Environment Properties",
    "MESSAGE_HELP_PROPERTY_APPENVPROPERTY":"This property sets the value for the column depending on the value chosen.",
    "LABEL_PROPERTY_VALUEOPERATION":"Set Value On",
    "MESSAGE_HELP_PROPERTY_VALUEOPERATION":"This property defines when the value is to be inserted in the column.",
    "LABEL_PROPERTY_USERINSERTABLE":"Insertable",
    "MESSAGE_HELP_PROPERTY_USERINSERTABLE":"This property defines whether the value for this column should be inserted or not, while creating a new record.",
    "LABEL_PROPERTY_USERUPDATABLE":"Updatable",
    "MESSAGE_HELP_PROPERTY_USERUPDATABLE":"This property defines whether the value for this column should be updated or not, while updating the record.",
    "LABEL_PROPERTY_SERVERINSERTABLE":"Insertable",
    "MESSAGE_HELP_PROPERTY_SERVERINSERTABLE":"This property defines whether the value for this column should be inserted or not, while creating a new record.",
    "LABEL_PROPERTY_SERVERUPDATABLE":"Updatable",
    "MESSAGE_HELP_PROPERTY_SERVERUPDATABLE":"This property defines whether the value for this column should be updated or not, while updating the record.",
    "LABEL_PROPERTY_DATABASEINSERTABLE":"Insertable",
    "MESSAGE_HELP_PROPERTY_DATABASEINSERTABLE":"This property defines whether the value for this column should be inserted or not, while creating a new record.",
    "LABEL_PROPERTY_DATABASEUPDATABLE":"Updatable",
    "MESSAGE_HELP_PROPERTY_DATABASEUPDATABLE":"This property defines whether the value for this column should be updated or not, while updating the record.",
    "LABEL_PROPERTY_APPENVINSERTABLE":"Insertable",
    "LABEL_PROPERTY_LOTTIE_AUTOPLAY": "Autoplay",
    "MESSAGE_HELP_PROPERTY_LOTTIE_AUTOPLAY": "When enabled, animation plays automatically.",
    "LABEL_PROPERTY_LOTTIE_LOOP": "Loop",
    "MESSAGE_HELP_PROPERTY_LOTTIE_LOOP": "When enabled, animation plays repeatedly.",
    "LABEL_PROPERTY_LOTTIE_SOURCE": "Source",
    "MESSAGE_HELP_PROPERTY_LOTTIE_SOURCE": "Path to Lottie animation (JSON) definition file.",
    "LABEL_PROPERTY_LOTTIE_SPEED": "Speed",
    "MESSAGE_HELP_PROPERTY_LOTTIE_SPEED": "Speed at which Lottie Animation has to run. If the value is negative, animation runs in reverese direction.",
    "LABEL_PROPERTY_LOTTIE_ONREADY": "On Ready",
    "MESSAGE_HELP_PROPERTY_LOTTIE_ONREADY": "This event handler is called when the lottie animation is loaded.",
    "LABEL_PROPERTY_LOTTIE_ONPLAY": "On Play",
    "MESSAGE_HELP_PROPERTY_LOTTIE_ONPLAY": "This event handler is called when the lottie animation is playing.",
    "LABEL_PROPERTY_LOTTIE_ONPAUSE": "On Pause",
    "MESSAGE_HELP_PROPERTY_LOTTIE_ONPAUSE": "This event handler is called when the lottie animation is paused.",
    "LABEL_PROPERTY_LOTTIE_ONCOMPLETE": "On Complete",
    "MESSAGE_HELP_PROPERTY_LOTTIE_ONCOMPLETE": "This event handler is called when the lottie animation is completed.",
    "LABEL_PROPERTY_APPENVUPDATABLE":"Updatable",
    "LABEL_PROPERTY_VALIDATIONMESSAGE":"Validation Message",
    "MESSAGE_HELP_PROPERTY_VALIDATIONMESSAGE":"Message to be shown below the input field on validation error. This message is shown on blur of the input field",
    "LABEL_PROPERTY_TARGETTABLE":"Parent Table",
    "MESSAGE_HELP_PROPERTY_TARGETTABLE":"This property corresponds to the name of the related table.",
    "LABEL_PROPERTY_CARDINALITY":"Cardinality",
    "MESSAGE_HELP_PROPERTY_CARDINALITY":"This property sets the cardinality of the relation.",
    "LABEL_PROPERTY_ATTRIBUTENAME": "Attribute Name",
    "LABEL_PROPERTY_REFERENCEDENTITY": "Referenced Entity",
    "LABEL_PROPERTY_COLLECTION": "Collection",
    "LABEL_PROPERTY_FETCHCHILD": "Fetch Child",
    "LABEL_PROPERTY_FETCHPARENT": "Fetch ",
    "LABEL_PROPERTY_COLUMN_FILTERS": "Columns to filter",
    "LABEL_PROPERTY_VALIDATORS_MIN": "Min",
    "LABEL_PROPERTY_VALIDATORS_MAX": "Max",
    "LABEL_PROPERTY_VALIDATORS_REGEXP": "Regexp",
    "LABEL_PROPERTY_VALIDATORS_VALUE": "Value",
    "LABEL_PROPERTY_RELATEDCOLUMNS":"Related Columns",
    "MESSAGE_HELP_PROPERTY_RELATEDCOLUMNS":"This property corresponds to the names of the related columns in the table.",
    "LABEL_PROPERTY_VALIDATORS":"Validators",
    "LABEL_PROPERTY_CASCADEENABLED": "Enable",
    "LABEL_PROPERTY_CASCADEREMOVE": "Cascade Remove",
    "LABEL_NO_VALIDATION":"No Validation",
    "LABEL_SOURCE_COLUMN":"Source Column",
    "LABEL_TARGET_COLUMN":"Target Column",
    "LABEL_PROPERTY_VIRTUAL":"Virtual",
    "LABEL_PROPERTY_PLACES":"Decimal Places",
    "MESSAGE_HELP_PROPERTY_PLACES":"This specifies the number of decimal places to show for this number. This applies when the type is number.",
    "LABEL_PROPERTY_CHECKEDVALUE":"Checked Value",
    "MESSAGE_HELP_PROPERTY_CHECKEDVALUE":"This property defines the value of the component when the element is in the checked state. Default value is boolean value true. If specified, the value will be of string type",
    "LABEL_PROPERTY_UNCHECKEDVALUE":"UnChecked Value",
    "MESSAGE_HELP_PROPERTY_UNCHECKEDVALUE":"This property defines the value of the component when the element is in the unchecked state.",
    "LABEL_PROPERTY_LINK":"link",
    "MESSAGE_HELP_PROPERTY_LINK":"Type in a URL and this label will be turned into a link",
    "LABEL_PROPERTY_BORDERTOP":"borderTop",
    "MESSAGE_HELP_PROPERTY_BORDERTOP":"Enter border top value.",
    "LABEL_PROPERTY_BORDERRIGHT":"borderRight",
    "MESSAGE_HELP_PROPERTY_BORDERRIGHT":"Enter border right value.",
    "LABEL_PROPERTY_BORDERBOTTOM":"borderBottom",
    "MESSAGE_HELP_PROPERTY_BORDERBOTTOM":"Enter border bottom value.",
    "LABEL_PROPERTY_BORDERLEFT":"borderLeft",
    "MESSAGE_HELP_PROPERTY_BORDERLEFT":"Enter border left value.",
    "LABEL_PROPERTY_PADDINGTOP":"paddingTop",
    "MESSAGE_HELP_PROPERTY_PADDINGTOP":"Enter padding top value.",
    "LABEL_PROPERTY_PADDINGRIGHT":"paddingRight",
    "MESSAGE_HELP_PROPERTY_PADDINGRIGHT":"Enter padding right value.",
    "LABEL_PROPERTY_PADDINGBOTTOM":"paddingBottom",
    "MESSAGE_HELP_PROPERTY_PADDINGBOTTOM":"Enter padding bottom value.",
    "LABEL_PROPERTY_PADDINGLEFT":"paddingLeft",
    "MESSAGE_HELP_PROPERTY_PADDINGLEFT":"Enter padding left value.",
    "LABEL_PROPERTY_RESIZETOFIT":"resizeToFit",
    "MESSAGE_HELP_PROPERTY_RESIZETOFIT":"resizeToFit forces the Label component to grow or shrink to the exact size required to display the caption without wrapping.",
    "LABEL_HELP_PROPERTY_LINK":"link",
    "LABEL_PROPERTY_SCOPEDATAVALUE":"Script Variable",
    "MESSAGE_HELP_PROPERTY_SCOPEDATAVALUE":"The variable in the script that will hold the value of the component. To define the variable in script use '$scope.VariableName'. Type here as 'VariableName'",
    "LABEL_PROPERTY_UPDATEON": "Update Value on",
    "MESSAGE_HELP_PROPERTY_UPDATEON":"If the selected value is `blur`: datavalue will be updated on blur event, `keypress`: datavalue will be updated on keypress.",
    "LABEL_PROPERTY_POLLINTERVAL":"Poll Interval",
    "MESSAGE_HELP_PROPERTY_POLLINTERVAL":"Time interval in  milli seconds to poll the service.",
    "LABEL_PROPERTY_DISPLAYFORMAT":"Display Format",
    "MESSAGE_HELP_PROPERTY_DISPLAYFORMAT": "The keys in display format represent the special tokens/characters used to delimit acceptable ranges of inputs.<br>For example, we use '9' here to accept any numeric values for a phone number: displayformat='(999) 999-9999'. The values associated with each token are regexen. Each regex defines the ranges of values that will be acceptable as inputs in the position of that token.<br>Tokens:<br>A Any letter.<br>9 Any number.<br>* Any letter or number.<br>? Make any part of the mask optional.",
    "LABEL_PROPERTY_SHOWDISPLAYFORMATON": "Show Display Format On",
    "MESSAGE_HELP_PROPERTY_SHOWDISPLAYFORMATON": "This property decides when to show the display format on the component.<br><br>'Always': the provided display format will always be shown<br>'On keypress': the provided display format will be shown when user starts typing in the component.",
    "LABEL_CONFIGURE_FORMATS": "Configure Formats",
    "LABEL_PROPERTY_CAPTIONPLACEMENT":"Caption Placement",
    "MESSAGE_HELP_PROPERTY_CAPTIONPLACEMENT":"Placement of progress bar value.",
    "LABEL_PROPERTY_UPDATEDELAY": "Update Delay",
    "MESSAGE_HELP_PROPERTY_UPDATEDELAY":"The amount of delay in milliseconds to update the datavalue.",
    "LABEL_PROPERTY_HYPERLINK":"Hyperlink",
    "MESSAGE_HELP_PROPERTY_HYPERLINK":"The web url you want to redirect to on clicking the anchor.",
    "LABEL_PROPERTY_TARGET":"Target",
    "MESSAGE_HELP_PROPERTY_TARGET":"For every option in the dropdownlist there is separate content, <br> _blank: Opens the linked document in a new window or tab <br> _self:Opens the linked document in the same frame as it was clicked (this is default) <br> _parent: Opens the linked document in the parent frame <br> _top : Opens the linked document in the full body of the window.",
    "LABEL_PROPERTY_INITIALVALUE":"initialValue",
    "MESSAGE_HELP_PROPERTY_INITIALVALUE":"Initial value that will be displayed in your component.",
    "LABEL_PROPERTY_CLASS":"Class Name",
    "MESSAGE_HELP_PROPERTY_CLASS":"This property allows user to select one or more predefined class of style options from the view list drop down on the right",
    "LABEL_PROPERTY_CONDITIONALCLASS":"Conditional Class",
    "MESSAGE_HELP_PROPERTY_CONDITIONALCLASS":"This property allows user to bind expression to class property",
    "LABEL_PROPERTY_CONDITIONALSTYLE":"Conditional Style",
    "MESSAGE_HELP_PROPERTY_CONDITIONALSTYLE":"This property allows user to bind expression to style property <br> Syntax: <br> {'CSS propertyname': 'value expression'} <br> Example: <br> 1. {'color': 'red'} <br> 2. {'color': Page.Variables.MyVariable.dataSet.status === 'success' ? 'green' : 'red'} <br> 3. {'color': 'red', Page.Variables.MyVariable.dataSet.status === 'success' ? 'green' : 'red'}",
    "LABEL_PROPERTY_MENUCLASS":"Class Name",
    "MESSAGE_HELP_PROPERTY_MENUCLASS":"Class will be applied to the component. ",
    "LABEL_PROPERTY_GRIDCLASS": "Data Table Class",
    "MESSAGE_HELP_PROPERTY_GRIDCLASS": "Classes will be applied to the data table.",
    "LABEL_PROPERTY_LISTCLASS": "List class name",
    "MESSAGE_HELP_PROPERTY_LISTCLASS": "This property allows user to select a pre-defined list class name from the view-list drop down on the right.",
    "LABEL_PROPERTY_ITEMCLASS":"List item class name",
    "MESSAGE_HELP_PROPERTY_ITEMCLASS":"This property allows user to select a predefined list class name from the view-list drop down on the right.",
    "LABEL_PROPERTY_CHIPCLASS":"Chip item class name",
    "MESSAGE_HELP_PROPERTY_CHIPCLASS":"This property allows user to select a predefined chip class name from the view-list drop down on the right.",
    "LABEL_PROPERTY_UPLOADPATH":"UploadPath",
    "MESSAGE_HELP_PROPERTY_UPLOADPATH":"This is file path where you want to store file in server",
    "LABEL_PROPERTY_PADDINGUNIT":"Unit",
    "MESSAGE_HELP_PROPERTY_PADDINGUNIT":"unit for the padding property. ",
    "LABEL_PROPERTY_BORDERUNIT":"Unit",
    "MESSAGE_HELP_PROPERTY_BORDERUNIT":"unit for the padding property. ",
    "LABEL_PROPERTY_MARGINUNIT":"Unit",
    "MESSAGE_HELP_PROPERTY_MARGINUNIT":"unit for the padding property. ",
    "LABEL_PROPERTY_EDITORCLASS":"EditorClass",
    "MESSAGE_HELP_PROPERTY_EDITORCLASS":"Class will be applied to the editor in your component. ",
    "LABEL_PROPERTY_PREVIEWCLASS":"PreviewClass",
    "MESSAGE_HELP_PROPERTY_PREVIEWCLASS":"Class will be applied to the preview in your component. ",
    "LABEL_PROPERTY_ONABORT": "On Abort",
    "MESSAGE_HELP_PROPERTY_ONABORT": "This event handler is called when the operation is aborted",
    "LABEL_PROPERTY_ONPROGRESS": "On Progress",
    "MESSAGE_HELP_PROPERTY_ONPROGRESS": "This event handler is called when the operation is on progress",
    "LABEL_PROPERTY_SHOWHEADER": "Show Header",
    "MESSAGE_HELP_PROPERTY_SHOWHEADER": "Show/hide header of the component",
    "LABEL_PROPERTY_SPACING":"Spacing",
    "MESSAGE_HELP_PROPERTY_SPACING": "Use condensed option for a compact table view",
    "LABEL_PROPERTY_COLLAPSIBLE": "Collapsible",
    "MESSAGE_HELP_PROPERTY_COLLAPSIBLE": "Enable control for collapsing and expanding the component",
    "LABEL_PROPERTY_ENABLEFULLSCREEN": "Enable Full Screen",
    "MESSAGE_HELP_PROPERTY_ENABLEFULLSCREEN": "Enable control for making the component full screen",
    "LABEL_PROPERTY_HEADER": "Header",
    "MESSAGE_HELP_PROPERTY_HEADER": "Header template",
    "LABEL_PROPERTY_TOPNAV": "Top nav",
    "MESSAGE_HELP_PROPERTY_TOPNAV": "Top nav template",
    "LABEL_PROPERTY_LEFTNAV": "Left panel",
    "MESSAGE_HELP_PROPERTY_LEFTNAV": "Left panel template",
    "LABEL_PROPERTY_RIGHTNAV": "Right panel",
    "MESSAGE_HELP_PROPERTY_RIGHTNAV": "Right panel template",
    "LABEL_PROPERTY_FOOTER": "Footer",
    "MESSAGE_HELP_PROPERTY_FOOTER": "Footer template",
    "LABEL_PROPERTY_EXPANDED": "Expanded",
    "MESSAGE_HELP_PROPERTY_EXPANDED": "Set the default state of the container whether it is expanded or collapsed ",
    "LABEL_PROPERTY_LABEL": "Label Field",
    "LABEL_PROPERTY_VALUES":" Value Field",
    "LABEL_PROPERTY_LABEL_DATA": "Label Data",
    "LABEL_PROPERTY_VALUE_DATA":" Value Data",
    "LABEL_PROPERTY_NODELABEL": "Node Label",
    "LABEL_PROPERTY_NODEICON": "Node Icon",
    "LABEL_PROPERTY_NODECHILDREN": "Node Children",
    "LABEL_PROPERTY_NODEID": "Node Id",
    "MESSAGE_HELP_PROPERTY_NODECHILDREN": "Property of the object for node children binding, default value is children. The property where the nested object is present",
    "MESSAGE_HELP_PROPERTY_NODEICON": "Property of the object for node icon binding, default value is icon",
    "MESSAGE_HELP_PROPERTY_NODELABEL": "Property of the object for node label binding, default value is label",
    "MESSAGE_HELP_PROPERTY_NODEID": "Property of the object for node id binding, used to evaluate the default value bound",
    "LABEL_PROPERTY_ITEMID": "Action Id",
    "MESSAGE_HELP_PROPERTY_ITEMID": "Id should be the mapped to the page name so that the breadcrumb path is generated when the page is loaded.",
    "LABEL_PROPERTY_ITEMLABEL": "Action Label",
    "MESSAGE_HELP_PROPERTY_ITEMHINT": "Hint for anchor or menu items generated dynamically.",
    "LABEL_PROPERTY_ITEMHINT": "Action Hint",
    "MESSAGE_HELP_PROPERTY_ITEMLABEL": "Label for anchor or menu items generated dynamically.",
    "LABEL_PROPERTY_ITEMACTION": "Action Task",
    "MESSAGE_HELP_PROPERTY_ITEMACTION": "Action Task for anchor or menu items generated dynamically.",
    "LABEL_PROPERTY_USERROLE": "User Role",
    "MESSAGE_HELP_PROPERTY_USERROLE": "Role for anchor or menu items generated dynamically.",
    "LABEL_PROPERTY_ITEMICON": "Action Icon",
    "MESSAGE_HELP_PROPERTY_ITEMICON": "Class for the icon in anchor or menu items generated dynamically. Example- 'fa fa-ban' or 'glyphicon glyphicon-cloud'",
    "LABEL_PROPERTY_ITEMLINK": "Action Link",
    "MESSAGE_HELP_PROPERTY_ITEMLINK": "Link for the items generated dynamically.",
    "LABEL_PROPERTY_ISACTIVE": "Is Active",
    "MESSAGE_HELP_PROPERTY_ISACTIVE": "Boolean field to determine if the item should be shown as selected",
    "LABEL_PROPERTY_ITEMBADGE": "Item Badge",
    "MESSAGE_HELP_PROPERTY_ITEMBADGE": "Value to be displayed in the badge span for anchor",
    "LABEL_PROPERTY_ITEMCHILDREN": "Sub Actions",
    "MESSAGE_HELP_PROPERTY_ITEMCHILDREN": "When a menu component is required the sub items can be mentioned in the children",
    "LABEL_PROPERTY_BADGEVALUE": "Badge Value",
    "MESSAGE_HELP_PROPERTY_BADGEVALUE": "Value to be displayed in the badge span for anchor and button",
    "LABEL_PROPERTY_SHOWCOUNT": "Show Count",
    "MESSAGE_HELP_PROPERTY_SHOWCOUNT": "Count of list items in list group will be shown, if set to true",
    "LABEL_PROPERTY_HIDEHORIZONTALSCROLLBAR": "Hide Horizontal Scrollbar",
    "MESSAGE_HELP_PROPERTY_HIDEHORIZONTALSCROLLBAR": "The horizontal scrollbar will be hidden if set to true.",
    "LABEL_PROPERTY_HORIZONTALSCROLLTOITEM": "Horizontal scroll to item",
    "MESSAGE_HELP_PROPERTY_HORIZONTALSCROLLTOITEM": "Horizontally scrolled to the item on click, if set to true.",
    "LABEL_PROPERTY_BOTTOMSHEETHEIGHTRATIO": "Bottom Sheet Height Ratio",
    "MESSAGE_HELP_PROPERTY_BOTTOMSHEETHEIGHTRATIO": "Sets the height of the bottom sheet when it opens, as a percentage of the screen height (value between 0 and 1). For example, 0.3 means the sheet will take 30% of the device screen height.",
    "LABEL_PROPERTY_EXPAND": "Expand",
    "MESSAGE_HELP_PROPERTY_EXPAND": "If set to true, the user can swipe up to expand the bottom sheet. If false, the sheet remains at its default height and doesn't respond to swipe gestures.",
    "LABEL_PROPERTY_DISABLESWIPEDOWNCLOSE": "Disable Swipe Down Close",
    "MESSAGE_HELP_PROPERTY_DISABLESWIPEDOWNCLOSE": "If set to true, the bottom sheet will not close when the user swipes down the bottom sheet.",
    "LABEL_PROPERTY_BOTTOMSHEETMINIMUMHEIGHT": "Bottom Sheet Minimum Height",
    "MESSAGE_HELP_PROPERTY_BOTTOMSHEETMINIMUMHEIGHT": "Sets the minimum height of the bottom sheet can collapse to when swiped down, as a percentage of the screen height (value between 0 and 1). For example, 0.3 means the sheet will take 30% of the device screen height.This works only when the disable swipe down close property is set to true.",
    "LABEL_PROPERTY_ENABLEDRAGSETTLE": "Enable Drag Settle",
    "MESSAGE_HELP_PROPERTY_ENABLEDRAGSETTLE": "Allows the bottom sheet to remain at the position where the user releases it after swiping down. When enabled, the bottom sheet will not automatically close on release, providing a more natural drag experience.",
    "LABEL_PROPERTY_SHOWONRENDER": "Show On Render",
    "MESSAGE_HELP_PROPERTY_SHOWONRENDER": "Set showonrender to true if you want to open the bottom sheet automatically when the page loads.",
    "LABEL_PROPERTY_BOTTOMSHEETEXPANDEDHEIGHTRATIO": "Bottom Sheet Expanded Height Ratio",
    "MESSAGE_HELP_PROPERTY_BOTTOMSHEETEXPANDEDHEIGHTRATIO": "Defines the height the bottom sheet reaches when fully expanded, as a percentage of the screen height (value between 0 and 1). For example, 0.9 means it expands to 90% of the screen.",
    "LABEL_PROPERTY_DISABLESCROLLONREST": "Disable Scroll on Rest",
    "MESSAGE_HELP_PROPERTY_WM-BOTTOMSHEET_DISABLESCROLLONREST":"If set to true, it disables the internal scroll functionality of the bottom sheet content when the sheet is in its collapsed (shrinked) state.",
    "LABEL_PROPERTY_SUBMITONDONE": "Submit on done",
    "MESSAGE_HELP_PROPERTY_SUBMITONDONE": "Pressing the Done key on the keyboard should trigger the form submission.",
    "LABEL_PROPERTY_TRIGGERONRENDERWHENHIDDEN": "Trigger onRender when hidden",
    "MESSAGE_HELP_PROPERTY_TRIGGERONRENDERWHENHIDDEN": "The onRender method will not be called if the component is hidden",
    "LABEL_PROPERTY_BADGETYPE": "Badge Type",
    "MESSAGE_HELP_PROPERTY_BADGETYPE": "The property controls the color of the badge. This values are default, primary, success, info, warning, danger",
    "LABEL_PROPERTY_XAXISDATAKEY": "x-axis",
    "MESSAGE_HELP_PROPERTY_XAXISDATAKEY": "The key of the object, i.e x-axis variable, on the chart.",
    "LABEL_PROPERTY_XDOMAIN": "Origin",
    "MESSAGE_HELP_PROPERTY_XDOMAIN": "By default axis scale starts from 0.Choosing 'Min' option makes the scale starting value to minimum of all values. This option is better used when there are minute changes in data.",
    "LABEL_PROPERTY_YDOMAIN": "Origin",
    "MESSAGE_HELP_PROPERTY_YDOMAIN": "By default axis scale starts from 0.Choosing 'Min' option makes the scale starting value to minimum of all values. This option is better used when there are minute changes in data.",
    "LABEL_PROPERTY_XAXISLABEL": "Caption",
    "MESSAGE_HELP_PROPERTY_XAXISLABEL": "The caption of x axis on the chart.",
    "LABEL_PROPERTY_XUNITS": "Units",
    "MESSAGE_HELP_PROPERTY_XUNITS":"Specifies the units for the x axis.",
    "LABEL_PROPERTY_XNUMBERFORMAT":"Display format",
    "MESSAGE_HELP_PROPERTY_XNUMBERFORMAT":"Shows the options to format the number type in x axis.",
    "LABEL_PROPERTY_XDATEFORMAT":"Date format",
    "MESSAGE_HELP_PROPERTY_XDATEFORMAT":"Shows the options to format the date type in x axis.",
    "LABEL_PROPERTY_YAXISDATAKEY":"y-axis",
    "MESSAGE_HELP_PROPERTY_YAXISDATAKEY":"The key of the object, i.e y-axis variable, on the chart.",
    "LABEL_PROPERTY_YAXISLABEL":"Caption",
    "MESSAGE_HELP_PROPERTY_YAXISLABEL":"The caption of y axis on the chart.",
    "LABEL_PROPERTY_YUNITS":"Units",
    "MESSAGE_HELP_PROPERTY_YUNITS":"Specifies the units for the y axis.",
    "LABEL_PROPERTY_YNUMBERFORMAT":"Display format",
    "MESSAGE_HELP_PROPERTY_YNUMBERFORMAT":"Shows the options to format the number type in y axis.",
    "LABEL_PROPERTY_YDATEFORMAT":"Date format",
    "MESSAGE_HELP_PROPERTY_YDATEFORMAT":"Shows the options to format the date type in y axis.",
    "LABEL_PROPERTY_AGGREGATION":"Aggregation",
    "MESSAGE_HELP_PROPERTY_AGGREGATION":"Shows the options to aggregate the data in the chart.",
    "LABEL_PROPERTY_AGGREGATIONCOLUMN":"Aggregation Column",
    "MESSAGE_HELP_PROPERTY_AGGREGATIONCOLUMN":"Shows the options to aggregate the data in the chart.",
    "LABEL_PROPERTY_GROUPBY":"Group by",
    "MESSAGE_HELP_PROPERTY_GROUPBY":"This property allows for grouping the list of rows in the variable bound to a dataset by selecting one of the field names from the drop-down list.",
    "LABEL_PROPERTY_INTERPOLATION": "Datapoint Interpolation",
    "MESSAGE_HELP_PROPERTY_INTERPOLATION": "This property determines how datapoints are joined and rendered in the chart.",
    "LABEL_PROPERTY_MATCH":"Group as",
    "MESSAGE_HELP_PROPERTY_MATCH":"If set to alphabetic, the group heading will contain the starting character of the grouped data key and if set to word, the group heading will contain the word. If set to any of the TIME options, data is grouped based on the time option given",
    "LABEL_PROPERTY_DATEFORMAT": "Date Format",
    "MESSAGE_HELP_PROPERTY_DATEFORMAT": "Determines the format to be applied on the group heading",
    "LABEL_PROPERTY_ORDERBY":"Order by",
    "MESSAGE_HELP_PROPERTY_ORDERBY":"This allows for multiple selection for ordering the display of rows based on fields in asc or desc order - up arrow for asc and down arrow for desc",
    "LABEL_PROPERTY_ORDERBYCOLUMN":"Order by Column",
    "MESSAGE_HELP_PROPERTY_ORDERBYCOLUMN":"Shows the options to order the data in the chart.",
    "LABEL_PROPERTY_SHOWRECORDCOUNT":"Show Total Records",
    "MESSAGE_HELP_PROPERTY_SHOWRECORDCOUNT":"This property controls whether the total record count is displayed in the data paginator or not.",
    "LABEL_PROPERTY_SHOWNAVIGATION":"Show Navigation",
    "MESSAGE_HELP_PROPERTY_SHOWNAVIGATION": "This property controls whether or not navigation controls are displayed for the live-list.",
    "LABEL_PROPERTY_NAVIGATION": "Type",
    "MESSAGE_HELP_PROPERTY_NAVIGATION": "Select the pagination type for the component. This property determines how records are fetched.",
    "LABEL_PROPERTY_NAVIGATIONALIGN": "Align",
    "MESSAGE_HELP_PROPERTY_NAVIGATIONALIGN": "This property specifies how the paginator should be aligned horizontally.",
    "LABEL_PROPERTY_SELECTIONLIMIT":"Selection Limit",
    "MESSAGE_HELP_PROPERTY_SELECTIONLIMIT": "This property will allow users to select only a limited number of items.",
    "LABEL_PROPERTY_ENABLEREORDER":"Enable Reorder",
    "MESSAGE_HELP_PROPERTY_ENABLEREORDER": "This property will allow users to reorder the list items.",
    "LABEL_PROPERTY_STATEHANDLER": "Retain State",
    "MESSAGE_HELP_PROPERTY_STATEHANDLER": "This property will allow users to maintain component states using state handling on the URL, Local Storage or Session Storage.",
    "MESSAGE_HELP_PROPERTY_WM-LIST_STATEHANDLER": "This property will allow users to maintain component states using state handling on the URL, Local Storage or Session Storage.<br><br>Note: It does not work if the Pagination property is set as \"On Demand\" or \"Infinite Scroll\".",
    "LABEL_PROPERTY_INPUTPOSITION":"Input Position",
    "MESSAGE_HELP_PROPERTY_INPUTPOSITION": "This property will allow users to choose the position of the input box in the component.",
    "LABEL_PROPERTY_INPUTWIDTH":"Input Width",
    "MESSAGE_HELP_PROPERTY_INPUTWIDTH": "This property will allow users to choose the width for the input.",
    "LABEL_PROPERTY_EDITMODE":"Edit mode",
    "LABEL_PROPERTY_VIEWMODE":"View mode",
    "LABEL_PROPERTY_EDIT": "Edit",
    "LABEL_PROPERTY_DELETE": "Delete",
    "LABEL_PROPERTY_NEW": "New",
    "LABEL_PROPERTY_RESET": "Reset",
    "LABEL_PROPERTY_SAVE": "Save",
    "LABEL_PROPERTY_CANCEL": "Cancel",
    "LABEL_PROPERTY_GRID_ACTIONS" : "Data Table Actions",
    "LABEL_PROPERTY_ROW_ACTIONS" : "Row Actions",
    "LABEL_PROPERTY_ACTIONS_LAYOUT": "Actions Layout",
    "LABEL_PROPERTY_DEFAULTMODE":"Default Mode",
    "MESSAGE_HELP_PROPERTY_DEFAULTMODE": "This property controls whether live form is in view or edit mode when form is opened",
    "LABEL_PROPERTY_DEFAULTVIEW":"Default View",
    "MESSAGE_HELP_PROPERTY_DEFAULTVIEW": "This property shows the action bar if set to action-view and shows the search bar if set to search-view",
    "LABEL_PROPERTY_TEMPLATEVIEW":"Template View",
    "MESSAGE_HELP_PROPERTY_TEMPLATEVIEW": "This property shows the selected template. If leftActionTemplate is set then leftActionTemplate will only be displayed",
    "LABEL_PROPERTY_ENABLEFULLSWIPE":"Enable fullswipe",
    "MESSAGE_HELP_PROPERTY_ENABLEFULLSWIPE": "This property enables to trigger the last button action of the right action template on swipping towards left or the first button action of the left action template on swiping towards right",
    "LABEL_PROPERTY_SEARCHON":"Search On",
    "MESSAGE_HELP_PROPERTY_SEARCHON": "This property specifies when to invoke the search call. If set to typing, then search call is invoked on typing. If set to onsearchiconclick, then search call is invoked only on search icon button click. By default this property is set to typing. Note: onsearchiconclick will work only when searchicon on the component is available",
    "LABEL_PROPERTY_SHOWCLEAR":"Show clear",
    "MESSAGE_HELP_PROPERTY_SHOWCLEAR": "This property specifies whether to show clear button or not in the input box",
    "LABEL_PROPERTY_DEBOUNCETIME":"Delay Time(ms)",
    "MESSAGE_HELP_PROPERTY_DEBOUNCETIME": "Delay (in ms) after which the query will be triggered after the last character is typed by the user. Default delay is 250 ms.\n This delay is for performance optimization of multiple network calls.",
    "LABEL_PROPERTY_MATCHMODE":"Match Mode",
    "MESSAGE_HELP_PROPERTY_MATCHMODE": "This property specifies how to apply the filter on fields whether to match the query anywhere (or start or end) in the string. Options provided are startignorecase, start, endignorecase, end, anywhereignorecase, anywhere, exactignorecase, exact. Default matchmode is startignorecase. \n Examples 1. start: \"Wa\" would match \"WaveMaker\" \n  2. end: \"Maker\" would match \"WaveMaker\" \n 3. anywhere: \"ve\" would match \"WaveMaker\"",
    "LABEL_PROPERTY_ANIMATION":"Animation",
    "MESSAGE_HELP_PROPERTY_ANIMATION": "This property controls the animation of an element. The animation is based on the css classes and works only in the run mode.",
    "LABEL_PROPERTY_TEXTANIMATION":"Text Animation",
    "MESSAGE_HELP_PROPERTY_TEXTANIMATION": "Controls word-by-word text animation effect. Select 'fadeIn' to animate each word individually with a fade-in effect.",
    "LABEL_PROPERTY_ANIMATIONSPEED":"Animation Speed",
    "MESSAGE_HELP_PROPERTY_ANIMATIONSPEED": "Controls the timing delay between words in text animation. Higher values create slower word-by-word transitions (in milliseconds).",
    "LABEL_PROPERTY_HANDLESIZEON":"Handle Size On",
    "MESSAGE_HELP_PROPERTY_HANDLESIZEON":"How big the toggle circle appears when turned ON. Use larger numbers (like 1.5) for emphasis, smaller numbers (like 1.0) for subtle.",
    "LABEL_PROPERTY_HANDLESIZEOFF":"Handle Size Off",
    "MESSAGE_HELP_PROPERTY_HANDLESIZEOFF":"How big the toggle circle appears when turned OFF. Typically kept at 1.0 (normal size).",
    "LABEL_PROPERTY_HANDLESIZEBOUNCE":"Handle Size Bounce",
    "MESSAGE_HELP_PROPERTY_HANDLESIZEBOUNCE":"How much the circle expands during the bounce effect when toggled. Higher values create a more playful animation.",
    "LABEL_PROPERTY_BOUNCEDURATION":"Bounce Duration",
    "MESSAGE_HELP_PROPERTY_BOUNCEDURATION":"How long (in milliseconds) the bounce animation takes. Higher values make it slower. Example: 300 is fast, 600 is slow.",
    "LABEL_PROPERTY_SLIDEDURATION":"Slide Duration",
    "MESSAGE_HELP_PROPERTY_SLIDEDURATION":"How long (in milliseconds) the circle takes to slide when toggled. Higher values make it slower. Example: 300 is snappy, 600 is smooth.",
    "LABEL_PROPERTY_ANIMATEITEMS":"Animation on to content",
    "MESSAGE_HELP_PROPERTY_ANIMATEITEMS": "This property controls the animation of an inner items of an element. The animation is based on the css classes and works only in the run mode.",
    "LABEL_PROPERTY_ADVANCEDSETTINGS":"Advanced Settings",
    "LABEL_PROPERTY_ADDROW":"Insert Row",
    "LABEL_PROPERTY_ADDCOLUMN":"Insert Column",
    "LABEL_PROPERTY_ADDROWBELOW":"Insert Row Below",
    "LABEL_PROPERTY_ADDROWABOVE":"Insert Row Above",
    "LABEL_PROPERTY_ADDCOLUMNLEFT":"Insert Column to left",
    "LABEL_PROPERTY_ADDCOLUMNRIGHT":"Insert Column to Right",
    "LABEL_PROPERTY_INSERT":"Insert",
    "LABEL_PROPERTY_ISROWSELECTABLE":"Row Selectable",
    "MESSAGE_HELP_PROPERTY_ISROWSELECTABLE":"If this property is enabled, clicking anywhere on the row will trigger its selection. Otherwise, the row will not be selected on click.",
    "LABEL_PROPERTY_ALLOWPAGESIZECHANGE": "Show Page Size Selection",
    "MESSAGE_HELP_PROPERTY_ALLOWPAGESIZECHANGE": "This property lets users adjust how many records are shown per page dynamically. For example, switching between 10, 25, or 50 records based on preference.",
    "MESSAGE_HELP_PROPERTY_INSERT": "Insert elements in the component",
    "LABEL_PROPERTY_SECURITY":"Security",
    "LABEL_PROPERTY_ACCESSROLES":"Component Access",
    "MESSAGE_HELP_PROPERTY_ACCESSROLES": "Set the access roles for components",
    "LABEL_PROPERTY_TOOLTIPS":"Show Tooltips",
    "MESSAGE_HELP_PROPERTY_TOOLTIPS": "This property controls whether to show the tooltip on hover",
    "LABEL_PROPERTY_SHOWLEGEND":"Display Position",
    "MESSAGE_HELP_PROPERTY_SHOWLEGEND": "This property controls whether to show the legends",
    "LABEL_PROPERTY_CAPTIONS":"Captions",
    "MESSAGE_HELP_PROPERTY_CAPTIONS": "This property controls whether to show the captions",
    "LABEL_PROPERTY_SHOWXAXIS":"Show X Axis",
    "MESSAGE_HELP_PROPERTY_SHOWXAXIS": "This property controls whether to show x axis",
    "LABEL_PROPERTY_SHOWYAXIS":"Show Y Axis",
    "MESSAGE_HELP_PROPERTY_SHOWYAXIS": "This property controls whether to show y axis",
    "LABEL_PROPERTY_LEGENDPOSITION":"Legend Position",
    "MESSAGE_HELP_PROPERTY_LEGENDPOSITION": "This property controls where to show the legends – top or bottom.",
    "LABEL_PROPERTY_HIGHLIGHTPOINTS":"Highlight Points",
    "MESSAGE_HELP_PROPERTY_HIGHLIGHTPOINTS": "This property controls whether to highlight data points in the chart or not. Applies for Line,Cumulative Line and Area chart.",
    "LABEL_PROPERTY_LINETHICKNESS":"Line Thickness",
    "MESSAGE_HELP_PROPERTY_LINETHICKNESS": "This property controls the thickness of line in Line and Cumulative Line charts. Its accepts values like '5px', '0.85em'",
    "LABEL_PROPERTY_STAGGERLABELS":"Stagger Labels",
    "MESSAGE_HELP_PROPERTY_STAGGERLABELS": "This property controls whether to stagger the labels which distributes labels into multiple lines",
    "LABEL_PROPERTY_FORMATTYPE":"Format Type",
    "MESSAGE_HELP_PROPERTY_FORMATTYPE": "This property allows the user to set the display format for the x axis labels",
    "LABEL_PROPERTY_REDUCEXTICKS":"Reduce X Datapoints",
    "MESSAGE_HELP_PROPERTY_REDUCEXTICKS": "This property controls whether to reduce the xticks or not",
    "LABEL_PROPERTY_LABELTYPE":"Value Display",
    "MESSAGE_HELP_PROPERTY_LABELTYPE": "This property controls the type of the label to be shown in the chart.Key is the value of the key data, value is the data value, and percent represents the percentage that the slice of data represents",
    "LABEL_PROPERTY_SHOWVALUES":"Show Values",
    "MESSAGE_HELP_PROPERTY_SHOWVALUES": "This property controls showing of values on the bars",
    "LABEL_PROPERTY_SHOWLABELS":"Show Values",
    "MESSAGE_HELP_PROPERTY_SHOWLABELS": "This property controls showing of labels",
    "LABEL_PROPERTY_SHOWCONTROLS":"Show Controls",
    "MESSAGE_HELP_PROPERTY_SHOWCONTROLS": "This property controls showing the default controls for charts",
    "LABEL_PROPERTY_VIEWTYPE":"Data Arrangement",
    "MESSAGE_HELP_PROPERTY_VIEWTYPE": "This property controls show whether to show bars in grouped or stacked way",
    "LABEL_PROPERTY_AREAVIEWTYPE":"Data Arrangement",
    "MESSAGE_HELP_PROPERTY_AREAVIEWTYPE": "This property controls show whether to show areas in stack, stream or expand",
    "LABEL_PROPERTY_BARSPACING":"Bar Spacing",
    "MESSAGE_HELP_PROPERTY_BARSPACING": "This property controls the spacing between the bars and value ranges from 0.1 to 0.9",
    "LABEL_PROPERTY_DONUTRATIO":"Radius",
    "MESSAGE_HELP_PROPERTY_DONUTRATIO": "This property controls the radius and value ranges from 0.1 to 1.",
    "LABEL_PROPERTY_CENTERLABEL":"Center Label",
    "MESSAGE_HELP_PROPERTY_CENTERLABEL": "Center Label is the text to include within the middle of a donut chart",
    "LABEL_PROPERTY_SHOWLABELSOUTSIDE":"Show Labels Outside",
    "MESSAGE_HELP_PROPERTY_SHOWLABELSOUTSIDE": "This property controls the labels should be outside or inside.",
    "LABEL_PROPERTY_XAXISLABELDISTANCE":"Caption distance",
    "MESSAGE_HELP_PROPERTY_XAXISLABELDISTANCE": "This property controls the distance between the x axis and its label.",
    "LABEL_PROPERTY_YAXISLABELDISTANCE":"Caption distance",
    "MESSAGE_HELP_PROPERTY_YAXISLABELDISTANCE": "This property controls the distance between the y axis and its label.",
    "LABEL_PROPERTY_SHOWXDISTANCE":"Show X Distance",
    "MESSAGE_HELP_PROPERTY_SHOWXDISTANCE": "This property enables showing the distance from the x axis.",
    "LABEL_PROPERTY_SHOWYDISTANCE":"Show Y Distance",
    "MESSAGE_HELP_PROPERTY_SHOWYDISTANCE": "This property enables showing the distance from the y axis.",
    "LABEL_PROPERTY_BUBBLESIZE":"Size",
    "MESSAGE_HELP_PROPERTY_BUBBLESIZE": "This property controls the size of the bubble.",
    "LABEL_PROPERTY_SHAPE":"Shape",
    "MESSAGE_HELP_PROPERTY_SHAPE": "This property controls the shape of the data point.",
    "LABEL_PROPERTY_THEME":"Theme",
    "MESSAGE_HELP_PROPERTY_THEME": "This property controls the theme of the chart.",
    "LABEL_PROPERTY_CUSTOMCOLORS":"Custom Colors",
    "MESSAGE_HELP_PROPERTY_CUSTOMCOLORS": "This property enables to define custom colors to chart.It can be binded to array of colors.",
    "LABEL_PROPERTY_LABELCOLORS":"Label Colors",
    "MESSAGE_HELP_PROPERTY_LABELCOLORS": "This property allows you to define custom colors for chart labels. It can be bound to an array of colors.",
    "LABEL_PROPERTY_ACTIONS":"Menu Actions",
    "MESSAGE_HELP_PROPERTY_ACTIONS": "This property sets the actions for the component. To set the data and events see menu component",
    "LABEL_PROPERTY_TREEICONS":"Tree Icons",
    "MESSAGE_HELP_PROPERTY_TREEICONS": "This property sets expand-collapse icons on the tree",
    "LABEL_PROPERTY_LEVELS":"Levels",
    "MESSAGE_HELP_PROPERTY_LEVELS": "This property sets levels of the tree to be expanded by default.",
    "LABEL_PROPERTY_LEFTNAVPANELICONCLASS":"Left Nav Panel Icon Class",
    "MESSAGE_HELP_PROPERTY_LEFTNAVPANELICONCLASS": "This property sets the icon class for Left nav panel toggle button.",
    "LABEL_PROPERTY_BACKBUTTON":"Show Back Button",
    "MESSAGE_HELP_PROPERTY_BACKBUTTON": "Back button is displayed only when this property is set.",
    "LABEL_PROPERTY_BACKBUTTONICONCLASS":"Back Button Icon Class",
    "MESSAGE_HELP_PROPERTY_BACKBUTTONICONCLASS": "This property sets the icon for the back button.",
    "LABEL_PROPERTY_SEARCHBUTTON":"Show Search Button",
    "MESSAGE_HELP_PROPERTY_SEARCHBUTTON": "Search button is displayed only when this property is set.",
    "LABEL_PROPERTY_SEARCHBUTTONICONCLASS":"Search Button Icon Class",
    "MESSAGE_HELP_PROPERTY_SEARCHBUTTONICONCLASS": "This property sets the icon for the search button.",
    "LABEL_PROPERTY_MENUICONCLASS":"Menu Icon",
    "MESSAGE_HELP_PROPERTY_MENUICONCLASS": "This property sets the icon for the menu button that will appear in the mobile layout ONLY.",
    "LABEL_PROPERTY_MOREBUTTONICONCLASS":"More Button Icon Class",
    "MESSAGE_HELP_PROPERTY_MOREBUTTONICONCLASS": "This property sets the icon for the more button.",
    "LABEL_PROPERTY_MOREBUTTONLABEL":"More Button Label",
    "MESSAGE_HELP_PROPERTY_MOREBUTTONLABEL": "Sets the label displaed on more items button.",
    "LABEL_PROPERTY_BACKBUTTONLABEL":"Back Button Label",
    "MESSAGE_HELP_PROPERTY_BACKBUTTONLABEL": "This property sets the back button label.",
    "LABEL_PROPERTY_SEARCHBUTTONLABEL":"Search Label",
    "MESSAGE_HELP_PROPERTY_SEARCHBUTTONLABEL": "This property sets the search label.",
    "LABEL_PROPERTY_SEARCHPLACEHOLDER":"Search Placeholder",
    "MESSAGE_HELP_PROPERTY_SEARCHPLACEHOLDER": "This property sets the search placeholder.",
    "LABEL_PROPERTY_STEPSTYLE":"Step Style",
    "MESSAGE_HELP_PROPERTY_STEPSTYLE": "This property sets style on to the step title whether auto or justified(Ie..step titles will be occupying full space).",
    "LABEL_PROPERTY_ACTIONSALIGNMENT":"Actions Alignment",
    "MESSAGE_HELP_PROPERTY_ACTIONSALIGNMENT": "This property sets placement of actions, if placement is left the next, done, prev buttons will be placed left and skip will be placed right and vice versa",
    "LABEL_PROPERTY_DEFAULTSTEP":"Default Step",
    "MESSAGE_HELP_PROPERTY_DEFAULTSTEP": "This property allows users to set default step on load of wizard.",
    "LABEL_PROPERTY_DISABLETOUCHEFFECT": "Disable Touch Effect",
    "MESSAGE_HELP_PROPERTY_DISABLETOUCHEFFECT": "This property determines whether the component has any interaction effect",
    "LABEL_PROPERTY_STOPATLAST": "Stop At Last",
    "MESSAGE_HELP_PROPERTY_STOPATLAST": "When enabled, prevents the carousel from automatically looping back to the first item when reaching the last item. Users must manually navigate backward using controls.",
    "LABEL_BIND_VARIABLE":"Bind Property",
    "LABEL_PARTIAL_PARAMS": "Partial Params",
    "LABEL_CLEAR_BINDING":"Clear Binding",
    "COMMENT_WIDGET_PROPERTYGROUP_RESOURCES":"-----------Component Property Groups Localization Resources----------",
    "LABEL_PROPERTYGROUP_PROPERTIES":"Properties",
    "LABEL_PROPERTYGROUP_CHART":"Chart",
    "LABEL_PROPERTYGROUP_XAXISFORMAT":"Data Format",
    "LABEL_PROPERTYGROUP_YAXISFORMAT":"Data Format",
    "LABEL_PROPERTYGROUP_LEGEND":"Legend",
    "LABEL_PROPERTYGROUP_COLORS":"Datapoint Color",
    "LABEL_PROPERTYGROUP_DATAFILTERING":"Data Filtering",
    "LABEL_PROPERTYGROUP_VALUE":"Value",
    "LABEL_PROPERTYGROUP_VALUEFORMAT":"Value Format",
    "LABEL_PROPERTYGROUP_ACCESSIBILITY": "Accessibility",
    "LABEL_PROPERTYGROUP_ACTIONS": "Actions",
    "LABEL_PROPERTYGROUP_LAYOUT":"Layout",
    "LABEL_PROPERTYGROUP_CUSTOMWIDGETPROPS":"Component Properties",
    "LABEL_PROPERTYGROUP_CONTENT":"Content",
    "LABEL_PROPERTYGROUP_PARTIALPARAMS":"Partial Params",
    "LABEL_PROPERTYGROUP_VALUES":"Default Value",
    "LABEL_PROPERTYGROUP_VALUEDISPLAY":"Display Format",
    "LABEL_PROPERTYGROUP_TEXT":"Text",
    "LABEL_PROPERTYGROUP_GRAPHICS":"Graphics",
    "LABEL_PROPERTYGROUP_PICTURE":"Picture",
    "LABEL_PROPERTYGROUP_BEHAVIOR":"Behavior",
    "LABEL_PROPERTYGROUP_SCROLLBEHAVIOR":"Scroll Behavior",
    "LABEL_PROPERTYGROUP_POSITION":"Position",
    "LABEL_PROPERTYGROUP_SYSTEMBARSCUSTOMISATION":"System Bars Customisation",
    "LABEL_PROPERTYGROUP_POPOVERBEHAVIOR":"Popover Behavior",
    "LABEL_PROPERTYGROUP_SKELETON":"Skeleton",
    "LABEL_PROPERTY_SHOWSKELETON": "Show Skeleton",
    "LABEL_PROPERTY_BARSTYLE":"Barstyle",
    "MESSAGE_HELP_PROPERTY_BARSTYLE":"Sets the color of the status bar content (text and icons).<br>Useful for matching the status bar to the screen’s theme — for example, light text on dark backgrounds or dark text on light backgrounds.<br><br>Note: This setting applies only to Android. On iOS, the system automatically adjusts the status bar style based on the screen configuration.",
    "LABEL_PROPERTY_STICKY":"Sticky",
    "MESSAGE_HELP_PROPERTY_STICKY":"Keeps the container fixed (sticky) at the top while scrolling, ensuring it appears below any mobile navigation bar (if any)",
    "LABEL_PROPERTY_STATUSBARSTYLE":"Status Bar Style",
    "MESSAGE_HELP_PROPERTY_STATUSBARSTYLE":"Sets the color of the status bar content (text and icons).<br>Useful for matching the status bar to the screen’s theme — for example, light text on dark backgrounds or dark text on light backgrounds.<br><br>Note: This setting applies only to Android. On iOS, the system automatically adjusts the status bar style based on the screen configuration.",
    "LABEL_PROPERTY_NAVIGATIONBARSTYLE":"Navigation Bar Style",
    "MESSAGE_HELP_PROPERTY_NAVIGATIONBARSTYLE":"Sets the color of the device navigation bar.<br>Useful for matching the navigation bar to the screen’s theme — for example, a light color for light themes or a dark color for dark themes.<br><br>Note: This setting applies only to Android. There's no need to set this for iOS.",
     "LABEL_PROPERTY_ONSCROLL":"On Scroll",
    "MESSAGE_HELP_PROPERTY_ONSCROLL":"Define behaviour of top and bottom navbars when the page scrolls.",
    "LABEL_PROPERTY_SCROLLABLE":"Scrollable",
    "MESSAGE_HELP_PROPERTY_SCROLLABLE":"This property determines whether the widget is scrollable or not.",
    "MESSAGE_HELP_PROPERTY_SHOWSKELETON": "This property determines to show the skeleton or not",
    "LABEL_PROPERTY_SHOWSKELETONCHILDREN": "Show Skeleton Children",
    "MESSAGE_HELP_PROPERTY_SHOWSKELETONCHILDREN": "This property determines in the skeleton mode whether to show children or not",
    "LABEL_PROPERTY_SKELETONANIMATIONRESOURCE": "Skeleton Animation Resource",
    "MESSAGE_HELP_PROPERTY_SKELETONANIMATIONRESOURCE": "Path to Lottie animation (JSON) definition file.",
    "LABEL_PROPERTY_SKELETONANIMATIONSPEED": "Skeleton Animation Speed",
    "MESSAGE_HELP_PROPERTY_SKELETONANIMATIONSPEED": "Speed at which Lottie Animation has to run. If the value is negative, animation runs in reverese direction.",
    "LABEL_PROPERTY_NUMBEROFSKELETONITEMS": "Number Of Skeleton Items",
    "MESSAGE_HELP_PROPERTY_NUMBEROFSKELETONITEMS": "This property defines the number of items will be shown in skeleton mode",
    "LABEL_PROPERTY_DATEHEADERTITLE": "Date Title",
    "MESSAGE_HELP_PROPERTY_DATEHEADERTITLE": "Title for the date picker dialog",
    "LABEL_PROPERTY_DATECONFIRMATIONTITLE": "Date Confirmation Title",
    "MESSAGE_HELP_PROPERTY_DATECONFIRMATIONTITLE": "Title for confirmation button in date picker dialog",
    "LABEL_PROPERTY_DATECANCELTITLE": "Date Cancel Title",
    "MESSAGE_HELP_PROPERTY_DATECANCELTITLE": "Title for cancel button in date picker dialog",
    "LABEL_PROPERTY_TIMEHEADERTITLE": "Time Title",
    "MESSAGE_HELP_PROPERTY_TIMEHEADERTITLE": "Title for the time picker dialog",
    "LABEL_PROPERTY_TIMECONFIRMATIONTITLE": "Time Confirmation Title",
    "MESSAGE_HELP_PROPERTY_TIMECONFIRMATIONTITLE": "Title for confirmation button in time picker dialog",
    "LABEL_PROPERTY_TIMECANCELTITLE": "Time Cancel Title",
    "MESSAGE_HELP_PROPERTY_TIMECANCELTITLE": "Title for cancel button in time picker dialog",
    "LABEL_PROPERTY_AUTOCAPITALIZE": "Capitalize property in Text component",
    "MESSAGE_HELP_PROPERTY_AUTOCAPITALIZE": "This property helps to change text to all capital, first letter in each sentence capital, only first letter capital in a sentence and no change, base on the properties characters, words, sentence and none respectively",
    "LABEL_PROPERTY_RETURNKEYTYPE": "Return key type",
    "MESSAGE_HELP_PROPERTY_RETURNKEYTYPE": "To toggle between 'next' and 'done' as return key labels, which appear on the keyboard.",
    "LABEL_PROPERTY_SKIPSCRIPTEVENTTRIGGER": "Skip on change event from script",
    "MESSAGE_HELP_PROPERTY_SKIPSCRIPTEVENTTRIGGER": "When enabled on change event doesn't gets triggered when changing datavalue from script",
    "LABEL_PROPERTY_LAYOUTPOSITION": "Layout Position",
    "MESSAGE_HELP_PROPERTY_LAYOUTPOSITION": "Position of the label with respect to the form fields",
    "LABEL_PROPERTY_ENABLESCROLL": "Enable header scroll",
    "MESSAGE_HELP_PROPERTY_ENABLESCROLL": "This property enables scrolling of headers",
    "LABEL_PROPERTYGROUP_DATARENDERING":"Data Rendering",
    "LABEL_PROPERTYGROUP_SEARCHPROPERTIES":"Search Properties",
    "LABEL_PROPERTYGROUP_MESSAGE":"Message",
    "LABEL_PROPERTYGROUP_DELETEDIALOG":"Delete Dialog Actions",
    "LABEL_PROPERTYGROUP_NAVIGATION": "Pagination",
    "LABEL_PROPERTYGROUP_IMAGEPROPERTIES":"Image Properties",
    "LABEL_PROPERTYGROUP_OUTPUT": "Output",
    "LABEL_PROPERTYGROUP_DATATABLE":"Data",
    "LABEL_PROPERTYGROUP_POPUP":"Popup Properties",
    "LABEL_PROPERTYGROUP_DATASET":"Dataset",
    "LABEL_PROPERTYGROUP_VALIDATION":"Validation",
    "LABEL_PROPERTYGROUP_VALIDATORS":"Validators",
    "LABEL_PROPERTYGROUP_CASCADEOPTIONS":"Cascade Options",
    "LABEL_PROPERTYGROUP_FETCHOPTIONS":"While fetching",
    "LABEL_PROPERTYGROUP_PARENTFETCHOPTIONS":"While fetching",
    "LABEL_PROPERTYGROUP_OPERATIONS":"Operations",
    "LABEL_PROPERTYGROUP_HELP":"Help",
    "LABEL_PROPERTYGROUP_CAPTION":"Caption",
    "LABEL_PROPERTYGROUP_FORMAT":"Format",
    "LABEL_PROPERTYGROUP_DISPLAYSTYLE":"Display Style",
    "LABEL_PROPERTYGROUP_BASIC":"Basic",
    "LABEL_PROPERTYGROUP_STYLES":"Styles",
    "LABEL_PROPERTYGROUP_BORDER":"Border Style",
    "LABEL_PROPERTYGROUP_TEXTSTYLE":"Text Style",
    "LABEL_PROPERTYGROUP_BACKGROUNDSTYLE":"Background Style",
    "LABEL_PROPERTYGROUP_ADDITIONAL":"Additional",
    "LABEL_PROPERTYGROUP_EVENTS":"Events",
    "LABEL_PROPERTYGROUP_EVENTSDATA": "Events Data",
    "LABEL_PROPERTYGROUP_IMAGE":"Image",
    "LABEL_PROPERTYGROUP_XAXIS":"X-Axis",
    "LABEL_PROPERTYGROUP_YAXIS":"Y-Axis",
    "LABEL_PROPERTYGROUP_ZAXIS":"Z-Axis",
    "LABEL_PROPERTYGROUP_SECURITY":"Security",
    "LABEL_PROPERTYGROUP_VIDEO":"Video",
    "LABEL_PROPERTYGROUP_AUDIO":"Audio",
    "LABEL_PROPERTYGROUP_DEVICESIZE":"Device Sizes",
    "LABEL_PROPERTYGROUP_TOUCHEVENTS":"Touch Events",
    "LABEL_PROPERTYGROUP_MOUSEEVENTS":"Mouse Events",
    "LABEL_PROPERTYGROUP_CALLBACKEVENTS":"Callback Events",
    "LABEL_PROPERTYGROUP_KEYBOARDEVENTS":"Keyboard Events",
    "LABEL_PROPERTYGROUP_DETAILS":"Details",
    "LABEL_PROPERTYGROUP_DATAVALUE":"Data Value",
    "LABEL_PROPERTYGROUP_CONSTRAINTS":"Constraints",
    "LABEL_PROPERTYGROUP_ADDITIONALPROPERTIES":"Additional Properties",
    "LABEL_PROPERTYGROUP_PRIMARYKEY":"Primary Key",
    "LABEL_PROPERTYGROUP_NEWPROPERTY":"NewProperty",
    "LABEL_PROPERTYGROUP_UNIQUEKEY":"Unique Constraints",
    "LABEL_PROPERTYGROUP_TEMPORALTABLE":"Temporal Information",
    "LABEL_PROPERTYGROUP_SEARCH_PLACEHOLDER":"Start typing",
    "LABEL_PROPERTYGROUP_AND":"and",
    "LABEL_PROPERTYGROUP_ADD_NEW_EVENT_HANDLER_TITLE":"Add New Event Handler",
    "LABEL_PROPERTYGROUP_EDIT_EVENT":"Edit Event",
    "LABEL_PROPERTYGROUP_REMOVE_EVENT_HANDLER":"Remove Event Handler",
    "LABEL_PROPERTYGROUP_SERVERPROPS": "Server Properties",
    "MESSAGE_PLACEHOLDER_GRID_DESIGNER_EDIT_OPTIONS":"Placeholder for the field",
    "MESSAGE_PLACEHOLDER_VALUE_FOR_FIELD":"Value for the field",
    "MESSAGE_PLACEHOLDER_DEFAULT_VALUE":"Default value",
    "MESSAGE_PLACEHOLDER_PATTERN":"pattern",
    "MESSAGE_PLACEHOLDER_FILTER_WIDGET_FOR_FIELD":"Filter Component type for the field",
    "MESSAGE_PLACEHOLDER_WIDGET_TYPE_FOR_FIELD":"Component type for the field",
    "MESSAGE_PLACEHOLDER_DATE_PATTERN":"Date pattern",
    "MESSAGE_VARIABLE_DELETED":"Variable does not exist",
    "MESSAGE_WIDGET_DELETED": "Component does not exist",
    "MESSAGE_LOCALE_MESSAGES_DELETED": "Locale key does not exist",
    "MESSAGE_PAGE_PARAM_DELETED": "Page Param does not exist",
    "MESSAGE_PREFAB_PROPERTY_DELETED": "Prefab property does not exist",
    "MESSAGE_SORTING_ORDER":"Ascending/Descending",
    "MESSAGE_PROPERTY_DELETE_FIELD": "Delete Field",
    "MESSAGE_PROPERTY_ADD_FIELD": "Add Field",
    "MESSAGE_DESCENDING_ORDER": "Descending",
    "MESSAGE_ASCENDING_ORDER": "Ascending",
    "MESSAGE_SELECT_FIELD": "Select Field",
    "COMMENT_WEBSERVICE_PROPERTY":"-----------Component Styles Localization Resources----------",
    "LABEL_PROPERTY_WEBSERVICE":{
        "connectionTimeout":"Connection Timeout (ms)",
        "endpointAddress":"Endpoint Address",
        "httpBasicAuthPassword":"HTTP Basic Auth Password",
        "httpBasicAuthUsername":"HTTP Basic Auth Username",
        "requestTimeout":"Request Timeout (ms)"
    },
    "COMMENT_WIDGET_STYLES_RESOURCES":"-----------Component Styles Localization Resources----------",
    "LABEL_PROPERTY_FONTSIZE_HINT":"Font size",
    "LABEL_PROPERTY_FONTFAMILY_HINT":"Arial, Geneva",
    "LABEL_PROPERTY_BACKGROUNDSIZE_HINT":"width, height",
    "LABEL_PROPERTY_BACKGROUNDPOSITION_HINT":"top, left",
    "LABEL_PROPERTY_ALERTTYPE":"Alert Type",
    "MESSAGE_HELP_PROPERTY_ALERTTYPE":"This property will help in identifying the type of alert in the alert box.",
    "LABEL_PROPERTY_COLOR":"Color",
    "MESSAGE_HELP_PROPERTY_COLOR":"Change the color style attribute of the component using this property.",
    "LABEL_PROPERTY_BORDER":"Border",
    "MESSAGE_HELP_PROPERTY_BORDER":"Changes the border thickness for this component. Entering \"4,3,2,1\" gives it a border of 4px on top, 3px on right, 2px on bottom and 1px on left.",
    "LABEL_PROPERTY_BORDERSTYLE":"Style",
    "MESSAGE_HELP_PROPERTY_BORDERSTYLE":"Changes the border style for this component. Select any of the default options available.",
    "LABEL_PROPERTY_BORDERCOLOR":"Color",
    "MESSAGE_HELP_PROPERTY_BORDERCOLOR":"Enter a border color for your component; rgb and hex values are accepted: rgb(0,255,0) and #00FF00 are both valid entries",
    "LABEL_PROPERTY_BACKGROUNDCOLOR":"Color",
    "MESSAGE_HELP_PROPERTY_BACKGROUNDCOLOR":"This property defines the background color style attribute for the component.",
    "LABEL_PROPERTY_BACKGROUNDSIZE":"Size",
    "MESSAGE_HELP_PROPERTY_BACKGROUNDSIZE":"This property defines the background size style attribute for the component.",
    "LABEL_PROPERTY_MARGIN":"Margin",
    "LABEL_PROPERTY_MARGINTOP":"Margin Top",
    "MESSAGE_HELP_PROPERTY_MARGIN":"Sets the margin in pixels for your component. The margin for an object is outside of its border (the padding is inside the border).",
    "LABEL_PROPERTY_MARGINBOTTOM":"Margin Bottom",
    "MESSAGE_HELP_PROPERTY_MARGINBOTTOM":"Sets the margin in pixels for your component. The margin for an object is outside of its border (the padding is inside the border).",
    "LABEL_PROPERTY_MARGINRIGHT":"Margin Right",
    "MESSAGE_HELP_PROPERTY_MARGINRIGHT":"Sets the margin in pixels for your component. The margin for an object is outside of its border (the padding is inside the border).",
    "LABEL_PROPERTY_MARGINLEFT":"Margin Left",
    "MESSAGE_HELP_PROPERTY_MARGINLEFT":"Sets the margin in pixels for your component. The margin for an object is outside of its border (the padding is inside the border).",
    "LABEL_PROPERTY_OFFSET":"Offset",
    "MESSAGE_HELP_PROPERTY_OFFSET": "This property controls the offset of the chart.",
    "LABEL_PROPERTY_PADDING":"Padding",
    "MESSAGE_HELP_PROPERTY_PADDING":"Sets the padding in pixels for your component. The padding for an object is inside of its border (the margin is outside the border).",
    "LABEL_PROPERTY_OPACITY":"Opacity",
    "MESSAGE_HELP_PROPERTY_OPACITY":"This property defines the opacity style attribute for the component.",
    "LABEL_PROPERTY_OVERFLOW":"Overflow",
    "MESSAGE_HELP_PROPERTY_OVERFLOW":"This property defines the overflow style attribute for the component. It specifies what happens if content overflows an element's box.",
    "LABEL_PROPERTY_ZINDEX":"z-index",
    "LABEL_PROPERTY_VISIBILITY":"Visibility",
    "LABEL_PROPERTY_DISPLAY":"Display",
    "LABEL_PROPERTY_VERTICAL":"Vertical",
    "LABEL_PROPERTY_SERVICE":"Service",
    "MESSAGE_HELP_PROPERTY_ZINDEX":"This property defines the z-index style attribute for the component.",
    "LABEL_PROPERTY_FONTFAMILY":"Font Family",
    "MESSAGE_HELP_PROPERTY_FONTFAMILY":"This property defines the font-family style attribute for the component.",
    "LABEL_PROPERTY_FONTWEIGHT":"Font Weight",
    "MESSAGE_HELP_PROPERTY_FONTWEIGHT":"This property defines the font-weight style attribute for the component.",
    "LABEL_PROPERTY_FONTSIZE":"Size",
    "MESSAGE_HELP_PROPERTY_FONTSIZE":"This property defines the font-size style attribute for the component.",
    "LABEL_PROPERTY_FONTUNIT":"Font Unit",
    "MESSAGE_HELP_PROPERTY_FONTUNIT":"This property defines the font-unit style attribute for the component. Units for the font can be specified as either px or em.",
    "LABEL_PROPERTY_FONTSTYLE":"Font Style",
    "MESSAGE_HELP_PROPERTY_FONTSTYLE":"This property defines the font-style style attribute for the component.",
    "LABEL_PROPERTY_TEXTALIGN":"Text Align",
    "MESSAGE_HELP_PROPERTY_TEXTALIGN":"This property defines the text-align style attribute for the component. Values can be left, center or right.",
    "LABEL_PROPERTY_VERTICALALIGN":"Vertical Align",
    "MESSAGE_HELP_PROPERTY_VERTICALALIGN":"This property defines the vertical align property of the components.",
    "LABEL_PROPERTY_TEXTDECORATION":"Text Decoration",
    "MESSAGE_HELP_PROPERTY_TEXTDECORATION":"This property defines the text-decoration style attribute for the component. Text decoration can be bold, underline or italics.",
    "LABEL_PROPERTY_FONTPROPERTY":"Font Property",
    "MESSAGE_HELP_PROPERTY_FONTPROPERTY":"This property defines the font style attribute for the component.",
    "LABEL_PROPERTY_FONTVARIANT":"Font Variant",
    "MESSAGE_HELP_PROPERTY_FONTVARIENT":"This property defines the font-variant style attribute for the component.",
    "LABEL_PROPERTY_WHITESPACE":"White Space",
    "MESSAGE_HELP_PROPERTY_WHITESPACE":"This property defines the whitespace style attribute for the component.",
    "LABEL_PROPERTY_WORDBREAK":"Word Break",
    "MESSAGE_HELP_PROPERTY_WORDBREAK":"This property defines the wordbreak style attribute for the component.",
    "LABEL_PROPERTY_CURSOR":"Cursor",
    "MESSAGE_HELP_PROPERTY_CURSOR":"This property defines the cursor style attribute for the component.",
    "LABEL_PROPERTY_BORDERRADIUS":"Border Radius",
    "MESSAGE_HELP_PROPERTY_BORDERRADIUS":"This property defines the border-radius style attribute for the component.",
    "LABEL_PROPERTY_EDITORBORDER":"Editor Border",
    "MESSAGE_HELP_PROPERTY_EDITORBORDER":"This property defines the editor border style attribute for the component.",
    "LABEL_PROPERTY_BORDERWIDTH":"Border Width",
    "MESSAGE_HELP_PROPERTY_BORDERWIDTH":"This property defines the border-width style attribute for the component.",
    "LABEL_PROPERTY_BACKGROUNDGRADIENT":"Background Gradient",
    "MESSAGE_HELP_PROPERTY_BACKGROUNDGRADIENT":"This property defines the background-gradient style attribute for the component.",
    "LABEL_PROPERTY_BACKGROUND":"Background",
    "MESSAGE_HELP_PROPERTY_BACKGROUND":"BACKGROUND poperties",
    "LABEL_PROPERTY_BACKGROUNDIMAGE":"Image",
    "MESSAGE_HELP_PROPERTY_BACKGROUNDIMAGE":"User has following options to set backgroundImage \r\n 1) Direct image name with extension \r\n 2) Direct valid web url to the image \r\n 3) path to the image in the project directory, ex:resources/images/imagelists/example.png \r\n 4) url(imageName with extension) or url('imageName with extension') or url(\"imageName with extension\")",
    "LABEL_PROPERTY_BACKGROUNDREPEAT":"Repeat",
    "MESSAGE_HELP_PROPERTY_BACKGROUNDREPEAT":"Background can be repeated vertically/horizontally/both or can be set to no-repeat to not to repeat.",
    "LABEL_PROPERTY_BACKGROUNDRESIZEMODE":"Resize Mode",
    "MESSAGE_HELP_PROPERTY_BACKGROUNDRESIZEMODE":"Background is placed in 5 ways. \r\n 1) cover - covers all the available space with edge trimming, but no stretching.\r\n 2) contain - Fits the image in the available space without stretching and trimming. \r\n 3) stretch - image is stretched to cover the entire space.\r\n 4) center - center of space,\r\n 5) repeat - image is repeated to cover the entire space. This option will not be considered when background position or size is specified.",
    "LABEL_PROPERTY_BACKGROUNDPOSITION":"Position",
    "MESSAGE_HELP_PROPERTY_BACKGROUNDPOSITION":"The background-position property sets the starting position of a background image. This can be given in 1. (x%, y%) \n 2. (xpos, ypos) \n 3. (left, top), (center, top) etc.",
    "LABEL_PROPERTY_BACKGROUNDATTACHMENT":"Attachment",
    "MESSAGE_HELP_PROPERTY_BACKGROUNDATTACHMENT":"This property defines the background attachment attribute for the component.",
    "LABEL_PROPERTY_YOUTUBEURL":"Youtube Url",
    "MESSAGE_HELP_PROPERTY_YOUTUBEURL":"This property defines the youtube video link url attribute for the youtube prefab. This url specifies the location where the video can be found.",
    "LABEL_PROPERTY_APPID":"App Id",
    "MESSAGE_HELP_PROPERTY_APPID":"This property defines the facebook app-id attribute for the prefab. The app-id that has been registered with facebook for creating facebook associated apps.",
    "LABEL_PROPERTY_PROTOCOL":"Protocol",
    "MESSAGE_HELP_PROPERTY_PROTOCOL":"This property defines the protocol attribute for the prefab.",
    "LABEL_PROPERTY_HOST":"Host",
    "MESSAGE_HELP_PROPERTY_HOST":"This property defines the host attribute for the component.",
    "LABEL_PROPERTY_ITEMDATA":"Item Data",
    "MESSAGE_HELP_PROPERTY_ITEMDATA":"This property defines the item-data attribute for the component.",
    "LABEL_PROPERTY_AUTHTOKEN":"Auth Token",
    "MESSAGE_HELP_PROPERTY_AUTHTOKEN":"This property defines the auth token required for facebook prefab and facebook associated components.",
    "LABEL_PROPERTY_TEXT":"Text",
    "MESSAGE_HELP_PROPERTY_TEXT":"styles that can be applied to the text in your component ",
    "COMMENT_WIDGET_EVENTS_RESOURCES":"-----------Component Events Localization Resources----------",
    "LABEL_PROPERTY_ONENTERKEYPRESS": "On Enter Key Press",
    "MESSAGE_HELP_PROPERTY_ONENTERKEYPRESS":"When the user hits ENTER/Return while focus is in this editor, execute the specified event handler.",
    "LABEL_PROPERTY_ONCHANGE":"Change",
    "MESSAGE_HELP_PROPERTY_ONCHANGE":"This event handler is called each time your element's value changes.",
    "LABEL_PROPERTY_ONCANCHANGE":"Can Change",
    "MESSAGE_HELP_PROPERTY_ONCANCHANGE":"Event handler for the canChange event.",
    "LABEL_PROPERTY_ONCLOSEORDESTROY":"Close Or Destroy",
    "MESSAGE_HELP_PROPERTY_ONCLOSEORDESTROY":"Event handler to handle both close or destroy events.",
    "LABEL_PROPERTY_CHANGEONKEY":"Change On Key",
    "MESSAGE_HELP_PROPERTY_CHANGEONKEY":"Checking this box causes the onChange event to fire every time a new character is entered in the text editor.",
    "LABEL_PROPERTY_ONFOCUS": "On Focus",
    "MESSAGE_HELP_PROPERTY_ONFOCUS":"This event handler is called each time your element is focused.",
    "LABEL_PROPERTY_ONHIDE": "On Hide",
    "MESSAGE_HELP_PROPERTY_ONHIDE":"This event should fire any time a component is hidden due to changes in its parent's state.",
    "LABEL_PROPERTY_ONSHOW": "On Show",
    "MESSAGE_HELP_PROPERTY_ONSHOW":"This event should fire any time a component is shown due to changes in its parent's state",
    "LABEL_PROPERTY_ONBLUR": "On Blur",
    "MESSAGE_HELP_PROPERTY_ONBLUR":"This event handler is called each time your focus leaves your element.",
    "LABEL_PROPERTY_ONHELPCLICK":"On Help Click",
    "MESSAGE_HELP_PROPERTY_ONHELPCLICK":"This event handler is called whenever the help icon is clicked.",
    "LABEL_PROPERTY_ONTABDROP":"On Tab Drop",
    "MESSAGE_HELP_PROPERTY_ONTABDROP":"This event handler is called whenever the tab is dropped.",
    "LABEL_PROPERTY_ONTABREMOVED":"On Tab Removed",
    "MESSAGE_HELP_PROPERTY_ONTABREMOVED":"This event handler is called whenever a tab is removed.",
    "LABEL_PROPERTY_ONRIGHTCLICK":"Right Click",
    "MESSAGE_HELP_PROPERTY_ONRIGHTCLICK":"If the user right clicks/context clicks on this component, fire this event handler",
    "LABEL_PROPERTY_ONMOUSEOVER": "On Mouse Over",
    "MESSAGE_HELP_PROPERTY_ONMOUSEOVER":"This event fires when the mouse hovers over this component.",
    "LABEL_PROPERTY_ONMOUSEOUT": "On Mouse Out",
    "MESSAGE_HELP_PROPERTY_ONMOUSEOUT":"This event fires when the mouse moves away from this component.",
    "LABEL_PROPERTY_ONDEACTIVATE":"On Deactivate",
    "MESSAGE_HELP_PROPERTY_ONDEACTIVATE":"This event handler is called whenever the deactivate event is called.",
    "LABEL_PROPERTY_ONCLICK": "On Click",
    "MESSAGE_HELP_PROPERTY_ONCLICK":"This event handler is called whenever the click event is triggered on a component.",
    "LABEL_PROPERTY_ONCHIPCLICK": "On Chip Click",
    "MESSAGE_HELP_PROPERTY_ONCHIPCLICK":"This event handler is called whenever the click event is triggered on a chip item.",
    "LABEL_PROPERTY_ONDBLCLICK": "On Double Click",
    "MESSAGE_HELP_PROPERTY_ONDBLCLICK":"This event handler is called whenever the double click event is triggered on a component.",
    "LABEL_PROPERTY_ONTAP": "On Tap",
    "MESSAGE_HELP_PROPERTY_ONTAP":"This event handler is called whenever the tap event is triggered on a component.",
    "LABEL_PROPERTY_ONDOUBLETAP": "On Double Tap",
    "MESSAGE_HELP_PROPERTY_ONDOUBLETAP":"This event handler is called whenever the double tap event is triggered on a component.",
    "LABEL_PROPERTY_ONLONGTAP": "On Long Tap",
    "MESSAGE_HELP_PROPERTY_ONLONGTAP":"This event handler is called whenever user presses and hold on a component for more than 500ms.",
    "LABEL_PROPERTY_ONTOUCHSTART": "On Touch Start",
    "MESSAGE_HELP_PROPERTY_ONTOUCHSTART":"This event handler is called whenever user touches the component.",
    "LABEL_PROPERTY_ONTOUCHEND": "On Touch End",
    "MESSAGE_HELP_PROPERTY_ONTOUCHEND":"This event handler is called whenever user releases touch from the component.",
    "LABEL_PROPERTY_ONMOUSEUP":"Mouse Up",
    "MESSAGE_HELP_PROPERTY_ONMOUSEUP":"This event handler is called whenever the mouse is moved upwards on the y-axis.",
    "LABEL_PROPERTY_ONMOUSEDOWN":"Mouse Down",
    "MESSAGE_HELP_PROPERTY_ONMOUSEDOWN":"This event handler is called whenever the mouse is moved downwards on the y-axis.",
    "LABEL_PROPERTY_ONMOUSEMOVE":"Mouse Move",
    "MESSAGE_HELP_PROPERTY_ONMOUSEMOVE":"This event handler is called whenever the mouse is moved.",
    "LABEL_PROPERTY_ONMOUSEENTER": "On Mouse Enter",
    "MESSAGE_HELP_PROPERTY_ONMOUSEENTER":"This event handler is called whenever the mouse enters the component.",
    "LABEL_PROPERTY_ONMOUSELEAVE": "On Mouse Leave",
    "MESSAGE_HELP_PROPERTY_ONMOUSELEAVE":"This event handler is called whenever the mouse leaves the component.",
    "LABEL_PROPERTY_ONKEYPRESS": "On Key Press",
    "MESSAGE_HELP_PROPERTY_ONKEYPRESS":"This event handler is called whenever a key is pressed.",
    "LABEL_PROPERTY_ONKEYUP": "On Key Up",
    "MESSAGE_HELP_PROPERTY_ONKEYUP":"This event handler is called whenever a key is released.",
    "LABEL_PROPERTY_ONKEYDOWN": "On Key Down",
    "MESSAGE_HELP_PROPERTY_ONKEYDOWN":"This event handler is called whenever a key is pressed down.",
    "LABEL_PROPERTY_ONSUCCESS": "On Success",
    "MESSAGE_HELP_PROPERTY_ONSUCCESS":"This event handler is called whenever a success event is triggered.",
    "LABEL_PROPERTY_ONERROR": "On Error",
    "MESSAGE_HELP_PROPERTY_ONERROR":"This event handler is called whenever a error event is triggered.",
    "LABEL_PROPERTY_ONRESULT": "On Result",
    "MESSAGE_HELP_PROPERTY_ONRESULT": "This event is called after invoking an insert, update or delete service call, whether or not the service call was successful.",
    "LABEL_PROPERTY_ONBEFORESERVICECALL": "On Before Service Call",
    "MESSAGE_HELP_PROPERTY_ONBEFORESERVICECALL": "Validate or modify data before sending it to the server.",
    "LABEL_PROPERTY_ONCLEAR": "On Clear",
    "MESSAGE_HELP_PROPERTY_ONCLEAR": "This event is called when user clears the search text entered.",
    "LABEL_PROPERTY_ONBEFORESUBMIT": "On Before Submit",
    "MESSAGE_HELP_PROPERTY_ONBEFORESUBMIT": "Validate or modify data before submitting the form",
    "LABEL_PROPERTY_ONBEFORESEGMENTCHANGE": "On Before Segment Change",
    "MESSAGE_HELP_PROPERTY_ONBEFORESEGMENTCHANGE": "This event handler is called before showing a segment.",
    "LABEL_PROPERTY_ONSEGMENTCHANGE": "On Segment Change",
    "MESSAGE_HELP_PROPERTY_ONSEGMENTCHANGE": "This event handler is called after showing a segment.",
    "LABEL_PROPERTY_ONSEARCH": "On Search",
    "MESSAGE_HELP_PROPERTY_ONSEARCH": "This event handler is called after the search.",
    "LABEL_PROPERTY_ONBACKBTNCLICK": "On Back Button Click",
    "MESSAGE_HELP_PROPERTY_ONBACKBTNCLICK": "This event handler is triggered whenever back button is clicked. If no callback is bound, then user will be navigated to previous page.",
    "LABEL_PROPERTY_ONOK":"On Ok",
    "MESSAGE_HELP_PROPERTY_ONOK":"This event handler is called whenever an ok event is triggered.",
    "LABEL_PROPERTY_ONSUBMIT":"On Submit",
    "MESSAGE_HELP_PROPERTY_ONSUBMIT":"This event handler is called whenever a submit event is triggered.",
    "LABEL_PROPERTY_ONBEFORERENDER":"On Before Render",
    "MESSAGE_HELP_PROPERTY_ONBEFORERENDER":"This event handler is called before rendering the form fields",
    "LABEL_PROPERTY_ONBEFOREEXPORT":"On Before Export",
    "MESSAGE_HELP_PROPERTY_ONBEFOREEXPORT":"This event handler is called before downloading the file",
    "LABEL_PROPERTY_ONBEFOREFILTER":"On Before Filter",
    "MESSAGE_HELP_PROPERTY_ONBEFOREFILTER":"This event handler is called before filter call is triggered by data table.",
    "LABEL_PROPERTY_ONCLOSE":"On Close",
    "MESSAGE_HELP_PROPERTY_ONCLOSE":"This event handler is called whenever a close event is triggered.",
    "LABEL_PROPERTY_HIDECLOSE":"Hide Close",
    "MESSAGE_HELP_PROPERTY_HIDECLOSE":"This property helps to manage the close button visibility.",
    "LABEL_PROPERTY_ONACTIONSCLICK":"On Actions Click",
    "MESSAGE_HELP_PROPERTY_ONACTIONSCLICK":"This event handler is called when the actions icon is clicked.",
    "LABEL_PROPERTY_ONCANCEL":"On Cancel",
    "MESSAGE_HELP_PROPERTY_ONCANCEL":"This event handler is called whenever a cancel event is triggered.",
    "LABEL_PROPERTY_ONSELECT":"On Select",
    "LABEL_PROPERTY_ONBEFORESELECT":"On Before Select",
    "MESSAGE_HELP_PROPERTY_ONSELECT":"This event handler is called when the tab is selected",
    "LABEL_PROPERTY_ONDELETE":"On Delete",
    "LABEL_PROPERTY_ONBEFOREDELETE":"On Before Delete",
    "MESSAGE_HELP_PROPERTY_ONDELETE":"This event handler is called when the delete icon is clicked.",
    "MESSAGE_HELP_PROPERTY_ONBEFOREDELETE":"This event handler is called before the onDelete event is triggered.",
    "LABEL_PROPERTY_ONCHIPSELECT":"On Chip Select",
    "MESSAGE_HELP_PROPERTY_ONCHIPSELECT":"This event handler is called when the chip item is selected.",
    "LABEL_PROPERTY_ONROWSELECT":"On Row Select",
    "MESSAGE_HELP_PROPERTY_WM-TABLE_ONROWSELECT":"This event handler is called when the row is selected in data table",
    "LABEL_PROPERTY_ONDESELECT":"On Deselect",
    "MESSAGE_HELP_PROPERTY_ONDESELECT":"This event handler is called when the tab is deselected.",
    "LABEL_PROPERTY_ONDRAGHANDLEICONCLICK":"On Drag Handle Icon Click",
    "MESSAGE_HELP_PROPERTY_ONDRAGHANDLEICONCLICK":"This event handler is called when the bottom sheet drag handle icon is tapped",
    "LABEL_PROPERTY_ONROWDESELECT":"On Row Deselect",
    "MESSAGE_HELP_PROPERTY_ONROWDESELECT":"This event handler is called when the row is deselected in data table",
    "LABEL_PROPERTY_ONSWIPEUP": "On Swipe Up",
    "MESSAGE_HELP_PROPERTY_ONSWIPEUP":"This event handler is called whenever swipeup event is triggered.",
    "LABEL_PROPERTY_ONSWIPEDOWN": "On Swipe Down",
    "MESSAGE_HELP_PROPERTY_ONSWIPEDOWN":"This event handler is called whenever swipedown event is triggered.",
    "LABEL_PROPERTY_ONSWIPELEFT": "On Swipe Left",
    "MESSAGE_HELP_PROPERTY_ONSWIPELEFT":"This event handler is called whenever swipeleft event is triggered.",
    "LABEL_PROPERTY_ONSWIPERIGHT": "On Swipe Right",
    "MESSAGE_HELP_PROPERTY_ONSWIPERIGHT":"This event handler is called whenever swiperight event is triggered.",
    "LABEL_PROPERTY_ONPINCHIN": "On Pinch In",
    "MESSAGE_HELP_PROPERTY_ONPINCHIN":"This event handler is called whenever pinchin event is triggered.",
    "LABEL_PROPERTY_ONPINCHOUT": "On Pinch Out",
    "MESSAGE_HELP_PROPERTY_ONPINCHOUT":"This event handler is called whenever pinchout event is triggered.",
    "LABEL_PROPERTY_ONSTART":"On Start",
    "MESSAGE_HELP_PROPERTY_ONSTART":"This event handler is called on start of the progress.",
    "LABEL_PROPERTY_ONBEFORE":"On Before",
    "LABEL_PROPERTY_ONCOMPLETE":"On Complete",
    "MESSAGE_HELP_PROPERTY_ONCOMPLETE":"This event handler is called on complete of the progress.",
    "LABEL_PROPERTY_ONBEFOREUPDATE":"On Before Update",
    "MESSAGE_HELP_PROPERTY_ONBEFOREUPDATE":"This event handler is called on before update of the progress.",
    "LABEL_PROPERTY_ONLOAD": "On Load",
    "MESSAGE_HELP_PROPERTY_ONLOAD": "This event handler is called when the component is loaded.",
    "LABEL_PROPERTY_ONPREV": "On Prev",
    "MESSAGE_HELP_PROPERTY_ONPREV": "This event handler is called when the prev step button is clicked on component",
    "LABEL_PROPERTY_ONNEXT": "On Next",
    "MESSAGE_HELP_PROPERTY_ONNEXT": "This event handler is called when the next step button is clicked on component",
    "LABEL_PROPERTY_ONSKIP": "On Skip",
    "MESSAGE_HELP_PROPERTY_ONSKIP": "This event handler is called when the skip link is clicked on component",
    "LABEL_PROPERTY_ONDONE": "On Done",
    "MESSAGE_HELP_PROPERTY_ONDONE": "This event handler is called when the done button is clicked on component",
    "LABEL_PROPERTY_ONATTACH": "On Attach",
    "MESSAGE_HELP_PROPERTY_ONATTACH": "This event handler is called when the page instance from cache is attached to dom.",
    "LABEL_PROPERTY_ONDETACH": "On Detach",
    "MESSAGE_HELP_PROPERTY_ONDETACH": "This event handler is called when the page instance is detached from dom and saved in cache.",
    "LABEL_PROPERTY_ONDESTROY": "On Destroy",
    "MESSAGE_HELP_PROPERTY_ONDESTROY": "This event handler is called when the prefab is destroyed.",
    "MESSAGE_HELP_PROPERTY_ONPAGEDESTROY": "This event handler is called when the page is destroyed.",
    "MESSAGE_HELP_PROPERTY_ONPARTIALDESTROY": "This event handler is called when the partial is destroyed.",
    "MESSAGE_HELP_PROPERTY_ONPREFABDESTROY": "This event handler is called when the prefab is destroyed.",
    "LABEL_PROPERTY_ONRESIZE": "On Resize",
    "MESSAGE_HELP_PROPERTY_ONRESIZE": "This event handler is called when the window is resized.",
    "LABEL_PROPERTY_ONORIENTATIONCHANGE": "On Orientation Change",
    "MESSAGE_HELP_PROPERTY_ONORIENTATIONCHANGE": "This event handler is called when the screen orientation is changed.",
    "LABEL_PROPERTY_MULTIPLE":"Multiple",
    "MESSAGE_HELP_PROPERTY_MULTIPLE":"Enable/Disable to switch between Multiple/Single File Upload Component.",
    "LABEL_PROPERTY_FILEUPLOADTITLE": "Title",
    "MESSAGE_HELP_PROPERTY_FILEUPLOADTITLE": "Title text for fileupload while in multiselect mode",
    "MESSAGE_HELP_PROPERTY_TITLE": "Set the title of the component",
    "MESSAGE_HELP_PROPERTY_DISPLAYNAME": "Set the title of the component",
    "MESSAGE_HELP_PROPERTY_WIDGET": "Type of component to represent the form field",
    "LABEL_PROPERTY_FILEUPLOADMESSAGE": "Message",
    "MESSAGE_HELP_PROPERTY_FILEUPLOADMESSAGE": "Title text for fileupload while in multiselect mode",
    "MESSAGE_HELP_PROPERTY_MESSAGE": "Set the browse files message of fileupload component",
    "LABEL_PROPERTY_CONTENTTYPE":"Allowed File Extensions",
    "MESSAGE_HELP_PROPERTY_CONTENTTYPE":"Select the default filter file type in file choose option. It can be bindable to a string having comma separated extensions. Example: '.pdf, .doc, .gif'",
    "LABEL_PROPERTY_DESTINATION":"Upload Directory",
    "MESSAGE_HELP_PROPERTY_DESTINATION":"If value is set as 'files' then file will be uploaded to '/resources/uploads/files'.",
    "LABEL_PROPERTY_MAXSIZE":"Max Size",
    "MESSAGE_HELP_PROPERTY_MAXSIZE":"If max size is set, chips will restrict adding more than max size.",
    "LABEL_PROPERTY_ALLOWONLYSELECT":"Allow Only Select",
    "MESSAGE_HELP_PROPERTY_ALLOWONLYSELECT":"If Allow Only Select is set to true, chips will restrict adding values other than in the selection. By default there is no restriction",
    "LABEL_PROPERTY_MAXFILESIZE":"Max File Size",
    "LABEL_PROPERTY_MAXFILESIZE_INFO":"size in MB",
    "LABEL_PROPERTY_MAXFILESIZE_EXCEEDED":"Max File Size exceeded. Max file size limit is 50MB.",
    "MESSAGE_HELP_PROPERTY_MAXFILESIZE":"If max file size is set, file upload will restrict the files more than max file size. Default Max file size is 30MB",
    "LABEL_PROPERTY_MODE":"Mode",
    "MESSAGE_HELP_PROPERTY_MODE":"If the Mode value is 'Upload', on files select, selected files will be uploaded. And if value is 'Select', it will just allow to select files but not uploading.",
    "LABEL_PROPERTY_CACHE":"Cache",
    "MESSAGE_HELP_PROPERTY_CACHE":"During navigation to another page, generally this page instance is deleted. If this property is true, then this page instance is stored in cache.",
    "LABEL_PROPERTY_REFRESHDATAONATTACH":"Refresh data on attach",
    "MESSAGE_HELP_PROPERTY_REFRESHDATAONATTACH":"If enabled, all page variables that have 'Request data on page load' as true, are refreshed after attaching the page.",
    "LABEL_PROPERTY_HEADING":"Title",
    "MESSAGE_HELP_PROPERTY_HEADING":"This property defines the heading or title for the accordion panels.",
    "LABEL_PROPERTYGROUP_CAPTIONFORSTEPS":"Caption for Steps",
    "LABEL_PROPERTY_NEXTBTNLABEL":"Next",
    "MESSAGE_HELP_PROPERTY_NEXTBTNLABEL":"This property defines the caption for Next step",
    "LABEL_PROPERTY_PREVIOUSBTNLABEL":"Previous",
    "MESSAGE_HELP_PROPERTY_PREVIOUSBTNLABEL":"This property defines the caption for Previous step",
    "LABEL_PROPERTY_DONEBTNLABEL":"Done",
    "MESSAGE_HELP_PROPERTY_DONEBTNLABEL":"This property defines the caption for Done action",
    "MESSAGE_HELP_PROPERTY_DONEBTNICONCLASS":"This property will modify the icon of the Done button.",
    "LABEL_PROPERTY_CANCELBTNLABEL":"Cancel",
    "MESSAGE_HELP_PROPERTY_CANCELBTNLABEL":"This property defines the caption for Cancel action",
    "LABEL_PROPERTY_SHOWALLTITLES":"Show All Titles",
    "MESSAGE_HELP_PROPERTY_SHOWALLTITLES":"This property controls whether all step titles are displayed in the wizard header, regardless of the active step. When enabled, all step titles are visible; when disabled, only the active step title is shown.",
    "LABEL_PROPERTY_SUBHEADING":"Sub Heading",
    "MESSAGE_HELP_PROPERTY_SUBHEADING":"This property defines the sub heading or title for the component.",
    "LABEL_PROPERTY_DESCRIPTION":"Description",
    "MESSAGE_HELP_PROPERTY_DESCRIPTION":"This property defines the description for the accordion panels.",
    "LABEL_PROPERTY_PANEICON":"Icon Class",
    "MESSAGE_HELP_PROPERTY_PANEICON":"This property can assign an icon for the pane.",
    "LABEL_PROPERTY_LOADINGICON":"Loading Icon",
    "LABEL_TITLEICONCLASS":"Title Icon Class",
    "MESSAGE_HELP_PROPERTY_LOADINGICON":"This property can assign an icon that is shown while loading list items.",
    "LABEL_PROPERTY_CLOSEOTHERS":"Close others",
    "MESSAGE_HELP_PROPERTY_CLOSEOTHERS":"This property specifies whether on clicking of an accordion panel, should other panels close.",
    "LABEL_PROPERTY_ISDEFAULTPANE":"Is Default Pane",
    "MESSAGE_HELP_PROPERTY_ISDEFAULTPANE":"This property determines if this pane is the default pane.",
    "LABEL_PROPERTY_ONEXPAND":"On Expand",
    "MESSAGE_HELP_PROPERTY_ONEXPAND":"This property defines the event handler for the expand event of the component.",
    "LABEL_PROPERTY_ONFULLSCREEN": "On Full Screen",
    "MESSAGE_HELP_PROPERTY_ONFULLSCREEN": "This event is called on the full screen state of the component",
    "LABEL_PROPERTY_ONEXITFULLSCREEN": "On Exit Full Screen",
    "MESSAGE_HELP_PROPERTY_ONEXITFULLSCREEN": "This event is called when the full screen state is exited.",
    "LABEL_PROPERTY_ONCOLLAPSE":"On Collapse",
    "MESSAGE_HELP_PROPERTY_ONCOLLAPSE":"This property defines the event handler for the collapse event of the component.",
    "LABEL_PROPERTY_ONTRANSFORM": "On Transform",
    "MESSAGE_HELP_PROPERTY_ONTRANSFORM": "This function is called transform the data before it is bound to the component and it expects raw data and returns the transformed data",
    "LABEL_PROPERTY_ONSORT": "On Data Sort",
    "MESSAGE_HELP_PROPERTY_ONSORT": "This event handler is called when the user clicks the table headers to sort your table.",
    "LABEL_PROPERTY_ONGRIDBUTTONCLICK": "Data Table Action Click",
    "MESSAGE_HELP_PROPERTY_ONGRIDBUTTONCLICK": "If you use a Button formatter in a data table column, this event gets called when that button is clicked",
    "LABEL_PROPERTY_ONHEADERCLICK": "On Header Click",
    "MESSAGE_HELP_PROPERTY_ONHEADERCLICK": "To add code to handle right clicks on cells, use this handler",
    "LABEL_PROPERTY_ONBEFOREROWDELETE": "On Before Row Delete",
    "MESSAGE_HELP_PROPERTY_ONBEFOREROWDELETE": "This event is fired before a record is deleted in the table.",
    "LABEL_PROPERTY_ONROWDELETE": "On Record Delete",
    "MESSAGE_HELP_PROPERTY_ONROWDELETE": "This event is fired after a record is deleted in the table.",
    "LABEL_PROPERTY_ONBEFOREROWINSERT": "On Before Record Insert",
    "MESSAGE_HELP_PROPERTY_ONBEFOREROWINSERT": "This event is fired before a new record is inserted in the table.",
    "LABEL_PROPERTY_ONROWINSERT": "On Record Insert",
    "MESSAGE_HELP_PROPERTY_ONROWINSERT": "This event is fired after a new record is inserted in the table.",
    "LABEL_PROPERTY_ONBEFOREROWUPDATE": "On Before Record Update",
    "MESSAGE_HELP_PROPERTY_ONBEFOREROWUPDATE": "This event is fired before a record is updated in the table.",
    "LABEL_PROPERTY_ONROWUPDATE": "On Record Update",
    "MESSAGE_HELP_PROPERTY_ONROWUPDATE": "This event is fired after a record is updated in the table.",
    "LABEL_PROPERTY_ONBEFOREFORMRENDER": "On Before Form Render",
    "MESSAGE_HELP_PROPERTY_ONBEFOREFORMRENDER": "This event is fired on edit of a row and before the inline form is rendered.",
    "LABEL_PROPERTY_ONFORMRENDER": "On Form Render",
    "MESSAGE_HELP_PROPERTY_ONFORMRENDER": "This event is fired after the inline form is rendered.",
    "LABEL_PROPERTY_ONROWCLICK": "On Row Click",
    "MESSAGE_HELP_PROPERTY_ONROWCLICK": "When a row is clicked, this event will be fired.",
    "LABEL_PROPERTY_ONROWDBLCLICK": "On Row Double Click",
    "MESSAGE_HELP_PROPERTY_ONROWDBLCLICK": "When double click action is performed on a row, this event will be fired.",
    "LABEL_PROPERTY_ONCOLUMNSELECT": "On Column Select",
    "MESSAGE_HELP_PROPERTY_ONCOLUMNSELECT": "When a column is selected, this event will be fired.",
    "LABEL_PROPERTY_ONDATARENDER": "On Data Render",
    "MESSAGE_HELP_PROPERTY_ONDATARENDER": "When component is rendered with data, this event will be fired.",
    "LABEL_PROPERTY_ONBEFOREDATARENDER": "On Before Data Render",
    "MESSAGE_HELP_PROPERTY_ONBEFOREDATARENDER": "This event handler is called before the data is rendered on component.",
    "LABEL_PROPERTY_ONRENDER": "On Render",
    "MESSAGE_HELP_PROPERTY_ONRENDER": "When component is rendered, this event will be fired.",
    "LABEL_PROPERTY_ONBEFORENAVIGATE": "On Before Navigate",
    "MESSAGE_HELP_PROPERTY_ONBEFORENAVIGATE": "This event handler is called before the page is redirected",
    "LABEL_PROPERTY_ONCOLUMNDESELECT": "On Column Deselect",
    "MESSAGE_HELP_PROPERTY_ONCOLUMNDESELECT": "When a column is deselected, this event will be fired.",
    "LABEL_PROPERTY_ONSETRECORD": "On Pagination Change",
    "MESSAGE_HELP_PROPERTY_ONSETRECORD": "This event handler is called when the data is set using the pagination.",
    "LABEL_PROPERTY_ONPAGINATIONCHANGE": "On Before Pagination Change",
    "MESSAGE_HELP_PROPERTY_ONPAGINATIONCHANGE": "This event handler is called when the page is changed through navigation controls.",
    "LABEL_PROPERTY_ONPULLTOREFRESH": "On Pull To Refresh",
    "MESSAGE_HELP_PROPERTY_ONPULLTOREFRESH": "This event handler is called when the list is swiped down.",
    "LABEL_PROPERTY_ONSELECTIONLIMITEXCEED": "On Selection Limit Exceed",
    "MESSAGE_HELP_PROPERTY_ONSELECTIONLIMITEXCEED": "This event is triggered when selected items cross the Selection Limit",
    "LABEL_PROPERTY_ONBEFOREADD":"On Before Add",
    "MESSAGE_HELP_PROPERTY_ONBEFOREADD":"This event is triggered before the item is added to the chips list.",
    "LABEL_PROPERTY_ONADD":"On Add",
    "MESSAGE_HELP_PROPERTY_ONADD":"This event is triggered when an item is added to the chips list.",
    "LABEL_PROPERTY_ONBEFOREREMOVE":"On Before Remove",
    "MESSAGE_HELP_PROPERTY_ONBEFOREREMOVE":"This event is triggered before the item is removed from the chips list.",
    "LABEL_PROPERTY_ONREMOVE":"On Remove",
    "MESSAGE_HELP_PROPERTY_ONREMOVE":"This event is triggered when an item is removed from the chips list.",
    "LABEL_PROPERTY_ONBEFOREREORDER": "On Before Reorder",
    "MESSAGE_HELP_PROPERTY_ONBEFOREREORDER": "This event is triggered before the item in a list is reordered.",
    "LABEL_PROPERTY_ONREORDER": "On Reorder",
    "MESSAGE_HELP_PROPERTY_ONREORDER": "This event is triggered when the item in a list is reordered.",
    "LABEL_PROPERTY_ONDAYCLICK": "On Day Click",
    "MESSAGE_HELP_PROPERTY_ONDAYCLICK": "This event handler a user click on a day in the calendar.",
    "LABEL_PROPERTY_ONEVENTDROP": "On Event Drop",
    "MESSAGE_HELP_PROPERTY_ONEVENTDROP": "This event handler is triggered when dragging of an event in calendar stops and the event has moved to a different day/time.",
    "LABEL_PROPERTY_ONEVENTRESIZE": "On Event Resize",
    "MESSAGE_HELP_PROPERTY_ONEVENTRESIZE": "This event handler is triggered when resizing of the event in calendar stops and the event has changed in duration.",
    "LABEL_PROPERTY_ONEVENTCLICK": "On Event Click",
    "MESSAGE_HELP_PROPERTY_ONEVENTCLICK": "This event handler is triggered when an event is clicked in calendar",
    "LABEL_PROPERTY_ONEVENTRENDER": "On Event Render",
    "MESSAGE_HELP_PROPERTY_ONEVENTRENDER": "This event handler is triggered when an event is rendered.",
    "LABEL_PROPERTY_ONVIEWRENDER": "On View Render",
    "MESSAGE_HELP_PROPERTY_ONVIEWRENDER": "This event handler is triggered when the calender view is changed.",
    "LABEL_PROPERTY_SHOWINDEVICE": "Show in device",
    "MESSAGE_HELP_PROPERTY_SHOWINDEVICE": "This property helps to manage the component visibility across device sizes (Extra small devices Phones (<768px), Small devices Tablets (≥768px), Medium devices Desktops (≥992px), Large devices Desktops (≥1200px) of viewport width)",
    "LABEL_PROPERTY_ONOPENED": "On Open",
    "MESSAGE_HELP_PROPERTY_ONOPENED": "This event handler is called whenever dialog is opened.",
    "LABEL_PROPERTY_LOADMODE": "Load",
    "MESSAGE_HELP_PROPERTY_LOADMODE": "This property defines the load behavior of the container.",
    "LABEL_PROPERTY_LOADDELAY": "Load Delay",
    "MESSAGE_HELP_PROPERTY_LOADDELAY": "Time in milliseconds, after which the container has to be loaded. This property is used only when the load mode is set to 'after-delay'.",
    "LABEL_PROPERTY_EVENTTITLE": "Title",
    "MESSAGE_HELP_PROPERTY_EVENTTITLE": "Title is shown on the event.",
    "LABEL_PROPERTY_EVENTSTART": "Start",
    "MESSAGE_HELP_PROPERTY_EVENTSTART": "Start time of the event",
    "LABEL_PROPERTY_EVENTEND": "End",
    "MESSAGE_HELP_PROPERTY_EVENTEND": "End time of the event.",
    "LABEL_PROPERTY_EVENTALLDAY": "All Day",
    "MESSAGE_HELP_PROPERTY_EVENTALLDAY": "Displays the event for complete day",
    "LABEL_PROPERTY_EVENTCLASS": "Class Name",
    "MESSAGE_HELP_PROPERTY_EVENTCLASS": "Style classes applied for the event",
    "LABEL_PROPERTY_ONREADY": "On Ready",
    "MESSAGE_HELP_PROPERTY_ONREADY": "This event handler is called when the container is loaded.",
    "LABEL_PROPERTY_DEFAULTPANEINDEX": "Default Pane Index",
    "MESSAGE_HELP_PROPERTY_DEFAULTPANEINDEX": "This property sets the default active pane on load of component based on provided index.",
    "LABEL_PROPERTY_DEFAULTSTEPINDEX": "Default Step Index",
    "MESSAGE_HELP_PROPERTY_DEFAULTSTEPINDEX": "This property sets the default active step on load of Dynamic wizard based on provided index.",
    "LABEL_PROPERTY_ENCODEURL": "Encode URL",
    "MESSAGE_HELP_PROPERTY_ENCODEURL": "Check this if you want the provided URL to be encoded at run time.",
    "LABEL_PROPERTY_ONLOGINSUCCESS": "On Login Success",
    "COMMENT_WEB_SERVICE_LOCALIZATION_RESOURCES": "-----------WEB SERVICE Localization Resources----------",
    "LABEL_WEB_SERVICE_TITLE_SOAP": "SOAP",
    "LABEL_WEB_SERVICE_TITLE_REST":"REST",
    "LABEL_WEB_SERVICE_TITLE_XHR":"XHR",
    "LABEL_WEB_SERVICE_TITLE_FEED":"FEED",
    "LABEL_WEB_SERVICE_TITLE_WEBSOCKET":"WebSocket",
    "LABEL_TITLE_PROFILES_CONFIGURATION":"Profiles Configuration",
    "LABEL_TITLE_APP_ENVIRONMENT": "App Environment",
    "LABEL_TITLE_OAUTH_2": "OAuth 2.0",
    "LABEL_SOAP_SERVICE": "Soap Service",
    "LABEL_REST_SERVICE": "Rest Service",
    "LABEL_FEED_SERVICE": "Feed Service",
    "SERVICE_NAME": {
        "JAVASERVICE": "Java Service",
        "RESTSERVICE": "Rest Service",
        "SOAPSERVICE": "Soap Service",
        "FEEDSERVICE": "Feed Service",
        "DATASERVICE": "Database Service",
        "WEBSOCKETSERVICE": "WebSocket Service",
        "OPENAPISERVICE": "Imported APIs"
    },
    "LABEL_WEBSERVICE_SELECT_PROVIDER":"Select a webservice provider",
    "LABEL_FEED_SERVICE_DESCRIPTION":"This service supports all of the popular RSS and Atom formats including RSS 0.90, RSS 0.91 Netscape, RSS 0.91 Userland, RSS 0.92, RSS 0.93, RSS 0.94, RSS 1.0, RSS 2.0, Atom 0.3, and Atom 1.0.",
    "COMMENT_DATABASE_LOCALIZATION_RESOURCES":"-----------Database Localization Resources----------",
    "LABEL_DATABASE_DATABASE_INFO":"Database Info",
    "LABEL_DATAMODEL_INFO":"Data Model Info",
    "LABEL_DATABASE_SELECT_WS_PROVIDER":"Default workspace database",
    "LABEL_DATABASE_SELECT_EX_PROVIDER":"Select an external database",
    "LABEL_DATABASE_IMPORT_HRDB_PREFIX":"Or import",
    "LABEL_DATABASE_IMPORT_HRDB_SUFFIX":"sample HR database",
    "LABEL_DATABASE_IMPORT_SALESDB_SUFFIX":"sample Sales database",
    "LABEL_DATABASE_CONNECT_DATABASE":"Connect to Database",
    "LABEL_ADD_DATABASE_TO_PROJECT": "Connect Database to Project",
    "LABEL_ADD_DATAMODEL_TO_PROJECT": "Add Data Model to Project",
    "LABEL_CONNECT_TO_DATABASE": "Connect to a DB",
    "LABEL_UPLOAD_MYSQL_FILE": "Upload MySQL files",
    "LABEL_DATABASE_CREATE_DATABASE":"Create Database",
    "LABEL_DATABASE_CREATE_EMPTY":"Create empty database",
    "LABEL_DATABASE_SQL_UPLOAD":"Upload .sql file",
    "LABEL_DATABASE_EXPORT_DATABASE":"Export Database",
    "LABEL_DATABASE_REVERT_DATAMODEL":"Revert Data Model",
    "LABEL_DATABASE_REIMPORT_DATABASE":"Re-Import Data Model",
    "LABEL_DATABASE_APPLY_DATAMODEL":"Export Database",
    "LABEL_DATABASE_UPDATE_DATABASE":"Update Database",
    "LABEL_DATABASE_UPDATE_DATABASE_DISABLED":"No schema changes to Update",
    "LABEL_DATABASE_UPDATE_DATAMODEL":"Update Data Model",
    "LABEL_DATABASE_UPDATE_DATAMODEL_DISABLED":"No changes to Update",
    "LABEL_DATABASE_REIMPORT_DATAMODEL":"Re-Import Data Model",
    "LABEL_DATABASE_DELETE_TABLE":"Delete Table",
    "LABEL_DATABASE_DELETE_ENTITY": "Delete Entity",
    "LABEL_DATABASE_DELETE_ATTRIBUTE": "Delete Attribute",
    "LABEL_DATABASE_DELETE_REFERENCE": "Delete Reference",
    "LABEL_DATABASE_DELETE_UNIQUE_KEY":"Delete Unique Constraint",
    "LABEL_DATABASE_ADD_UNIQUE_KEY":"Add Unique Constraint: ${0}",
    "LABEL_DATABASE_NO_COLUMNS_SELECTED":"No columns selected",
    "LABEL_DATABASE_DELETE_COLUMN":"Delete Column",
    "LABEL_DATABASE_DELETE_RELATION":"Delete Relation",
    "LABEL_DATABASE_DELETE_QUERY":"Delete Query",
    "LABEL_DATABASE_RUN_QUERY":"Run Query",
    "LABEL_DATABASE_DELETE_PROCEDURE":"Delete Procedure",
    "LABEL_PROCEDURE_UNTITLED": "Untitled",
    "LABEL_DATABASE_UPGRADE_QUERY":"Upgrade API",
    "LABEL_DATABASE_QUERY_VERSION":"Query API Version",
    "MESSAGE_DATABASE_QUERY_UPGRADE_SUCCESS":"Query API upgraded successfully.",
    "MESSAGE_DATABASE_QUERY_UPGRADE_FAILED":"Upgrading Query API failed.",
    "MESSAGE_DATABASE_QUERY_UPGRADE_PROGRESS":"Upgrading Query API ...",
    "MESSAGE_DATABASE_QUERY_USAGE_CHECK":"Checking for query usage ...",
    "MESSAGE_DATABASE_QUERY_USAGE_FAILED":"Failed to get query usage details.",
    "MESSAGE_DATABASE_QUERY_UPGRADE_TEXT": "You are currently using the old version of the query api. Click continue to migrate the query api to the latest version.",
    "MESSAGE_DATABASE_QUERY_UPGRADE_HINT": "You are currently using the old version of the query api. Please upgrade to latest version.",
    "MESSAGE_DATABASE_QUERY_USAGE": "This api is being used by variables in the following pages.",
    "MESSAGE_DATABASE_QUERY_USAGE_NOTE": "Note: Please note that this upgrade might break the component bindings and script reference which needs to be resolved manually.",
    "MESSAGE_DATABASE_QUERY_BLOB_IDENTIFIERS": "Select a column or combination of columns/fields that uniquely identifies a row in the query result.",
    "MESSAGE_DATABASE_QUERY_NO_BLOB_IDENTIFIERS": "Query returning blob column needs an additional​ identifier column to save.",
    "LABEL_DATABASE_IMPORT_POSTGRESQL_DB":"Import PostgreSQL Database",
    "LABEL_DATABASE_SQL_MISMATCH":"SQL Mismatch",
    "LABEL_CREATE_NEW_DATABASE":"Create a new",
    "LABEL_CREATE_NEW_DATABASE_USING_DESIGNER":"using DB Designer",
    "MESSAGE_DATABASE_DATA_LOSS":"The SQL type of the following columns has been changed. This will lead to a loss of data. Are you sure you want to continue?",
    "LABEL_DATABASE_DATA_LOSS_WARNING":"Choose your columns carefully! Data lost once cannot be recovered.",
    "MESSAGE_DATABASE_NO_COLUMNS_FOUND":"No columns found.",
    "MESSAGE_DATABASE_NO_UNIQUE":"No Unique Constraints are defined on this table",
    "MESSAGE_ERROR_SAME_PK_COLUMNS": "Primary key already unique key. No need to specify seperately.",
    "MESSAGE_ERROR_SAME_UNIQUEKEY_COLUMNS": "Constraint already defined with same columns.",
    "MESSAGE_DATABASE_UNIQUE_KEY":"Are you sure you want to delete unique constraint- \"${0}\"?",
    "MESSAGE_DATABASE_DELETE_TABLE":"Are you sure you want to delete table - \"${0}\"?",
    "MESSAGE_DATABASE_DELETE_COLUMN":"Are you sure you want to delete column - \"${0}\"?",
    "MESSAGE_DATABASE_DELETE_RELATION":"Are you sure you want to delete \"${0}\" relation between \"${1}\" and \"${2}\"?",
    "MESSAGE_DATABASE_DELETE_ENTITY":"Are you sure you want to delete entity - \"${0}\"?",
    "MESSAGE_DATABASE_DELETE_ATTRIBUTE" :"Are you sure you want to delete attribute - \"${0}\"?",
    "MESSAGE_DATABASE_DELETE_ATTRIBUTE_AND_ENTITIES":"Are you sure you want to delete attribute - \"${0}\"? This may delete the following entities:",
    "MESSAGE_DATABASE_DELETE_REFERENCE":"Are you sure you want to delete \"${0}\" reference between \"${1}\" and \"${2}\"?",
    "MESSAGE_DATABASE_DELETE_DATAMODEL":"Are you sure you want to delete datamodel - \"${0}\" from the project?",
    "MESSAGE_DATABASE_DELETE_QUERY":"Are you sure you want to delete query - \"${0}\"?",
    "MESSAGE_DATABASE_DELETE_PROCEDURE":"Are you sure you want to delete procedure - \"${0}\"?",
    "MESSAGE_DATABASE_NULL_VALUES_QUERY_PARAMETERS": "Test Run might fail because Query Parameters has null values. Do you want to continue?",
    "MESSAGE_DATABASE_IMPORT_POSTGRESQL_DB":"When importing a Postgres database, there is a known bug that occurs when your table/column names have capital letters in them. If your database table/column names are all lower case, you can ignore this warning. SOLUTION-Edit your database before importing it to remove upper case letters. Continue with import?",
    "MESSAGE_DATABASE_EXPORT_DATABASE":"The schema changes might result in data loss. Are you sure you want to export the datamodel?",
    "MESSAGE_DATABASE_UPDATE_DATABASE":"The schema changes might result in data loss. Are you sure you want to update the database?",
    "MESSAGE_DATABASE_REVERT_DATAMODEL":"All changes made to the datamodel will be lost. Are you sure you want to revert to the published datamodel?",
    "MESSAGE_DATABASE_REIMPORT_DATAMODEL": "All changes made after previous publish will be lost. Are you sure you want to re-import datamodel?",
    "MESSAGE_DATABASE_REIMPORT_DATABASE":"All changes made after previous export will be lost. Are you sure you want to re-import database ?",
    "MESSAGE_DATABASE_EXPORT_DATAMODEL": "Are you sure you want to export the datamodel?",
    "MESSAGE_XFRAME_OPTIONS_DENY":"Deny option does not allow to load the app in a frame.",
    "MESSAGE_XFRAME_OPTIONS_SAMEORIGIN":"Same Origin option allows the app to be loaded on the same origin as the app itself.",
    "MESSAGE_XFRAME_OPTIONS_ALLOW_FROM":"Allow From option enables the app to be loaded in a frame on the specified origin and on the same origin.",
    "MESSAGE_XFRAME_OPTIONS_ALLOW_FROM_URL": "Please provide url in x-frame configuration",
    "MESSAGE_ERROR_SSL": "Please provide SSL port number",
    "MESSAGE_ERROR_INSUFFICIENT_VALUES":"Please provide table names, column names and cardinality to create a relation.",
    "MESSAGE_ERROR_MISMATCH_SQLTYPES":"Sql types of the columns do not match.",
    "MESSAGE_ERROR_UNEQUAL_ONE_ONE_COLUMNS":"Source table and target table should have same number of composite keys to create a One to One composite relation.",
    "MESSAGE_ERROR_SOURCE_NON_PRIMARY":"Source column is not a primary key",
    "MESSAGE_ERROR_SOURCE_TABLE_NON_COMPOSITE":"Source table must have composite keys to create One to Many composite relation.",
    "MESSAGE_ERROR_SOURCE_TABLE_NON_COMPOSITE_MANY_ONE":"Source table must have atleast one non composite key column to create Many to One composite relation.",
    "MESSAGE_ERROR_DUPLICATE_COLUMNS":"Please provide unique columns to create a composite relation",
    "MESSAGE_ERROR_UNIQUE_COMPOSITE_COLUMNS":"Please select composite unique columns to create a composite relation",
    "MESSAGE_ERROR_BASIC_ONE_ONE":"Source and target columns should be primary keys and unique to create a relation.",
    "MESSAGE_ERROR_BASIC_ONE_MANY":"Source column is not a primary key.",
    "MESSAGE_ERROR_BASIC_TARGET_ONE_MANY":"Target column must be a non primary key.",
    "MESSAGE_ERROR_BASIC_SOURCE_MANY_ONE":"Source column must be a non primary key.",
    "MESSAGE_ERROR_SOURCE_NON_KEY_ONE_ONE":"Source column should be either a Primary key or Unique key.",
    "MESSAGE_ERROR_TARGET_NON_KEY_ONE_ONE":"Target column should be either a Primary key or Virtual Primary key.",
    "MESSAGE_ERROR_TARGET_TABLE_NON_COMPOSITE":"Target table must have atleast one non composite key column to create a One to Many composite relation",
    "MESSAGE_ERROR_BASIC_MANY_ONE":"Target column is not a primary key",
    "MESSAGE_ERROR_SELF_ONE_ONE":"Source and target columns should be different to create a self relation.",
    "MESSAGE_ERROR_SELF_COMPOSITE":"Self composite relations are not possible.",
    "MESSAGE_ERROR_TARGET_NON_COMPOSITE_ONE_TO_ONE":"Target table should have composite keys to create One to One composite relation",
    "MESSAGE_ERROR_TARGET_NON_COMPOSITE":"Target table should have composite keys to create Many to One composite relation",
    "MESSAGE_ERROR_MISMATCH_VIRTUAL_PROPERTY":"Selected columns must be either virtual or non virtual / Relation is not selected as virtual. ",
    "MESSAGE_ERROR_VIRTUAL_RELATION":"Relation should be selected as virtual.",
    "MESSAGE_ERROR_REVERT_DATAMODEL":"Error in reverting to published datamodel",
    "MESSAGE_ERROR_EXPORT_DATAMODEL":"Error in exporting to datamodel",
    "MESSAGE_ERROR_DATABASE_PRIMARY_KEY_LENGTH_NOT_ALLOWED":"Primary key column should have length < 255.",
    "MESSAGE_ERROR_DATABASE_PRECISION_NOT_ALLOWED":"Precision cannot be greater than 65.",
    "MESSAGE_ERROR_DATABASE_SCALE_NOT_ALLOWED":"Scale cannot be greater than 30.",
    "MESSAGE_ERROR_INVALID_LENGTH_VALUE": "Length cannot be greater than 999999999.",
    "MESSAGE_ERROR_DATABASE_COLUMN_ZERO_LENGTH_NOT_ALLOWED":"Length value for any column should be > 0.",
    "MESSAGE_ERROR_INVALID_COLUMN_DEFAULTVALUE": "Default value does not match with given JavaType.",
    "MESSAGE_ERROR_INVALID_PK_COLUMN_DEFAULTVALUE": "Default value cannot be given to Primary Key Column.",
    "MESSAGE_ERROR_INVALID_PK_COLUMN_SQLTYPE": "Sqltype cannot be given as 'boolean' to Primary Key Column",
    "MESSAGE_ERROR_INVALID_PK_COLUMN_SQLTYPE_BLOB": "Sqltype cannot be given as 'blob' to Primary Key Column",
    "MESSAGE_ERROR_INVALID_PK_COLUMN_JAVATYPE_CLOB": "Javatype cannot be given as 'clob' to Primary Key Column",
    "MESSAGE_ERROR_INVALID_PK_COLUMN_JAVATYPE_TEXT": "Javatype cannot be given as 'text' to Primary Key Column",
    "MESSAGE_ERROR_INVALID_COLUMN_INPUT_TYPE": "At least one of the options (Insertable, Updatable) must be selected for the column",
    "MESSAGE_ERROR_INVALID_COLUMN_INPUT": "At least one of the options (Insertable, Updatable) must be selected for the column \"${0}\"",
    "MESSAGE_ERROR_DATABASE_DATA_TYPE_CHANGE_NOT_ALLOWED":"Column is part of a relation and hence property cannot be updated. Please delete the relation first.",
    "MESSAGE_ERROR_DATABASE_SQLTYPE_MISMATCH_GENERATOR":"Generator type is identity, and hence column type can be either short, integer or big_integer only.",
    "MESSAGE_INFO_DATABASE_RESET_GENERATOR": "Generator type is modified to assigned, as the column sqltype cannot support auto-increment",
    "MESSAGE_INFO_DATABASE_RESET_GENERATOR_JAVA_TYPE": "Generator type is modified to assigned, as the column javatype cannot support auto-increment",
    "MESSAGE_INFO_DATABASE_QUERY_COMPILATION_IN_PROGRESS":"${0} compilation is in progress.",
    "MESSAGE_INFO_DATABASE_DATA_LOADING_FAILED":"Failed to load data.",
    "MESSAGE_ERROR_DEPLOY_FAILED": "Failed to deploy the application. Please check logs for more information.",
    "MESSAGE_INFO_SAMPLE_DATA":"Representational Data",
    "MESSAGE_ERROR_FETCH_DATA":"Chart cannot be rendered based on input condition. Check if the condition is correct.",
    "MESSAGE_INVALID_AXIS":"Chart cannot be rendered based on the selection. Check if the inputs for x,y axis is correctly configured.",
    "MESSAGE_INFO_RE_IMPORT_PREFIX": ". Click ",
    "MESSAGE_INFO_EXPORT_DATAMODEL_PREFIX": "DB schema is in draft state. Click ",
    "MESSAGE_INFO_DISABLE_QUERY_PROCEDURE": "Please re-import database to access query/procedure.",
    "MESSAGE_INFO_EXPORT_DATAMODEL_HERE": "here",
    "MESSAGE_INFO_EXPORT_DATAMODEL_SUFFIX": " to update the database with the schema changes.",
    "MESSAGE_INFO_EXPORT_MODEL_PREFIX": "Model schema is in draft state. Click ",
    "MESSAGE_INFO_EXPORT_MODEL_HERE": "here",
    "MESSAGE_INFO_EXPORT_MODEL_SUFFIX": " to update the Model with the schema changes.",
    "MESSAGE_INFO_RE_IMPORT_SUFFIX": " to re-import database.",
    "MESSAGE_INFO_SELECT_DB_NAME": "Select \"Database Name\" and click ",
    "MESSAGE_INFO_IMPORT_SUFFIX": " to import database",
    "MESSAGE_INFO_RE_IMPORT_DISABLE": ". Please save the changes to enable re-import",
    "MESSAGE_INFO_TEST_CONNECTION_RE_IMPORT_DISABLE": ". Please test the connection and then save the changes to renable re-import",
    "MESSAGE_INFO_DEFAULT_VARIABLE": "The service has been imported successfully. Use this auto generated variable to invoke the service in runtime. Set the input parameters to the service in \"Data\" tab below ",
    "MESSAGE_INFO_OPEN_SCRIPT_FILE_PREFIX":"Function template for ${1} will be added to ${0}.js. ",
    "MESSAGE_INFO_OPEN_SCRIPT_FILE_SUFFIX":" to edit",
    "MESSAGE_INSECURE_WS_URL":"Services hosted on ws:// protocol can not be tested over https connection. \"Proceed without Testing\" or try a service hosted on wss:// protocol.",
    "MESSAGE_INVALID_WS_URL":"Please make sure you provide a valid WebSocket URL.",
    "LABEL_ADVANCED_SETTINGS":"Advanced Settings",
    "LABEL_PROCEED_WITHOUT_TEST":"Proceed without testing",
    "LABEL_TEST_CONNECTION":"Test Connection",
    "LABEL_DATABASE_CONNECTION_SETTINGS":"Connection Settings",
    "LABEL_BLOCK_CONNECTION_SETTINGS_PREFIX":"You have made changes to the datamodel, export database for the changes to be effective. Settings will show up after the export of the database.",
    "LABEL_BLOCK_TAB_SUFFIX":"You can continue with the datamodel design.",
    "LABEL_BLOCK_QUERY_PREFIX":"You have made changes to the datamodel, export database for the changes to be effective. You can create queries after you export the database.",
    "LABEL_BLOCK_PROCEDURE_PREFIX":"You have made changes to the datamodel, export database for the changes to be effective. You can create procedures after you export the database.",
    "LABEL_PROCEED_TO_DESIGN":"PROCEED TO DESIGN",
    "LABEL_DATABASE_USE_SAMPLE_DB":"Import Sample DB",
    "LABEL_DATABASE_ALREADY_IMPORTED_SAMPLE_DB":"Sample DB already Imported",
    "LABEL_DATABASE_DATABASE_SYSTEM":"Database System",
    "LABEL_DATABASE_HOST":"Host",
    "LABEL_DATABASE_USER_NAME":"User Name",
    "LABEL_DATABASE_PASSWORD":"Password",
    "LABEL_SHOW_DATABASE_PASSWORD":"Show password",
    "LABEL_DATABASE_DATABASE_NAME":"Database Name",
    "LABEL_DATABASE_DATABASE_SCHEMA": "Import Schema as",
  "LABEL_DATABASE_DATABASE_SERVER_VERSION": "Database Server Version",
    "LABEL_DATABASE_DATABASE_SCHEMA_EDITABLE": "editable",
    "LABEL_DATABASE_DATABASE_SCHEMA_READONLY": "readonly",
    "LABEL_DATABASE_DATABASE_NAME_TOOLTIP":"Enter Database Service Name (aplhanumeric characters)",
    "LABEL_DATABASE_INSTANCE_NAME":"Instance Name",
    "LABEL_DATABASE_SID":"SID",
    "LABEL_DATABASE_MARIADB":"Workspace-DB (MariaDB)",
    "LABEL_SERVICE_NAME":"Service Name",
    "LABEL_SERVICE_ID": "Service ID",
    "LABEL_PACKAGE_NAME":"Package Name",
    "LABEL_BINDINGS_XML":"Bindings XML",
    "LABEL_DATABASE_PORT":"Port",
    "LABEL_DATABASE_FILENAME":"File",
    "LABEL_DATABASE_CONNECTION_URL":"Connection URL",
    "LABEL_DATABASE_JAVA_PACKAGE":"Java Package",
    "LABEL_DATABASE_TABLE_FILTER":"Table Filter",
    "LABEL_DATABASE_SCHEMA_NAME":"Default Schema Name",
    "LABEL_DATABASE_SCHEMA_FILTER":"Schema Filter",
    "LABEL_DATABASE_DRIVER_CLASS":"Driver Class",
    "LABEL_DATABASE_DIALECT":"Dialect",
    "LABEL_DATABASE_METADATA_DIALECT": "Metadata Dialect",
    "LABEL_DATABASE_RDBMS":"RDBMS",
    "LABEL_DATABASE_DATABASE":"Database",
    "LABEL_DATABASE_BEHAVIOR":"Behavior",
    "LABEL_DATABASE_QUERY_NAME":"Name",
    "LABEL_CREATE_DEFAULT_VARIABLES":"Auto-create Variables",
    "LABEL_UPDATE_DATABASE_DATALOSS_WARNING":"Yes, I understand that this will delete existing database and re-create it.",
    "MESSAGE_HELP_PROPERTY_QUERYNAME": "This is the name of the query.",
    "MESSAGE_HELP_PROPERTY_PROCEDURENAME": "This is the name of the stored procedure.",
    "LABEL_DATABASE_QUERY_COMMENT":"Description",
    "MESSAGE_HELP_PROPERTY_QUERYDESCRIPTION": "This property refers to the description for the query.",
    "MESSAGE_HELP_PROPERTY_PROCEDUREDESCRIPTION": "This property refers to the description for the stored procedure.",
    "MESSAGE_HELP_PROPERTY_PROCEDURE": "This is used to execute a execute a stored procedure in the database.",
    "MESSAGE_HELP_PROPERTY_QUERYPAGINATION": "This refers to the pagination. Query returns single/multiple record(s) based on the toggle selected",
    "LABEL_DATABASE_QUERY_TYPE":"Query Type",
    "LABEL_DATABASE_QUERY_PAGINATION": "Records :",
    "LABEL_DATABASE_QUERY_IDENTIFIER": "Select Identifier",
    "LABEL_DATABASE_QUERY_RECORDS_PAGINATED": "Paginated",
    "LABEL_PAGINATED":"Paginated",
    "LABEL_SINGLE":"Single",
    "MESSAGE_HELP_PROPERTY_NATIVESQL": "This refers to the query type. The options supported are Native and HQL queries.",
    "LABEL_DATABASE_QUERY_NATIVE_SQL":"Native SQL",
    "LABEL_DATABASE_QUERY_HQL":"HQL",
    "LABEL_DATABASE_QUERY_PARAMETERS":"Parameters",
    "MESSAGE_HELP_PROPERTY_QUERYPARAMETERS":"This property can be used to provide parameters to the query. The parameters should start with a \":\" followed by the parameter name. When the query contains a parameter, this table is automatically populated.",
    "MESSAGE_HELP_PROPERTY_PROCEDUREPARAMETERS":"This property can be used to provide parameters to the stored procedure. The parameters should start with a \":\" followed by the parameter name. When the procedure contains a parameter, this table is automatically populated.",
    "COMMENT_VARIABLE_LOCALIZATION_RESOURCES":"-----------Variable Localization Resources----------",
    "MESSAGE_ERROR_VARIABLE_TYPE_NOT_DEFINED":"Please define a variable type for creating a variable",
    "LABEL_INSERT_VARIABLE_TAB_TITLE":"Variable",
    "LABEL_INSERT_VARIABLE_FORM_TITLE":"New Variable",
    "LABEL_INSERT_VARIABLE_FILTER_ALL":"All",
    "LABEL_PREBUILT_VARIABLE":"Prebuilt Variables",
    "LABEL_PREBUILT_VARIABLE_MONTHS":"Months",
    "LABEL_PREBUILT_VARIABLE_DAYS":"Days",
    "LABEL_PREBUILT_VARIABLE_COUNTRY":"Country List",
    "LABEL_PREBUILT_VARIABLE_US_STATES":"US States List",
    "wm.Variable":"Static Variable",
    "wm.ServiceVariable": "Service Variable",
    "wm.LiveVariable":"Live Variable",
    "wm.LoginVariable":"Login Variable",
    "wm.LogoutVariable":"Logout Variable",
    "wm.NavigationVariable":"Navigation Call",
    "wm.NotificationVariable":"Notification Call",
    "wm.TimerVariable":"Timer Variable",
    "wm.DeviceVariable":"Device Variable",
    "wm.WebSocketVariable":"Web Socket Variable",
    "LABEL_TYPE_VARIABLE":"Type of Variable:",
    "LABEL_TYPE_CALL":"Type of Call:",
    "LABEL_INSERT_VARIABLE_PLACEHOLDER":"Enter a variable name",
    "MESSAGE_INSERT_VARIABLE_VALID_NAME":"Enter a valid variable name!",
    "MESSAGE_INSERT_VARIABLE_ALREADY_EXISTS":"Variable already exists! Enter another name.",
    "MESSAGE_INVALID_PARAMETER":"This variable uses operation which is deprecated.Please review this. ",
    "MESSAGE_INVALID_PARAMETER_INFO": "This parameter is no more valid",
    "MESSAGE_DEPRECATED_OPERATION":"Operation for the selected variable is deprecated, please review ",
    "MESSAGE_INSERT_VARIABLE_DUPLICATE":"Duplicate variable name(s) found : ",
    "LABEL_VARIABLE":"Variable",
    "LABEL_BIND_USE_EXPRESSION":"Use Expression",
    "LABEL_RESOURCE":"Resource",
    "LABEL_AUDIO":"Audio",
    "LABEL_VIDEO":"Video",
    "LABEL_TYPE":"Type",
    "LABEL_CONNECTOR": "Connector",
    "LABEL_ICONS": "Icons",
    "MESSAGE_PLACEHOLDER_SEARCH_VARIABLE_NAME":"Search for Variable name",
    "MESSAGE_INSERT_VARIABLE_PROPERTY_REQUIRED":" is required! Please provide appropriate value.",
    "MESSAGE_POST_METHODS_NOT_FOUND":"This service does not have any POST type operations.",
    "MESSAGE_INSERT_VARIABLE_PROPERTY_PATTERN":" Special characters are not allowed, value should start with an alphabet and must have at least two characters!",
    "MESSAGE_INSERT_VARIABLE_INVALID_DATASET":"Please enter valid JSON.",
    "MESSAGE_VARIABLE_BINDING_VALIDATE_SUCCESS":"This variable can be bound to ",
    "MESSAGE_VARIABLE_BINDING_VALIDATE_FAILURE":"Return types do not match.",
    "MESSAGE_WEBSERVICE_IMPORT_FIELD_MISSING":"Missing field: ",
    "MESSAGE_WEBSERVICE_IMPORT_FIELD_INVALID": "Service/Package Name cannot contain spaces",
    "LABEL_WEBSERVICE_DELETE":"Delete Web Service",
    "LABEL_REST_DELETE":"Delete Rest Service",
    "LABEL_SWAGGER_DELETE": "Delete Imported APIs",
    "MESSAGE_WEBSERVICE_DELETE":"Are you sure you want to delete web service - \"${0}\"?",
    "MESSAGE_SWAGGER_DELETE": "Are you sure you want to delete - \"${0}\"?",
    "LABEL_JAVASERVICE_DELETE":"Delete Java Service",
    "MESSAGE_FILESERVICE_DELETE_WARNING": "The File Service is used by File Upload component. Deleting this may cause functional breakage in the application. Do you want to continue?",
    "MESSAGE_JAVASERVICE_DELETE":"Are you sure you want to delete java service - \"${0}\"?",
    "LABEL_INSERT_CALL_TAB_TITLE":"Call",
    "LABEL_INSERT_OTHERS_TAB_TITLE":"Others",
    "LABEL_DELETE":"Delete",
  "LABEL_UNDO":"Undo",
  "LABEL_REDO":"Redo",
  "LABEL_SHOWHIDE":"Show hidden elements",
    "MESSAGE_DATASET_NOT_SELECTED_FOR_DISPLAYEXPR":"Please set a dataSet before editing your display expression.",
    "MESSAGE_NODE_NOT_SELECTED":"Please select a node to bind property - \"${0}\"",
    "BIND_VALUE_NOT_SELECTED_MESSAGE":"Please select a valid \"${0}\" to bind.",
    "MESSAGE_EMPTY_BINDEXPR":"Empty expression.",
    "MESSAGE_SYNTAX_ERROR_DISPLAYEXPR":"Syntax error in bind-expression.",
    "COMMENT_VARIABLE_PROPERTY_PANEL_LOCALIZATION_RESOURCES":"-----------Variable Property Panel Localization Resources----------",
    "LABEL_FIELD_EDITOR": "Field Editor",
    "LABEL_TEXT_EDITOR": "Text Editor",
    "LABEL_ADD_FIELD": "Add field to dataset",
    "LABEL_REMOVE_FIELD": "Remove this field from dataset",
    "LABEL_VARIABLE_PROPERTYGROUP_PROPERTIES":"Properties",
    "LABEL_VARIABLE_PROPERTYGROUP_DATA":"Data",
    "LABEL_VARIABLE_PROPERTYGROUP_EVENTS":"Events",
    "LABEL_VARIABLE_PROPERTYGROUP_FILTER_CRITERIA":"Filter Criteria",
    "LABEL_VARIABLE_PROPERTYSUBGROUP_BEHAVIOR":"Behavior",
    "LABEL_VARIABLE_PROPERTYSUBGROUP_SPINNER":"Spinner",
    "LABEL_VARIABLE_PROPERTYSUBGROUP_DATASET":"Dataset",
    "LABEL_VARIABLE_PROPERTYSUBGROUP_INPUTFIELDS":"Input Fields",
    "LABEL_VARIABLE_PROPERTYSUBGROUP_FILTERFIELDS":"Filter Fields",
    "LABEL_VARIABLE_PROPERTYSUBGROUP_BINDINGS":"Bindings",
    "LABEL_VARIABLE_PROPERTYSUBGROUP_DATATRANSFORMATION":"Custom Data & Key Mapping",
    "LABEL_VARIABLE_PROPERTYSUBGROUP_MOBILE":"Mobile",
    "LABEL_VARIABLE_PROPERTYSUBGROUP_SERVICE":"Service",
    "LABEL_VARIABLE_PROPERTYSUBGROUP_SERVEROPTIONS":"Server Options",
    "LABEL_VARIABLE_PROPERTYSUBGROUP_JSON":"JSON",
    "LABEL_VARIABLE_PROPERTIES_TRANSFORMATIONREQUIRED":"Data & keys are different fields",
    "LABEL_VARIABLE_TYPE":"Variable Type",
    "LABEL_VARIABLE_PROPERTIES_COLUMNFIELD":"Key Field",
    "LABEL_VARIABLE_PROPERTIES_DATAFIELD":"Data Field",
    "LABEL_VARIABLE_PROPERTIES_TITLE":"Title ",
    "LABEL_VARIABLE_PROPERTIES_NAME":"Name: ",
    "LABEL_VARIABLE_PROPERTIES_OWNER":"Owner: ",
    "LABEL_VARIABLE_PROPERTIES_ISLIST":"Is List: ",
    "LABEL_VARIABLE_PROPERTIES_TWOWAYBINDING":"Enable Two Way Binding: ",
    "LABEL_VARIABLE_PROPERTIES_UPDATE":"Update: ",
    "LABEL_VARIABLE_PROPERTIES_TYPE":"Type: ",
    "LABEL_VARIABLE_PROPERTIES_JSON":"Json: ",
    "LABEL_VARIABLE_PROPERTIES_DATASET":"Dataset: ",
    "LABEL_VARIABLE_PROPERTIES_SAVEINCOOKIE":"Save in Cookie: ",
    "LABEL_VARIABLE_PROPERTIES_SAVEINPHONEGAP":"Save in PhoneGap: ",
    "LABEL_VARIABLE_PROPERTIES_AUTOUPDATE":"Update data on input change",
    "LABEL_CRUD_VARIABLE_PROPERTIES_AUTOUPDATE":"Update list data on input change",
    "LABEL_VARIABLE_PROPERTIES_USEDEFAULTSUCCESSHANDLER":"Use default success handler",
    "LABEL_VARIABLE_PROPERTIES_REDIRECTTO":"Redirect To: ",
    "LABEL_VARIABLE_PROPERTIES_CLEARINPUT":"Clear Input: ",
    "LABEL_VARIABLE_PROPERTIES_DESIGNMAXRESULTS":"Design Max. Results: ",
    "LABEL_VARIABLE_PROPERTIES_DOWNLOADFILE":"Download File: ",
    "LABEL_VARIABLE_PROPERTIES_INPUT":"Input: ",
    "LABEL_VARIABLE_PROPERTIES_MAXRESULTS":"Records per request ",
    "LABEL_VARIABLE_PROPERTIES_POOLSIZE" : "Pool size",
    "LABEL_VARIABLE_PROPERTIES_MAXPOOLSIZE":"Max ",
    "LABEL_VARIABLE_PROPERTIES_MINPOOLSIZE":"Min ",
    "LABEL_VARIABLE_PROPERTIES_OPERATION":"Operation: ",
    "LABEL_VARIABLE_PROPERTIES_QUEUE":"Queue: ",
    "LABEL_VARIABLE_PROPERTIES_SERVICE":"Service: ",
    "LABEL_VARIABLE_PROPERTIES_STARTUPDATE":"Request data on page load",
    "LABEL_CRUD_VARIABLE_PROPERTIES_STARTUPDATE":"Request list data on page load",
    "LABEL_VARIABLE_PROPERTIES_UPDATENOW":"Update Now: ",
    "LABEL_VARIABLE_PROPERTIES_INFLIGHTBEHAVIOR":"In Flight Behavior: ",
    "LABEL_VARIABLE_PROPERTIES_LOADINGDIALOG":"Loading Dialog: ",
    "LABEL_VARIABLE_PROPERTIES_ROLES":"Roles: ",
    "LABEL_VARIABLE_PROPERTIES_LIVESOURCE":"Live Source: ",
    "LABEL_VARIABLE_PROPERTIES_SPINNERCONTEXT":"Spinner Context: ",
    "LABEL_VARIABLE_PROPERTIES_SPINNERMESSAGE":"Spinner Message: ",
    "LABEL_VARIABLE_PROPERTIES_MATCHMODE":"Match Mode: ",
    "LABEL_VARIABLE_PROPERTIES_ORDERBY":"Order by: ",
    "LABEL_VARIABLE_PROPERTIES_IGNORECASE":"Ignore case: ",
    "LABEL_VARIABLE_PROPERTIES_DISABLED":"Disabled: ",
    "LABEL_VARIABLE_PROPERTIES_REFIREONDBCHANGE":"Refire on DB change: ",
    "LABEL_VARIABLE_PROPERTIES_ONCANUPDATE":"On Can Update",
    "LABEL_VARIABLE_PROPERTIES_ONBEFOREDATASETREADY":"On Before Dataset Ready",
    "LABEL_VARIABLE_PROPERTIES_ONBEFOREUPDATE":"On Before Update",
    "LABEL_VARIABLE_PROPERTIES_ONBEFORE_DELETE":"On Before Delete Record",
    "LABEL_VARIABLE_PROPERTIES_ONBEFORE_INSERT":"On Before Insert Record",
    "LABEL_VARIABLE_PROPERTIES_ONBEFORE_READ":"On Before List Records",
    "LABEL_VARIABLE_PROPERTIES_ONBEFORE_UPDATE":"On Before Update Record",
    "LABEL_VARIABLE_PROPERTIES_ONRESULT": "On Result",
    "LABEL_VARIABLE_PROPERTIES_ONSUCCESS": "On Success",
    "LABEL_VARIABLE_PROPERTIES_ONERROR": "On Error",
    "LABEL_VARIABLE_PROPERTIES_ONBEFORE": "On Before",
    "LABEL_VARIABLE_PROPERTIES_ONPROGRESS": "On Progress",
    "LABEL_VARIABLE_PROPERTIES_ONABORT": "On Abort",
    "LABEL_VARIABLE_PROPERTIES_ONONLINE": "On Online",
    "LABEL_VARIABLE_PROPERTIES_ONOFFLINE": "On Offline",
    "LABEL_VARIABLE_PROPERTIES_ONPREPARESETDATA":"On Before Dataset Ready",
    "LABEL_VARIABLE_PROPERTIES_ONBEFOREOPEN":"On Before Open",
    "LABEL_VARIABLE_PROPERTIES_ONOPEN":"On Open",
    "LABEL_VARIABLE_PROPERTIES_ONCLOSE":"On Close",
    "LABEL_VARIABLE_PROPERTIES_ONBEFOREMESSAGESEND":"On Before Message Send",
    "LABEL_VARIABLE_PROPERTIES_ONMESSAGERECEIVE":"On Message Receive",
    "LABEL_VARIABLE_PROPERTIES_PAGENAME":"Page Name:",
    "LABEL_VARIABLE_PROPERTIES_VIEWNAME":"View Name:",
    "LABEL_VARIABLE_PROPERTIES_TABNAME":"Tab Name:",
    "LABEL_VARIABLE_PROPERTIES_ACCORDIONNAME":"Accordion Name:",
    "LABEL_VARIABLE_PROPERTIES_TEXT":"Text",
    "LABEL_VARIABLE_PROPERTIES_OKBUTTONTEXT":"Ok button text",
    "LABEL_VARIABLE_PROPERTIES_ALERTTYPE":"Alert type",
    "LABEL_VARIABLE_PROPERTIES_CANCELBUTTONTEXT":"Cancel button text",
    "LABEL_VARIABLE_PROPERTIES_DURATION":"Duration (ms)",
    "LABEL_VARIABLE_PROPERTIES_CLASS":"Class",
    "LABEL_VARIABLE_PROPERTIES_TOASTERPOSITION":"Toaster Position",
    "LABEL_VARIABLE_PROPERTIES_SHOWCLOSEBUTTON":"Show Close Button",
    "LABEL_VARIABLE_PROPERTIES_CLOSEICONCLASS":"Close Icon Class",
    "LABEL_VARIABLE_PROPERTIES_MESSAGEICONCLASS":"Message Icon Class",
    "LABEL_VARIABLE_PROPERTIES_EVENTTITLE":"Event Title:",
    "LABEL_VARIABLE_PROPERTIES_EVENTNOTES":"Event Notes:",
    "LABEL_VARIABLE_PROPERTIES_EVENTLOCATION":"Event Location:",
    "LABEL_VARIABLE_PROPERTIES_EVENTSTART":"Event Start:",
    "LABEL_VARIABLE_PROPERTIES_EVENTEND":"Event End:",
    "LABEL_VARIABLE_PROPERTIES_RECURRINGEVENT":"Recurring Event:",
    "LABEL_VARIABLE_PROPERTIES_RECURRINGEVENTFREQUENCY":"Recurring Frequency:",
    "LABEL_VARIABLE_PROPERTIES_BARCODEFORMAT":"Bar code format",
    "LABEL_VARIABLE_PROPERTIES_IMAGEQUALITY":"Quality (0 -100):",
    "LABEL_VARIABLE_PROPERTIES_IMAGETARGETWIDTH":"Target Width (px)",
    "LABEL_VARIABLE_PROPERTIES_IMAGETARGETHEIGHT":"Target Height (px)",
    "LABEL_VARIABLE_PROPERTIES_ALLOWIMAGEEDIT":"Allow Edit:",
    "LABEL_VARIABLE_PROPERTIES_IMAGEENCODINGTYPE":"Encoding Type:",
    "LABEL_VARIABLE_PROPERTIES_CORRECTORIENTATION":"Correct Orientation:",
    "LABEL_VARIABLE_PROPERTIES_SAVETOPHOTOALBUM":"Save To Photo Album:",
    "LABEL_VARIABLE_PROPERTIES_GEOLOCATIONHIGHACCURACY":"Enable High Accuracy:",
    "LABEL_VARIABLE_PROPERTIES_GEOLOCATIONMAXIMUMAGE":"Maximum Age:",
    "LABEL_VARIABLE_PROPERTIES_GEOLOCATIONTIMEOUT":"Timeout:",
    "LABEL_VARIABLE_PROPERTIES_CONTACTFILTER":"Filter:",
    "LABEL_VARIABLE_PROPERTIES_VIBRATIONTIME":"Vibration Time:",
    "LABEL_VARIABLE_PROPERTIES_CONNECTONPAGELOAD":"Connect on page load",
    "LABEL_VARIABLE_PROPERTIES_DATAUPDATESTRATEGY":"On New Data",
    "LABEL_VARIABLE_PROPERTIES_DATALIMIT":"Data Limit",
    "LABEL_VARIABLE_PROPERTIES_SEGMENTNAME":"Segment Name",
    "LABEL_VARIABLE_PROPERTIES_CLEARDATA":"Clear offline data before pull",
    "LABEL_VARIABLE_PROPERTIES_FILEPATH":"File Path",
    "LABEL_VARIABLE_PROPERTIES_FILETYPE":"File Type",
    "LABEL_VARIABLE_PROPERTIES_SHOWPROGRESS":"Show progress",
    "LABEL_NO_PARAMS_FOUND_FOR_SELECTED_SERVICE": "No params found for selected service operation",
    "LABEL_ADD_VARIABLE_DIALOG_TITLE":"Variables available for the page",
    "LABEL_TYPE_VARIABLES_NOT_FOUND":"Variables of type \"${0}\" are not found.",
    "LABEL_VARIABLES_NOT_FOUND":"There are no variables associated with current workspace",
    "LABEL_WIDGETS_NOT_FOUND":"There are no components associated with current workspace",
    "LABEL_DELETE_VARIABLE":"Delete this variable",
    "LABEL_RESTORE_VARIABLE":"Restore this variable",
    "LABEL_DELETE_FIELD":"Delete this field",
    "LABEL_RESTORE_FIELD":"Restore this field",
    "LABEL_DELETE_ACTION":"Delete this action",
    "LABEL_RESTORE_ACTION":"Restore this action",
    "LABEL_REORDER": "Reorder",
    "LABEL_BUILDING_BLOCKS":"Building Blocks",
    "LABEL_PAGE":"Page",
    "LABEL_PAGES":"Pages",
    "LABEL_PARTIAL":"Partial",
    "LABEL_APPLICATION":"Application",
    "LABEL_REACT_NATIVE_BUILD":"UI-Build",
    "LABEL_APP":"Application",
    "LABEL_MOBILE":"Mobile Application",
    "LABEL_MOBILE_BUILD":"Build",
    "LABEL_MOBILE_ANDROID_BUILD":"Android Build",
    "LABEL_MOBILE_CORDOVA_BUILD":"Build Cordova Zip",
    "LABEL_MOBILE_IOS_BUILD":"iOS Build",
    "LABEL_MOBILE_PHONEGAP_BUILD":"Build Phonegap Zip",
    "LABEL_MOBILE_DOWNLOAD_CORDOVA":"Project as Cordova ZIP",
    "LABEL_MOBILE_DOWNLOAD_REACTNATIVE":"Project as ReactNative ZIP",
    "LABEL_MOBILE_BUILD_FOR_IOS":"Build for iOS",
    "LABEL_MOBILE_BUILD_FOR_ANDROID":"Build for Android",
    "LABEL_OPEN_APP_CHEF": "Open AppChef",
    "LABEL_MOBILE_BUILD_CORDOVA":"Build Cordova Zip",
    "LABEL_MOBILE_BUILD_PHONEGAP":"Download Cordava Zip",
    "LABEL_MOBILE_BUILD_PROFILES":"Build Profiles",
    "LABEL_MOBILE_RELATED_TABLES": "Add Required Tables",
    "LABEL_MOBILE_DEPENDENT_TABLES": "Remove Dependent Tables",
    "MESSAGE_MOBILE_BUILD_QUEUE_SUCCESS":"Build Request is successfully added to the queue. Once the build is finished, you will receive a mail containing",
    "MESSAGE_QUEUE_SUCCESS":" - Request is successfully added to the queue. Please check the progress in Job section",
    "MESSAGE_CORDOVA_ZIP_QUEUE_SUCCESS":"Cordova Zip Request is successfully added to the queue. Please check the progress in Job section",
    "MESSAGE_EXPORT_WAR_QUEUE_SUCCESS":"Export as WAR Request is successfully added to the queue. Please check the progress in Job section",
    "MESSAGE_MOBILE_BUILD_QUEUE_PHONEGAP":"PhoneGap Build request is succesfully sent to Build Server. For more details check your PhoneGap account.",
    "LABEL_ENABLE_OFFLINE": "Enable data storage when device is offline",
    "LABEL_OFFLINE_CONFIG": "Offline Configuration for Table:",
    "LABEL_BUNDLED": "Bundle the data with the app",
    "LABEL_APP_START": "Synchronize data when online",
    "LABEL_OFFLINE_CONFIG_IN_BETA_VERSION": " Note: This feature is currently in beta state.",
    "LABEL_AVAILABLE_FOR_OFFLINE": "This table is available for offline",
    "LABEL_COLUMN_NAME": "Column Name",
    "LABEL_ATTRIBUTE_NAME": "Attribute Name",
    "LABEL_ENTITY_NAME": "Entity Name",
    "LABE_FILTER_VALUE": "Filter Value",
    "LABEL_TABLES": "Tables",
    "LABEL_DB_DESIGNER_OFFLINE_ENABLE_OFFLINE": "Enable Table for offline use",
    "LABEL_DB_DESIGNER_OFFLINE_PROPERTY":"Properties",
    "LABEL_DB_DESIGNER_OFFLINE_DELTA_FIELD_NAME":"Delta Field",
    "LABEL_DB_DESIGNER_OFFLINE_MAX_NO_OF_RECORDS_TO_FETCH":"Maximum No Of Records",
    "LABEL_DB_DESIGNER_OFFLINE_PAGE_SIZE":"Page Size",
    "LABEL_DB_DESIGNER_OFFLINE_ORDER_BY":"Order By",
    "LABEL_DB_DESIGNER_OFFLINE_FILTER":"Filter",
    "LABEL_DB_DESIGNER_OFFLINE_QUERY":"Query",
    "LABEL_DB_DESIGNER_OFFLINE_DATA_CONFIGURATION": "Data Configuration",
    "LABEL_DB_DESIGNER_OFFLINE_BUNDLE_CONFIGURATION": "Bundle Configuration",
    "LABEL_DB_DESIGNER_OFFLINE_PULL_CONFIGURATION": "Pull Configuration",
    "LABEL_DB_DESIGNER_OFFLINE_DATA_CONFIG_STRATEGY_TYPE_READ_ONLY_BUNDLE_DATA": "Bundle data with installer (Read-only)",
    "LABEL_DB_DESIGNER_OFFLINE_DATA_CONFIG_STRATEGY_TYPE_SYNC_BUNDLE_DATA": "Bundle data with installer + on-demand sync (Read-Write)",
    "LABEL_DB_DESIGNER_OFFLINE_DATA_CONFIG_STRATEGY_TYPE_SYNC_ON_DEMAND_DATA": "Sync data on-demand (Read-Write)",
    "LABEL_DB_DESIGNER_OFFLINE_DATA_CONFIG_STRATEGY_TYPE_READ_ONLY_CACHE_DATA": "Cache CRUD variable response (Read-only)",
    "LABEL_DB_DESIGNER_OFFLINE_OFFLINE_CONFIG": "Offline Configuration for Table:",
    "LABEL_DB_DESIGNER_OFFLINE_DATA_STRATEGY_BUNDLED": "Bundle the data with the app",
    "LABEL_DB_DESIGNER_OFFLINE_DATA_STRATEGY_APP_START": "Pull data from server",
    "LABEL_DB_DESIGNER_OFFLINE_DATA_STRATEGY_LIVE": "Cache response of database CRUD variables only",
    "LABEL_DB_DESIGNER_OFFLINE_OFFLINE_CONFIG_IN_BETA_VERSION": " Note: This feature is currently in beta phase.",
    "LABEL_DB_DESIGNER_OFFLINE_ENABLED_PUSH_OPERATIONS": "Allow following operations in offline",
    "LABEL_DB_DESIGNER_OFFLINE_PUSH_ENABLE_INSERT": "Insert",
    "LABEL_DB_DESIGNER_OFFLINE_PUSH_ENABLE_UPDATE": "Update",
    "LABEL_DB_DESIGNER_OFFLINE_PUSH_ENABLE_DELETE": "Delete",
    "LABEL_DB_DESIGNER_OFFLINE_COLUMN_NAME": "Column Name",
    "LABEL_DB_DESIGNER_OFFLINE_OPERATOR":"Operator",
    "LABEL_DB_DESIGNER_OFFLINE_FILTER_VALUE": "Filter Value",
    "LABEL_DB_DESIGNER_OFFLINE_TABLES": "Tables",
    "LABEL_DB_DESIGNER_ENABLE_ALL_TABLES_OFFLINE":"Enable all for offline use",
    "LABEL_DB_DESIGNER_OFFLINE_OFFLINE_QUERY_INFO":"A HQL where clause has to be specified. For example, 'From Employee where department.id=2' is the HQL to use to pull Employees from department 2. So, just specify the where clause 'department.id=2' (with out From Employee where) as the query to use.",
    "MESSAGE_DB_DESIGNER_OFFLINE_TABLE_AVAILABLE_OFFLINE": "This table is available in offline.",
    "MESSAGE_DB_DESIGNER_OFFLINE_TABLE_UNAVAILABLE_OFFLINE": "This table is not available in offline.",
    "MESSAGE_DB_DESIGNER_OFFLINE_DELETE_FIELD_FROM_SORTING_ORDER":"Delete column from sorting order",
    "MESSAGE_DB_DESIGNER_OFFLINE_DESCENDING_ORDER":"Descending",
    "MESSAGE_DB_DESIGNER_OFFLINE_ASCENDING_ORDER":"Ascending",
    "MESSAGE_DB_DESIGNER_OFFLINE_ADD_FIELD_TO_SORTING_ORDER":"Add column to sorting order",
    "MESSAGE_DB_DESIGNER_OFFLINE_ADD_FIELD_TO_FILTER":"Add column to filter",
    "MESSAGE_DB_DESIGNER_OFFLINE_DELETE_FIELD_FROM_FILTER": "Remove column from filter",
    "MESSAGE_HELP_DB_DESIGNER_OFFLINE_DELTA_FIELD_NAME":"Column that has time at which record got last updated. While fetching the data, Where clause is constructed such that only modified records after last pull are only fetched.",
    "MESSAGE_HELP_DB_DESIGNER_OFFLINE_BUNDLE_DELTA_FIELD_NAME":"Column that has time at which record got last updated. While fetching the data, Where clause is constructed such that only modified records after last pull are only fetched. Bundled data will only participate in pull, if this field is specified.",
    "MESSAGE_HELP_DB_DESIGNER_OFFLINE_MAX_NO_OF_RECORDS_TO_FETCH":"Maximum number of records to pull. If zero value or no value or negative value is specified, then all the matched records will be pulled.",
    "MESSAGE_HELP_DB_DESIGNER_OFFLINE_PAGE_SIZE":"Number of records to pull in a single network call. Make sure that page size is less than 'records per request' in database configuration of server profile.",
    "LABEL_STRING":"String",
    "LABEL_BOOLEAN":"Boolean",
    "LABEL_NUMBER":"Number",
    "LABEL_DATE":"Date",
    "LABEL_TIME": "Time",
    "LABEL_ENTRY":"Entry",
    "LABEL_START":"start",
    "LABEL_END":"end",
    "LABEL_OR": "Or",
    "LABEL_ANYWHERE":"anywhere",
    "LABEL_EXACT":"exact",
    "LABEL_EXECUTELAST":"executeLast",
    "LABEL_EXECUTEALL":"executeAll",
    "LABEL_DONTEXECUTE":"dontExecute",
    "COMMENT_WIDGET_DESIGNER_LOCALIZATION_RESOURCES":"-----------Component Designer Localization Resources----------",
    "LABEL_GRID_DESIGNER_DIALOG_SUBTITLE":"Format Options",
    "LABEL_GRID_DESIGNER_EDIT_OPTIONS":"Edit Mode",
    "LABEL_GRID_DESIGNER_VIEW_OPTIONS":"View Mode",
    "LABEL_GRID_DESIGNER_EXPORT_OPTIONS":"Export Options",
    "LABEL_GRID_DESIGNER_FILTER_OPTIONS":"Filter Options",
    "LABEL_WIDGET_DESIGNER_GROUP_BASIC":"Basic",
    "LABEL_WIDGET_DESIGNER_GROUP_EVENTS":"Events",
    "LABEL_WIDGET_DESIGNER_GROUP_ADVANCED":"Advanced",
    "LABEL_WIDGET_DESIGNER_GROUP_SECURITY":"Security",
    "LABEL_WIDGET_DESIGNER_GROUP_STYLES": "Styles",
    "LABEL_WIDGET_DESIGNER_BINDING_FIELD":"Mapped Field",
    "LABEL_WIDGET_DESIGNER_FIELD_TYPE":"Field Type",
    "LABEL_WIDGET_DESIGNER_BINDING_COLUMN":"Mapped Column",
  "LABEL_WIDGET_DESIGNER_BINDING_TARGET_COLUMN":"Sort By",
    "LABEL_WIDGET_DESIGNER_COLUMN_TYPE":"Column Type",
    "LABEL_WIDGET_DESIGNER_DISPLAY_NAME":"Display Name",
    "LABEL_WIDGET_DESIGNER_REQUIRED":"Required",
    "LABEL_WIDGET_DESIGNER_READONLY":"Readonly",
    "LABEL_WIDGET_DESIGNER_SEARCHABLE":"Enable Data Filter",
    "LABEL_WIDGET_DESIGNER_SORTABLE":"Enable Sort",
    "LABEL_WIDGET_DESIGNER_CASEINSENSITIVE": "Case-Insensitive Sort",
    "LABEL_WIDGET_DESIGNER_HIDDEN":"Hidden",
    "LABEL_WIDGET_DESIGNER_TITLE":"Title",
  "LABEL_WIDGET_DESIGNER_EXPAND_TITLE":"Expand Title",
  "LABEL_WIDGET_DESIGNER_COLLAPSE_TITLE":"Collapse Title",
    "LABEL_ADD_WIDGET":"Add Component",
    "LABEL_ADD_COLUMN":"Add Custom Column",
    "LABEL_DELETE_COLUMN":"Delete Column",
    "LABEL_INCREASE_PRIORITY":"Increase priority",
    "LABEL_DECREASE_PRIORITY":"Decrease priority",
    "LABEL_ADD_GROUP":"Add Group",
    "LABEL_DELETE_GROUP":"Delete Group",
    "LABEL_ADD_CRITERIA": "Add Criteria",
    "LABEL_DELETE_CRITERIA": "Delete Criteria",
    "LABEL_CRITERIA_PREVIEW": "Filter Criteria Preview",
    "LABEL_EDIT_CRITERIA": "Edit Criteria",
    "LABEL_FILTER_CRITERIA": "Filter Criteria",
    "PLACEHOLDER_HYPERLINK":"Hyperlink",
    "PLACEHOLDER_ENTER_SHORTCUT_KEY":"Enter a Shortcut Key",
    "PLACEHOLDER_BUTTON_TAB_INDEX":"Tab index for the button",
    "PLACEHOLDER_DESIGNER_BUTTON_TITLE":"Title for the button",
    "PLACEHOLDER_DESIGNER_COLUMN_TITLE":"Title for the column",
    "PLACEHOLDER_DESIGNER_WIDGET_LABEL":"Label for the component",
    "PLACEHOLDER_DESIGNER_BUTTON_CLASS":"Class for the button",
    "PLACEHOLDER_DESIGNER_BUTTON_CAPTION":"Caption for the button",
    "PLACEHOLDER_DESIGNER_BUTTON_ICON":"Icon for the button",
    "PLACEHOLDER_DESIGNER_BUTTON_ICON_CLASS":"Icon class for the button",
    "PLACEHOLDER_DESIGNER_BUTTON_ACTION":"Action for the button",
    "PLACEHOLDER_DESIGNER_CHECKBOX_DISABLE":"Disable Property for checkbox",
    "PLACEHOLDER_DESIGNER_COLUMN_WIDTH":"Width for the column",
    "PLACEHOLDER_DESIGNER_COLUMN_BACKGROUND":"Background color for the column",
    "PLACEHOLDER_DESIGNER_FIELD_BACKGROUND": "Background color for the field",
    "PLACEHOLDER_DESIGNER_COLUMN_CLASS":"Class for the column",
    "PLACEHOLDER_DESIGNER_CONDITION_EXPRESSION":"Condition expression",
    "PLACEHOLDER_DESIGNER_COLUMN_CUSTOM_EXPRESSION":"Custom expression for the column (if any)",
    "PLACEHOLDER_DESIGNER_IMAGE_WIDGET_SRC":"Image source",
    "PLACEHOLDER_DESIGNER_IMAGE_WIDGET_CLASS":"Class for the component",
    "PLACEHOLDER_DESIGNER_IMAGE_WIDGET_HYPERLINK":"Hyperlink for anchor",
    "LABEL_WIDGET_DESIGNER_WIDTH":"Width",
    "LABEL_WIDGET_DESIGNER_WIDTH_UNIT":"Width Unit",
    "LABEL_WIDGET_DESIGNER_TEXT_ALIGNMENT":"Text Alignment",
    "LABEL_WIDGET_DESIGNER_BACKGROUND_COLOR":"Background",
    "LABEL_WIDGET_DESIGNER_TEXT_COLOR":"Text Color",
    "LABEL_WIDGET_DESIGNER_VALUE_EXPRESSION":"Value Expression",
    "LABEL_WIDGET_DESIGNER_DESCRIPTION":"Description",
    "LABEL_WIDGET_DESIGNER_CLASS":"Class",
    "LABEL_WIDGET_DESIGNER_CONDITIONAL_CLASS":"Conditional Classes",
    "LABEL_WIDGET_DESIGNER_ADD_CONDITIONAL_CLASS":"Add new class",
    "LABEL_WIDGET_DESIGNER_REMOVE_CONDITION":"Remove condition",
    "LABEL_WIDGET_DESIGNER_ICONNAME":"Icon Name",
    "LABEL_WIDGET_DESIGNER_ICONCLASS":"Icon Class",
    "LABEL_WIDGET_DESIGNER_ACTION":"Action",
    "LABEL_WIDGET_DESIGNER_SHOWMODE":"Show in Mode",
    "LABEL_WIDGET_DESIGNER_FILTER_ON_FIELD":"Filter on field",
    "LABEL_WIDGET_DESIGNER_WIDGET":"Component",
    "LABEL_WIDGET_DESIGNER_WIDGET_TYPE":"Component type for the field",
    "LABEL_PREFERRED": "Preferred",
    "LABEL_DISPALY_PROPERTIES":"Display Properties",
    "LABEL_LOOK_UP_DATA": "Look Up Data",
    "LABEL_WIDGET_DESIGNER_SELECT_A_WIDGET": "-- Select a component -- ",
    "LABEL_WIDGET_DESIGNER_RANGE":"Show Range Selector",
    "LABEL_WIDGET_DESIGNER_TYPE":"Type",
    "LABEL_WIDGET_DESIGNER_FIELD":"Field",
    "LABEL_WIDGET_DESIGNER_TYPE_OF_FIELD":"Type of the field",
    "LABEL_WIDGET_DESIGNER_DISPLAYEXPRESSION":"Display Expression:",
    "LABEL_PROPERTY_FILETYPE":"File types",
    "LABEL_PROPERTY_EXTENSIONS":"Extensions",
    "LABEL_WIDGET_DESIGNER_WIDGET_TITLE": "Component Title",
    "LABEL_WIDGET_DESIGNER_WIDGET_CLASS": "Component Class",
    "LABEL_WIDGET_DESIGNER_WIDGET_CONDITIONAL_CLASS": "Conditional Component Classes",
    "LABEL_WIDGET_DESIGNER_WIDGET_CONDITIONAL_STYLE": "Conditional Component Styles",
    "LABEL_WIDGET_DESIGNER_WIDGET_ACTION": "Component Action",
    "LABEL_WIDGET_DESIGNER_WIDGET_ICONNAME": "Component Icon",
    "LABEL_WIDGET_DESIGNER_WIDGET_HYPERLINK": "Component Hyperlink",
    "LABEL_WIDGET_DESIGNER_WIDGET_SRC": "Image Source",
    "LABEL_WIDGET_DESIGNER_WIDGET_DISABLE":"Disable",
    "LABEL_WIDGET_DESIGNER_SELECT_ALL":"Select All",
    "LABEL_WIDGET_DESIGNER_MATCH_MODE": "Match Mode",
    "LABEL_KEYCODE":"KeyCode",
    "LABEL_HORIZONTAL":"horizontal",
    "LABEL_VERTICAL":"vertical",
    "LABEL_SPIN":"spin",
    "LABEL_PULSE":"pulse",
    "LABEL_SELECT_ICON_DIALOG_TITLE":"Select Icon",
    "MESSAGE_PLACEHOLDER_SEARCH_ICONS":"Search Icons",
    "HELP_MESSAGE_WIDGET_DESIGNER_MATCH_MODE":"This property specifies how to apply the filter. The options are:\nStart: match characters at the front of the string. For example, \"Wa\" would match \"WaveMaker\".\nEnd: match characters at the end of the string. For example, \"Maker\" would match \"WaveMaker\".\nAnywhere: match characters anywhere in the string. For example, \"ve\" would match \"WaveMaker\".\nExact: match all characters the string. For example, only \"WaveMaker\" would match \"WaveMaker\".",
    "MESSAGE_HELP_PROPERTY_FILETYPE":"The file types allowed for upload",
    "MESSAGE_HELP_PROPERTY_EXTENSIONS":"The extensions allowed for upload",
    "HELP_MESSAGE_WIDGET_DESIGNER_BINDING_FIELD":"The binding for the field. It is the target field in the data object the form is bound to",
    "HELP_MESSAGE_WIDGET_DESIGNER_FIELD_TYPE":"Data type of the binding field",
    "HELP_MESSAGE_WIDGET_DESIGNER_BINDING_COLUMN":"The binding for the column. It is the target column in the data object the grid is bound to",
    "HELP_MESSAGE_WIDGET_DESIGNER_COLUMN_TYPE":"Data type of the binding column",
    "HELP_MESSAGE_WIDGET_DESIGNER_DISPLAY_NAME":"Display name for the field",
    "HELP_MESSAGE_WIDGET_DESIGNER_REQUIRED":"Required property for the field, when enabled, hints the user to fill the field",
    "HELP_MESSAGE_WIDGET_DESIGNER_TITLE":"The title against the field",
  "HELP_MESSAGE_WIDGET_DESIGNER_EXPANDTITLE":"The Expand title against the field",
  "HELP_MESSAGE_WIDGET_DESIGNER_COLLAPSEETITLE":"The Collapse title against the field",
    "HELP_MESSAGE_WIDGET_DESIGNER_SHORTCUTKEY": "KeyCode = [Alt] in Windows/Linux;  (In Firefox - [Alt][Shift]);  [Control][Alt] in Mac",
    "HELP_MESSAGE_WIDGET_DESIGNER_DUPLICATE_FIELD": "Mapped field name must be unique. Please provide a unique field name",
    "HELP_MESSAGE_WIDGET_DESIGNER_DUPLICATE_COLUMN": "Mapped column name must be unique. Please provide a unique column name",
    "HELP_MESSAGE_WIDGET_DESIGNER_CAPTION":"The caption against the button",
    "HELP_MESSAGE_WIDGET_DESIGNER_WIDTH":"Width for the field",
    "HELP_MESSAGE_WIDGET_DESIGNER_WIDTH_UNIT":"Width Unit for the width set",
    "HELP_MESSAGE_WIDGET_DESIGNER_ALLOW_EDITING": "Allow field to be edited",
    "HELP_MESSAGE_WIDGET_DESIGNER_TEXT_ALIGNMENT":"Text Alignment for the field",
    "HELP_MESSAGE_WIDGET_DESIGNER_BACKGROUND_COLOR":"Background color for the column",
    "HELP_MESSAGE_WIDGET_DESIGNER_TEXT_COLOR":"Text Color for the column",
    "HELP_MESSAGE_WIDGET_DESIGNER_VALUE_EXPRESSION":"Custom expression for the column. Select one of the available components from above list or provide a custom expression here (for more info click on the 'Help' link above).",
    "HELP_MESSAGE_WIDGET_DESIGNER_EXPORT_EXPRESSION":"Expression against the column to be displayed when data is exported. E.g. (firstname + lastname). If left empty, actual value against the column will be displayed.",
    "HELP_MESSAGE_WIDGET_DESIGNER_WIDGET_CLASS": "Class to apply on the component",
    "HELP_MESSAGE_WIDGET_DESIGNER_COLUMN_CONDITIONAL_CLASS": "The CSS class provided in first textbox will be applied on the table column, if it satisfies the condition provided in the second textbox (for more info click on the 'Help' link above).",
    "HELP_MESSAGE_WIDGET_DESIGNER_WIDGET_CONDITIONAL_CLASS": "The CSS class provided in first textbox will be applied on the component, if it satisfies the condition provided in the second textbox (for more info click on the 'Help' link above)",
    "HELP_MESSAGE_WIDGET_DESIGNER_WIDGET_CONDITIONAL_STYLE": "This property allows user to bind expression to style property. The provided styles will be applied on the component. <br>Syntax: <br>{'CSS propertyname': 'value expression'} <br>Example: <br>1. {'color': 'red'} <br> 2. {'color': Page.Variables.MyVariable.dataSet.status === 'success' ? 'green' : 'red'} <br>3. {'color': 'red', 'background': Page.Variables.MyVariable.dataSet.status === 'success' ? 'green' : 'red'}",
    "HELP_MESSAGE_WIDGET_DESIGNER_DESCRIPTION":"Description",
    "HELP_MESSAGE_WIDGET_DESIGNER_CLASS": "CSS class for styling the field",
    "HELP_MESSAGE_WIDGET_DESIGNER_ICONNAME":"Icon Name for the actions",
    "HELP_MESSAGE_WIDGET_DESIGNER_ICONCLASS":"Icon Class for the action button",
    "HELP_MESSAGE_WIDGET_DESIGNER_ACTION":"The action to invoke when clicked",
    "HELP_MESSAGE_WIDGET_DESIGNER_LIVE_FORM_ACTIONS": "The action to invoke when clicked.\nDefault actions:\nsave: Form is saved and will remain in edit mode with previous values entered.\nsaveAndNew: Form is saved and new form is opened with default values.\nsaveAndView: Form is saved and form will go in to view mode with previous values entered",
    "HELP_MESSAGE_WIDGET_DESIGNER_DISABLE":"Enable/disable checkbox",
    "HELP_MESSAGE_WIDGET_DESIGNER_UPDATEMODE":"To show the field/action in update mode",
    "HELP_MESSAGE_WIDGET_DESIGNER_FILTER_ON_FIELD":"Filters the values for the current field when the 'Filter on field' value changes. Example: Filtering the cities when State is changed",
    "HELP_MESSAGE_WIDGET_DESIGNER_WIDGET":"Select a component from the list of available components. The selected component will be displayed in the table column. Usage of components under 'Others' category is not recommended. ",
    "HELP_MESSAGE_WIDGET_DESIGNER_WIDGET_SELECT": "Select component should be used in specific use cases where the dataset has fixed data for e.g Countries, State, City Data and is limited to a maximum of 500 items.",
    "HELP_MESSAGE_WIDGET_DESIGNER_WIDGET_AUTOCOMPLETE": "Autocomplete is a search type component that enables users to quickly find and select from a pre-populated dynamic initial dataset as they type, leveraging search and filtering. As the user scroll down the list the next set of values will be loaded.",
    "LABEL_WIDGET_DESIGNER_WIDGET_GROUP": "Group",
    "MESSAGE_PLACEHOLDER_WIDGET_DESIGNER_WIDGET_GROUP":"Select a group",
    "HELP_MESSAGE_WIDGET_DESIGNER_GROUP": "Select a group to which the selected column/ group should be moved.",
    "HELP_MESSAGE_WIDGET_DESIGNER_SHOW": "Show/Hide the column",
    "HELP_MESSAGE_WIDGET_DESIGNER_RANGE":"Enable this option if user can filter on minimum and maximum values",
    "HELP_MESSAGE_WIDGET_DESIGNER_TYPE":"The related table",
    "HELP_MESSAGE_WIDGET_DESIGNER_FIELD":"The field of the related table, from which the select is populated",
    "HELP_MESSAGE_WIDGET_DESIGNER_DISPLAYEXPRESSION":"This is an advanced property that gives more control over what is displayed in the component. A Display Expression uses a Javascript expression to format exactly what is shown. E.g (firstname + ' ' + lastname), where firstname & lastname are two fields in the dataset object",
    "HELP_MESSAGE_WIDGET_DESIGNER_SORTABLE": "This property enables sort on the column.",
    "HELP_MESSAGE_WIDGET_DESIGNER_CASEINSENSITIVE": "Enable this property to make sorting case-insensitive, treating uppercase and lowercase letters the same. e.g: A,a,B,b,C,c",
    "HELP_MESSAGE_WIDGET_DESIGNER_READONLY": "This property enables readonly property on the column.",
    "HELP_MESSAGE_WIDGET_DESIGNER_SEARCHABLE": "This property enables search on the column.",
    "HELP_MESSAGE_WIDGET_DESIGNER_MAX_RATING": "Maximum value (number of stars) of Rating.It should be less than or equal to 10.",
    "HELP_MESSAGE_DISABLE_PRIMARY_DELETE": "Primary key fields cannot be removed. For hiding this field, set show to false from properties panel.",
    "MESSAGE_ERROR_WIDGET_CLASSNAME_QUOTES_NOT_ALLOWED": "Quotes not allowed in class name.",
    "MESSAGE_ERROR_WIDGET_CONDITION_QUOTES_NOT_ALLOWED": "Double quotes not allowed in conditional expression.",
    "MESSAGE_ERROR_DUPLICATE_WIDGETNAME_TITLE": "Duplicate Component Name",
    "MESSAGE_ERROR_DUPLICATE_WIDGETNAME_DESC": "A component with the given name exists. Please provide a different name.",
    "MESSAGE_ERROR_INVALID_WIDGETNAME_TITLE": "Invalid Component Name",
    "MESSAGE_ERROR_INVALID_WIDGETNAME_DESC": "Component name can not be empty.",
    "MESSAGE_ERROR_INVALID_SPECIALCHARS_DESC": "Special characters are not allowed.Please provide a valid component name.",
    "MESSAGE_ERROR_INVALID_INPUT_DESC": "Invalid input. Refer help text for the correct format",
    "MESSAGE_ERROR_INVALID_INPUT_DATE": "Invalid date format. Please provide in yyyy-MM-dd format",
    "LABEL_ARTIFACTS_LIST": "List of available artifacts",
    "LABEL_PREFABS_LIST": "List of available prefabs",
    "LABEL_NO_PREFABS_MESSAGE": "Loading Prefabs... You can import them using 'Import -> Prefabs'",
    "LABEL_LOADING_ARTIFACT_MESSAGE": "Loading artifacts...",
    "LABEL_ARTIFACT_NO_DESCRIPTION_MESSAGE": "No description available",
    "LABEL_ARTIFACT_CUSTOM_METADATA": "Metadata",
    "LABEL_ARTIFACT_DEPENDANT_INFO": "Dependencies",
    "LABEL_ARTIFACT_NO_TAGS_MESSAGE": "No tags present",
    "MSG_VERSION_ALREADY_PUBLISHED": "The version you selected has already been published. Please provide a different version.",
    "LABEL_ARTIFACT_SUMMARY": "Summary",
    "LABEL_ARTIFACT_SUMMARY_DESCRIPTION": "Verify the details and proceed to Publish",
    "LABEL_NO_ARTIFACT_MESSAGE": "No results found matching the search criteria.",
    "LABEL_NO_THEMES_MESSAGE":"Loading Themes... You can import them using 'Import -> Themes'",
    "LABEL_NO_TEMPLATES_MESSAGE":"Loading Templates... You can import them using 'Import -> Templates'",
    "LABEL_NO_PROJECT_SHELL_MESSAGE":"Loading Project Shells...",
    "LABEL_NO_TEMPLATE_BUNDLE_MESSAGE":"No Template found.",
    "MESSAGE_DROP_CONTENT_CANVAS":"You are currently editing a partial page.",
    "MESSAGE_PREFAB_CONFIG_ERROR_TITLE":"Prefab Config error",
    "MESSAGE_PREFAB_CONFIG_ERROR_DESC": "Prefab Config file is invalid.",
    "MESSAGE_PREFAB_IMPORT_ERROR_TITLE":"Prefab Import error",
    "MESSAGE_PREFAB_NOT_IMPORTED": "\"${0}\" prefab is not imported in studio",
    "MESSAGE_PREFAB_DEPENDENCIES_ERROR_TITLE": "Prefab Dependencies error",
    "MESSAGE_PREFAB_DEPENDENCIES_ERROR_DESC": "Not able to load Prefab dependencies.",
    "MESSAGE_THEME_CONFIG_ERROR_TITLE": "Theme Config error",
    "MESSAGE_THEME_CONFIG_ERROR_DESC": "Theme Config file is invalid.",
    "COMMENT_TEMPLATES_LOCALIZATION_RESOURCES":"-----------Templates Localization Resources----------",
    "TEMPLATE_DEFAULT_PROJECT":"Default Project",
    "TEMPLATE_SELECT":"Select Template",
    "PROJECT_SHELL_SELECT":"Select Project Shell",
    "TEMPLATE_LEFTNAV_PROJECT":"Menu on side Project",
    "TEMPLATE_ESHOP":"eShop",
    "LABEL_LIVEGRID_DESIGNER_DIALOG_TITLE":"Data Table Designer",
    "LABEL_PROPERTY_FIELDS":"Fields",
    "PLACEHOLDER_DESIGNER_DESCRIPTION":"Enter description for field",
    "LABEL_RELEASE": "Release",
    "LABEL_RELEASED": "Released",
    "LABEL_BUILD_NUMBER" : "Build Number",
    "MESSAGE_POPUP_BLOCKER": "Popup Blocker detected, run application using Manual Launch link.",
    "MESSAGE_SESSION_TIMEOUT_LOGIN": "Session Timed Out, please click below to Login Again.",
    "LABEL_MANUAL_LAUNCH": "Manual Launch",
    "LABEL_SESSION_TIMEOUT_LOGIN": "Login",
    "TITLE_POPUP_BLOCKER": "Pop-up Blocker",
    "TITLE_PROJECT_TOKEN_SUMMARY": "Project Token Usage",
    "LABEL_TOTAL_TOKENS": "Total Tokens",
    "LABEL_TOKENS_CATEGORY": "Category",
    "LABEL_TOKENS_USED": "Tokens Used",
    "TITLE_BUILD_POPUP": "Mobile Build Status",
    "TITLE_SENT_TO_PHONEGAP": "Sent To PhoneGap",
    "USER_GUIDE": "Documentation",
    "API_DOCS": "API Documentation",
    "ACTIONS_NOT_AVAILABLE": "Actions are available only in design mode.",
    "PROPERTIES_NOT_AVAILABLE": "Properties are available only in design mode.",
    "COMMENT_SECURITY_LOCALIZATION_RESOURCES":"-----------Security Localization Resources----------",
    "LABEL_DEMO": "Demo",
    "LABEL_ACTIVE_DIRECTORY": "Active Directory",
    "LABEL_ACTIVE_DIRECTORY_URL": "URL",
    "LABEL_AUTHENTICATION_PROVIDER": "Authentication Provider: ",
    "LABEL_SESSION_CONFIGURATION": "Session Configuration",
    "LABEL_XFRAME_CONFIGURATION": "X-Frame Configuration",
    "LABEL_TOKEN_BASED_AUTHENTICATION": "Token Based Authentication",
    "LABEL_CORS_CONFIGURATION": "Cors Configuration",
    "LABEL_ENABLE_TOKENS": "Enable Tokens",
    "LABEL_TOKEN_PARAMETER": "Token Parameter",
    "LABEL_TOKEN_VALIDITY": "Token Validity",
    "LABEL_X_FRAME_OPTIONS": "Policy Type",
    "LABEL_URL_PLACEHOLDER": "eg:https://www.example.com",
    "LABEL_TITLE_RUNTIME":"Build Options",
    "LABEL_RUNTIME_OPTIONS":"Mode",
    "LABEL_ANGULAR_BUILD_TYPE":"Type",
    "LABEL_ANGULAR_BUILD_MODE_WM":"WaveMaker",
    "LABEL_ANGULAR_BUILD_MODE_ANGULAR":"Angular",
    "LABEL_REACT_BUILD_MODE":"React",
    "LABEL_ANGULAR_BUILD_TYPE_DEV":"Development",
    "LABEL_ANGULAR_BUILD_TYPE_PROD":"Production",
    "LABEL_SOURCE_MAPS":"Source Maps:",
    "LABEL_NODE_MAX_MEMORY":"Max Memory(in MB):",
    "LABEL_CAS": "CAS",
    "LABEL_SAML": "SAML",
    "LABEL_JWS": "JWS",
    "LABEL_OPAQUE_TOKEN":"OPAQUE",
    "LABEL_OPENID": "Open ID",
    "LABEL_USER_NAME_ATTRIBUTE": "User Name Attribute",
    "LABEL_TOKEN_URL":"Token Url",
    "LABEL_JWKS_URL":"JWKS Url",
    "LABEL_USER_INFO_ENDPOINT":"User Info Endpoint",
    "LABEL_LOGOUT_URL": "Logout Url",
    "LABEL_PROVIDER_ID": "Provider ID",
    "LABEL_SELECT_PROVIDER_ID": "Select Provider ID",
    "LABEL_REDIRECT_URL": "Redirect Url",
    "LABEL_SAML_IDP": "SAML Identity Provider",
    "LABEL_IDENTITY_PROVIDER": "Identity Provider",
    "LABEL_SERVICEPROVIDER": "Service Provider Configuration",
    "LABEL_SERVICEPROVIDER_INFO": "Service Provider (Application) Information",
    "LABEL_CONFIRM_AND_SAVE": "Confirm & Save",
    "LABEL_ROLES":"App Roles",
    "LABEL_APP_ROLE":"App Role",
    "LABEL_ROLE_NAME":"Role Name",
    "LABEL_NEW_ROLE":"New Role",
    "LABEL_NEW_ROLE_PLACEHOLDER":"Enter Role Name",
    "LABEL_PRIORITY":"Priority",
    "LABEL_LANDING_PAGE": "Landing Page",
    "LABEL_ROLES_TOOLTIP":"Configure App Roles",
    "LABEL_LOGIN_CONFIGURATION":"Login Configuration",
    "LABEL_LOGIN_CONFIGURATION_TOOLTIP":"Configure Login page and Associate user roles with landing pages",
    "LABEL_OWASP":"Safeguards",
    "LABEL_OWASP_TOOLTIP":"Safeguards",
    "LABEL_XSS":"XSS",
    "LABEL_XSS_ENABLE":"XSS Protection",
    "LABEL_CSRF":"CSRF",
    "LABEL_CSRF_TOOLTIP": "CSRF",
    "LABEL_ALLOWED_HOSTS": "Allowed Hosts",
    "LABEL_HOSTS": "Hosts",
    "LABEL_HOST": "Host",
    "LABEL_HELP_HOSTS": "Determines which hostnames should be allowed. The default is to allow any hostname. The hostname is the domain name through which your app is accessed.",
    "LABEL_HOSTS_PLACEHOLDER": "Enter Hosts (comma separated values) Eg: example.com",
    "LABEL_MAX_CONCURRENT_SESSIONS_PER_USER":"Max Concurrent Sessions Per User",
    "MESSAGE_MAX_SESSIONS_ALLOWED":"If a user has reached the configured maximum permitted sessions value, the behaviour is to expire the least recently used session, which will be invalidated if accessed again. Values can be either -1 meaning unlimited, or a positive integer to limit (never zero)",
    "MESSAGE_MAX_SESSIONS_INVALID":"Invalid Max Concurrent Sessions Per User value",
    "MESSAGE_INVALID_COOKIE": "Invalid Cookie value. Cookie value must not be 0",
    "LABEL_SESSION_PERSISTENCE":"Session Persistence",
    "LABEL_SESSION_PERSISTENCE_TOOLTIP": "Session Persistence",
    "LABEL_SESSION_PERSISTENCE_HELP": "As number of users increase, application may need to be deployed on more than one server. To scale deployment of app the session storage needs to be in external storage.",
    "LABEL_SESSION_PERSISTENCE_TYPE": "Type",
    "LABEL_SESSION_PERSISTENCE_SELECT_TYPE": "Select Type",
    "LABEL_SESSION_PERSISTENCE_REDIS_HOST": "Host",
    "LABEL_SESSION_PERSISTENCE_REDIS_PORT": "Port",
    "LABEL_SESSION_PERSISTENCE_REDIS_DATABASE": "Database",
    "LABEL_SESSION_PERSISTENCE_REDIS_PASSWORD": "Password",
    "LABEL_SESSION_PERSISTENCE_IN_MEMORY": "In Memory (No Horizontal Scaling)",
    "LABEL_SESSION_PERSISTENCE_IMPORT_DB": "Import Database",
    "LABEL_SESSION_PERSISTENCE_MESSAGE_IMPORT_DB": "Import Database with ",
    "LABEL_CONFIG_PROFILE_SESSION_PERSISTENCE_TYPE": "Type",
    "LABEL_CONFIG_PROFILE_SESSION_PERSISTENCE_DATABASE": "Database:",
    "LABEL_CONFIG_PROFILE_SESSION_PERSISTENCE_REDIS_HOST": "Redis Host:",
    "LABEL_CONFIG_PROFILE_SESSION_PERSISTENCE_REDIS_PORT": "Redis Port:",
    "LABEL_CONFIG_PROFILE_SESSION_PERSISTENCE_REDIS_PASSWORD": "Redis Password:",
    "LABEL_CONFIG_PROFILE_SESSION_PERSISTENCE_REDIS_DATABASE": "Redis Database:",
    "LABEL_SESSION_PERSISTENCE_DATABASE_HELP": "Please select the database imported with 'editable' mode as session persistence adds few additional tables to your schema. If you had imported the schema as 'readonly', you can change it to 'editable' mode from the settings tab of the DB Designer.",
    "LABEL_CORS":"CORS",
    "LABEL_XSRF_ENABLE":"XSRF Protection",
    "LABEL_SSL_ENABLE":"SSL",
    "LABEL_SSL_ENABLE_TOOLTIP": "SSL",
    "LABEL_SESSION_TIMEOUT_CONFIG":"Session Timeout",
    "LABEL_REMEMBER_ME":"Allow remember me",
    "LABEL_TIMEOUT": " for ",
    "LABEL_MINUTES":"minutes",
    "LABEL_DAYS":"days",
    "LABEL_STRATEGY":"Strategy",
    "LABEL_TOKEN_NAME":"Token Name",
    "LABEL_PROTECTION":"Protection",
    "LABEL_ALLOW_CORS":"Enable",
    "LABEL_ALLOW_X_FRAME_OPTIONS":"Enable",
    "LABEL_XSS_STRATEGY_NONE":"NONE",
    "LABEL_XSS_STRATEGY_ENCODE":"ENCODE",
    "LABEL_SERVICE_PROVIDER_INFO":"Service Provider Information",
    "LABEL_INTEGRATION_INFO":"Integration Information",
    "LABEL_IDENTITY_PROVIDER_INFO":"Identity Provider Information",
    "PLACEHOLDER_TOKEN_URL":"Enter Token Url",
    "PLACEHOLDER_JWKS_URL":"Enter JWKS Url",
    "PLACEHOLDER_USER_INFO_ENDPOINT":"Enter User Info Endpoint",
    "PLACEHOLDER_LOGOUT_URL": "Enter Logout Url",
    "PLACEHOLDER_USER_ID_ATTRIBUTE_NAME":"Enter the attribute name",
    "PLACEHOLDER_SCOPES":"Enter Scopes (comma separated values). Eg. email, username, ...",
    "LABEL_XSS_STRATEGY_WHITE_SPACE":"WHITE LIST",
    "MESSAGE_HELP_XSS_STRATEGY_NONE": "Application is vulnerable to XSS attacks",
    "MESSAGE_HELP_XSS_STRATEGY_ENCODE": "The HTML encoding will be enabled for scripts",
    "MESSAGE_HELP_XSS_STRATEGY_WHILTE_LIST": "Policy based white listing",
    "MESSAGE_HELP_ALLOW_X_FRAME_OPTIONS": "Enable this to allow X-Frame Options",
    "MESSAGE_HELP_X_FRAME_OPTIONS_DENY": "Deny option does not allow to load the app in a frame.",
    "MESSAGE_HELP_X_FRAME_OPTIONS_SAMEORIGIN":"Same Origin option allows the app to be loaded on the same origin as the app itself.",
    "MESSAGE_HELP_X_FRAME_OPTIONS_ALLOW_FROM":"Allow From option enables the app to be loaded in a frame on the specified origin and on the same origin.",
    "MESSAGE_HELP_ALLOW_CORS":"Enable this to allow Cross Origin Resource Sharing.",
    "MESSAGE_HELP_ALLOW_CORS_CREDENTIALS":"Use this option to allow users to include credentials (including cookies and auth data) to be sent with the requests.",
    "MSSAGE_HELP_ALLOW_SSL":"Enable this to allow SSL",
    "MESSAGE_HELP_CORS_MAX_AGE":"Set the validity, in secs, of the preflight request response.",
    "MESSAGE_HELP_CORS_NAME":"Name of the path entry. Duplicate names are not allowed and cannot be empty",
    "MESSAGE_HELP_CORS_PATH":"Only the resources with the mentioned path can be exposed. This cannot be empty.",
    "MESSAGE_HELP_CORS_ORIGIN":"Responses can be exposed only to these Origins. This field cannot be empty.",
    "LABEL_MAX_AGE_SECONDS":"secs",
    "LABEL_SECONDS":"seconds",
    "LABEL_NEW_PATH_ENTRY": "New Entry",
    "LABEL_ALLOW_CREDENTIALS":"Allow Credentials",
    "LABEL_PATH_ENTRIES": "Path Entries",
    "LABEL_PATH":"Path",
    "LABEL_MAX_AGE":"Max Age",
    "LABEL_ALLOWED_ORIGINS": "Allowed Origins",
    "LABEL_ORIGIN":"Origin",
    "LABEL_DESTINATION": "Destination",
    "LABEL_SENSOR": "Sensor",
    "LABEL_POLICY_FILE_HELPTEXT":"Note: The file is opened in editor",
    "LABEL_AUTHENTICATION": "Authentication",
    "LABEL_AUTHENTICATION_TOOLTIP": "Authentication",
    "LABEL_AUTHORIZATION": "Authorization",
    "LABEL_AUTHORIZATION_TOOLTIP": "Authorization",
    "LABEL_PERMISSIONS":"Permissions",
    "LABEL_PERMISSIONS_TOOLTIP":"Configure Permissions",
    "LABEL_WEB_SERVICES":"Web Services",
    "LABEL_WEB":"Web",
    "LABEL_REACTNATIVE":"React Native",
   "LABEL_MOBILE_HEADING":"Mobile",
    "LABEL_DESIGN_SYSTEM":"Design System",
    "LABEL_API_SERVICES":"API Services",
    "LABEL_SOAP_SERVICES":"Soap Services",
    "LABEL_SECURITY_PROVIDER": "Security Provider",
    "LABEL_ENABLE_PROVIDER": "Enable Provider",
    "LABEL_SECURITY_PROVIDER_TOOLTIP": "Select the appropriate Security Provider",
    "LABEL_ENABLE_SECURITY": "Enable Security",
    "LABEL_TEST_API" : "Test the API before saving",
    "LABEL_REST_SERVICE_ADD_PROVIDER": "Add Provider",
    "LABEL_REST_SERVICE_DIALOG_SELECT_PROVIDER": "Select or Add Provider",
    "LABEL_APP_LOGIN_THROUGH": "Enable App Login Using",
    "LABEL_SESSION_OUT_LOGIN_THROUGH": "Login on Session Timeout",
    "LABEL_APP_LOGIN_PAGE": "Configure Login behavior of the App. Choose 'Page' if login should be done through a separate page. Choose 'Dialog' if login should be done through a dialog(present in Common page) whenever required. If 'Page' is selected user will be always redirected to the selected page on app load.",
    "LABEL_APP_SESSION_TIME_OUT_LOGIN_PAGE": "Configure Session timeout Login behavior of the App. Choose 'Page' if re-login should be done through a separate page. Choose 'Dialog' if re-login should be done through a dialog(present in Common page) on session timeout. If 'Page' is selected, user will be always redirected to the selected page on session timeout.",
    "LABEL_APP_SESSION_TIME_OUT_VALUE": "Configure the time period of user inactivity after which the session will get expired at the server. By default it is 30 minutes.",
    "LABEL_POST_LANDING_PAGE": "Post Login Landing Page",
    "LABEL_CONFIGURATION": "Configuration",
    "LABEL_CONFIGURE":"Configure",
    "LABEL_DATA_CONFIGURATION": "Data Configuration",
    "MESSAGE_NO_SOURCE": "There is no Service found in the application. The component requires the data to be bound from service output. After importing a database or web service, drag and drop the component again and you will find the Services here. Alternatively, you can use existing variables to show data.",
    "MESSAGE_NO_SOURCE_FOR_SELECTED_SERVICE": "There is no data source available for the selected service type. The component requires data source to be bound from service type. Try again after importing/creating the service.",
    "LABEL_USER_INTERFACE": "User Interface",
    "LABEL_SELECT_WIDGET": "Select Component",
    "LABEL_SELECT_WIDGET_FOR_FIELD":"--- Select a component for field ---",
    "LABEL_SELECT_FIELDS": "Select Fields",
    "LABEL_SELECT_LOGIN_PAGE": "Select Login Page",
    "LABEL_SESSION_TIMEOUT_MINUTES": "Session Timeout (minutes)",
    "LABEL_COOKIE_MAXAGE": "Cookie Max-Age",
    "MESSAGE_ERROR_COOKIE_MAXAGE": "Please enter Cookie Max-Age value",
    "MESSAGE_MINIMUM_ENABLED_PROVIDERS_TO_DELETE": "At least one provider must remain enabled. Please enable another provider before deleting this one.",
    "MESSAGE_MINIMUM_PROVIDERS_ENABLED": "At least one provider should be enabled",
    "LABEL_COOKIE_MAXAGE_MINUTES": "Cookie Max-Age (minutes)",
    "MESSAGE_COOKIE_MAXAGE_MINUTES": "A positive value indicates when the cookie should expire relative to the current time. A value of 0 means the cookie should expire immediately. A negative value results in no 'Max-Age' attribute in which case the cookie is removed when the browser is closed.",
    "LABEL_USE_SSL": "Use SSL",
    "LABEL_USE_SSL_TOOLTIP": "Check the SSL authentication mechanism for the application",
    "LABEL_ROLE": "Role Mapping",
    "LABEL_USER_TABLE": "User Table",
    "LABEL_USER": "User",
    "LABEL_USERNAME_COLUMN": "Username Column",
    "LABEL_USERID_COLUMN": "User Id Column",
    "LABEL_PASSWORD_COLUMN": "Password Column",
    "LABEL_ROLE_COLUMN": "Role Column",
    "LABEL_ENTER_PASSWORD": "Enter Password",
    "LABEL_ENTER_USERNAME": "Enter Username",
    "LABEL_ENTER_PAGE_NAME": "Enter Page Name",
    "LABEL_ENTER_PREFAB_NAME": "Enter Prefab Name",
    "LABEL_PREFAB_NAME": "Prefab Name",
    "LABEL_VERSION": "Version",
    "LABEL_VERSION_CURRENT": "Current Version",
    "LABEL_VERSION_PUBLISHED": "Published Version",
    "LABEL_VERSION_IN_PROJECT": "Version in Project",
    "LABEL_VERSION_NEW": "New Version",
    "LABEL_IN_PROJECT": "in project",
    "LABEL_CAUSING_CONFLICT": "causing conflict",
    "LABEL_DEPENDENCY_TYPE": "Dependency Type",
    "LABEL_USED_BY_PROJECT": "Used in Project",
    "LABEL_USED_BY_PREFABS": "Used in Prefab(s)",
    "LABEL_SELECTED_PROJECT": "Selected Project:",
    "LABEL_SELECTED": "Selected",
    "LABEL_NONE_SELECTED": "None Selected",
    "LABEL_SELECT_ROLE": "Select App Role",
    "LABEL_USER_ROLES": "User Roles",
    "LABEL_ROLE_GROUPS": "User Role Groups",
    "LABEL_ROLE_GROUPS_AUTHENTICATED":"Authenticated",
    "LABEL_ROLE_GROUPS_EVERYONE":"Everyone",
    "LABEL_ROLE_GROUPS_ANONYMOUS":"Anonymous",
    "LABEL_MULTITENANT_CONFIGURATION":"Multitenant Configuration",
    "LABEL_TENANT_ID_FIELD_NAME":"Tenant ID Field Name",
    "LABEL_DEFAULT_TENANT_ID_VALUE":"Default Tenant ID Value",
    "LABEL_ROLES_BY_SQL_QUERY":"Roles By Query",
    "LABEL_ENTER_QUERY":"Enter Query",
    "LABEL_TEST_QUERY":"Test Query",
    "LABEL_QUERY_PLACEHOLDER": "/*Please choose User Table and Username to autopopulate query*/",
    "LABEL_ROLES_FROM_QUERY":"Roles from Query",
    "LABEL_ERROR_FROM_QUERY":"Errors from Query",
    "LABEL_ACCESS_LEVEL":"Access Level",
    "LABEL_EVERYONE":"Everyone",
    "LABEL_ANONYMOUS": "Anonymous",
    "LABEL_ONLY_AUTHENTICATED_USERS":"Authenticated",
    "LABEL_DATABASE_SERVICE": "Database Service",
    "LABEL_DATAMODEL_SERVICE":"DataModel Service",
    "LABEL_CREATE_DATAMODEL": "Create Data Model",
    "LABEL_IMPORT_DATAMODEL": "Import Data Model",
    "LABEL_NO_ROLES_FOUND":"No roles returned",
    "LABEL_SELECT_PROVIDER": "Select Provider",
    "LABEL_DOMAIN": "Domain",
    "LABEL_DOMAIN_HELP_MESSAGE": "If domain is not provided, it should be provided along with username while login",
    "LABEL_LDAP_URL": "LDAP URL",
    "LABEL_TEST_USER_NAME": "Test Username",
    "LABEL_TEST_USER_PASSWORD": "Test User Password",
    "LABEL_MANAGER_DN": "Manager DN",
    "LABEL_MANAGER_PASSWORD": "Manager Password",
    "LABEL_USER_SEARCH_PATTERN": "User Search Pattern",
    "LABEL_SEARCH_USER_ROLE": "Search User Role",
    "LABEL_SELECT_USER_ROLE_PROVIDER": "Select User Role Provider",
    "LABEL_GROUP_SEARCH_BASE": "Group Search Base",
    "LABEL_GROUP_ROLE_ATTRIBUTE": "Group Name Attribute",
    "LABEL_GROUP_SEARCH_FILTER": "User Group Filter",
    "LABEL_CAS_URL": "Server URL",
    "LABEL_CAS_LOGIN_URL": "Login URL",
    "LABEL_CAS_LOGOUT_URL": "Logout URL",
  "LABEL_JWS_PROVIDERID": "Provider ID",
  "PLACEHOLDER_JWS_PROVIDERID": "Enter Provider ID",
  "LABEL_JWS_ISSUE_URL": "Issuer URL",
  "PLACEHOLDER_JWS_ISSUE_URL": "Enter Issuer URL",
  "LABEL_JWS_PRINCIPAL_CLAIM_NAME": "Principal Claim Name",
  "PLACEHOLDER_JWS_PRINCIPAL_CLAIM_NAME": "Enter Principal Claim Name",
  "LABEL_OPAQUE_INTROSPECTION_URL": "Introspection URL",
  "PLACEHOLDER_OPAQUE_INTROSPECTION_URL":"Enter Introspection URL",
  "LABEL_OPAQUE_CLIENT_ID": "Client Id",
  "PLACEHOLDER_OPAQUE_CLIENT_ID":"Enter Clinet Id",
  "LABEL_OPAQUE_CLIENT_SECRET": "Cient Secret",
  "PLACEHOLDER_OPAQUE_CLIENT_SECRET":"Enter Clinet Secret",
  "LABEL_OPAQUE_PRINCIPAL_CLAIM_NAME": "Principal Claim Name",
  "PLACEHOLDER_OPAQUE_PRINCIPAL_CLAIM_NAME": "Enter Principal Claim Name",
    "LABEL_CAS_VALIDATION_URL": "Validation URL",
    "LABEL_CAS_SERVICE_PARAM": "Service Parameter Name",
    "LABEL_CAS_ARTIFACT_PARAM": "Ticket Parameter Name",
    "LABEL_ROLE_ATTRIBUTE_NAME": "Role Attribute Name",
    "LABEL_ROLE_ATTRIBUTE": "Role Attribute",
    "LABEL_RESOLUTION_STEPS":"Resolution Steps",
    "LABEL_NO_ISSUES_FOUND": "No issues found",
    "LABEL_NO_ISSUES_FOUND_APIS": "No issues found in the APIs. Refresh to check again.",
    "MESSAGE_APPLICATION_DISRUPTION":"To prevent application disruption, please commit all pending changes and maintain a clean workspace before proceeding with API reimport. Alternatively, follow our recommended",
    "MESSAGE_GIT_BRANCHING":"Git Branching Strategy",
    "MESSAGE_CODE_EFFECTIVELY":"to manage your code effectively.",
    "MESSAGE_ENDPOINT_MODIFIED":"in-use endpoints are modified across",
    "MESSAGE_ERRORS":"errors in the app, we'll pinpoint the locations of these errors in the next steps.",
    "MESSAGE_RE_IMPORT_API_PAGE":"pages causing",
    "MESSAGE_SUCESS_NO_ISSUES_FOUND": "We haven't found any breaking issues in the application. We recommend you to check your custom javascript that may be invoking this API.",
  "MESSAGE_JWS_PROVIDERID_NOT_SET": "Please provide Provider ID",
  "MESSAGE_JWS_ISSUERURL_NOT_SET": "Please provide Issuer URL",
  "MESSAGE_JWS_PRINCIPALCLAIMNAME_NOT_SET": "Please provide Principal Claim Name ",
  "MESSAGE_OPAQUE_INTROSPECTIONURL_NOT_SET": "Please provide Introspection URL",
  "MESSAGE_OPAQUE_CLIENTID_NOT_SET": "Please provide Client ID",
  "MESSAGE_OPAQUE_CLIENTSECRET_NOT_SET": "Please provide Client Secret",
  "MESSAGE_OPAQUE_PRINCIPALCLAIMNAME_NOT_SET": "Please provide Principal Claim Name ",
  "LABEL_HELP_OPAQUE_CLIENT_ID": "The Client Id for app provided by the OpenId provider.",
  "LABEL_HELP_OPAQUE_CLIENT_SECRET": "The Client Secret for app provided by the OpenId provider.",
  "LABEL_HELP_OPAQUE_INTROSPECTION_URL": "The Introspection URL of the  OpenId provider.",
  "LABEL_HELP_OPAQUE_PRINCIPALCLAIMNAME": "The Principal Claim Name of the OpenId Provider ",
  "LABEL_HELP_JWS_PROVIDER_ID": "The Provider Id for app provided by the JWS provider.",
  "LABEL_HELP_JWS_ISSUE_URL": "The Issue URL of the  JWS provider.",
  "LABEL_HELP_JWS_PRINCIPALCLAIMNAME": "The Principal Claim Name of the JWS Provider ",
    "MESSAGE_CAS_URL_NOT_SET": "Please provide Server URL",
    "MESSAGE_CAS_LOGIN_URL_NOT_SET": "Please provide Login URL",
    "MESSAGE_CAS_LOGOUT_URL_NOT_SET": "Please provide Logout URL",
    "MESSAGE_CAS_VALIDATION_URL_NOT_SET": "Please provide Validation URL",
    "MESSAGE_CAS_SERVICE_PARAMETER_NOT_SET": "Please provide Service Parameter Name",
    "MESSAGE_CAS_TICKET_PARAMETER_NOT_SET": "Please provide Ticket Parameter Name",
    "MESSAGE_CAS_ROLE_ATTRIBUTE_NAME_NOT_SET": "Please provide Role Attribute Name",
    "MESSAGE_POLICY_UPLOAD_SUCCESSFULLY": "Policy file uploaded successfully",
    "MESSAGE_POLICY_UPLOAD_FAILED": "Policy file uploaded failed",
    "MESSAGE_SELECT_XML_FILE": "Policy file should be .xml type",
    "LABEL_HELP_CAS_SERVER_URL": "Context path of the cas server",
    "LABEL_HELP_CAS_LOGIN_URL": "Login path relative to the server url where login page will be shown",
    "LABEL_HELP_CAS_LOGOUT_URL": "Logout path relative to the server url where logout need to be invoked",
    "LABEL_HELP_CAS_VALIDATION_URL": "Url where service ticket validation will happen",
    "LABEL_HELP_CAS_SERVICE_PARAM": "Configures the request parameter to look for when sending request to CAS. The default value is 'service'. Eg. /cas-server-webapp/login?service=https://localhost:8443/cassample-1.0/login/cas",
    "LABEL_HELP_CAS_ARTIFACT_PARAM": "Configures the Request Parameter to look for when attempting to see if a CAS ticket was sent from the server. The default value is 'ticket'. Eg. /cassample-1.0/login/cas?ticket=ST-1-lCYeRuXfmhKid1auqdy2-cas01.example.org",
    "LABEL_HELP_CAS_ROLE_PROVIDER": "User Role provider. Possible options are CAS and Database",
    "LABEL_HELP_CAS_ROLE_ATTRIBUTE_NAME": "To fetch possible attribute names, click on test connection and login",
    "LABEL_SAML_METADATA_URL": "Metadata URL",
    "LABEL_SAML_METADATA_SRC": "Metadata Source",
    "LABEL_SAML_END_POINT_URL": "Endpoint URL",
    "LABEL_SAML_ENTITY_BASE_URL": "Entity base URL",
    "LABEL_SAML_SP_UPLOAD_METADATA_FILE": "Metadata File",
    "LABEL_SAML_SP_AUDIENCE_URL": "Audience URL(SP Issuer)",
    "LABEL_SAML_SSO_URL": "Single Signon URL",
    "LABEL_SAML_SLO_URL": "Single Signout URL",
    "LABEL_SAML_KEYSTORE": "KeyStore",
    "LABEL_SAML_UPLOAD": "Upload JKS File",
    "LABEL_SAML_ALIAS": "Alias",
    "LABEL_SAML_PASSWORD": "Password",
    "LABEL_SAML_SUBJECT": "Subject Name",
    "LABEL_SAML_MAX_AUTH_AGE": "Max Authentication Age",
    "LABEL_SAML_PLACEHOLDER_MAX_AUTH_AGE": "Enter time in seconds",
    "MESSAGE_SAML_DEPLOY_FAILED": "Error getting the application metadata URLs. Run the project once and try again.",
    "MESSAGE_OPEN_ID_DEPLOY_FAILED": "Error getting the application Redirect URL. Run the project once and try again.",
    "MESSAGE_SAML_SP_METADATA_DEPLOY_FAILED": "Unable to load Metadata URL due to deployment failure.",
    "MESSAGE_SAML_IDP_METADATA_NOT_SET": "Please provide IdP Metadata URL.",
    "MESSAGE_SAML_IDP_METADATA_INVALID": "Please enter a valid Metadata URL.",
    "MESSAGE_SAML_EMPTY_METADATA_FILE" : "Please enter metadata file name",
    "MESSAGE_SAML_VALIDATING_METADATA_FILE": "Validating Metadata File.",
    "MESSAGE_SAML_LOAD_BEFORE_SAVE": "Please click load button.",
    "MESSAGE_SAML_UPLOAD_METADATA_FILE": "Please upload metadata file.",
    "MESSAGE_SAML_JSK_FILE_NOT_UPLOAD": "Please upload a KeyStore file.",
    "MESSAGE_SAML_ALIAS_KEY_NOT_SET": "Please fill Alias key field.",
    "MESSAGE_SAML_PASSWORD_NOT_SET": "Please enter the password.",
    "MESSAGE_SAML_PASSWORD_LENGTH": "Password must be at least 6 characters in length.",
    "MESSAGE_SAML_SUBJECT_NAME_NOT_SET": "Please enter subject name.",
    "MESSAGE_SAML_NO_SPL_CHARACTERS_FILE_NAME": "Uploaded file name should not contain special characters.",
    "MESSAGE_SAML_METADATA_VALIDATION_FAILED": "Failed to validate Metadata URL.",
    "MESSAGE_SAML_MAX_AUTH_AGE_LESS_THAN_ZERO": "Please enter max authentication age greater than zero",
    "MESSAGE_ROLE_ATTRIBUTE_NAME_NOT_SET": "Please provide Role Attribute Name",
    "LABEL_HELP_PKCE_MSG": "PKCE is a technique for clients to mitigate the threat of having the authorization code intercepted. If your oAuth provider supports PKCE, you can enable it here.",
    "LABEL_HELP_PKCE_CODE_CHALLENGE_MSG": "Code Challenge method which your oAuth provider supports for PKCE.",
    "LABEL_HELP_SAML_METADATA": "Metadata URL or Metadata file can be used to configure SAML.",
    "LABEL_HELP_SAML_END_POINT_URL": "The Endpoint URL of the Identity Provider.",
    "LABEL_HELP_SAML_SP_METADATA": "Metadata URL gives the information about the service provider which is required by the Identity Provider.",
    "LABEL_HELP_SAML_AUDIENCE_URL": "The service provider endpoint where the assertions are received.",
    "LABEL_HELP_SAML_SP_SSO_URL": "The Single Signon URL of the service provider.",
    "LABEL_HELP_SAML_SP_SLO_URL": "The Single Logout URL of the service provider.",
    "LABEL_HELP_SAML_KEYSTORE": "Java KeyStore file can be uploaded or auto generated.",
    "LABEL_HELP_SAML_ALIAS": "The alias of the public key for the service provider.",
    "LABEL_HELP_SAML_PASSWORD": "This is the KeyStore password. This should be a minimum of 6 characters.",
    "LABEL_HELP_SAML_SUBJECT_NAME": "This is the Subject name of the self-signed certificate.",
    "LABEL_HELP_REMOVE_FILE": "Deselect/Remove the file",
    "LABEL_HELP_SAML_ROLE_PROVIDER": "User Role provider. Possible options are SAML and Database.",
    "LABEL_HELP_SAML_ROLE_ATTRIBUTE_NAME": "Role parameter configured in Identity Provider.",
    "LABEL_HELP_SAML_IDP_CONFIG": "Enter the Metadata URL or upload Metadata File of the SAML 2.0 Identity provider and load the configuration.",
    "LABEL_HELP_SAML_SERVICE_PROVIDER": "Import an existing KeyStore or let WaveMaker auto generate and manage the KeyStore.",
    "LABEL_HELP_SAML_SERVICE_PROVIDER_INFO": "Application URLs are provided below that needs to be configured/registered with the Identity Provider.",
    "LABEL_HELP_SAML_MAX_AUTH_AGE": "Time (in seconds) between user authentication and processing of an authentication statement.",
    "LABEL_HELP_OPENID_PROVIDER_ID": "The OpenId provider to be used.",
    "LABEL_HELP_OPENID_REDIRECT_URL": "The Redirection Url is endpoint on the app server that will receive the response form the OpenId after successful login.",
    "LABEL_HELP_OPENID_SCOPES": "The list of scopes that the app wants to get access form the OpenId.",
    "LABEL_HELP_OPENID_USER_NAME_ATTRIBUTE": "Sets the attribute name used to access the user's name from the user info response.",
    "LABEL_HELP_OPENID_CLIENT_ID": "The Client Id for app provided by the OpenId provider.",
    "LABEL_HELP_OPENID_CLIENT_SECRET": "The Client Secret for app provided by the OpenId provider.",
    "LABEL_HELP_OPENID_AUTHORIZATION_URL": "The Url of the authorization server’s authorization endpoint.",
    "LABEL_HELP_OPENID_TOKEN_URL": "The Url of the authorization server’s token endpoint.",
    "LABEL_HELP_OPENID_JWKS_URL": "The Url of the authorization server’s JSON Web Key Set document.",
    "LABEL_HELP_OPENID_USER_INFO_ENDPOINT": "The Url of the authorization server’s User Info endpoint.",
    "LABEL_HELP_OPENID_LOGOUT_URL": "The Url of the authorization server’s logout endpoint.",
    "LABEL_HELP_OPENID_ROLE_PROVIDER": "User Role provider. Possible options are OpenId and Database.",
    "LABEL_USER_DETAILS_PROVIDER": "User Details Provider",
    "LABEL_HEADERS": "Headers",
    "LABEL_HEADER_NAME": "Header Name",
    "LABEL_HEADER_VALUE": "Header Value",
    "LABEL_APP_LEVEL_VARIABLES": "App level variables",
    "LABEL_FILE_RESOURCE": "File Resource",
    "LABEL_SELECT_FILES": "Select Files:",
    "LABEL_CUSTOM": "Custom",
    "LABEL_BASIC":"Basic",
    "LABEL_CLASS_NAME": "Class Name",
    "LABEL_FULLY_QUAL_CLASS_NAME": "Provide fully qualified class name",
    "MESSAGE_PROVIDE_VALUE": "Please provide ${0}",
    "MESSAGE_CONFIRM_CHANGE_PROVIDER": "Are you sure you want to save? You may lose your current settings.",
    "MESSAGE_CONFIRM_CHANGE_LOGIN_PAGE_PERMISSION": "A secured 'Page' cannot be used as a login page. On Save, the page permission will be changed to 'Everyone'",
    "MESSAGE_ROLE_NOT_SET": "Please provide role",
    "MESSAGE_LOGIN_PAGE_NOT_SET": "Please provide Login on Session timeout configuration",
    "MESSAGE_SESSION_TIMEOUT_NOT_SET": "Session Timeout value not set",
    "MESSAGE_HEADER_NAME_NOT_SET": "Please provide Token Name",
    "MESSAGE_CORS_MAX_AGE_NOT_SET": "Please provide Max Age for CORS configuration",
    "MESSAGE_INVALID_HEADER_NAME": "Token Name cannot contain special characters",
    "MESSAGE_ROLE_ALREADY_EXISTS": "Role already exists",
    "MESSAGE_USER_ALREADY_EXISTS": "User already exists",
    "MESSAGE_SUCCESS_DEMO_SECURITY": "Successfully saved Demo security",
    "MESSAGE_SUCCESS_SAVE_SECURITY": "Successfully saved security changes",
    "MESSAGE_ERROR_DEMO_SECURITY": "Error occurred while saving Demo security",
    "MESSAGE_ERROR_INCORRECT_POOL_SIZE":"Min pool size cannot be greater than max pool size",
    "MESSAGE_ERROR_INCORRECT_VALID_TOKEN_TIME":"Please enter valid 'token validity' time in security configuration",
    "MESSAGE_ERROR_POOL_MIN" : "Please enter a valid min pool size in database configuration",
    "MESSAGE_ERROR_POOL_MAX" : "Please enter a valid max pool size in database configuration",
    "MESSAGE_ERROR_RECORDS_MAX" : "Please enter a valid value for records per request in database configuration",
    "MESSAGE_SAVE_SECURITY": "Saving security settings...",
    "MESSAGE_SUCCESS_DB_SECURITY": "Successfully saved Database security",
    "MESSAGE_ERROR_DB_SECURITY": "Error occurred while saving Database security",
    "MESSAGE_SUCCESS_LDAP_SECURITY": "Successfully saved LDAP security",
    "MESSAGE_ERROR_LDAP_SECURITY": "Error occurred while saving LDAP security",
    "MESSAGE_SUCCESS_AD_SECURITY": "Successfully saved Active Directory security",
    "MESSAGE_ERROR_AD_SECURITY": "Error occurred while saving Active Directory security",
    "MESSAGE_SUCCESS_CAS_SECURITY": "Successfully saved CAS security",
    "MESSAGE_ERROR_CAS_SECURITY": "Error occurred while saving CAS security",
    "MESSAGE_SUCCESS_SAML_SECURITY": "Successfully saved SAML security",
    "MESSAGE_SUCCESS_OPEN_ID_SECURITY": "Successfully saved Open Id security",
    "MESSAGE_ERROR_SAML_SECURITY": "Error occurred while saving SAML security",
    "MESSAGE_DATAMODEL_NOT_SET": "Please select Database field",
    "MESSAGE_USER_TABLE_NOT_SET": "Please select User Table",
    "MESSAGE_SELECT_ATLEAST_ONE_ROLE": "A user exists without any role, please select atleast one role for the user ('Users' tab).",
    "MESSAGE_USERNAME_NOT_SET": "Please select Username field",
    "MESSAGE_USERID_NOT_SET": "Please select Userid field",
    "MESSAGE_PASSWORD_NOT_SET": "Please select Password field",
    "MESSAGE_ROLE_QUERY_NOT_SET": "Please enter Role Query",
    "MESSAGE_LDAP_URL_NOT_SET": "Please provide LDAP URL",
    "MESSAGE_GROUP_SEARCH_BASE_NOT_SET": "Please provide group search base value",
    "MESSAGE_GROUP_ROLE_ATTRIBUTE_NOT_SET": "Please provide group name attribute",
    "MESSAGE_GROUP_SEARCH_FILTER_NOT_SET": "Please provide user search filter",
    "MESSAGE_USER_SEARCH_PATTERN_NOT_SET": "Please provide User search pattern",
    "MESSAGE_AD_URL_NOT_SET": "Please provide Active Directory URL",
    "MESSAGE_AD_DOMAIN_NOT_SET": "Please provide Active Directory domain",
    "MESSAGE_TEST_USER_DN_NOT_SET": "Please provide Test Username",
    "MESSAGE_TEST_USERNAME_NOT_SET": "Please provide Test username",
    "MESSAGE_TEST_USER_PWD_NOT_SET": "Please provide Test user Password",
    "MESSAGE_USER_ROLE_PROVIDER_NOT_SET": "Please provide User Role Provider",
    "MESSAGE_DOMAIN_NOT_SET": "Please provide Domain",
    "MESSAGE_ROOT_DN_NOT_SET": "Please provide Root DN",
    "MESSAGE_URL_NOT_SET": "Please provide Url",
    "MESSAGE_TESTING_CONNECTION": "Testing the connection",
    "MESSAGE_TESTING_QUERY": "Testing the query",
    "MESSAGE_QUERY_TESTED_SUCCESSFULLY": "Tested query successfully",
    "MESSAGE_QUERY_PARAMETER_NOT_SET": "Please provide a parameter to test the query",
    "MESSAGE_QUERY_NOT_SET": "Please provide a query to test",
    "MESSAGE_CONNECTION_NOT_TESTED": "Please test the connection before proceeding",
    "MESSAGE_ROLES_QUERY_NOT_TESTED": "Please test the roles query before proceeding",
    "MESSAGE_PROJECT_URL_NOT_SET": "Please provide Project URL",
    "MESSAGE_SPECIAL_CHARACTERS_NOT_ALLOWED": "Special characters and space are not allowed",
    "MESSAGE_ERROR_DELETE_WIDGET_NOT_ALLOWED" : "Delete action is not permitted for the selected component",
    "MESSAGE_INFO_NAV_ALLOWED_WIDGETS" : "Only Anchor, Menu and Popover are allowed in Nav component",
    "MESSAGE_INFO_BUTTON_GROUP_ALLOWED_WIDGETS" : "Only Button is allowed in Buttons Group component",
    "MESSAGE_GRID_CANNOT_LOAD_DATA_IN_STUDIO" : "Cannot load data for Dynamic Datatable",
    "MESSAGE_CANNOT_GENERATE_FIELDS_IN_STUDIO": "Cannot generate fields for Dynamic Form",
    "MESSAGE_SUCCESS_CUSTOM_SECURITY": "Custom Security has been configured",
    "MESSAGE_REDIS_HOST_NOT_SET": "Please provide REDIS host",
    "MESSAGE_REDIS_PORT_NOT_SET": "Please provide REDIS port",
    "MESSAGE_REDIS_DATABASE_NOT_SET": "Please provide REDIS Database",
    "MESSAGE_JDBC_SERVICE_NOT_SET": "Please choose Database",
    "HINT_CUSTOM_AUTHENTICATION": "Provide an implementation for <b>com.wavemaker.runtime.security.WMCustomAuthenticationManager</b> that should have at least one public empty constructor. This class should be available within this application.",
    "DB_SHELL_MESSAGE_RESOURCES":"---------DB Shell Message Resources----------",
    "DB_COMMAND_EXECUTION_FAILURE": "An error occurred while connecting to dbshell. Please check server logs for more information",
    "LABEL_DB_TOOLS":"DB Tools",
    "LABEL_DB_TOOLS_TITLE":"DB Tools (ALT+T)",
    "LABEL_MYSQL_CLOUD":"MariaDB Cloud",
    "LABEL_REMOTE_CLOUD":"Deployment Server",
    "LABEL_DB_SHELL_CLOUD":"DB Shell-MariaDB Cloud",
    "LABEL_DB_SHELL_REMOTE":"DB Shell-Deployment Server",
    "LABEL_DB_SHELL_SCRIPT":"Script",
    "LABEL_DATABASE_ACTION": "Database Action",
    "LABEL_DB_SHELL_SCRIPT_IMPORT":"Import",
    "LABEL_DB_SHELL_SCRIPT_EXPORT":"Export",
    "LABEL_DB_SHELL_SCRIPT_EXECUTE":"Execute",
    "LABEL_DB_SHELL_EXPORT_DUMP":"Get Data Dump",
    "LABEL_DB_SHELL_SCHEMA_ONLY":"Schema only",
    "MESSAGE_EXECUTING_SCRIPT":"Executing Script...",
    "MESSAGE_SUCCESS_SCRIPT_EXECUTION":"Script execution successful",
    "MESSAGE_ERROR_SCRIPT_EXECUTION":"An error occurred while executing script",
    "MESSAGE_ERROR_OCCURRED":"An error occurred",
    "LABEL_CLEAR_DB_SHELL":"Clear DB Shell",
    "LABEL_CLOSE_DB_TOOLS":"Close DB Tools",
    "LABEL_RECONNECT_DB_SHELL":"Reconnect to DB Shell",
    "MESSAGE_DB_SHELL_RECONNECT":"Please try connecting again.",
    "MESSAGE_DB_SHELL_DISCONNECTED":"You are currently not connected.",
    "VCS_MESSAGE_RESOURCES": "---------VCS Message Resources----------",
    "LABEL_VCS_CHECKOUT_PROJECT": "Checkout",
    "MESSAGE_VCS_PULL_SUCCESS": "Project changes were pulled successfully",
    "MESSAGE_VCS_PULL_FAILURE": "Changes couldn't be pulled",
    "MESSAGE_VCS_PUSH_SUCCESS": "Project changes were pushed to \"${0}\" branch successfully",
    "MESSAGE_VCS_PUSH_FAILURE": "Changes couldn't be pushed",
    "MESSAGE_VCS_IMPORT_SUCCESS": "Project was successfully imported from version control",
    "MESSAGE_VCS_IMPORT_FAILURE": "Project couldn't be imported",
    "MESSAGE_VCS_ADD_SUCCESS": "Project was successfully added to version control",
    "MESSAGE_VCS_ADD_FAILURE": "Project couldn't be added",
    "LABEL_VCS": "VCS",
    "MESSAGE_VCS_HINT": "Sync Project Changes",
    "LABEL_VCS_IMPORT_PROJECT": "Checkout Project from Version Control",
    "LABEL_VCS_ADD_PROJECT": "Add Project to Version Control",
    "LABEL_VCS_COMMIT_PROJECT": "Commit Project Changes",
    "LABEL_VCS_LOGIN": "Login to Version Control",
    "LABEL_VCS_REVERT_PROJECT": "Revert Project Changes",
    "LABEL_VCS_VIEW_PROJECT_CHANGES": "View Project Changes",
    "LABEL_VCS_VIEW_COMMIT_CHANGES": "View Commit Changes",
    "LABEL_VCS_COMPARE_DIFF": "Compare File Diff",
    "LABEL_VCS_MERGE_FILES": "Merge Files",
    "LABEL_VCS_MENU_PUSH_PROJECT": "Push Changes",
    "LABEL_VCS_MENU_PULL_PROJECT": "Pull Changes",
    "LABEL_VCS_MENU_COMMIT_PROJECT": "Commit Changes",
    "LABEL_VCS_MENU_REVERT_PROJECT": "Revert Changes",
    "LABEL_VCS_MENU_VIEW_PROJECT_CHANGES": "View Changes",
    "LABEL_VCS_MENU_ADD_EXTERNAL_PROJECT": "Push to External Repo",
    "LABEL_OPEN_IN_VCS": "Open in VCS",
    "LABEL_VCS_MENU_ADD_PROJECT": "Add Project to VCS",
    "LABEL_VCS_MENU_MERGE_CONFLICTS": "Merge Conflicts",
    "LABEL_VCS_MENU_VIEW_HISTORY": "Commit History",
    "LABEL_VCS_MERGE_CHANGES_FROM_SERVER": "Changes From Server",
    "LABEL_VCS_MERGE_RESULT": "Merge Result",
    "LABEL_VCS_LOCAL_CHANGES": "Local Changes",
    "LABEL_VCS_SERVER_VERSION": "Server Version (Read-only)",
    "LABEL_VCS_COMMIT_VERSION": "Commit Version (Read-only)",
    "LABEL_VCS_YOUR_VERSION": "Your Version",
    "MESSAGE_VCS_LOGIN": "Logging in to the VCS provider",
    "MESSAGE_VCS_LOG_NOTE": "Browse through the commit history to see the changes in the project",
    "MESSAGE_VCS_NO_CHANGES": "There are no changes in the project",
    "LABEL_USER_VCS_CREDENTIALS_MSG": "Please provide the specified code repository credentials.",
    "LABEL_BASE_URL": "Base URL",
    "LABEL_UPDATE_VCS_CREDENTIALS": "Update Credentials",
    "MESSAGE_VCS_PUBLISH": "There are changes identified in the project. Clicking on \"Ok\" will push these changes to Version Control System and continue publishing. \"Cancel\" will cancel the publishing. Do you want to proceed?",
    "MESSAGE_VCS_PUSH_ON_DEPLOY": "There are changes identified in the project. Clicking on \"Yes\" will push these changes to Version Control System and continue deployment. \"No\" will cancel the deployment operation. Do you want to proceed?",
    "LABEL_NEWER": "Newer",
    "LABEL_OLDER": "Older",
    "LABEL_PUSH": "Push",
    "LABEL_PULL": "Pull",
    "LABEL_PULL_CONFIRM": "Confirm Pull Changes",
    "MESSAGE_PULL_CONFIRM": "Clicking OK will pull the latest changes from the VCS. Your local changes will be stashed and re-applied after the pull. After the successful pull, your workspace will be reloaded. Are you sure you want to pull the latest changes?",
    "LABEL_COMMIT": "Commit",
    "LABEL_REVERT": "Revert",
    "LABEL_SHOW_DIFF": "Show Diff",
    "LABEL_SHOW_CHANGES": "Show Changes",
    "LABEL_UPDATE_DB": "Update DB",
    "LABEL_ACCEPT_THEIRS": "Accept Theirs",
    "LABEL_ACCEPT_YOURS": "Accept Yours",
    "LABEL_MERGE_APPLY": "Apply",
    "LABEL_REAPPLY": "Re-Apply",
    "LABEL_DISCARD_PULL": "Discard Pull Changes",
    "LABEL_SAVE_CLOSE": "Save & Close",
    "LABEL_VCS_PROVIDER": "Select Repository",
    "LABEL_VCS_COMMIT": "Commit Message",
  "LABEL_VCS_MIGRATION_COMMIT": "Migration Commit Message",
    "TITLE_SAVE_CHANGES": "Save the changes",
    "TITLE_SAVE_CLOSE_CHANGES": "Save the changes and close the dialog",
    "MESSAGE_SAVE_API_CHANGES": "There are unsaved changes in the Endpoint \"${0}\" with methodType \"${1}\", please save them before testing.",
    "MESSAGE_CHART_PREVIEW": "Preview with Sample Data",
    "MESSAGE_VCS_IMPORTING": "Importing the project from VCS",
    "MESSAGE_VCS_LOGGING_IN": "Authenticating your VCS credentials",
    "MESSAGE_VCS_PUSHING": "Pushing the project changes to VCS",
    "MESSAGE_VCS_PREPARING_COMMIT_MESSAGE": "Preparing default commit message",
    "MESSAGE_VCS_PULLING": "Pulling the project changes from VCS",
    "MESSAGE_VCS_ADDING": "Adding the project to VCS",
    "MESSAGE_VCS_COMMIT": "Please provide appropriate commit message",
    "MESSAGE_VCS_HISTORY": "Fetching commits",
    "MESSAGE_WARN_VCS_USERNAME_EMPTY": "Enter a username",
    "MESSAGE_WARN_VCS_USERNAME_INVALID": "Username cannot be an email address",
    "MESSAGE_WARN_VCS_REPO_URL_DIFFERENT": "Project Name(${0}) and Repository name(${1}) are different.Do you want to continue ?",
    "MESSAGE_WARN_VCS_COMMIT_EMPTY": "Enter a commit message",
    "MESSAGE_WARN_VCS_URL_EMPTY": "Enter a url",
    "LABEL_FILE_PATH": "File Path",
    "LABEL_FILE_STATUS": "File Status",
    "LABEL_FILE_TYPE": "File Type",
    "LABEL_COMMIT_ID": "Commit ID",
    "LABEL_COMMIT_DATE": "Time",
    "LABEL_COMMIT_AUTHOR": "Author",
    "LABEL_COMMIT_MESSAGE": "Commit Message",
    "LABEL_COMMIT_STATE_MORE": "more",
    "LABEL_COMMIT_STATE_LESS": "less",
    "LABEL_PROCEED_MESSAGE": "Do you want to proceed?",
    "MESSAGE_VCS_NO_FILE_SELECTED": "Please select a file",
    "MESSAGE_VCS_SELECT_ONE_FILE_DIFF": "Diff can be viewed for only one file at a time",
    "MESSAGE_VCS_NO_DIFF_FOR_FOLDER": "Diff cannot be viewed for a folder",
    "MESSAGE_VCS_REVERTING_FILES": "Reverting all files",
    "MESSAGE_VCS_DISCARD_PULL": "This action will discard the latest pull changes and revert the source code to the last saved state.",
    "MESSAGE_VCS_REVERTING": "Reverting the selected files",
    "MESSAGE_VCS_REVERT_SUCCESS": "Selected files were reverted successfully",
    "MESSAGE_VCS_REVERT_FAILURE": "Selected files could not be merged",
    "MESSAGE_VCS_MERGING": "Merging the file",
    "MESSAGE_VCS_MERGE_SUCCESS": "Selected file was merged successfully",
    "MESSAGE_VCS_MERGE_FAILURE": "Selected file could not be merged",
    "LABEL_VCS_FILE_CHANGES": "Changes",
    "LABEL_VCS_PROJECT_SYNC_CHANGES": "Sync Project Changes",
    "LABEL_PROJECT_CHANGES": "Project Changes",
    "LABEL_VCS_CONFLICT_CHANGES": "Conflict",
    "LABEL_TITLE_VCS_CONFLICT_RESOLVE": "Click here to Resolve Conflicts",
    "LABEL_VCS_CONFLICT_RESOLVE": "Resolve",
    "LABEL_VCS_NON_CONFLICT_CHANGES": "Non-conflict",
    "LABEL_HEADER_I18N_ADD_MESSAGE_KEY": "Add Message Key",
    "LABEL_I18N_MANAGE_LANGUAGES_BUTTON": "Manage Languages",
    "MESSAGE_VCS_FETCH_STATUS": "Fetching Contents ...",
    "MESSAGE_VCS_RESOLVE_CONFLICTS": "Resolving Conflicts",
    "MESSAGE_NO_FILE_CONFLICTS": "No merge conflicts found",
    "MESSAGE_NO_FILES_VIEW": "No changes to view",
    "MESSAGE_NO_FILES_PUSH": "No file changes to push",
    "MESSAGE_ERROR_CONFLICTS_FOUND": "Please resolve conflicts before performing any other action",
    "MESSAGE_VCS_PROVIDER": "This project is under version control provided by ${0}",
    "MESSAGE_PROGRESS_MORE_ACTIONS": "Checking for project changes...",
    "MESSAGE_VCS_PROJECT_PULL_MESSAGE_EXTRA": "More changes are available for pull.",
    "MESSAGE_VCS_PROJECT_PULL_MESSAGE": "The project needs to get the latest changes from Version Control System. Do you want to pull these changes?",
    "MESSAGE_VCS_PROJECT_PUSH_MESSAGE": "Your changes in the project can be updated to the Version Control System. Do you want to push these changes?",
    "LABEL_YES": "Yes",
    "LABEL_NO": "No",
    "MESSAGE_VCS_NEW_FILES_COMMIT_TEMPLATE": "New files added - [${0}]\n",
    "MESSAGE_VCS_MODIFIED_FILES_COMMIT_TEMPLATE": "Files modified - [${0}]\n",
    "MESSAGE_VCS_REMOVED_FILES_COMMIT_TEMPLATE": "Removed files - [${0}]\n",
    "LABEL_UPDATE_VERSION": "Update Version",
    "LABEL_WIDGET_PREFAB_STATUS_DEV": "MOD",
    "LABEL_WIDGET_PREFAB_STATUS_BUNDLED": "BDL",
    "MESSAGE_VCS_COMMIT_TEMPLATE": "New files added - [${0}]\nFiles modified - [${1}]\nRefactored files - [${2}]\nFixed bugs - [${3}]\nRemoved files - [${4}]",
    "MESSAGE_PREFAB_VERSION_UPGRADE": "Project upgraded from version ${0} to ${1}\n",
    "MESSAGE_PREFAB_ERROR_PATTERN_PROPERTY_NAME": "Name of the property(lowercase alphanumeric chars only)",
    "MESSAGE_PREFAB_ERROR_DUPLICATE_PROPERTY_NAME": "A property with the given name already exists. Please provide a different name.",
    "MESSAGE_PREFAB_ERROR_PATTERN_SERVER_PROPERTY_NAME": "Name of the property(maximum of 32 alphanumeric chars only)",
    "MESSAGE_PREFAB_VERSION_MISMATCH_DEVELOPMENT": "The prefab \"${0}\" is in a development state. The published version of the prefab is ${2}. Click ${3} for getting the published prefab in the project.",
    "MESSAGE_PREFAB_VERSION_MISMATCH_OLDER": "The project is using an older version of the prefab \"${0}\". The published version of the prefab is ${1}. Click ${2} for getting the published version in the project.",
    "MESSAGE_PREFAB_VERSION_MISMATCH_FUTURE": "The project is using a future version of the prefab \"${0}\". The published version of the prefab is ${2}. Click ${3} for getting the published version in the project.",
    "MESSAGE_PREFAB_VERSION_MISMATCH_CONFLICT": "The project is using the prefab \"${0}\" of version ${1}. The published version of the prefab is ${2}. Click ${3} for getting the published version in the project.",
    "MESSAGE_ORG_PREFAB_VERSION_MISMATCH_OLDER": "The project is using the older version of the prefab \"${0}\". Choose a version and click update for getting a published version in the project.",
    "MESSAGE_ORG_PREFAB_VERSION_MISMATCH_FUTURE": "The project is using the future version of the prefab \"${0}\". Choose a version and click revert for getting a published version in the project.",
    "MSG_ORG_PREFAB_VERSION_MISMATCH_DEVELOPMENT_UPDATE": "The prefab \"${0}\" is in a development state. Choose a version and click \"${1}\" for getting a published version in the project.",
    "MSG_ORG_PREFAB_VERSION_MISMATCH_DEVELOPMENT_REVERT": "The prefab \"${0}\" is in a development state. Click Revert for getting the published prefab in the project.",
    "MESSAGE_PREFAB_BEFORE_PUBLISH": "Few VCS Actions needs to be taken care before publishing the ${0} to Workspace. Do you want to continue?",
    "MESSAGE_THEME_VERSION_MISMATCH_OLDER": "The project is using an older version of the theme \"${0}\". The published version of the theme is ${2}. Click ${3} for getting the published version in the project.",
    "MESSAGE_THEME_VERSION_MISMATCH_FUTURE": "The project is using a future version of the theme \"${0}\". The published version of the theme is ${2}. Click ${3} for getting the published version in the project.",
    "MESSAGE_THEME_VERSION_MISMATCH_CONFLICT": "The project is using the theme \"${0}\" of version ${1}. The published version of the theme is ${2}. Click ${3} for getting the published version in the project.",
    "MESSAGE_ORG_THEME_VERSION_MISMATCH": "The project is using an older version of the theme \"${0}\". Click update for getting the published version in the project.",
    "MESSAGE_THEME_VERSION_MISMATCH_DEVELOPMENT": "The project is using the theme \"${0}\" which is in development state. Click \"${1}\" for getting the published theme in the project.",
    "MESSAGE_ARTIFACT_NOT_PUBLISHED": "This is not a published artifact.",
    "MESSAGE_BUNDLED_PREFAB": "This Prefab is bundled in the project.",
    "LABEL_MAKE_DEFAULT_THEME":"Default",
    "LABEL_SYSTEM_THEME":"System",
    "LABEL_IMPORTED_THEME":"Imported",
    "MESSAGE_ADD_THEME_TO_PROJECT":"Theme will be added to project.",
    "MESSAGE_REMOVE_THEME_TO_PROJECT":"Theme will be removed from project.",
    "MESSAGE_DELETE_PREFAB": "Delete this prefab from project.",
    "TITLE_DELETE_PREFAB_FROM_PROJECT": "Delete Prefab From Project",
    "MESSAGE_DELETE_PREFAB_FROM_PROJECT": "Are you sure you want to delete the prefab - \"${0}\" from this project?",
    "MESSAGE_DELETE_MESSAGE_PREFAB": "Deleting prefab from project...",
    "MESSAGE_SUCCESS_DELETE_PREFAB": "Prefab has been deleted successfully from this project.",
    "CAUTION_DELETE_PREFAB_FROM_PROJECT": "Make sure you remove all the occurrences of the prefab from all the pages in the project.",
    "MESSAGE_FAILURE_DELETE_PREFAB_1": "Error while deleting the prefab from the project.",
    "MESSAGE_FAILURE_DELETE_PREFAB_2": "Prefab - \"${0}\" can't be deleted from the project because it is being used in the following pages:",
    "MESSAGE_VCS_INVALID_FILE_CONTENT": "The JSON file contains invalid content",
    "MESSAGE_VCS_RESOLVE_CONFLICTS_BEFORE_PROCEED": "Please resolve the merge conflicts before proceeding to work. Not doing so may corrupt your project.",
    "No Event": "No Event",
  "LABEL_ERROR_LOG_ANALYSIS": "Error Log Analysis Report",
  "LABEL_SUMMARY":"Summary:",
  "LABEL_AI_SUGGESTION": "Suggestion:",
    "Javascript": "Javascript",
    "New ServiceVariable": "New Service Variable",
    "New LiveVariable": "New Live Variable",
    "New NavigationCall": "New Navigation Call",
    "New NotificationCall": "New Notification Call",
    "MESSAGE_HELP_MODEL_NAME": "Name of the model schema",
    "MESSAGE_HELP_MODEL_SCOPE": "Scope of the new model",
    "MESSAGE_HELP_MODEL_REGION": "Region of the model",
    "MESSAGE_HELP_MODEL_SCHEMA": "Import the model from the given list",
    "MESSAGE_HELP_MODEL_METADATA_SERVICE_URL": "Data Models are synced with the remote server pointed to by this Url.",
    "MESSAGE_HELP_TEST_META_SERVICE_URL": "Provide Meta Data Service Url and test the connection",
    "MESSAGE_HELP_DB_TYPE" : "Type of database server you are connecting to.",
    "MESSAGE_HELP_DB_HOST" :"Network host for the database. The default value is localhost, meaning that the database is located on the same computer that WaveMaker studio is running on.",
    "MESSAGE_HELP_DB_USERNAME" : "Username for connecting to the database server.",
    "MESSAGE_HELP_DB_PASSWORD" : "Password for connecting to the database server.",
    "MESSAGE_HELP_DB_SERVER" : "Name of the database on your database server.",
    "MESSAGE_HELP_MODEL_SERVER": "Name of the Model Schema",
    "MESSAGE_HELP_INSTANCE_NAME" : "Name of the SQLServer instance.",
    "MESSAGE_HELP_DB_SERVICE" :"Service name is the name that is added to the service tree, and the name ServiceVariables will use.",
    "MESSAGE_HELP_DB_PORT" : "Port number for the database. Typically this is set automatically when the database type is selected and should not be changed.",
    "MESSAGE_HELP_DB_URL" :"When you import/export a database using the standard configuration options on the Import/Export Database screen, WaveMaker Studio creates a JDBC URL. This URL is shown here in the Connection URL field. If you want to change this JDBC URL, you can do it here.",
    "MESSAGE_HELP_DB_JAVA_PACKAGE" : "WaveMaker Studio generates Java classes when you import/export a database. If you want a different Java package name than the default name we generate, type it in here.",
    "MESSAGE_HELP_DB_TABLE_FILTER" :"By default WaveMaker Studio imports/exports all the tables in the database. If you want to import/export only a subset of the tables, type in a comma-delimited list of regular expressions here.",
    "MESSAGE_HELP_DB_SCHEMA_NAME" : "When you are importing/exporting a database that supports schemas, WaveMaker Studio imports/exports only the tables for the default schema. If you want to import/export tables from other schemas, add the schema names in this field.",
    "MESSAGE_HELP_DB_SCHEMA_FILTER" : "When you are importing/exporting a database that supports schemas, WaveMaker Studio imports/exports only the tables for the default schema. If you want to import/export tables from other schemas, add the schema names as comma separated values in this field.",
    "MESSAGE_HELP_DB_READ_ONLY": "Modifications to the schema are not allowed.",
    "MESSAGE_HELP_DB_DRIVER" : "JDBC driver class name. WaveMaker Studio creates a JAR file for each database that uses a specified driver. If you want to use a different JAR file for connecting, specify it here (the JAR file must be in the Application Server's class path).",
    "MESSAGE_HELP_DB_DIALECT" :"Hibernate dialect. Most users should leave this blank.",
    "MESSAGE_HELP_DB_METADATA_DIALECT": "The implementation class name of the JDBCMetaDataDialect class to read the metadata of the database being imported.",
    "MESSAGE_HELP_DB_NAMEING_STRATEGY":"Most users should leave this blank. Enter the name of a java class you created for handling the naming strategy.",
    "MESSAGE_HELP_REST_URL":"Endpoint URL to test the target Service. Url will be encoded before testing.",
    "MESSAGE_HELP_REST_ADVANCED_SETTING":"Check this to configure advanced settings for the REST service",
    "MESSAGE_HELP_WEBSOCKET_TEST_NOT_REQUIRED":"Enable this if you want to import the service without testing. It is recommended to provide sample request & response body formats before proceeding.",
    "MESSAGE_HELP_USE_PROXY":"Disable the Use Proxy to make a direct call to the target API for bypassing the proxy server. There may be issues if the API does not allow Cross Origin Resource Sharing.<br><br><u>Note</u>: \nUse Proxy should be enabled if you want to configure a Header or Query param as a Server Side Property. A server side param is sent from the proxy server and is hidden from the UI.",
    "MSG_HELP_DISABLE_USE_PROXY": "One or more params (Header or Query) of this service are configured as a Server Side Property. Hence, Use Proxy cannot be disabled.",
    "MSG_HELP_DISABLED_PARAM_TYPE": "To configure this property, 'Use Proxy' should be enabled.",
    "MESSAGE_HELP_WITH_CREDENTIALS":"Check this if the cookies from the endpoint API should be set and honored by the browser.",
    "MESSAGE_HELP_HTTP_METHOD":"Choose appropriate HTTP method",
    "MESSAGE_HELP_CONTENT_TYPE":"Choose appropriate content type",
    "MESSAGE_TITLE_CONTENT_TYPE": "Add Custom Content Type",
    "MESSAGE_HELP_POST_DATA":"Provide sample POST data here that the service would consume",
    "MESSAGE_HELP_REST_BASIC_AUTH":"Check it to use BASIC HTTP authentication for the service",
    "MESSAGE_HELP_REST_BASIC_AUTH_USERNAME":"Username for BASIC HTTP authentication",
    "MESSAGE_HELP_REST_BASIC_AUTH_PASSWORD":"Password for BASIC HTTP authentication",
    "MESSAGE_HELP_ADD_HEADERS":"Add headers to the service call",
    "MESSAGE_HELP_RESPONSE":"View the response from web service here",
    "MESSAGE_TEST_SERVICE":"Test Service",
    "MESSAGE_IMPORT_SERVICE":"Import Service",
    "MESSAGE_HELP_SOAP_WSDL_SRC":"Choose WSDL File Source",
    "MESSAGE_HELP_SWAGGER_SRC": "Choose Swagger File Source",
    "MESSAGE_SOAP_PLACEHOLDER":"Enter WSDL Source URL",
    "MESSAGE_SWAGGER_PLACEHOLDER": "Enter Swagger Source URL",
    "MESSAGE_HELP_SOAP_BINDINGS_XML":"Provide .xjb file to map Java classes to XML representations.",
    "MESSAGE_HELP_SOAP_SERVICE_NAME":"Imported Service Name (alphanumeric characters). If left empty, it is automatically generated by studio",
    "MESSAGE_HELP_SOAP_PACKAGE_NAME":"Imported Package Name (alphanumeric characters). If left empty, it will take your project package",
    "MESSAGE_PLACEHOLDER_SOAP_SERVICE_NAME":"Enter Service Name (Optional)",
    "MESSAGE_PLACEHOLDER_SOAP_PACKAGE_NAME":"Enter Package Name (Optional)",
    "MESSAGE_HELP_OPEN_API_SERVICE_NAME":"Imported Service Name (alphanumeric characters).",
    "MESSAGE_HELP_WEBSOCKET_MESSAGES":"The messages returned by the WebSocket service. Select one of the messages as a sample response body",
    "MESSAGE_HELP_WEBSOCKET_RESPONSE":"This response body will be treated as default response returned by the service. The meta data against Variables created for this service will be in accordance with this response.",
    "MESSAGE_HELP_AUTO_CREATE_VARIABLES":"Uncheck this if you do not want Studio to create variables corresponding to the service after it is imported",
    "MESSAGE_HELP_VARIABLE_BIND_HINT":"<b>Hint:</b> Select a node in left panel to bind to an available component",
    "MESSAGE_HELP_VARIABLE_FILTER_TYPE":"Filter variables by type",
    "MESSAGE_HELP_VARIABLE_FILTER_NAME":"Filter variables by name",
    "MESSAGE_PLACEHOLDER_SELECT_DATA_SOURCE":"Select a source",
    "MESSAGE_PLACEHOLDER_SELECT":"Select a ",
    "MESSAGE_HELP_VARIABLE_TYPE":"Select Type of Variable you want to create",
    "MESSAGE_HELP_VARIABLE_NAME":"Enter name of the new variable",
    "MESSAGE_HELP_VARIABLE_OWNER":"Select scope of the variable, 'Page' variable is available only in that page while 'Application' variable is available throughout the app",
    "MESSAGE_HELP_VARIABLE_ATTR_BIND":"You can provide value to this field or bind it to a WaveMaker component (variable, component, etc)",
    "MESSAGE_HELP_VARIABLE_FILTER_FIELD_OPTIONAL":"Optional : This criteria can be made optional. The optional criteria will not be included in the final query if the value is not available",
    "MESSAGE_HELP_APP_VARIABLE_ATTR_BIND":"You can provide value to this field or bind it to the Application level variable",
    "MESSAGE_HELP_VARIABLE_ADD_NEW":"Add new Variable of selected type",
    "MESSAGE_HELP_VARIABLE": {
        "SPINNERCONTEXT": "This property specifies on which UI component the spinner should show.",
        "SPINNERMESSAGE": "The message to be displayed below the spinner.",
        "HEADER_HELP_TEXT": {
            "SPINNER": "This section contains the fields to configure the spinner. If configured, a spinner will be displayed in the UI while the variable is in-flight."
        },
        "wm.Variable": {
            "TYPE": "Select the type of static variable, string, number, etc. Selecting a generated service type will create a static structure based on that type",
            "ISLIST": "Check this if you want the variable to be an array of selected type",
            "TWOWAYBINDING": "Aktivieren Sie diese Option, wenn für die Variable die bidirektionale Bindung aktiviert werden soll",
            "HEADER_HELP_TEXT": {
                "JSON": "Here you can edit the structure of dataset your variable holds, through text editor you can do so by editing the variable json",
                "INPUTFIELDS": "Here you can provide values to the various fields in the variable by entering value or binding it to a WaveMaker component"
            }
        },
        "wm.ServiceVariable": {
            "SERVICE": "Select the service out of imported/created services",
            "OPERATION": "This property lists the operations available based on the service selected. Depending on the operation you select, operation-specific input parameters become available. To access these properties, select the Data tab",
            "AUTOUPDATE": "Check this if you want to trigger the variable automatically on change of any input fields(under Data section)",
            "STARTUPDATE": "Check this if you want to trigger the variable on load. If checked, 'Page' variable will be triggered on page load while 'Application' variable will be triggered on application load",
            "INFLIGHTBEHAVIOR": "Select appropriate behavior for the variable when it is in-flight",
            "TRANSFORMATIONREQUIRED": "Check this if the service returns data and corresponding mapping keys/columns in separate fields of the returned data",
            "COLUMNFIELD": "Select the field that has array of columns to map data",
            "DATAFIELD": "Select the field that has array of data against the columns",
            "MAXRESULTS": "This property specifies the number of rows to return from the database at a time. Used in conjunction with the dataNavigator component, it allows the user to page through data in a data table.",
            "DESIGNMAXRESULTS": "Limits the number of results for queries made; only used within studio; see maxResults to limit the number at runtime.",
            "ONCANUPDATE": "A given service variable may only be firing once at a given time; as such, a service variable waiting for a response from the server will ignore any calls to update. Call canUpdate() if you want to find out if the service variable is able to send a request. canUpdate also tests the result of any custom onCanUpdate method you've provided.",
            "ONBEFOREUPDATE": "This event is triggered before the ServiceVariable is updated. This event handler gives you the opportunity to manipulate the data before your variable is assigned this value. The order of events is: onBeforeUpdate, onResult, onBeforeDatasetReady, onSuccess, onCanUpdate",
            "ONBEFOREDATASETREADY": "This event is triggered just before the Variable's dataSet is updated with the response received from the target service on success. You can manipulate this data in a JavaScript function and return the same.",
            "ONRESULT": "This event is triggered after the Service Variable is updated. onResult is triggered whether or not there was an error generated, i.e. it is triggered for both success & error situations. The order of events is: onBeforeUpdate, onResult, onBeforeDatasetReady, onSuccess, onCanUpdate",
            "ONSUCCESS": "This event is triggered after the Service Variable is updated. onSuccess is triggered whenever a service returns successfully. The order of events is: onBeforeUpdate, onResult, onBeforeDatasetReady, onSuccess, onCanUpdate",
            "ONERROR": "This event is triggered if there is an error generated during the Service call.",
            "HEADER_HELP_TEXT": {
                "SERVICE": "Provide the source information for the ServiceVariable here",
                "BEHAVIOR": "Configure properties that guide the behavior of ServiceVariable",
                "INPUTFIELDS": "This section contains the fields that are input parameters to the selected service. You can provide them values by entering manually or binding it to a WaveMaker component",
                "DATATRANSFORMATION": "This section is useful for mapping the keys and columns from separate fields of the data returned by the service"
            }
        },
        "wm.LiveVariable": {
            "LIVESOURCE": "This property specifies the data source for Variable, one of the imported or created database services.",
            "TYPE": "This property specifies the data type for the Variable, typically either a database table name or a Live View.",
            "OPERATION": "This property specifies the default operation to be performed when the Variable is assigned to some component. The options are 'Read', 'Insert', 'Update', 'Delete'.",
            "AUTOUPDATE": "Check this if you want to trigger the variable automatically on change of any input fields(under Data section)",
            "STARTUPDATE": "Check this if you want to trigger the variable on load. If checked, 'Page' variable will be triggered on page load while 'Application' variable will be triggered on application load",
            "INFLIGHTBEHAVIOR": "Select appropriate behavior for the variable when it is in-flight",
            "MAXRESULTS": "This property specifies the number of rows to return from the database at a time. Used in conjunction with the dataNavigator component, it allows the user to page through data in a data table.",
            "DESIGNMAXRESULTS": "Limits the number of results for queries made; only used within STUDIO i.e DESIGN mode; set maxResults to limit the number at runtime.",
            "IGNORECASE": "If this property is checked, the filter will ignore case. For example, \"wa\" will match \"WaveMaker\". Enabling this option could result in many rows being returned from queries.",
            "MATCHMODE": "This property specifies how to apply the filter. The options are:\nStart: match characters at the front of the string. For example, \"Wa\" would match \"WaveMaker\".\nEnd: match characters at the end of the string. For example, \"Maker\" would match \"WaveMaker\".\nAnywhere: match characters anywhere in the string. For example, \"ve\" would match \"WaveMaker\".\nExact: match all characters the string. For example, only \"WaveMaker\" would match \"WaveMaker\".",
            "ORDERBY": "This property defines how to sort the data returned by a query. Specify a column name and a direction (asc: for ascending or desc: for descending).\nFor example, to sort a Customer Live Variable by company name in ascending alphabetic order, then by state in descending order, enter the following orderBy property:\nfield1 asc,field2 desc",
            "ONCANUPDATE": "A given Live Variable may only be firing once at a given time; as such, a Live Variable waiting for a response from the server will ignore any calls to update. Call canUpdate() if you want to find out if the Live Variable is able to send a request. canUpdate also tests the result of any custom onCanUpdate method you've provided.",
            "ONBEFOREUPDATE": "This event is triggered before the Live Variable is updated. This event handler gives you the opportunity to manipulate the data before your variable is assigned this value. The order of events is: onBeforeUpdate, onResult, onBeforeDatasetReady, onSuccess, onCanUpdate",
            "ONBEFOREDATASETREADY": "This event is triggered just before the Variable's dataSet is updated with the response received from the target service on success. You can manipulate this data in a JavaScript function and return the same.",
            "ONRESULT": "This event is triggered after the Live Variable is updated. onResult is called whether or not there was an error generated. The order of events is: onBeforeUpdate, onResult, onBeforeDatasetReady, onSuccess, onCanUpdate",
            "ONSUCCESS": "This event is triggered after the Live Variable is updated. onSuccess is triggered whenever a service returns successfully. The order of events is: onBeforeUpdate, onResult, onBeforeDatasetReady, onSuccess, onCanUpdate",
            "ONERROR": "This event is triggered if there is an error generated during the Service call.",
            "HEADER_HELP_TEXT": {
                "SERVICE": "Provide the source information for the LiveVariable here",
                "BEHAVIOR": "Configure properties that guide the behavior of LiveVariable",
                "INPUTFIELDS": "This section contains the fields that are input parameters to the selected service. You can provide them values by entering manually or binding it to a WaveMaker component",
                "FILTERFIELDS": "This section contains the fields that are input parameters to the selected service. You can provide them values by entering manually or binding it to a WaveMaker component",
                "DATATRANSFORMATION": "This section is useful if the selected service returns data and corresponding mapping keys/columns in separate fields of the data",
                "SERVEROPTIONS": "This section lists properties used by the variable while fetching results from the database at server"
            }
        },
        "wm.DeviceVariable": {
            "SERVICE": "Choose the api service.",
            "OPERATION": "Choose the operation to invoke.",
            "EVENTTITLE": "Event Title",
            "EVENTNOTES": "Event Notes",
            "EVENTLOCATION": "Event Location",
            "EVENTSTART": "Event Start",
            "EVENTEND": "Event End",
            "AUTOUPDATE": "Check this if you want to trigger the variable automatically on change of any input fields(under Data section).",
            "STARTUPDATE": "Check this if you want to trigger the variable on load. If checked, 'Page' variable will be triggered on page load while 'Application' variable will be triggered on application load.",
            "RECURRINGEVENT": "Recurring event",
            "RECURRINGEVENTFREQUENCY": "Recurring event frequency",
            "BARCODEFORMAT": "Format of bar code to scan",
            "ALLOWIMAGEEDIT": "Allow editing of the image",
            "IMAGEQUALITY": "Quality of the saved image, expressed as a range of 0-100, where 100 is typically full resolution with no loss from file compression.",
            "IMAGETARGETWIDTH":"This property specifies the width to resize the image.",
            "IMAGETARGETHEIGHT":"This property specifies the height to resize the image.",
            "IMAGEENCODINGTYPE": "Choose the returned image file's encoding.",
            "CORRECTORIENTATION": "Rotate the image to correct for the orientation of the device during capture.",
            "SAVETOPHOTOALBUM": "Save the image to the photo album on the device after capture.",
            "GEOLOCATIONHIGHACCURACY": "Provides a hint that the application needs the best possible results.",
            "GEOLOCATIONMAXIMUMAGE": "Accept a cached position whose age is no greater than the specified time in milliseconds.",
            "GEOLOCATIONTIMEOUT": "The maximum length of time (milliseconds) that is allowed for the execution.",
            "CONTACTFILTER": "Contact filter text",
            "VIBRATIONTIME": "Amount of time in seconds to vibrate",
            "CLEARDATA": "If this property is true, then all data (except BUNDLED) will be removed before pulling data.",
            "FILETYPE": "Type of the file to open",
            "FILEPATH": "URL of file",
            "SHOWPROGRESS": "If this property is true, then the progress of variable operation is shown with progress bar.",
            "ONSUCCESS": "The function to invoke on the success of device variable",
            "ONERROR": "The function to invoke on the error of device variable",
            "ONPROGRESS": "The function to invoke as operation progresses.",
            "ONBEFORE": "The function to invoke before starting the operation.",
            "ONONLINE": "The function to invoke when the device goes online.",
            "ONOFFLINE": "The function to invoke when the device goes offline.",
            "HEADER_HELP_TEXT": {
                "SERVICE": "Provide the source information for the device variable here",
                "BEHAVIOR": "Configure properties that guide the behavior of DeviceVariable."
            }
        },
        "wm.LoginVariable": {
            "BEHAVIOUR": "Configure properties that guide the behavior of LoginVariable.",
            "USEDEFAULTSUCCESSHANDLER": "Choose the operation if you want the user to be navigated to the configured landing page based on user roles.",
            "AUTOUPDATE": "Check this if you want to trigger the variable automatically on change of any input fields(under Data section).",
            "STARTUPDATE": "Check this if you want to trigger the variable on load. If checked, 'Page' variable will be triggered on page load while 'Application' variable will be triggered on application load.",
            "INPUTFIELDS": "This section contains the fields that are input parameters to the selected service. You can provide them values by entering manually or binding it to a WaveMaker component.",
            "INFLIGHTBEHAVIOR": "Select appropriate behavior for the variable when it is in-flight.",
            "USERNAME": "Provide the username to be used for logging-in.",
            "PASSWORD": "Provide the password to be used for logging-in.",
            "ONCANUPDATE": "A given login variable may only be firing once at a given time; as such, a login variable waiting for a response from the server will ignore any calls to update. Call canUpdate() if you want to find out if the login variable is able to send a request. canUpdate also tests the result of any custom onCanUpdate method you've provided.",
            "ONBEFOREUPDATE": "This event is triggered before the Login Variable is updated. This event handler gives you the opportunity to manipulate the data before your variable is assigned this value. The order of events is: onBeforeUpdate, onResult, onSuccess, onBeforeDatasetReady, onCanUpdate.",
            "ONBEFOREDATASETREADY": "This event is triggered just before the Variable's dataSet is updated with the response received from the target service on success. You can manipulate this data in a JavaScript function and return the same.",
            "ONRESULT": "This event is triggered after the Login Variable is updated. onResult is triggered whether or not there was an error generated, i.e. it is triggered for both success & error situations. The order of events is: onBeforeUpdate, onResult, onSuccess, onBeforeDatasetReady, onCanUpdate.",
            "ONSUCCESS": "This event is triggered after the Login Variable is updated. onSuccess is triggered whenever a service returns successfully. The order of events is: onBeforeUpdate, onResult, onSuccess, onBeforeDatasetReady, onCanUpdate.",
            "ONERROR": "This event is triggered if there is an error generated during the Service call.",
            "HEADER_HELP_TEXT": {
                "BEHAVIOR": "Configure properties that guide the behavior of LoginVariable",
                "INPUTFIELDS": "This section contains the fields that are input parameters to the selected service. You can provide them values by entering manually or binding it to a WaveMaker component"
            }
        },
        "wm.LogoutVariable": {
            "BEHAVIOUR": "Configure properties that guide the behavior of LogoutVariable.",
            "USEDEFAULTSUCCESSHANDLER": "Choose the operation if you want the user to be navigated to the configured login page.",
            "INFLIGHTBEHAVIOR": "Select appropriate behavior for the variable when it is in-flight.",
            "REDIRECTTO": "Select the page to redirect on successful calling of LogoutVariable.",
            "ONCANUPDATE": "A given logout variable may only be firing once at a given time; as such, a logout variable waiting for a response from the server will ignore any calls to update. Call canUpdate() if you want to find out if the logout variable is able to send a request. canUpdate also tests the result of any custom onCanUpdate method you've provided.",
            "ONBEFOREUPDATE": "This event is triggered before the Logout Variable is updated. This event handler gives you the opportunity to manipulate the data before your variable is assigned this value. The order of events is: onBeforeUpdate, onResult, onBeforeDatasetReady, onSuccess, onCanUpdate",
            "ONBEFOREDATASETREADY": "This event is triggered just before the Variable's dataSet is updated with the response received from the target service on success. You can manipulate this data in a JavaScript function and return the same.",
            "ONRESULT": "This event is triggered after the Logout Variable is updated. onResult is triggered whether or not there was an error generated, i.e. it is triggered for both success & error situations. The order of events is: onBeforeUpdate, onResult, onBeforeDatasetReady, onSuccess, onCanUpdate",
            "ONSUCCESS": "This event is triggered after the Logout Variable is updated. onSuccess is triggered whenever a service returns successfully. The order of events is: onBeforeUpdate, onResult, onBeforeDatasetReady, onSuccess, onCanUpdate",
            "ONERROR": "This event is triggered if there is an error generated during the Service call.",
            "HEADER_HELP_TEXT": {
                "BEHAVIOR": "Configure properties that guide the behavior of LogoutVariable"
            }
        },
        "wm.TimerVariable": {
            "AUTOSTART": "Check this if you want to ensure that the timer starts at page load.",
            "DELAY": "Defines the time delay, in msecs, before triggering the specified event.",
            "REPEATING": "Specifies whether the timer is one-time or a repeating event.",
            "ONTIMERFIRE": "Event to be triggered on the completion of the timer.",
            "HEADER_HELP_TEXT": {
                "BEHAVIOR": "Configure properties that guide the behavior of TimerVariable"
            }
        },
        "wm.NotificationVariable": {
            "HEADER_HELP_TEXT": {
                "SERVICE": "Provide the operation type for the notification call here",
                "INPUTS": "This section lists properties used by the variable while displaying the notification"
            },
            "CONTENT": "Choose the content type to be displayed in Toast",
            "TITLE": "The text to be shown in the title of the notification call",
            "DURATION": "Duration of the toaster to be displayed for given number of milliseconds",
            "CLASS": "Choose the toast type",
            "TOASTERPOSITION": "Based on the position selected, the toast will be displayed accordingly",
            "ONCLICK": "The function to be triggered on click of Toaster",
            "ONHIDE": "The function to be triggered on hide of Toaster after the given duration",
            "SERVICE": "Choose the api service.",
            "OPERATION": "Based on the operation selected, the NotificationVariable will notify in the form of \"alert-box\", \"confirmation-box\" or \"toaster\"",
            "TEXT": "The text to be shown in the notification call",
            "PAGE": "Choose the Partial page to be displayed in the toaster",
            "OKBUTTONTEXT": "The text to be shown on click of ok button in the notification call",
            "CANCELBUTTONTEXT": "The text to be shown on click of cancel button in the notification call",
            "ALERTTYPE": "The type of alert to be shown for the notification call",
            "ONOK": "The function to be triggered on click of OK button",
            "ONCANCEL": "The function to be triggered on click of Cancel button",
            "ONCLOSE": "The function to be triggered on close"
        },
        "wm.NavigationVariable": {
            "HEADER_HELP_TEXT": {
                "SERVICE": "Provide the operation type for the navigation call here",
                "INPUTS": "This section lists properties used by the variable while displaying the notification"
            },
            "SERVICE": "Choose the api service.",
            "OPERATION": "Select the target for navigation for the variable. The options are:\n \"goToAccordion\": navigation target is an accordion\n \"goToPage\": navigation target is a page\n \"goToTab\": navigation target is a tab\n \"goToView\": navigation target is a view.",
            "INPUTS": "Choose the inputs.",
            "PAGENAME": "Choose the page to navigate on call of the navigation variable.",
            "TABNAME": "Choose the tab to navigate on call of the navigation variable.",
            "ACCORDIONNAME": "Choose the accordion to navigate on call of the navigation variable."
        },
        "wm.WebSocketVariable": {
            "SERVICE": "Target WebSocket service",
            "STARTUPDATE": "Connection will be established with the target service on page load.",
            "DATAUPDATESTRATEGY": "Determine what to do with data received from the variable.\n\n1. Refresh dataSet, dataSet will be updated with the data received.\n2. Add as last record, data will be appended at the end of dataSet. Latest data will be the last record in dataSet\n3. Add as first record, data will be prepended at the beginning of dataSet. Latest data will be the first record in dataSet",
            "DATALIMIT": "Maximum number of messages that dataSet will hold. Set it to 0 if no such upper limit is required.",
            "ONBEFOREOPEN": "The event is triggered just before the Variable attempts to establish a connection between the client and target Websocket service. If returned false from here, the connection establishment will be aborted.",
            "ONOPEN": "The event is triggered right after a successful connection is established between client and the Websocket service through the Variable.",
            "ONBEFOREMESSAGESEND": "The event is triggered just before the Variable attempts to send a message to the target service through the existing connection. User has a chance at this point to validate and edit the data to be sent to the service. Returning false from this event will prevent the message to be sent to the service.",
            "ONMESSAGERECEIVE": "The event is triggered on the Variable when a message is received from the Websocket service in an existing connection made by the Variable",
            "ONBEFORECLOSE": "Triggered before an existing connection(opened by the Variable) is closed. Returning false from here will abort the closing of the connection.",
            "ONCLOSE": "Triggered after the connection is closed.",
            "ONERROR": "Triggered if an error is encountered in establishing a connection with the server in the open phase."
        },
        "BY_SERVICE": {
            "database": {
                "LIVESOURCE": "Select database service",
                "TYPE": "Select table to perform CRUD operation on",
                "OPERATION": "Type of operation to perform on the table"
            },
            "databaseapi": {
                "LIVESOURCE": "Select one of the imported or created database services",
                "TARGET": "Select the type of API generated for the database",
                "TABLE": "Select table for which API will be invoked",
                "OPERATION": "Select the required API for the table. If API requires any inputs, it can be configured from the Data tab after the variable is created."
            },
            "web": {
                "SERVICE": "Select one of the imported REST, SOAP, WebSocket services"
            },
            "openapi": {
                "SERVICE": "Select one of the imported Swagger services",
                "TARGET": "Select the type of Variable you want to create (Entities to perform CRUD or Other Endpoints to perform a single operation)",
                "ENTITY": "Select entity for which APIs will be invoked"
            }
        }
    },
    "LABEL_VARIABLE_SERVICETYPE": {
        "database": "Database CRUD",
        "databaseapi": "Database APIs",
        "web": "Web Service",
        "openapi": "Imported APIs",
        "java": "Java Service",
        "security": "Security Service",
        "custom": "Model",
        "navigation": "Navigation",
        "notification": "Notification",
        "login": "Login",
        "logout": "Logout",
        "timer": "Timer",
        "device": "Device",
        "all": "All"
    },
    "MSG_VARIABLE_SERVICE_TYPE_HELP": {
        "database": "Perform Create, Read, Update and Delete operations on a DB Entity in the app",
        "databaseapi": "APIs generated for Database Tables, Queries and Procedures in the app",
        "openapi": "APIs generated for an imported OpenAPI/Swagger  document",
        "web": "APIs generated for REST, SOAP, WebSocket services in the app",
        "java": "APIs generated for Java Services in the app",
        "security": "APIs generated for Security Service in the app",
        "custom": "Storage model to store data on the client",
        "navigation": "Perform navigation to a page, tab, accordion or segment",
        "notification": "Action to show UI notifications in the app in form of a toaster, alert or a confirmation box",
        "login": "Perform user login in the app",
        "logout": "Perform user logout in the app",
        "timer": "Trigger an action in a specified time interval",
        "device": "Access native device capabilities like Camera, Contacts, Calendar, etc."
    },
    "LABEL_VARIABLE_SERVICETYPE_GROUP": {
        "database": "Database CRUD",
        "api": "APIs",
        "other": "Others"
    },
    "LABEL_VARIABLE_PROPERTY": {
        "wm.LiveVariable": {
            "liveSource": "Database",
            "type": "Table"
        },
        "wm.ServiceVariable": {
            "operation": "Method"
        },
        "wm.CrudVariable": {
            "startUpdate": "Request list data on page load",
            "autoUpdate": "Update list data on input change"
        },
        "wm.WebSocketVariable": {
            "startUpdate": "Connect on page load",
            "dataUpdateStrategy": "On New Data"
        },
        "wm.NavigationVariable": {
            "operation": "Navigation Target",
            "pageName": "Page Name"
        },
        "wm.NotificationVariable": {
            "operation": "Notification Type",
            "onOk": "onOk",
            "onCancel": "onCancel",
            "onBeforeClose": "onBeforeClose",
            "onClose": "onClose",
            "onClick": "onClick",
            "onHide": "onHide"
        },
        "wm.TimerVariable": {
            "autoStart": "Trigger on page load",
            "delay": "Trigger after a delay (milliseconds)",
            "repeating": "Repeat after delay",
            "onTimerFire": "onTimerFire"
        }
    },
    "LABEL_PROPERTY_OPTIONS": {
        "BY_WIDGET": {
            "wm-icon": {
                "iconposition": {
                    "left": "Left",
                    "right": "Right"
                }
            },
            "wm-chart": {
                "shape": {
                    "circle": "circle",
                    "cross": "cross",
                    "diamond": "diamond",
                    "random": "random",
                    "square": "square",
                    "triangle-down": "triangle-down",
                    "triangle-up": "triangle-up"
                },
                "showlegend": {
                    "hide": "hide",
                    "top": "top",
                    "bottom": "bottom"
                },
                "showlabels": {
                    "hide": "hide",
                    "inside": "inside",
                    "outside": "outside"
                },
                "interpolation": {
                    "linear": "linear",
                    "cardinal": "cardinal",
                    "step": "step"
                },
                "areaviewtype": {
                    "stack": "stack",
                    "stream": "stream",
                    "expand": "expand"
                },
                "viewtype": {
                    "Grouped": "Grouped",
                    "Stacked": "Stacked"
                },
                "barspacing": {
                    "small": "Small",
                    "medium": "medium",
                    "large": "large"
                },
                "donutratio": {
                    "small": "Small",
                    "medium": "medium",
                    "large": "large"
                },
                "xdomain": {
                    "Default": "Default",
                    "Min": "Min"
                },
                "ydomain": {
                    "Default": "Default",
                    "Min": "Min"
                }
            },
            "wm-carousel": {
                "animation": {
                    "auto": "auto",
                    "none": "none"
                }
            },
            "wm-tabs": {
                "tabsposition": {
                    "left": "left",
                    "top": "top",
                    "right": "right",
                    "bottom": "bottom"
                }
            }
        },
        "BY_PROPERTY": {
            "datafield": {
                "All Fields": "All Fields"
            },
            "overflow": {
                "visible":"visible",
                "hidden": "hidden",
                "scroll": "scroll",
                "auto": "auto",
                "initial": "initial",
                "inherit": "inherit"
            },
            "inputposition": {
                "first": "first",
                "last": "last"
            },
            "inputwidth": {
                "default": "default",
                "full": "full"
            },
            "captionposition": {
                "left": "left",
                "right": "right",
                "top": "top",
                "floating": "floating"
            },
            "layout": {
                "inline": "inline",
                "stacked": "stacked"
            },
            "badgetype": {
                "default": "default",
                "primary": "primary",
                "success": "success",
                "info": "info",
                "warning": "warning",
                "danger": "danger"
            },
            "transition": {
                "none": "none",
                "slide": "slide"
            },
            "iconposition": {
                "left": "left",
                "top": "top",
                "right": "right"
            },
            "audiopreload": {
                "none": "none",
                "metadata": "metadata",
                "auto": "auto"
            },
            "type": {
                "image": "image",
                "icon": "icon"
            }
        }
    },
    "LABEL_GROUPED_LIST_OPTIONS": {
        "Thousand" : "Thousand (Eg: 9K)",
        "Million"  : "Million (Eg: 9M)",
        "Billion"  : "Billion (Eg: 9B)",
        "%c" : "Date and Time",
        "%X" : "Time(%H:%M:%S)",
        "%H" : "In 24 hours [00-23]",
        "%I" : "In 12 hours [01-12]",
        "%M" : "Minutes [00-59]",
        "%S" : "Seconds [00-59]",
        "%L" : "MilliSeconds [000, 999]",
        "%p" : "either AM or PM",
        "%Z" : "Time zone offset",
        "%d" : "Zero padded day of month (Eg: 01)",
        "%e" : "Space padded day of month (Eg:  1)",
        "%j" : "Day of the year (Eg: 01-31-2016 returns 031)",
        "%a" : "Abbreviated weekday name (Eg: Wed)",
        "%A" : "Full weekday name (Eg: Wednesday)",
        "%U" : "Week number of the year(Sunday first day) (Eg: 01-31-2016 returns 05)",
        "%W" : "Week number of the year(Monday first day) (Eg: 01-31-2016 returns 04)",
        "%w" : "Week day[0(Sunday),6]  (Eg: 01-30-2016 returns 6)",
        "%b" : "Abbreviated month name (Eg: Mar)",
        "%B" : "Full month name  (Eg: March)",
        "%m" : "Month number  (Eg: 02) [01-12]",
        "%y" : "yy (Eg: 16)",
        "%Y" : "yyyy (Eg: 2016)"
    },
    "LABEL_EVENT_OPTION": {
        "No Event": "No Event",
        "Javascript": "Javascript",
        "Stop Propagation": "Stop Propagation",
        "New Variable": "New Variable",
        "New Action": "New Action"
    },
    "LABEL_NO_FILTER": "No Filter",
    "LABEL_MULTI_COLUMN": "Multi Column",
    "LABEL_PERCENTAGE": "Percentage",
    "LABEL_KEY_VALUE": "key, value",
    "LABEL_ALPHABET": "alphabet",
    "LABEL_WORD": "word",
    "LABEL_DECIMAL_DIGITS": "Decimal Digits",
    "LABEL_PRECISION": "Precision",
    "LABEL_STARTS_WITH_IGNORE_CASE": "Starts with ignore case",
    "LABEL_STARTS_WITH": "Starts with",
    "LABEL_ENDS_WITH_IGNORE_CASE": "Ends with ignore case",
    "LABEL_ENDS_WITH": "Ends with",
    "LABEL_CONTAINS_IGNORE_CASE": "Contains ignore case",
    "LABEL_CONTAINS": "Contains",
    "LABEL_IS_EQUAL_WITH_IGNORE_CASE": "Is equal to ignore case",
    "LABEL_IS_EQUAL": "Is equal to",
    "MESSAGE_HELP_MSG_KEY": "Unique identifier key for the new message. The message will be referred with this key",
    "MESSAGE_HELP_MSG_VAL": "Message value against the locale",
    "MESSAGE_SUCCESS_SAVE_PROJECT_SETTINGS": "Project settings updated successfully.",
    "MESSAGE_SUCCESS_SAVE_PREFAB_SETTINGS": "Prefab settings updated successfully.",
    "MESSAGE_FAILURE_SAVE_PREFAB_SETTINGS": "An error occurred while updating Prefab settings.",
    "MESSAGE_SUCCESS_SAVE_TEMPLATE_SETTINGS": "Template settings updated successfully.",
    "MESSAGE_ERROR_ADD_FOLDER": "An error occurred while adding the folder. Please check server logs for more information.",
    "MESSAGE_ERROR_INVALID_DATALIMIT":"Not setting an upper limit to the number of records might slow down the application over the time",
    "API_DESIGNER_MESSAGE_RESOURCES":"---------API Designer Message Resources----------",
    "API_DESIGNER_FILE_NOTE":"Note : Apis for file upload and download cannot be tested in the studio.",
    "LABEL_CORE_APIS":"Core APIs",
    "LABEL_PROJECT_CONFIGURATION": "Project Configuration",
    "LABEL_REFLECT_APIS":"Reflect APIs",
    "LABEL_APIS_TEAM_APPLNS":"Team Applications",
    "LABEL_APIS_EDN_APPLNS":"EDN Applications",
    "LABEL_ENDPOINTS":"Endpoints",
    "LABEL_DESCRIPTION":"Description",
    "LABEL_LOCATION": "Location",
    "LABEL_SUGGESTION": "Suggestion",
    "LABEL_METHOD_URL": "method url",
    "LABEL_METHOD_DESCRIPTION": "method description",
    "LABEL_PARAMETER_NAME": "parameter name",
    "LABEL_PARAMETER_DESCRIPTION": "parameter description",
    "LABEL_API_DESCRIPTION": "api description",
    "LABEL_API_TEST_VALUE": "enter value to test",
    "MESSAGE_API_TEST_FAIL_ID_MISSING": "Required field(s) missing: ",
    "LABEL_REQUEST_URL":"Request Url",
    "LABEL_REQUEST_PARAMETERS": "Request Parameters",
    "LABEL_REQUEST_CONTENTTYPE": "Request Content Type",
    "LABEL_IMPLEMENTATION_NOTES": "Implementation Notes",
    "LABEL_PARAMETER" :"Parameter",
    "LABEL_PARAMETER_TYPE" :"Parameter Type",
    "LABEL_DATA_TYPE": "Data Type",
    "LABEL_REQUIRED": "required",
    "LABEL_RESPONSE_CONTENTTYPE": "Response Content Type",
    "LABEL_RESPONSE_HEADERS": "Response Headers",
    "LABEL_RESPONSE_FORMAT": "Response Format",
    "LABEL_RESPONSE_MESSAGES": "Response Messages",
    "LABEL_HTTP_STATUS_CODE": "HTTP Status Code",
    "LABEL_REASON": "Reason",
    "LABEL_OPERATION": "Operation",
    "LABEL_LOADING_TEAM_PROJECTS":"Loading Team projects...",
    "LABEL_LOADING_EDN_PROJECTS":"Loading EDN projects...",
    "LABEL_LOADING_API_LIST":"Loading APIs list...",
    "LABEL_PREPARING_APIS":"Preparing APIs for selected service...",
    "LABEL_LOADING_API_ENDPOINT":"Loading selected API endpoint details",
    "LABEL_DEFINE":"Define",
    "LABEL_TEST":"Test",
    "LABEL_METHOD_TYPE":"Method Type",
    "LABEL_FOUND": "found",
    "LABEL_CLICK_ON":"Click on",
    "LABEL_NO_VARIABLE_MESSAGE":"on left to create new",
    "LABEL_NO_SERVICE_FOUND": "No service found for the selected service type",
    "LABEL_NO_TEAM_PROJECT_FOUND": "No project found in Team with published APIs",
    "LABEL_NO_EDN_PROJECT_FOUND": "No project found in EDN with published APIs",
    "LABEL_NO_API_FOUND": "No API found",
    "LABEL_NO_DESC_FOUND": "No description found",
    "LABEL_ENTITIES": "Entities",
    "LABEL_QUERIES": "Queries",
    "LABEL_PROCEDURES": "Procedures",
    "LABEL_PARAM_MISSING": "Parameter Missing",
    "LABEL_PARAM_NAME_EXIST": "Parameter with name \"${0}\" already exist.",
    "LABEL_TESTING_API": "Testing...",
    "MESSAGE_PROVIDE_PARAM": "Please provide missing parameter",
    "MESSAGE_SUCCESS_UPDATE_API": "Successfully updated the API",
    "MESSAGE_ERROR_UPDATE_API": "Error occurred while updating the API",
    "MESSAGE_DEVICE_PREVIEW": "In device preview mode, content cannot be edited",
    "MESSAGE_ERROR_MARKUP": "Detected invalid/extra content at the beginning or end of the page markup that might lead to error in application run. Please rectify.",
    "MESSAGE_DB_NO_UPDATE_PREVIEW_DESCRIPTION" : "Your changes do not affect the database, sources will be regenerated.",
    "LABEL_PROJECT_PROPERTIES": "Project Properties",
    "LABEL_PREFAB_PROPERTIES": "Prefab Properties",
    "LABEL_INPUT_PARAMS": "Page Params",
    "LABEL_PREFAB_PROPS_GROUP": "Group",
    "LABEL_PREFAB_PROPS_DISPLAY_NAME": "Display Name",
    "LABEL_PREFAB_PROPS_TEMPLATE": "Template",
    "LABEL_PREFAB_PROPS_CONTROLLER": "Controller",
    "LABEL_PREFAB_PROPS_VARIABLES": "Variables",
    "LABEL_PREFAB_PROPS_ICON": "Icon",
    "LABEL_PREFAB_PROPS_RESOURCES": "Resources",
    "MESSAGE_PREFAB_PROPS_STYLES": "Select or Enter the CSS resources for your prefab",
    "MESSAGE_PREFAB_PLACEHOLDER_STYLES": "Select Reference of the CSS File",
    "MESSAGE_PREFAB_PLACEHOLDER_SCRIPTS": "Select Reference of the Script File",
    "MESSAGE_PREFAB_PLACEHOLDER_MODULE_NAME": "Enter the Module Name",
    "MESSAGE_PREFAB_PLACEHOLDER_MODULE": "Enter the Scripts in reference to the Modules",
    "MESSAGE_PREFAB_PROPS_SCRIPTS": "Select or Enter the Javascript resources for your prefab",
    "MESSAGE_PREFAB_PROPS_MODULES": "Enter the Angular module name which has to be included in the controller.",
    "LABEL_PREFAB_CSS": "CSS",
    "LABEL_PREFAB_GROUP_PACKAGING": "Packaging",
    "LABEL_PREFAB_PROPS_STYLES": "Styles",
    "LABEL_PREFAB_PROPS_SCRIPTS": "Scripts",
    "LABEL_PREFAB_JAVASCRIPT": "Javascript",
    "LABEL_PREFAB_GROUP_WIDGET": "Component",
    "LABEL_PREFAB_PROPS_MODULES": "Angular Modules",
    "LABEL_PREFAB_PROPS_PROPERTIES": "Properties",
    "LABEL_PREFAB_PROPS_WIDGET_PROPERTIES": "UI Properties",
    "LABEL_PREFAB_PROPS_SERVERPROPERTIES": "Server Properties",
    "LABEL_PREFAB_PROPS_EVENTS": "Events",
    "LABEL_PREFAB_PROPS_METHODS": "Methods",
    "LABEL_PREFAB_PROPS_METHOD_NAME_PLACEHOLDER": "Name of the method(alphanumeric chars only)",
    "LABEL_PREFAB_PROPS_METHOD_DESC_PLACEHOLDER": "Description of the method",
    "LABEL_PREFAB_METHOD_PARAM_NAME_PLACEHOLDER": "Name of the parameter",
    "LABEL_PREFAB_METHOD_PARAM_TYPE_PLACEHOLDER": "Type of the parameter",
    "LABEL_PREFAB_METHOD_PARAM_DESC_PLACEHOLDER": "Description of the parameter",
    "TITLE_PREFAB_PROPS_ADD_STYLE": "Add Style",
    "TITLE_PREFAB_PROPS_ADD_SCRIPT": "Add Script",
    "TITLE_PREFAB_PROPS_ADD_MODULE": "Add Module",
    "TITLE_PREFAB_PROPS_ADD_PROPERTY": "Add Property",
    "TITLE_PREFAB_PROPS_ADD_EVENT": "Add Event",
    "TITLE_PREFAB_PROPS_ADD_METHOD": "Add Method",
    "TITLE_PREFAB_PROPS_DELETE_STYLE": "Delete this Style",
    "TITLE_PREFAB_PROPS_DELETE_SCRIPT": "Delete this Script",
    "MESSAGE_NO_PROPERTIES_EXIST": "No Properties exist.",
    "MESSAGE_NO_METHODS_EXIST": "No Methods exist.",
    "TITLE_PREFAB_PROPS_DELETE_MODULE": "Delete this Module",
    "TITLE_PREFAB_PROPS_DELETE_PROPERTY": "Delete this Property",
    "TITLE_PREFAB_PROPS_DELETE_METHOD": "Delete this Method",
    "TITLE_PREFAB_PROPS_DELETE_PARAMETER": "Delete this Parameter",
    "LABEL_PREFAB_PROPS_WIDGET": "Type",
    "LABEL_PREFAB_PROPS_TYPE": "Data Type",
    "LABEL_PREFAB_PROPS_ISLIST": "Is List",
    "LABEL_PREFAB_PROPS_METHOD": "Method",
    "LABEL_PREFAB_PROPS_OPTIONS": "Data Options",
    "LABEL_PREFAB_PROPS_VALUE": "Default Value",
    "LABEL_PREFAB_PROPS_HELP": "Description",
    "LABEL_PREFAB_PROPS_PROPERTYNAME": "Property Name",
    "LABEL_PREFAB_PROPS_DISPLAYNAME": "Display Name",
    "MESSGAE_FILL_OUT_FIELD": "Please Fill out this field",
    "LABEL_PREFAB_PROPS_SHOW": "Show",
    "LABEL_PREFAB_PROPS_SHOW_AT": "Show At",
    "LABEL_PREFAB_PROPS_DISABLED": "Disabled",
    "LABEL_PREFAB_PROPS_BINDABLE": "Binding Type",
    "LABEL_PREFAB_PROPS_DATAOPT_DEPENDSON": "Depends on UI property",
    "LABEL_PREFAB_PROPS_DATAOPT_CUSTOM": "Custom",
    "LABEL_PREFAB_PROPS_DATASET": "Dataset",
    "LABEL_PREFAB_METHOD_RETURN_TYPE": "Return Type",
    "MESSAGE_HELP_PREFAB_METHOD_RETURN_TYPE": "Return type of the method",
    "MESSAGE_HELP_PREFAB_PROPS_PROPERTYNAME": "Name of the property",
    "MESSAGE_HELP_PREFAB_PROPS_DISPLAYNAME": "Display name of the property. This will be used to display in properties panel after importing the prefab in a project",
    "MESSAGE_HELP_PREFAB_PROPS_HELPTEXT": "Help text against the property. This will be used to display in properties panel after importing the prefab in a project",
    "MESSAGE_HELP_PREFAB_PROPS_DATATYPE": "Data type of the property.",
    "MESSAGE_HELP_PREFAB_PROPS_ISLISTTYPE": "Is List data type of the property",
    "MESSAGE_HELP_PREFAB_PROPS_DEFAULTVALUE": "Default value of the property.",
    "MESSAGE_HELP_PREFAB_PROPS_BINDINGTYPE": "Binding type of the property. Property can be bound to any component/data source.",
    "MESSAGE_HELP_PREFAB_PROPS_WIDGETTYPE": "Component type of the property. The assigned component will be displayed in properties panel after importing the prefab in a project.",
    "MESSAGE_HELP_PREFAB_PROPS_DATAOPTIONS": "Data options type. Enabled for Checkbox set, Radio set, Select Components.",
    "MESSAGE_HELP_PREFAB_PROPS_DATASET": "Provide comma separated options or bind to a data source which is a list.",
    "MESSAGE_HELP_PREFAB_DATAOPT_DEPENDSON_PROPERTYNAME": "Choose a property based on which the data options will be provided for this component.",
    "MESSAGE_HELP_PREFAB_PROPS_SHOW": "Show/Hide the property",
    "MESSAGE_HELP_PREFAB_PROPS_SHOW_AT": "Show this property at the selected component level.",
    "MESSAGE_HELP_PREFAB_PROPS_DISABLED": "Enable/Disable the property",
    "MESSAGE_HELP_PREFAB_PROPS_GROUPNAME": "Name of the Group. Used to group the prefab after importing it into a project",
    "MESSAGE_HELP_PREFAB_PROPS_TEMPLATE": "Template Path of the Prefab",
    "MESSAGE_HELP_PREFAB_PROPS_ICON": "Assign the icon for the prefab project. Displayed in the prefabs list after importing it into a project.",
    "TITLE_PREFAB_EVENTS_DESC": "Description of the event",
    "MESSAGE_PREFAB_EVENT_ONLOAD": "Callback action which will be triggered on loading of the prefab.",
    "MESSAGE_PREFAB_EVENT_DESTROY": "Callback action which will be triggered on destroy of the prefab.",
    "LABEL_TEMPLATE_PROPERTIES":"Template Properties",
    "LABEL_TEMPLATE_PROPS_NAME":"Template Name",
    "LABEL_TEMPLATE_PROPS_ENTER_NAME":"Enter Name",
    "LABEL_TEMPLATE_PROPS_CATEGORY":"Category",
    "LABEL_TEMPLATE_PROPS_ENTER_CATEGORY":"Enter Category",
    "LABEL_TEMPLATE_PROPS_PUBLISH":"Publish",
    "LABEL_TEMPLATE_PROPS_DESCRIPTION":"Description",
    "LABEL_TEMPLATE_PROPS_ENTER_DESCRIPTION":"Enter Description",
    "LABEL_TEMPLATE_PROPS_TYPE":"Type",
    "LABEL_TEMPLATE_PROPS_KEYWORDS":"Keywords",
    "LABEL_TEMPLATE_PROPS_ENTER_KEYWORDS":"Enter Keywords",
    "LABEL_TEMPLATE_PROPS_THUMBNAIL":"Thumbnail",
    "LABEL_TEMPLATE_PROPS_SCREENSHOTS":"Screenshots",
    "MESSAGE_PREFAB_PROPS_COMMA_SEPARATED": "comma separated",
    "MESSAGE_ERROR_PREFAB_PROPS_SAVE": "Unable to save Prefab properties",
    "MESSAGE_ERROR_TEMPLATE_PROPS_SAVE": "Unable to save Template properties",
    "MESSAGE_SUCCESS_PREFAB_PROPS_SAVE":"Prefab properties successfully",
    "MESSAGE_ERROR_PREFAB_PROPS_READ": "Unable to read Prefab properties",
    "MESSAGE_NO_SERVICES_IMPORTED": "No Services Imported",
    "MESSAGE_NO_PREFABS_IMPORTED": "No Prefabs are being used",
    "MESSAGE_SAVE_CURRENT_PROVIDER": "Please save current selected security provider",
    "MESSAGE_MINIMUM_SECURITY_PROVIDER": "There should be at least one Security Provider",
    "MESSAGE_NO_SECURITY_PROVIDERS_SAVED": "No Security Providers Available",
    "MESSAGE_CUSTOM_SCRIPT_CREATED": "Code snippet for custom actions is created in the current page script file.",
    "MESSAGE_DEVICE_ACTION_BUTTON_INFO": "It is recommended to show not more than two action buttons for liveform in mobile.",
    "MESSAGE_CUSTOM_EVENT_SCRIPT_CREATED": "Code snippet for event is created in the current page script file.",
    "LABEL_MOBILEAPP_PROPERTIES": "Application Properties",
    "LABEL_MOBILEAPP_EDGETOEDGE": "Edge to Edge Apps",
    "LABEL_MOBILEAPP_SCROLL_BEHAVIOUR_TITLE" : "Scroll Behaviour",
    "LABEL_MOBILEAPP_SCROLL_BEHAVIOUR_OPTION_DEFAULT" : "Default",
    "LABEL_MOBILEAPP_SCROLL_BEHAVIOUR_OPTION_HIDE_TOPNAV" : "Hide Top Nav on Scroll",
    "LABEL_MOBILEAPP_SCROLL_BEHAVIOUR_OPTION_HIDE_TOPANDBOTTOMNAV" : "Hide Top & Bottom Nav on Scroll",
    "LABEL_MOBILEAPP_EDGE_TO_EDGE_DISPLAY_TITLE" : "Edge-to-Edge Display",
    "LABEL_MOBILEAPP_EDGE_TO_EDGE_DISPLAY_STATUSBAR_CONFIGURATION" : "Configure Status Bar (Optional)",
    "LABEL_MOBILEAPP_EDGE_TO_EDGE_DISPLAY_STATUSBAR_TYPE" : "Type",
    "LABEL_MOBILEAPP_EDGE_TO_EDGE_DISPLAY_STATUSBAR_TRANSPARENT" : "Transparent",
    "LABEL_MOBILEAPP_EDGE_TO_EDGE_DISPLAY_STATUSBAR_BLUR" : "Blur",
    "LABEL_MOBILEAPP_EDGE_TO_EDGE_DISPLAY_STATUSBAR_COLOUR" : "Colour",
    "LABEL_MOBILEAPP_EDGE_TO_EDGE_DISPLAY_STATUSBAR_OPACITY" : "Opacity",
    "LABEL_MOBILEAPP_EDGE_TO_EDGE_DISPLAY_STATUSBAR_BLUR_TINT" : "Blur Tint",
    "LABEL_MOBILEAPP_EDGE_TO_EDGE_DISPLAY_STATUSBAR_BLUR_INTENSITY" : "Blur Intensity",
    "MESSAGE_INFO_REFERENCE_VIDEO":"The effect shown in the video is for demonstration purposes only and may not represent the actual selected value.",
    "LABEL_MOBILEAPP_INFORMATION": "Application Information",
    "LABEL_MOBILEAPP_DEV_INFORMATION": "Developer Information",
    "LABEL_MOBILEAPP_PLUGINS": "Plugins",
    "LABEL_HEADER_SSL_PINNING":"SSL Pinning",
    "LABEL_MOBILEAPP_ICON": "App Icon",
    "LABEL_MOBILEAPP_SPLASHSCREEN": "Splash Screen",
    "LABEL_ENABLE_SSL_PINNING": "Enable SSL Pinning",
    "LABEL_HEADER_SSL_PINNING_DOMAIN_NAME":"Domain Name",
    "LABEL_HEADER_SSL_PINNING_PUBLIC_KEY":"SSL public key hash",
    "LABEL_MOBILEAPP_SPLASHSCREEN_SELECT_IMAGE": "Upload PNG",
    "LABEL_MOBILEAPP_SPLASHSCREEN_DESCRIPTION": "Customise the following properties for splash configuration",
    "LABEL_MOBILEAPP_SPLASHSCREEN_PROPS_COLOR": "Background color",
    "LABEL_MOBILEAPP_SPLASHSCREEN_PROPS_IMAGE": "Image",
    "LABEL_MOBILEAPP_SPLASHSCREEN_SELECT_ANIMATION": "Upload JSON file",
    "LABEL_MOBILEAPP_SPLASHSCREEN_PREVIEW": "Preview",
    "LABEL_MOBILEAPP_SPLASHSCREEN_DEVICE_LIGHT": "Device Light",
    "LABEL_MOBILEAPP_SPLASHSCREEN_DEVICE_DARK": "Device Dark",
    "LABEL_MOBILEAPP_SPLASHSCREEN_APPLY_DARK_COMMON": "Same as light config.",
    "LABEL_MOBILEAPP_SPLASHSCREEN_LIGHT_DESCRIPTION": "This config will apply if device appearance is in light mode",
    "LABEL_MOBILEAPP_SPLASHSCREEN_DARK_DESCRIPTION": "This config will apply if device appearance is in dark mode",
    "LABEL_MOBILEAPP_SPLASHSCREEN_SPLASH_ICON": "Splash Icon",
    "LABEL_MOBILEAPP_SPLASHSCREEN_BACKGROUND": "Background",
    "LABEL_MOBILEAPP_SPLASHSCREEN_ICON_WIDTH": "Icon width",
    "LABEL_MOBILEAPP_SPLASHSCREEN_SPLASH_ANIMATION": "Splash animation",
    "LABEL_MOBILEAPP_SPLASHSCREEN_ANIMATION_LOTTIE": "Lottie json file",
    "LABEL_MOBILEAPP_SPLASHSCREEN_APP_LAUNCH_FLOW": "App launch flow",
    "LABEL_MOBILEAPP_SPLASHSCREEN_IF_ADDED": "if added",
    "LABEL_MOBILEAPP_SPLASHSCREEN_HOWE_PAGE": "Home Page",
    "LABEL_MOBILEAPP_SPLASHSCREEN_ANIMATION": "Animation",
    "LABEL_MOBILEAPP_SPLASHSCREEN_APP_LAUNCH": "App launch",
    "LABEL_MOBILEAPP_SPLASHSCREEN_WIDTH_PREVIEW_NOTE": "Icon width may vary slightly based on icon (with or without background) and device resolution. Refer more at ",
    "LABEL_MOBILEAPP_SPLASHSCREEN_ANIMATION_INFO": "Splash animation will be displayed after splash screen.",
    "LABEL_MOBILEAPP_SPLASHSCREEN_SPLASH_DIMENSIONS": "Splash dimensions",
    "LABEL_MOBILEAPP_SUPPORTED_PLUGINS": "Standard Plugins",
    "LABEL_MOBILEAPP_CUSTOM_PLUGINS": "More Plugins",
    "LABEL_MOBILEAPP_APP_PROPERTIES": "App Properties",
    "LABEL_MOBILEAPP_DEVICE_ASSETS": "Icons & Splash Screens",
    "LABEL_MOBILEAPP_ICONS": "App Icons",
    "LABEL_MOBILEAPP_SPLASHSCREENS": "Splash Screens",
    "LABEL_LANDSCAPE": "Landscape",
    "LABEL_PORTRAIT": "Portrait",
    "LABEL_TABLET_PORTRAIT":"Tablet Portrait",
    "LABEL_TABLET_LANDSCAPE":"Tablet Landscape",
    "LABEL_LARGE_SCREEN":"Large screen",
    "LABEL_MOBILEAPP_WHITE_LISTINGS": "White Listings",
    "LABEL_MOBILEAPP_PROPS_APPLICATION_NAME": "Application Name",
    "LABEL_MOBILEAPP_PROPS_APPLICATION_SERVER_PATH": "Server Path",
    "LABEL_MOBILEAPP_BUILD_CONFIG_PROFILES": "Config Profile",
    "LABEL_MOBILEAPP_APP_DESCRIPTION": "APP DESCRIPTION",
    "LABEL_MOBILEAPP_PROPS_APPLICATION_ID": "Application ID",
    "LABEL_MOBILEAPP_PROPS_APPLICATION_VERSION": "Version",
    "LABEL_MOBILEAPP_PROPS_APPLICATION_DESCRIPTION": "Description",
    "LABEL_MOBILEAPP_PROPS_APPLICATION_DEVELOPER_NAME": "Developer Name",
    "LABEL_MOBILEAPP_PROPS_APPLICATION_DEVELOPER_URL": "Developer URL",
    "LABEL_MOBILEAPP_PROPS_APPLICATION_DEVELOPER_EMAIL": "Developer Email",
    "LABEL_MOBILEAPP_PROPS_APPLICATION_ORIENTATION": "Device Orientation",
    "LABEL_MOBILEAPP_PROPS_APPLICATION_AUTO_ORIENTATION": " Allows rotation",
    "LABEL_MOBILEAPP_PROPS_APPLICATION_PORTRAIT_ORIENTATION": " Locks to vertical",
    "LABEL_MOBILEAPP_PROPS_APPLICATION_LANDSCAPE_ORIENTATION": " Locks to horizontal",
    "LABEL_MOBILEAPP_IPHONE": "iPhone",
    "LABEL_MOBILEAPP_IPHONE_5_6_APP_ICON": "iPhone (5-6)",
    "LABEL_MOBILEAPP_IPHONE_7_13_APP_ICON": "iPhone (7-13)",
    "LABEL_MOBILEAPP_IPHONE_NOTIFICATIONS": "iPhone Notifications",
    "LABEL_MOBILEAPP_IPHONE_SETTINGS": "iPhone Settings",
    "LABEL_MOBILEAPP_IPHONE_SPOTLIGHT": "iPhone Spotlight",
    "LABEL_MOBILEAPP_IPAD": "iPad",
    "LABEL_MOBILEAPP_IPAD_5_6_APP_ICON": "iPad (5-6)",
    "LABEL_MOBILEAPP_IPAD_7_13_APP_ICON": "iPad (7-13)",
    "LABEL_MOBILEAPP_IPAD_PRO_9_13_APP_ICON": "iPad Pro (9-13)",
    "LABEL_MOBILEAPP_IPAD_NOTIFICATIONS": "iPad Notifications",
    "LABEL_MOBILEAPP_IPAD_SPOTLIGHT": "IPhone Spotlight",
    "LABEL_MOBILEAPP_APP_STORE": "App Store",
    "LABEL_MOBILEAPP_APP_STORE_ICON": "Icon",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_ORIENTATION": "Orientation",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_ORIENTATION_DEFAULT": "Default",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_ORIENTATION_PORTRAIT": "Portrait",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_ORIENTATION_LANDSCAPE": "Landscape",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_FULLSCREEN": "Full Screen",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_IOS_FILE_SHARING": "iOS File Sharing",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_IOS_PRERENDERED_ICON": "iOS Prerendered icon",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_IOS_VERSION": "iOS target Version",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_IOS_TARGET_DEVICE": "Target Device",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_IOS_TARGET_DEVICE_HANDSET": "iPhone",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_IOS_TARGET_DEVICE_TABLET": "iPad",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_IOS_TARGET_DEVICE_UNIVERSAL": "iPhone & iPad",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_ANDROID_VERSION": "Minimum Android Version",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_IOS_STATUS_BAR_STYLE": "iOS Status Bar Style",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_IOS_STATUS_BAR_STYLE_DEFAULT": "Default",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_IOS_STATUS_BAR_STYLE_BLACK_TRANSLUCENT": "Black Translucent",
    "LABEL_MOBILEAPP_DEVICE_SETTINGS_IOS_STATUS_BAR_STYLE_BLACK_OPAQUE": "Black Opaque",
    "LABEL_MOBILEAPP_PERMISSIONS_NETWORK": "Network",
    "LABEL_MOBILEAPP_PERMISSIONS_CONTACTS": "Contacts",
    "LABEL_MOBILEAPP_PERMISSIONS_NOTIFICATIONS": "Notifications",
    "LABEL_MOBILEAPP_PERMISSIONS_FILE": "File",
    "LABEL_MOBILEAPP_PERMISSIONS_GEOLOCATION": "Geolocation",
    "LABEL_MOBILEAPP_PERMISSIONS_MEDIA": "Media",
    "LABEL_MOBILEAPP_PERMISSIONS_CAMERA": "Camera",
    "LABEL_MOBILEAPP_PERMISSIONS_BATTERY": "Battery",
    "LABEL_MOBILEAPP_PERMISSIONS_BARCODE_SCANNER":"Barcode Scanner",
    "LABEL_MOBILEAPP_PERMISSIONS_FILEPICKER":"File Picker",
    "LABEL_MOBILEAPP_PERMISSIONS_VIBRATE": "Vibrate",
    "LABEL_MOBILEAPP_PERMISSIONS_CALENDAR": "Calendar",
    "LABEL_MOBILEAPP_PERMISSIONS_MEDIAPICKER":"Media Picker",
    "LABEL_MOBILEAPP_PERMISSIONS_OFFLINE_DB":"Offline DB",
    "LABEL_MOBILEAPP_PERMISSIONS_IMAGEPICKER":"Image Picker",
    "LABEL_MOBILEAPP_PERMISSIONS_WARNING_MSG": "These are the most common used stable React Native plugins tested with WaveMaker.",
    "LABEL_MOBILEAPP_PERMISSIONS_URL_WHITELIST":"URL Whitelist",
    "LABEL_MOBILEAPP_PERMISSIONS_ALLOWINTENT": "Allow Following Intents",
    "LABEL_MOBILEAPP_PERMISSIONS_ADD_WHITELIST_BTN_INFO":"Click to add this to whitelist",
    "LABEL_MOBILEAPP_PERMISSIONS_REMOVE_WHITELIST_BTN_INFO":"Click to remove this from whitelist",
    "LABEL_MOBILEAPP_PERMISSIONS_REMOVE_CUSTOM_PLUGIN":"Click to remove this from custom plugins",
    "LABEL_MOBILEAPP_PERMISSIONS_ADD_ALLOWINTENT_BTN_INFO":"Click to add this allow intent",
    "LABEL_MOBILEAPP_PERMISSIONS_REMOVE_ALLOWINTENT_BTN_INFO":"Click to remove this allow intent",
    "LABEL_MOBILEAPP_PERMISSIONS_ADD_PLUGINS": "Click to add Custom plugins",
    "LABEL_MOBILEAPP_PERMISSIONS_CUSTOM_PLUGINS": "You can choose from list of plugins available at npm. Just provide the plugin name and version. No download required. Search more plugins ",
    "LABEL_PLUGIN_ID": "Plugin name, eg: cordova-plugin-badge",
    "LABEL_EXPO_PLUGIN_ID": "Plugin name, eg: expo-battery",
    "LABEL_PLUGIN_SPEC": "Enter Version",
    "LABEL_RN_PLUGIN_SPEC": "Enter version or github url",
    "LABEL_RN_MOBILEAPP_PERMISSIONS_CUSTOM_PLUGINS": "You can choose from list of plugins provided by expo. Just provide the plugin name and version. No download required. Search more plugins ",
    "LABEL_PLUGIN_INFO":"Plugin",
    "LABEL_PLUGIN_URL": "Enter github Url",
    "LABEL_MOBILEAPP_GRAPHICS_DEVICE": "Device",
    "LABEL_MOBILEAPP_GRAPHICS_TYPE": "Type",
    "LABEL_MOBILEAPP_GRAPHICS_SIZE": "Size",
    "LABEL_MOBILEAPP_GRAPHICS_DENSITY": "Density",
    "LABEL_MOBILEAPP_GRAPHICS_PATH": "Path",
    "LABEL_MOBILEAPP_PLATFORM_IOS": "iOS",
    "LABEL_MOBILEAPP_PLATFORM_ANDROID": "Android",
    "LABEL_MOBILEAPP_PLATFORM_WINDOWS": "Windows",
    "LABEL_MOBILEAPP_PLATFORM_OTHERS": "Others",
    "LABEL_MOBILE_DEV_BUILD_MODE": "DEV",
    "LABEL_MOBILE_PROD_BUILD_MODE": "PROD",
    "LABEL_SELECT_LAYOUT": "Select Layout",
    "MESSAGE_SELECT_LAYOUT": "Select how you want the component to look like",
    "LABEL_TABLES_COLUMNS":"Table Columns",
    "LABEL_APPLY": "Apply",
    "LABEL_DISCARD": "Discard",
    "LABEL_SETTINGS_SAVE": "Save",
    "LABEL_DEPLOYMENT_PROFILE_NAME": "Profile Name:",
    "LABEL_PROJECT_SETTINGS": "Project Settings",
    "LABEL_USER_MANAGEMENT": "User Management",
    "LABEL_STUDIO_SETTINGS": "Studio Settings",
    "LABEL_CONFIG_PREFAB" : "Config Prefab",
    "LABEL_CONFIG_TEMPLATES": "Config Templates",
    "LABEL_CONFIG_PROFILES": "Config Profiles",
    "LABEL_BASIC_PROJECT_SETTINGS": "Basic",
    "LABEL_PREFAB_PROJECT_SETTINGS": "Prefab",
    "LABEL_TEMPLATEBUNDLE_PROJECT_SETTINGS": "Template Bundle",
    "LABEL_DEPLOYMENT_PROFILES": "Configuration Profiles",
    "LABEL_DEPLOYMENT_PROFILES_DB_SOURCE": "Datasource Managed by",
    "LABEL_DEPLOYMENT_PROFILES_DB_JNDI_AVIL": "JNDI Datasource is available only for custom profiles",
    "LABEL_DEPLOYMENT_PROFILES_NO_CONFIGURATION_CHANGE": "The development profile represents values given during the import/enabling of service. These values can be changed from their respective service configuration dialog/screens",
    "LABEL_DEPLOYMENT_PROFILES_DB_JNDI_NAME": "JNDI Name:",
    "LABEL_DEPLOYMENT_PROFILES_DB_CONNECTION_URL": "Connection Url",
    "LABEL_DEPLOYMENT_PROFILES_DB_USERNAME": "UserName",
    "LABEL_DEPLOYMENT_PROFILES_DB_PASSWORD": "Password",
    "LABEL_DEPLOYMENT_PROFILES_REST_APPLICATION_PATH": "Application path",
    "MESSAGE_DEPLOYMENT_PROFILES_DELETE_CONFIRM": "Are you sure want to delete profile - ${0}?",
    "MESSAGE_DEPLOYMENT_PROFILES_NO_DB": "Nothing to configure here. Once a database is imported in the project, the settings of the database of this profile will show up.",
    "MESSAGE_DEPLOYMENT_PROFILES_NO_REST": "Nothing to configure here. Once a REST service is imported in the project, the settings of the REST service of this profile will show up.",
    "MESSAGE_DEPLOYMENT_PROFILES_NO_SOAP": "Nothing to configure here. Once a SOAP service is imported in the project, the settings of the SOAP service of this profile will show up.",
    "MESSAGE_DEPLOYMENT_PROFILES_NO_WEB_SOCKET": "Nothing to configure here. Once a WEB SOCKET service is imported in the project, the settings of the WEB SOCKET service of this profile will show up.",
    "MESSAGE_DEPLOYMENT_PROFILES_NO_SECURITY": "Nothing to configure here. Once Security is enabled in the project, the settings of the Security for this profile will show up.",
    "MESSAGE_DEPLOYMENT_PROFILES_NO_APP_ENVIRONMENT_PARAMETERS": "Nothing to configure here. Parameters will show up once they are added in the development profile.",
    "MESSAGE_DEPLOYMENT_PREFAB_PROFILES_NO_APP_ENVIRONMENT_PARAMETERS": "Nothing to configure here. Parameters will show up once they are added in the prefab profile.",
    "MESSAGE_DEPLOYMENT_PROFILES_NO_OAUTH_PARAMETERS": "There are no OAuth 2.0 providers for configuration.",
    "MESSAGE_PROJECT_SETTINGS_UNSAVED_CHANGES": "You have unsaved changes. Are you sure you want to discard your changes?",
    "MESSAGE_DEPLOYMENT_PROFILES_PROFILE_NAME": "Enter profile name",
    "MESSAGE_DEPLOYMENT_PROFILES_INVALID_PROFILE_NAME": "Special characters are not allowed (except _ ).",
    "MESSAGE_DEPLOYMENT_PROFILES_DUPLICATE_PROFILE_NAME": "Profile with the given name exists.",
    "MESSAGE_SUCCESS_PROJECT_SETTINGS_SAVE": "Project settings updated successfully.",
    "MESSAGE_FILE_UPLOAD_SUCCESSFULLY": "File uploaded successfully",
    "MESSAGE_FILE_UPLOAD_FAILED": "File uploaded failed",
    "MESSAGE_CONFIG_FILE_UPLOAD_SUCCESSFULLY": "Config file uploaded successfully",
    "MESSAGE_CONFIG_FILE_UPLOAD_FAILED": "Config file uploaded failed",
    "MESSAGE_SUCCESS_DEPLOYMENT_PROFILE_UPDATE": "Profile updated successfully.",
    "MESSAGE_SUCCESS_DEPLOYMENT_PROFILE_DELETE": "Profile deleted successfully.",
    "MESSAGE_ERROR_PROJECT_SETTINGS_SAVE": "Unable to save project settings.",
    "MESSAGE_ERROR_DEPLOYMENT_PROFILES_LOAD": "Unable to load the list of profiles.",
    "MESSAGE_ERROR_DEPLOYMENT_PROFILE_LOAD": "Unable to load the profile details.",
    "MESSAGE_ERROR_DEPLOYMENT_PROFILE_CREATE": "Unable to create the profile.",
    "MESSAGE_ERROR_DEPLOYMENT_PROFILE_DELETE": "Unable to delete the profile.",
    "MESSAGE_ERROR_DEPLOYMENT_PROFILE_UPDATE": "Unable to update the profile details.",
    "MESSAGE_ERROR_DUPLICATE_PROPERTIES": "Property with the same key already exists.",
    "MESSAGE_ERROR_NO_PROPERTIES": "Please enter key and value.",
    "LABEL_ADD_PANE": "Add Pane",
    "LABEL_SELECT_PLATFORM": "Select platform",
    "LABEL_SELECT_PLATFORM_WEB": "Web Browsers",
    "LABEL_SELECT_PLATFORM_WEB_RESPONSIVE": "Web",
    "MESSAGE_SELECT_PLATFORM_WEB1": "Build",
    "MESSAGE_SELECT_PLATFORM_WEB2": "Responsive Web Apps",
    "MESSAGE_SELECT_PLATFORM_WEB3": "Make your app responsive on Web - make it look great on any browser, device and tablet.",
    "LABEL_SELECT_PLATFORM_MOBILE": "Mobile",
    "LABEL_SELECT_PLATFORM_MOBILE_HYBRID": "Hybrid Mobile",
    "MESSAGE_SELECT_PLATFORM_MOBILE": "Hybrid Mobile Apps",
    "MESSAGE_SELECT_PLATFORM_MOBILE2": "Build apps for Android and iOS, supporting all device capabilities.",
    "LABEL_TITLE_PROJECT_NAME" : "Project Name",
    "LABEL_TITLE_PROJECT_URL" : "Project Url",
    "LABEL_TITLE_MEMBERS" : "Members",
    "LABEL_TITLE_MEMBER" : "Member",
    "LABEL_TITLE_ADD_MEMBERS" : "Add Members",
    "LABEL_TITLE_PROJECT_MEMBERS": "Project Members",
    "LABEL_TITLE_MANAGE_MEMBERS": "Manage Members",
    "LABEL_CREATE_PROJECT_BRANCH": "Create Project Branch",
    "LABEL_TITLE_CREATE_PROJECT_BRANCH": "Create project from an existing branch",
    "LABEL_PROJECT_REPO_URL": "Project Repo URL",
    "LABEL_CREATE_FROM_BRANCH": "Create from branch",
    "LABEL_PROJECT_BRANCH_INFO": "Create a project from the branch where you can make hotfix, edits & enhancements.",
    "LABEL_PROJECT_BRANCH_STEP_1": "Master",
    "LABEL_PROJECT_BRANCH_STEP_2": "Create Branch",
    "LABEL_PROJECT_BRANCH_STEP_3": "Make Fix",
    "LABEL_PROJECT_BRANCH_STEP_4": "Copy manually to Master",
    "LABEL_PROJECT_BRANCH_STEP_5": "Master + Branch",
    "LABEL_PROJECT_BRANCH_STEP_7": "Delete Branch",
    "MSG_PROJECT_BRANCH_FLOW_STEP_2_1": "Create a new project branch from the master branch.",
    "MSG_PROJECT_BRANCH_FLOW_STEP_3_1": "Make required fixes to the project branch.",
    "MSG_PROJECT_BRANCH_FLOW_STEP_4_1": "Copy the new code in the master project branch.",
    "MSG_PROJECT_BRANCH_FLOW_STEP_7_1": "The new project branch can be deleted from all the members’ workspaces.",
    "MSG_PROJECT_BRANCH_FLOW_STEP_7_2": "Deleting this project does not affect the VCS  project branch.",
    "MSG_DEPLOY_NOT_SUPPORTED": "Deployment is not supported for the project branch",
    "MSG_FETCHING_BRANCHES_LIST": "Fetching branches from VCS",
    "MSG_CANNOT_CREATE_BRANCH_FOR_DEFAULT_VCS": "Cannot create project branch in Default VCS provided by WaveMaker.",
    "MSG_CHECKING_IF_PROJECT_BRANCH_EXISTS": "Checking if the project branch already exists in the network.",
    "MSG_PROJECT_BRANCH_ALREADY_EXISTS": "The project with the branch '${0}' already exists in the network.",
    "LABEL_REFRESH_BRANCHES_LIST": "Click here to refresh the branches list",
    "MSG_NO_BRANCHES_FOUND": "No branches exist, please create one from VCS.",
    "MSG_FETCHING_PROJECT_MEMBERS": "Fetching project members",
    "MSG_CREATING_PROJECT_BRANCH": "Creating project branch ...",
    "MSG_CANNOT_SWITCH_TO_SAME_PROJECT": "You are currently working on this project",
    "LABEL_SEARCH_PROJECT_BRANCH": "Search project branch",
    "LABEL_RECENTLY_VIEWED_BRANCHES": "Recently viewed project branches",
    "LABEL_VIEW_MORE": "View more",
    "LABEL_BRANCHES": "Branches",
    "LABEL_TITLE_ACTIVITIES" : "Activity",
    "LABEL_TITLE_MY_APPS" : "My Apps",
    "LABEL_TITLE_MY_APPLICATION" : "My Apps",
    "LABEL_TITLE_MY_PREFAB" : "My Prefabs",
    "LABEL_TITLE_MY_TEMPLATEBUNDLE" : "My Templates",
    "LABEL_TITLE_MY_ARCHIVED" : "My Archived Apps",
    "LABEL_TITLE_ALL_APPLICATION" : "Apps",
    "LABEL_TITLE_ALL_PREFAB" : "Prefabs",
    "LABEL_TITLE_ALL_TEMPLATEBUNDLE" : "Template Bundles",
    "LABEL_TITLE_ALL_SAMPLEAPP" : "Starter Apps",
    "LABEL_TITLE_ALL_ARCHIVED" : "Archived Apps",
    "LABEL_TITLE_HELP_TOOLTIP_APPLICATION": "Create a Responsive web or hybrid mobile app.",
    "LABEL_TITLE_HELP_TOOLTIP_PREFAB": "Independent, custom components that can be reused across apps.",
    "LABEL_TITLE_HELP_TOOLTIP_TEMPLATEBUNDLE": "Create, share and reuse your own templates.",
    "LABEL_TITLE_TOOLTIP_APPLICATION": "Easily build a Responsive Web or Hybrid mobile app.",
    "LABEL_TITLE_TOOLTIP_PREFAB": "Build reusable pre-tested components using a prefab.",
    "LABEL_TITLE_TOOLTIP_TEMPLATEBUNDLE": "Create Template bundles for app consistency in terms of look and feel ",
    "LABEL_TITLE_TOOLTIP_SAMPLEAPP": "Showcase of  Sample Apps that are available with WaveMaker Studio",
    "LABEL_SHOW_ARCHIVED_APPS_HINT": "Note: All 9.X Version applications have been moved to \"Archived Apps\".",
    "LABEL_SHOW_ARCHIVED_APPS_TOOLTIP": "Note: You can download these archived projects and can re-import them to upgrade to the latest version.",
    "MESSAGE_SAMPLE_APP_CREATED" : "Sample app '${0}' created successfully",
    "LABEL_TITLE_NOTIFICATIONS" : "Notifications",
    "LABEL_TITLE_INFORMATION" : "Information",
    "MESSAGE_EMAIL_REQUIRED" : "Email ID is required",
    "MESSAGE_LOGIN_PROGRESS" : "Logging in...",
    "LABEL_TITLE_SUBSCRIPTION" : "Subscription",
    "LABEL_MANAGE_SUBSCRIPTIONS" : "Manage Subscriptions",
    "LABEL_APP_NAME" : "APP NAME",
    "LABEL_PLAN" : "PLAN",
    "LABEL_DUE_ON" : "DUE ON ",
    "MESSAGE_SUCCESS_USERS_ADDED" : "Successfully added users to project",
    "MESSAGE_NO_NEW_NOTIFICATIONS" : "No new notifications.",
    "MESSAGE_SHOW_MORE_NOTIFICATIONS" : "Show more notifications",
    "LABEL_ICON_PROPERTY_SIZE": "Size",
    "LABEL_ICON_PROPERTY_ROTATE": "Rotate",
    "LABEL_ICON_PROPERTY_FLIP": "Flip",
    "LABEL_ICON_PROPERTY_ANIMATION": "Animation",
    "LABEL_ICON_PROPERTY_PULL": "Pull",
    "LABEL_ICON_PROPERTY_BORDER": "Border",
    "LABEL_ICON_PROPERTY_FIXEDWIDTH": "Fixed width",
    "LABEL_ICON_PREVIEW": "Icon Preview",
    "LABEL_SUBSCRIPTION_STATE" : "STATUS",
    "LABEL_SUBSCRIPTION_DAYS_LEFT" : "Day(s) Left",
    "LABEL_PLATFORM_TYPE" : "PLATFORM TYPE",
    "LABEL_TITLE_NO_PROJECTS" : "Select a project to view the project details",
    "LABEL_TITLE_SUBSCRIPTIONS" : "Subscriptions",
    "LABEL_NO_NETWORK_ACTIVITIES" : "No Network Activity",
    "LABEL_CONFIGURE_APP_DEPLOYMENT": "Deploy to Cloud",
    "MESSAGE_DEPLOYMENT_PROVIDER_HINT": "You have to setup a Cloud provider in order to deploy your application to the Cloud.",
    "MESSAGE_SELECT_DEPLOYMENT_PROVIDER": "Select a Cloud provider from the list below.",
    "MESSAGE_CONFIGURE_DEPLOYMENT_INSTANCE": "Specify configuration details below.",
    "MESSAGE_SELECT_DEPLOYMENT_PROFILE": "Select a configuration profile to deploy your application",
    "MESSAGE_DEPLOYMENT_DELETE_TARGET_AWS": "This action will remove your project's association with the AWS instance and will allow you to create a new deployment target for this app.<br><br>This action cannot be Undone. Do you want to proceed ?",
    "MESSAGE_DEPLOYMENT_DELETE_TARGET_AZURE": "This action will remove your project's association with the Azure instance and will allow you to create a new deployment target for this app.<br><br>This action cannot be Undone. Do you want to proceed ?",
    "MESSAGE_DEPLOYMENT_DELETE_TARGET_WM_CLOUD": "This action will remove your project's association with the WaveMaker Cloud deployment target and will allow you to create a new deployment target for this app.",
    "MESSAGE_DEPLOYMENT_DELETE_TARGET_WARNING_AWS": "<strong>Note: </strong>Your AWS instance, associated key and security group will not be deleted from your AWS account. You may delete them by logging into the AWS Management Console.",
    "MESSAGE_DEPLOYMENT_DELETE_TARGET_WARNING_AZURE": "<strong>Note: </strong>Your Azure instance, associated keys, security groups and networks will not be deleted from your Azure account. You may delete them by logging into the Azure Portal.",
    "MESSAGE_DEPLOYMENT_DELETE_TARGET_WARNING_WM_CLOUD": "<strong>WARNING: </strong>Your WaveMaker Cloud deployment will be deleted and any data on this target cannot be retrieved if you proceed. This action cannot be undone.",
    "MESSAGE_DEPLOYMENT_DELETE_TARGET_CONFIRM": "I understand that this action may result in data loss, and I confirm that I wish to proceed.",
    "MESSAGE_DEPLOYMENT_CREATING_AWS": "Creating AWS Deployment Target",
    "MESSAGE_PASSWORD_ERROR_AZURE": "Password must contain 12-72 characters and 3 of the following: 1 lower case character, 1 upper case character, 1 number, and 1 special character",
    "LABEL_DEPLOYMENT_TARGET_NAME": "Deployment Target Name",
    "LABEL_GCP_PROJECT_ID": "GCP Project ID",
    "LABEL_SERVICE_ACCOUNT_ID": "Service Account ID",
    "LABEL_CLIENT_CREDENTIAL_FILE": "Client Credential File",
    "LABEL_DEPLOYMENT_SECRET_KEY": "Secret Key",
    "LABEL_DEPLOYMENT_CLIENT_SECRET": "Client Secret",
    "LABEL_DEPLOYMENT_ACCESS_KEY": "Access Key",
    "LABEL_DEPLOYMENT_CLIENT_ID": "Client ID",
    "LABEL_DEPLOYMENT_ACCOUNT_ID": "AWS Account ID",
    "LABEL_DEPLOYMENT_REGION": "Region",
    "LABEL_DEPLOYMENT_RESOURCE_GROUP_NAME": "Resource Group Name",
    "LABEL_UPLOAD_CLIENT_CREDENTIAL_FILE": "Upload client credential file",
    "LABEL_DEPLOYMENT_SUBSCRIPTION_ID": "Subscription ID",
    "LABEL_DEPLOYMENT_TENANT_ID": "Tenant ID",
    "LABEL_DEPLOYMENT_PROCEED_DEPLOY": "DEPLOY APP",
    "LABEL_KEY": "Key",
    "LABEL_CALLBACK_URL": "Callback URL",
    "MESSAGE_OAUTH_CALLBACK_URL": "Set this as the callback URL in your app settings page",
    "MESSAGE_AZURE_DEPLOYMENT": "Your instance creation has started. You will receive an email once this is done.",
    "MESSAGE_CONFIGURE_DEPLOYMENT_INSTANCE_MEMORY": "Select the instance type. We will start the the selected type of instance on your behalf.",
    "MESSAGE_AZURE_INSTANCE_CREDENTIALS": "These credentials can be used later to access your instance.",
    "MESSAGE_DEPLOYMENT_AWS_PRICING_DESC": "AWS will charge you separately for the instance as per ",
    "MESSAGE_DEPLOYMENT_AZURE_PRICING_DESC": "Azure will charge you separately for the instance as per ",
    "MESSAGE_DEPLOYMENT_GOOGLE_CLOUD_PRICING_DESC": "Google Cloud will charge you separately for the instance as per ",
    "MESSAGE_DEPLOYMENT_AWS_PRICING": "AWS pricing.",
    "MESSAGE_DEPLOYMENT_AZURE_PRICING": "Azure pricing.",
    "MESSAGE_DEPLOYMENT_GOOGLE_CLOUD_PRICING": "Google Cloud pricing.",
    "MESSAGE_DEPLOYMENT_AWS_CONFIG_DETAILS": "Your AWS IAM key will be used to create a security group, a SSH keypair for the instance and to create the instance itself as per the options you choose in this wizard. Ensure that the IAM key you specify has the ",
    "MESSAGE_DEPLOYMENT_AWS_PERMISSION_DETAILS": "Ensure that the IAM key you specify has permissions for the following actions: \n\n'ec2:RunInstances',\n'ec2:CreateTags',\n'ec2:CreateKeyPair',\n'ec2:CreateSecurityGroups',\n'ec2:AuthorizeSecurityGroupIngress',\n'ec2:DescribeInstances',\n'ec2:DescribeInstanceStatus',\n'ec2:DescribeKeyPairs',\n'ec2:DescribeSecurityGroups'",
    "MESSAGE_DEPLOYMENT_AWS_REQUIRE_PERMISSION": "required permissions.",
    "LABEL_INSTANCE_TAGS": "Instance Tags",
    "MESSAGE_DEPLOYMENT_ADD_INSTANCE_TAG": "ADD TAG",
    "MESSAGE_DEPLOYMENT_REMOVE_INSTANCE_TAG": "Remove Instance Tag",
    "MESSAGE_INSTANCE_TAGS_HINT": "Choose your tags carefully! These tags can be used later to identify your instances",
    "LABEL_DEPLOY": "Deploy",
    "LABEL_SPOTCUES_PUBLISH": "Publish To Spotcues",
    "LABEL_PLACEHOLDER_NAME": "Enter App Name",
    "LABEL_ICON_URL": "Icon URL:",
    "LABEL_PLACEHOLDER_ICON": "Enter Icon URL",
    "LABEL_SEARCH_KEYWORDS": "Search Keywords",
    "LABEL_PLACEHOLDER_KEYWORDS": "Enter Text(Comma Separated Values)",
    "LABEL_ENTER": "Enter",
    "LABEL_SPOTCUES_API": "Spotcue API",
    "LABEL_SPOT_ID": "Spot ID",
    "LABEL_SPOT_SECRET": "Spot Secret",
    "LABEL_DEPLOY_NOTIFICATION":"You will receive an email once the deployment is done.",
    "LABEL_DEPLOY_INSPECT_CHECKING": "Checking for Errors",
    "LABEL_DEPLOY_INSPECT_CHECKING_ISSUES":"Checking for Issues",
    "LABEL_DEPLOY_INSPECT_ERRORS": "Errors Found",
    "LABEL_DEPLOY_INSPECT_WARNINGS": "Warnings Found",
    "LABEL_DEPLOY_INSPECT_NO_ERRORS": "No Errors Found",
    "LABEL_DEPLOY_CHECK_INSPECT_RESULT": "Check Inspection Results",
    "LABEL_DEPLOY_RUN_IN_BG": "Run in Background",
    "LABEL_DEPLOY_DEF_ERR_MSG":"Please check 'Manage App' for details",
    "LABEL_DEPLOY_INSP_ERR_MSG":"Please check 'Inspection Results' for errors",
    "LABEL_DEPLOY_PROGRESS_STEP_1": "Provisioning Environment",
    "LABEL_DEPLOY_PROGRESS_STEP_2": "Preparing Build",
    "LABEL_DEPLOY_PROGRESS_STEP_3": "Deploying Application",
    "LABEL_DEPLOY_FINISH_NOTIFICATION_1":"Please check '",
    "LABEL_DEPLOY_FINISH_NOTIFICATION_2":"' for details",
    "LABEL_LAST_DEPLOY_REQUEST":"Last Deployment Status: ",
    "LABEL_DEPLOY_STATUS":"Check Deployment Status",
    "LABEL_DEPLOY_CLOUD_SETUP": "Cloud Provider Setup",
    "LABEL_DEPLOY_CHANGE_TARGET": "Change Deployment Target",
    "LABEL_REDEPLOY": "Redeploy",
    "LABEL_DEPLOY_WM_CLOUD": "WaveMaker Cloud",
    "LABEL_DEPLOY_AZURE": "Azure",
    "LABEL_DEPLOY_AWS": "AWS",
    "LABEL_DEPLOY_SELECT_TARGET": "Select Deployment Target",
    "LABEL_DEPLOY_MENU_CHANGE_DEPLOYMENT_TARGET": "Change Deployment Target",
    "LABEL_SELECT_PROFILE": "Select Profile",
    "MESSAGE_DEPLOYMENT_ERROR_SELECT_INSTANCE": "Please select an instance type",
    "MESSAGE_DEPLOYMENT_LOADING_CREATE_TARGET_WMCloud": "Deployment Target creation is in progress",
    "MESSAGE_DEPLOYMENT_LOADING_CREATE_TARGET_AWS": "Connecting to AWS",
    "MESSAGE_DEPLOYMENT_LOADING_CREATE_TARGET_AZURE": "Connecting to Azure",
    "MESSAGE_DEPLOYMENT_ERROR_CREATE_TARGET": "Deployment Target creation failed",
    "MESSAGE_DEPLOYMENT_IN_PROGRESS_CREATE_TARGET": "Deployment Target creation is in-progress",
    "MESSAGE_DEPLOYMENT_SUCCESS_CREATE_TARGET": "Deployment Target ${0} created",
    "MESSAGE_DEPLOYMENT_SUCCESS_DELETE_TARGET": "Existing Deployment Target has been deleted.",
    "MESSAGE_DEPLOYMENT_ERROR_DELETE_TARGET": "Error while deleting Deployment Target",
    "MESSAGE_DEPLOYMENT_LOADING_DELETE_TARGET": "Please wait while the existing Deployment Target is deleted",
    "MESSAGE_DEPLOYMENT_ERROR_SELECT_PROFILE": "Please select the profile",
    "MESSAGE_DEPLOYMENT_ERROR_KEY_PAIR": "Error while downloading key pair",
    "MESSAGE_CLIENT_CREDENTIAL_FILE_MISFORMAT": "Only JSON files are allowed",
    "MESSAGE_DEPLOYMENT_LOADING_KEY_PAIR": "Key pair download is in progress",
    "MESSAGE_DEPLOYMENT_SUCCESS_KEY_PAIR": "Key pair downloaded successfully",
    "LABEL_DEPLOYMENT_DOWNLOAD_SSH_KEY": "DOWNLOAD PRIVATE SSH KEY",
    "LABEL_DEPLOYMENT_CREATE_DEPLOYMENT_TARGET": "CREATE DEPLOYMENT TARGET",
    "LABEL_EDIT": "Edit",
    "LABEL_CUT": "Cut",
    "LABEL_COPY": "Copy",
    "LABEL_PASTE": "Paste",
    "LABEL_TRIAL_EXPIRES_IN":"Trial expires in  ${0} days",
    "LABEL_SUBSCRIPTION_TYPE" : "Subscription Type",
    "LABEL_CANCEL_SUBSCRIPTION_CONTENT_MESSAGE" : "Are you sure you want to cancel the subscription for the application with name ${0}",
    "MESSAGE_SUCCESS_UNSUBSCRIBE" : "Successfully cancelled subscription for the application with name \"${0}\"",
    "LABEL_ACTIONS_CANCEL_SUBSCRIPTION" : "Cancel Subscription",
    "LABEL_WAVEMAKER_TRIAL" : "WaveMaker Trial",
    "LABEL_WAVEMAKER_START_USING" : "Start using WaveMaker",
    "LABEL_WAVEMAKER_NOT_NOW" : "No Thanks, I'll Upgrade Later",
    "LABEL_CANT_CREATE_APP" : "Upgrade Subscription",
    "LABEL_PROFILE" : "Profile",
    "LABEL_EMPTY_PREFAB_LIST_MESSAGE": 'No prefabs found. Try importing services to enable prefabs.',
    "LABEL_PROFILES_DEVELOPMENT":"development",
    "LABEL_PROFILES_DEPLOYMENT":"deployment",
    "LABEL_FIRSTNAME" : "First Name",
    "LABEL_NO_MEMBER_ADDED_TO_PROJECT" : "No contributor added to this project",
    "LABEL_NO_MEMBER_AVAILABLE_TO_PROJECT" : "No member available to this project",
    "LABEL_LEFT" : "left",
    "LABEL_CENTER" : "center",
    "LABEL_RIGHT" : "right",
    "LABEL_TOP": "top",
    "LABEL_FLOATING": "floating",
    "LABEL_DAY_PLAN" : "day plan",
    "LABEL_DAYS_PLAN" : "days plan",
    "LABEL_MONTHLY" : "Monthly",
    "LABEL_MONTH" : "Month",
    "LABEL_YEARLY" : "Yearly",
    "LABEL_YEAR" : "Year",
    "LABEL_DAILY" : "Daily",
    "LABEL_DAY" : "Day",
    "LABEL_WEEKLY" : "Weekly",
    "LABEL_WEEK" : "Week",
    "LABEL_NA" : "N / A",
    "LABEL_DIALOG":"Dialog",
    "LABEL_INLINE":"Inline",
    "LABEL_FREE_ACCOUNT" : "Free Account",
    "LABEL_SUBSCRIPTION_STATUS": "Status",
    "LABEL_AUTO_RENEW_ON_MESSAGE": "Auto Renew on ",
    "LABEL_UPDATES":"Updates",
    "LABEL_MANAGE_APPLICATIONS":"Manage Deployed Apps",
    "LABEL_TEAM_PORTAL": "Team Portal",
    "LABEL_LAUNCHPAD": "LaunchPad",
    "LABEL_DEPLOYING_APP":"Deploying App - ",
    "LABEL_CONFIG_FAILED":"Configuration failed",
    "LABEL_DEPLOY_FAILED":"Deployment failed",
    "LABEL_JOIN_PENDING":"Join Pending",
    "LABEL_PLAN_START_DATE": "Start Date",
    "LABEL_PLAN_NEXT_RENEWAL_DATE": "Next Renewal Date",
    "LABEL_PLAN_RESPONSE_MESSAGE_1": "Your card will be charged",
    "LABEL_PLAN_RESPONSE_MESSAGE_2": "automatically on the next renewal date ${0}.",
    "LABEL_PLAIN_PLAN" : "Plan",
    "LABEL_RESPONSE_PLAN_APP_NAME": "for ${0}",
    "LABEL_TODAY": "Today",
    "LABEL_PLAN_PAY" : "Pay",
    "LABEL_PLAN_PROCEED" : "Proceed",
    "LABEL_PAYMENT_SUCCESS": "Your Payment was successful. Your Subscription details are as follows.",
    "LABEL_PAYMENT_FAILED": "We are sorry, but your current payment method could not be processed.",
    "LABEL_CANCEL_SUBSCRIPTION_MESSAGE1": "We are sad to hear that you have decided not to renew this app's subscription. Your app subscription will not be auto-renewed at the end of the current subscription period, which expires on ${0}. As per our terms, subscription cancellations are not refundable. However, you will still have full access to your app till the end of the subscription period.  You can also re-activate the subscription during this period from the project listing page.We are always looking for ways to get better.",
    "LABEL_CANCEL_SUBSCRIPTION_MESSAGE2": "We'd love to know why you have chosen to cancel the subscription for this app.",
    "LABEL_CANCEL_SUBSCRIPTION": "CANCEL MY SUBSCRIPTION",
    "LABEL_CANCEL_SUBSCRIPTION_SUCCESS": "Cancel subscription request submitted successfully",
    "LABEL_GO_BACK": "GO BACK",
    "LABEL_CANCEL_REASON_1": "Product Related(quality,features etc),",
    "LABEL_CANCEL_REASON_2": "Expensive Pricing",
    "LABEL_CANCEL_REASON_3": "Poor Support",
    "LABEL_CANCEL_REASON_4": "I don't need WM anymore",
    "LABEL_CANCEL_REASON_5": "None of the above",
    "LABEL_PROJECTS_LIST_WAVEMAKER_SAMPLE_APPS": "Sample Apps",
    "LABEL_PROJECTS_LIST_WAVEMAKER_USE_SAMPLE_APPS": "Use Sample Apps",
    "LABEL_PROJECTS_LIST_WAVEMAKER_CREATE_NEW_APPS": "Create new app",
    "LABEL_PROJECTS_LIST_WAVEMAKER_GET_STARTED":"Get Started",
    "LABEL_NO_PROJECT_ACTIVITY": "No Project Activity",
    "MESSAGE_EMPTY_EMAIL_ADDRESS": "Email address cannot be empty",
    "MESSAGE_EMPTY_CURRENT_PASSWORD": "Current password cannot be empty",
    "MESSAGE_EMPTY_NEW_PASSWORD": "New password cannot be empty",
    "MESSAGE_EMPTY_CONFIRM_PASSWORD": "Confirm password cannot be empty",
    "MESSAGE_INVALID_FIELD": "Invalid Field",
    "MESSAGE_INVALID_CURRENT_PASSWORD": "Current password is invalid",
    "MESSAGE_INVALID_NEW_PASSWORD": "New password is invalid",
    "MESSAGE_INVALID_CONFIRM_PASSWORD": "Confirm password is invalid",
    "MESSAGE_ONE_OR_MORE_INVALID_EMAIL_ADDRESS": "One or more email address(s) is invalid",
    "MESSAGE_ENABLE_SECURITY": "Authentication is not enabled for the application. Turn ON Authentication and select a Security Provider to configure it.",
    "MESSAGE_ENABLE_NETWORK_ACCESS": "It is not a recommended configuration to allow all the URLs. Only for development purpose, we provide this default configuration.",
    "MESSAGE_WIDGET_SELECT_DATASOURCE": "Select the source of data for the component. You can configure template and fields in the next steps.",
    "MESSAGE_WIDGET_SELECT_TEMPLATE": "Select a template and configure the content in the next step. Or use the default template.",
    "MESSAGE_WIDGET_MAP_FIELDS": "Map the fields of the variable selected ${0}('${1}') to the properties of the elements for the chosen template('${2}').",
    "MESSAGE_WIDGET_NAVIGATION": "Select pagination to enable navigation on the component.",
    "MESSAGE_CAPTION_POSITION_ALIGN": "Select a template and configure the content in the next step. Align and position caption for the form fields, also set size to caption of form fields.",
    "LABEL_SELECT_VARIABLE": "Select a variable:",
    "LABEL_SUBMIT_API_VARIABLE": "Form Submit Variable:",
    "LABEL_DYNAMIC_FORM_METADATA": "The Form Fields are dynamic",
    "LABEL_DYNAMIC_GRID_METADATA": "The Columns are dynamic",
    "MESSAGE_DYNAMIC_FORM_METADATA": "Enable this option if Form Fields are changing based on the API response",
    "MESSAGE_DYNAMIC_GRID_METADATA": "Enable this option if grid Columns are changing based on the API response",
    "LABEL_SELECT_SERVICE": "Select a service:",
    "LABEL_SELECT_SERVICE_TYPE": "Select a service type:",
    "LABEL_TRIGGER_SERVICE": "Trigger service on page load.",
    "LABEL_SELECT_SOURCE": "Source of data:",
    "LABEL_SELECT_OPERATION_TYPE": "Operation/Type",
    "LABEL_SELECT_TABLE": "Table/Entity",
    "LABEL_EXISTING_VARIABLE": "Variable",
    "LABEL_RETRIEVE_DATA": "Retrieve Data From:",
    "MESSAGE_FOR_SERVICE_INPUT": "Service may require inputs please configure them through variable dialog.",
    "LABEL_SELECT_DATANODE": "Select data node",
    "MESSAGE_BINDING_SUCCESS": "Selected field can be bound to the component.",
    "MESSAGE_BINDING_ERROR": "Selected field cannot be bound due to type mismatch.",
    "LABEL_SELECT_A_WIDGET": "Select a component:",
    "MESSAGE_TEMPLATE_SELECT_WIDGET": "Select a template and configure the fields from the properties panel.",
    "MESSAGE_TEMPLATE_MAP_FIELDS": "Customize field display for target platforms or use Advanced Settings from properties panel to configure.",
    "MESSAGE_TEMPLATE_MAP_FIELDS_FORM": "Configure fields for selected ${0}('${1}')",
    "LABEL_SELECT_VIEW": "Select View",
    "LABEL_PAGE_VIEWS": "Page Views",
    "LABEL_DIALOGS": "Dialogs",
    "MESSAGE_MIN_LENGTH_FIRST_NAME": "First name too short: Minimum 2 characters required.",
    "MESSAGE_MAX_LENGTH_FIRST_NAME": "First name too long: Maximum 20 characters allowed.",
    "MESSAGE_MAX_LENGTH_LAST_NAME": "Last name too long: Maximum 20 characters allowed.",
    "MESSAGE_MAX_LENGTH_CURRENT_PASSWORD": "Current password too long: Maximum 20 characters allowed.",
    "MESSAGE_MAX_LENGTH_NEW_PASSWORD": "New password too long: Maximum 20 characters allowed",
    "MESSAGE_MIN_LENGTH_CURRENT_PASSWORD": "Current password too short: Minimum 6 characters required.",
    "MESSAGE_MIN_LENGTH_NEW_PASSWORD": "New password  too short: Minimum 8 characters required.",
    "LABEL_NEW_PASSWORD_HINT": "Password must contain a min of 8 characters and a max of 20 characters including uppercase, lowercase letters,numbers and special characters like _-.@&*!#$%",
    "LABEL_NAME_MAX_LENGTH_HINT": "Name can contain a maximum of 20 characters.",
    "LABEL_PROPERTY_MINPLACEHOLDER": "Min Placeholder",
    "LABEL_PROPERTY_MAXPLACEHOLDER": "Max Placeholder",
    "MESSAGE_HELP_PROPERTY_MAXPLACEHOLDER": "Placeholder to be shown in second component, when range is selected",
    "LABEL_PROPERTY_MINDEFAULTVALUE": "Min Value",
    "LABEL_PROPERTY_MAXDEFAULTVALUE": "Max Value",
    "MESSAGE_HELP_PROPERTY_MAXDEFAULTVALUE": "Default value to be set in second component, when range is selected",
    "LABEL_PROPERTY_LOGINMODE": "Login Mode",
    "LABEL_PROPERTY_BUTTONCAPTION": "Button Caption",
    "LABEL_PROPERTY_BUTTONCLASS": "Button Class",
    "LABEL_PROPERTY_LOGINSUCCESSMESSAGE": "Success Message",
    "LABEL_PROPERTY_SCOPE": "Scope",
    "LABEL_PROPERTY_SECRET": "Secret",
    "LABEL_PROPERTY_ALLOWFULLSCREEN": "Allow Full Screen",
    "LABEL_PROPERTY_DARKCOLOR": "Dark Color",
    "LABEL_PROPERTY_LIGHTCOLOR": "Light Color",
    "LABEL_PROPERTY_LEVEL": "Correction Level",
    "LABEL_PROPERTY_MAPTYPE": "Map Type",
    "LABEL_PROPERTY_LOCATIONS": "Locations",
    "LABEL_PROPERTY_MARKERTYPE": "Location Type",
    "LABEL_PROPERTY_LAT": "Marker Latitude",
    "LABEL_PROPERTY_LNG": "Marker Longitude",
    "LABEL_PROPERTY_INFO": "Marker Info",
    "LABEL_PROPERTY_SHADE": "Perimeter Color",
    "LABEL_PROPERTY_RADIUS": "Perimeter Radius",
    "LABEL_PROPERTY_ZOOM": "Zoom",
    "MESSAGE_WIDGET_CONFIG": "Select template for live component on the left and configure fields on the right. Fields will change according to the template selected on to the left, fields can be also be later configured from advanced tabs from properties panel.",
    "MESSAGE_LIVE_WIDGET_CONFIG": "Select template for live component and in next steps configure respective components that are part of live component.",
    "LABEL_MEMBER_ROLE": "Role",
    "LABEL_MEMBER_CHANGE_ROLE": "Change Role To",
    "LABEL_REMOVE_PROJECT_MEMBER": "Remove Project Member",
    "MESSAGE_REMOVE_PROJECT_MEMBER": "Do you really want to remove '${1}'  from '${0}' project ?",
    "MESSAGE_REMOVE_PROJECT_MEMBER_SUCCESSFUL": "Successfully removed '${1}' from '${0}' project",
    "MESSAGE_EDIT_PROJECT_MEMBER_SUCCESSFUL": "Successfully updated the '${1}' role of '${0} Project'",
    "LABEL_REMOVE_PROJECT_OWNER": "Remove Project Owner",
    "MESSAGE_REMOVE_PROJECT_OWNER": "Owner who created the project cannot be removed.",
    "MESSAGE_EDIT_PROJECT_OWNER": "Do you really want to switch the role of '${1}' from '${2}' to '${3}' in '${0}'  project ?",
    "EDIT_PROJECT_OWNER_TITLE": "Update Member role",
    "LABEL_REMOVE_USER": "Remove User",
    "LABEL_MAKE_OWNER": "Make this member as Owner ?",
    "LABEL_OWNER": "Owner",
    "LABEL_CONTRIBUTOR":"Contributor",
    "LABEL_MEMBERS_IN": "Members in ",
    "PLACEHOLDER_MESSAGE_ADD_MEMBER_EMAILS":"Enter comma separated email address(es).",
    "LABEL_GET_THIS_APP":"Get this App",
    "LABEL_UPGRADE_NOW":"Upgrade Now!",
    "LABEL_MAKE_CONTRIBUTOR": "Make this member as Contributor ?",
    "LABEL_ADD_OWNER": "Add as Owner",
    "LABEL_ADD_CONTRIBUTOR": "Add as Contributor",
    "LABEL_FROM_PROJECT": "this member from the project ?",
    "MESSAGE_UPDATING_ROLE": "Updating Project Member Role...",
    "MESSAGE_APPLY_TEMPLATE_WARNING": "All changes to the current page will be lost. Proceed with caution.",
    "LABEL_CHANGE_TEMPLATE": "Change Template",
    "MESSAGE_FORM_FIELD_CONFIG": "Choose data source from the list of Static Variables or Service Variables, and then configure fields.",
    "LABEL_NOTE": "Note",
    "LABEL_PHONEGAP_CREDENTIALS": "Provide PhoneGap Credentials",
    "MESSAGE_PHONEGAP_CREDENTIALS_NOTE": "We don't store your credentials. We use them to send the project to your PhoneGap account for an effortless build.",
    "LABEL_ADOBE_ID": "Adobe ID",
    "LABEL_SIGN_IN": "Sign in with your Adobe ID to Continue",
    "LABEL_PG_BUILD": "PhoneGap Build",
    "LABEL_SELECT_PLATFORM_KEYS": "Select Platform Keys",
    "LABEL_SELECT_KEY_ANDROID": "Select an Android Key",
    "LABEL_NO_KEYS_ANDROID":"No Android Keys Available",
    "LABEL_SELECT_KEY_IOS": "Select an iOS Key",
    "LABEL_NO_KEYS_IOS":"No iOS Keys Available",
    "MESSAGE_PHONEGAP_BUILD_KEYS": "Without key, only dev builds can be triggered for Android. For iOS builds key is mandatory. Please upload one to your PhoneGap account if you don't have keys and make sure they are unlocked.",
    "LABEL_BUILD_SETTINGS": "Build Settings",
    "LABEL_BUILD_CONFIG_HYDRATION": "Hydration",
    "LABEL_BUILD_CONFIG_PRIVATE_APPLICATION" :"Private Application",
    "LABEL_BUILD_CONFIG_DEBUGGING":"Debugging",
    "LABEL_BUILD_CONFIG_PUBLIC_SHARING": "Public Sharing",
    "MESSAGE_PHONEGAP_AUTH_ERROR": "Please check your Username/Password",
    "MESSAGE_MOBILE_BUILD_ERROR": "Error occurred while processing the build request.",
    "LABEL_PHONEGAP_BUILD_CONFIG": "Build Config",
    "LABEL_PHONEGAP_LOGIN": "Login to PhoneGap",
    "LABEL_PHONEGAP_CONFIG": "PhoneGap Config",
    "LABEL_PHONEGAP_CHECK_STATUS": "Check Status",
    "LABEL_MOBILE_BUILD_SEND_TO_PHONEGAP": "Send To PhoneGap",
    "LABEL_MOBILE_BUILD_SEND_TO_PHONEGAP_TOOLTIP": "Build Using PhoneGap",
    "MESSAGE_FILL_REQUIRED_FIELDS": "Please enter all the mandatory fields and ensure that all fields are in the correct format.",
    "LABEL_NAVIGATION_HELP_TEXT": "HELP:",
    "MESSAGE_NAVIGATION_HELP_TEXT_NONE": "No pagination will be provided.",
    "MESSAGE_NAVIGATION_HELP_TEXT_BASIC": "This option gives a next and previous arrow along with the page numbers at the bottom of the page.",
    "MESSAGE_NAVIGATION_HELP_TEXT_CLASSIC": "A bar with total number of pages and number of items in the current page will be displayed, along with arrows for pagination.",
    "MESSAGE_NAVIGATION_HELP_TEXT_PAGER": "This option gives a next and previous buttons at the bottom of the page for pagination.",
    "MESSAGE_NAVIGATION_HELP_TEXT_INLINE": "This option gives a next and previous arrows at both the sides of the page for pagination, carousel style.",
    "MESSAGE_NAVIGATION_HELP_TEXT_SCROLL": "On the scroll over the list will cause the next page to load and display.",
    "MESSAGE_HELP_MOBILE_APPLICATION_NAME": "Application Name",
    "MESSAGE_HELP_MOBILE_SERVER_PATH": "Server path where the application is hosted",
    "MESSAGE_HELP_MOBILE_APPLICATION_INFORMATION": "Displays the details related to the application",
    "MESSAGE_HELP_MOBILE_APPLICATION_ID": "Provide application ID[Generally package name]",
    "MESSAGE_HELP_MOBILE_APPLICATION_VERSION": "Specify the version of the application",
    "MESSAGE_HELP_MOBILE_APPLICATION_DESCRIPTION": "Make a description of the application",
    "MESSAGE_HELP_MOBILE_DEVELOPER_DETAILS": "Specify developer details",
    "MESSAGE_HELP_MOBILE_DEVELOPER_NAME": "Specify developer's name",
    "MESSAGE_HELP_MOBILE_DEVELOPER_URL": "Specify developer's URL in http://yourdomain.com format",
    "MESSAGE_HELP_MOBILE_DEVELOPER_EMAIL_ID": "Specify developer's email id",
    "MESSAGE_HELP_MOBILE_ORIENTATION": "Choose how the app displays: Default allows rotation, Portrait locks to vertical, Landscape locks to horizontal.",
    "MESSAGE_HELP_MOBILE_APPLICATION_PLUGINS": "Select the device specific plugin required for the application",
    "MESSAGE_HELP_MOBILE_APPLICATION_PLUGINS_EXISTS": "This plugin is already included.",
    "MESSAGE_HELP_MOBILE_APPLICATION_PLUGIN_ERROR": "Enter the plugin id and plugin spec to add.",
    "MESSAGE_HELP_MOBILE_APPLICATION_PLUGIN_URL_INVALID": "Please specify valid github url, eg: https://github.com/petermetz/cordova-plugin-ibeacon.git",
    "MESSAGE_HELP_RN_MOBILE_APPLICATION_PLUGIN_URL_INVALID": "Please specify valid github url, eg: https://github.com/react-native-webview/react-native-webview.git",
    "MESSAGE_HELP_MOBILE_APPLICATION_PLUGIN_VER_INVALID": "Please specify the plugin version, eg: 0.8.3",
    "MESSAGE_HELP_MOBILE_APPLICATION_IS_STANDARD_PLUGIN": "This plugin is already available. Please select it from standard plugins.",
    "MESSAGE_HELP_MOBILE_APPLICATION_PLUGIN_ID_EMPTY": "Enter the plugin id.",
    "MESSAGE_HELP_MOBILE_APPLICATION_CUSTOM_PLUGINS": "Add the custom plugins to the application",
    "MESSAGE_HELP_MOBILE_APPLICATION_SERVER_PATH_INVALID": "Server path should not contain hash or query params.",
    "MESSAGE_HELP_MOBILE_APPLICATION_NAVIGATION_WHITELIST": "List URL's to access external websites in the application",
    "MESSAGE_HELP_MOBILE_APPLICATION_INTENT_WHITELIST": "Controls which URLs the app is allowed to open",
    "MESSAGE_HELP_MOBILE_INVALID_APPLICATION_ID": "Invalid application id. Application id is a reversed domain name and it has segments of alphanumeric characters separated dot (.) character. Each segment must start with an alphabet. Ex: com.appId",
    "MESSAGE_HELP_MOBILE_BUILD_CONFIG_PROFILES": "Build configuration like 'perform angular compilation' are taken from this profile.",
    "MESSAGE_HELP_ANDROID_APPLICATION_PREFERENCES": "Application properties specific to android",
    "MESSAGE_HELP_IPHONE_APPLICATION_IPHONE_PREFERENCES": "Application properties specific to iphone",
    "MESSAGE_HELP_ANDROID_APPLICATION_MINIMUM_TARGET" : "App cannot be installed on device with android os version less than minimum specified version.",
    "MESSAGE_HELP_IPHONE_APPLICATION_TARGET" : "Specifies target version for iphone",
    "MESSAGE_HELP_ANDROID_PRERENDERED_ICON" : "Specify android prepended icon",
    "MESSAGE_HELP_IPHONE_PRERENDERED_ICON" : "Specify iOS prepended icon",
    "MESSAGE_HELP_IOS_FILE_SHARING" : "If enabled, then documents/files of app can be imported/exported using iTunes.",
    "MESSAGE_HELP_ANDROID_STATUS_BAR_STYLE": "Specify android status bar style",
    "MESSAGE_HELP_IPHONE_STATUS_BAR_STYLE": "Specify iphone status bar style",
    "MESSAGE_HELP_ANDROID_APPLICATION_FULL_SCREEN": "Sets the android device to full screen",
    "MESSAGE_HELP_IPHONE_APPLICATION_FULL_SCREEN": "Sets the iphone device to full screen",
    "MESSAGE_HELP_ANDROID_APPLICATION_ICON": "Select or edit android specific icons",
    "MESSAGE_HELP_IPHONE_APPLICATION_ICON": "Select or edit iphone specific icons",
    "MESSAGE_HELP_ANDROID_APPLICATION_SPLASH_SCREEN": "Select or edit android specific splash screen",
    "MESSAGE_HELP_IPHONE_APPLICATION_SPLASH_SCREEN": "Select or edit iphone specific splash screen",
    "MESSAGE_HELP_MOBILE_SPLASH_PREVIEW_INFO": "Select an option to preview here. Background will preview with icon and background color. Animation will preview animation. App launch will preview both.",
    "LABEL_EDIT_APP_ICONS_SPLASHSCREENS": "Edit App Icons / SplashScreens",
    "LABEL_SELECTED_FILE_PLACEHOLDER": "Selected file name goes here",
    "LABEL_SEARCH_USER_DATABASE": "User Database",
    "LABEL_SEARCH_USER_TABLE": "User Table",
    "LABEL_SEARCH_USER_ID": "User ID Column",
    "LABEL_SEARCH_USER_NAME": "User Name Column",
    "LABEL_SEARCH_USER_PASSWORD": "User Password Column",
    "LABEL_SEARCH_LIVE_FILTER_FIELD": "Filter Field",
    "LABEL_SEARCH_API_METHODS": "Search by Method Name or URL",
    "LABEL_HOST_NAME": "Host Name",
    "LABEL_BASE_PATH": "Base Path",
    "LABEL_OPEN_API_SECURITY_MSG": "Please make sure the below information is configured correctly. Without these, the imported APIs may not work.",
    "LABEL_FILTER": "Filter",
    "LABEL_VIEW_AS":"View As",
    "MESSAGE_USE_FUNCTIONS_IN_EXPRESSIONS": "If expression is more than 100 characters, better to wrap the expression in a function and call the function from here.",
    "LABEL_HIDDEN_WIDGET": "Hidden Component",
    "LABEL_FILE_EXPLORER": "File Explorer",
    "LABEL_SHORTCUTS": "Shortcuts",
    "LABEL_INSPECT": "Inspect",
    "LABEL_ISSUES": "Issues",
    "LABEL_API_ISSUES": "API Issues",
    "LABEL_API": "API",
    "LABEL_ISSUE_LOCATION": "Issue Location",
    "LABEL_SELECT_API": "Select API",
    "LABEL_SELECT_ISSUE_LOCATION": "Select Issue Location",
    "LABEL_PLEASE_SELECT_API": "Please select API",
    "HEADING_RE_IMPORT_API_TOUR": "Re-import APIs",
    "MESSAGE_RE_IMPORT_API_TOUR": "Now you can easily adapt to changes in APIs by reimporting them. Easily find and fix breaking changes in any of your application pages.",
    "LABEL_SELECT_ISSUE_TO_SEE_RESOLUTION_STEPS": "Select issue to see resolution steps",
    "LABEL_SELECT_API_TO_SEE_ISSUES": "Select API to see issues",
    "LABEL_SELECT_ISSUE_LOCATION_TO_SEE_ISSUES": "Select Issue Location to see issues",
    "LABEL_KEYBOARD_SHORTCUTS": "Keyboard Shortcuts",
    "LABEL_KEYBOARD_CTRL_S": "Save the content",
    "LABEL_KEYBOARD_CTRL_ALT_Q": "Test drive your app without toolbar",
    "LABEL_KEYBOARD_CTRL_ALT_R": "Test drive your app",
    "LABEL_KEYBOARD_CTRL_ALT_P": "preview",
    "LABEL_KEYBOARD_CTRL_SPACE": "Suggestions in script",
    "LABEL_KEYBOARD_ESC": "Move to the parent element",
    "LABEL_KEYBOARD_DLT": "Delete element, page",
    "LABEL_KEYBOARD_CTRL_C": "Copy element",
    "LABEL_KEYBOARD_CTRL_V": "Paste element",
    "LABEL_KEYBOARD_CTRL_Z": "Undo",
    "LABEL_KEYBOARD_CTRL_SHIFT_Z": "Redo",
    "LABEL_KEYBOARD_CTRL_ENTER": "Query run",
    "LABEL_PAGE_STRUCTURE": "Page Structure",
    "LABEL_DATABASES": "Databases",
    "LABEL_DATAMODELS":"Data Models",
    "LABEL_REGIONS": "Regions",
    "LABEL_METADATA_SERVICE_URL": "Service Url",
    "PLACEHOLDER_METADATA_SERVICE_URL": "http[s]://example.com",
    "LABEL_CONFIGURE_URL": "Configure Service Url",
    "LABEL_JAVA_SERVICES": "Java Services",
    "MESSAGE_HELP_TUTORIALS_NO_DATA": "No Tutorials Found",
    "LABEL_TUTORIALS": "Tutorials",
    "MESSAGE_HELP_TUTORIALS_LOADING": "Loading Tutorials...",
    "LABEL_TUTORIAL_APP": "Tutorial Application",
    "MESSAGE_HELP_TUTORIAL_COMPLETE": "% complete",
    "LABEL_ADD_USER": "Add New Member",
    "LABEL_USER_MANAGEMENT_PERMISSIONS": "Permissions",
    "LABEL_USER_MANAGEMENT_PERMISSIONS_VIEW_ALL": "All",
    "LABEL_USER_MANAGEMENT_PERMISSIONS_VIEW_BY_ROLE": "By Role",
    "USER_MANAGEMENT_LABEL_DIALOG": "User Management",
    "USER_MANAGEMENT_SUCCESS_USER_CHANGE": "Member updated successfully",
    "LABEL_DELETE_USER": "Delete Member",
    "MESSAGE_USER_DELETE":"Are you sure you want to delete user - \"${0}\" from the project?",
    "LABEL_RESTORE_USER": "Restore this Member",
    "USERS_ASSIGNED_TO_ROLE": "No member assigned to this role",
    "LABEL_DELETE_USER_TOOLTIP": "Delete this user",
    "LABEL_RECENT_ITEMS": "Recent Items",
    "MESSAGE_WRITE_CONFIG_SUCCESS": "Config of the template bundle successfully updated",
    "MESSAGE_WRITE_CONFIG_ERROR": "Error while writing the config file of template bundle",
    "MESSAGE_READ_CONFIG_ERROR": "Error while reading the config file of template bundle",
    "TITLE_WRITE_CONFIG_SUCCESS": "Success",
    "TITLE_WRITE_CONFIG_ERROR": "Write config Error",
    "TITLE_READ_CONFIG_ERROR": "Read config Error",
    "MESSAGE_404_ERROR": "Requested resource not found",
    "MESSAGE_401_ERROR": "Requested resource requires authentication",
    "MESSAGE_LOADING_PROCEDURE": "Loading Procedure List from Database...",
    "MESSAGE_NO_PROCEDURE": "No procedures in database",
    "LABEL_NUMBER_OF_RECORDS_ADDED": "Number of Records Added",
    "LABEL_NUMBER_OF_RECORDS_UPDATED": "Number of Records Updated",
    "LABEL_NUMBER_OF_RECORDS_DELETED": "Number of Records Deleted",
    "LABEL_TABLE_COLUMNS":"Table Columns",
    "LABEL_LAYOUT": "Layout",
    "LABEL_FILTER_LAYOUT": "Filter Layout",
    "LABEL_FILTER_Fields": "Filter Fields",
    "LABEL_FORM_LAYOUT": "Form Layout",
    "LABEL_FORM_FIELDS": "Form Fields",
    "LABEL_SIMPLE_VIEW_ONLY": "Simple View only",
    "LABEL_INLINE_EDITABLE": "Inline Editable",
    "LABEL_FORM_AS_DIALOG": "Form as Dialog",
    "LABEL_FORM_BELOW": "Form Below",
    "LABEL_DETAILS_BELOW": "Details Below",
    "LABEL_QUICK_EDIT": "Quick Edit",
    "LABEL_1_COLUMN": "1 Column",
    "LABEL_2_COLUMN": "2 Column",
    "LABEL_3_COLUMN": "3 Column",
    "LABEL_MOBILE_INLINE": "Inline",
    "LABEL_MOBILE_PAGE": "Page",
    "LABEL_MOBILE_DIALOG_FORM": "Dialog Form",
    "LABEL_LIVE_WIDGET_LAYOUT": "Live Component Layout",
    "LABEL_FILTER_WITH_GRID_AND_FORM": "Filter with Grid and Form",
    "LABEL_LIST_WITH_FORM": "List with Form",
    "LABEL_PAGINATION_BASIC": "Basic",
    "LABEL_PAGINATION_PAGER": "Pager",
    "LABEL_PAGINATION_CLASSIC": "Classic",
    "LABEL_PAGINATION_NONE": "None",
    "LABEL_MATCHMODE_CONTAINS_IGNORE_CASE": "Contains ignore case",
    "LABEL_MATCHMODE_CONTAINS": "Contains",
    "LABEL_MATCHMODE_STARTS_WITH_IGNORE_CASE": "Starts with ignore case",
    "LABEL_MATCHMODE_STARTS WITH": "Starts with",
    "LABEL_MATCHMODE_ENDS_WITH_IGNORE_CASE": "Ends with ignore case",
    "LABEL_MATCHMODE_ENDS_WITH": "Ends with",
    "LABEL_MATCHMODE_IS_EQUAL_TO_IGNORE_CASE": "Is equal to ignore case",
    "LABEL_MATCHMODE_IS_EQUAL_TO": "Is equal to",
    "LABEL_MATCHMODE_IS_NOT_EQUAL_TO": "Is not equal to",
    "LABEL_MATCHMODE_IS_NULL": "Is null",
    "LABEL_MATCHMODE_IS_NOT_NULL": "Is not null",
    "LABEL_MATCHMODE_IS_EMPTY": "Is empty",
    "LABEL_MATCHMODE_IS_NOT_EMPTY": "Is not empty",
    "LABEL_MATCHMODE_IS_NULL_OR_EMPTY": "Is null or empty",
    "LABEL_MATCHMODE_IN": "In",
    "LABEL_MATCHMODE_LESS_THAN": "Less than",
    "LABEL_MATCHMODE_LESS_THAN_OR_EQUALS_TO": "Less than or equals to",
    "LABEL_MATCHMODE_GREATER_THAN": "Greater than",
    "LABEL_MATCHMODE_GREATER_THAN_OR_EQUALS_TO": "Greater than or equals to",
    "LABEL_MATCHMODE_BETWEEN": "Between",
    "LABEL_ALL":"All",
    "LABEL_ALL_THEME":"All Theme",
    "LABEL_FOR_DELETE_THEME":"Are you sure you want to delete",
    "LABEL_TABLET": "Tablet",
    "LABEL_LAPTOP_TABLET_LANDSCAPE":"Laptop\\Tablet Landscape",
    "LABEL_USE_BLANK_DESCRIPTION": "Use Blank Template",
    "LABEL_BLANK_CANVAS_DESCRIPTION": "Blank Canvas",
    "LOGIN_OPTIONS_DIALOG": "Dialog",
    "LOGIN_OPTIONS_PAGE": "Page",
    "LABEL_DIALOG_CLOSE": "Close",
    "LABEL_APP_INSPECTION_RESULTS": "App Inspection Results",
    "LABEL_MESSAGE_ERRORCOUNT": "Error Count:",
    "LABEL_MESSAGE_WARNINGCOUNT": "Warning Count:",
    "LABEL_MORE_DETAILS": " for more details.",
    "MESSAGE_ERROR_JOB_FAILED": "Inspection has failed. Click on refresh to inspect again.",
    "MESSAGE_INFO_JOB_TOO_LONG": "Inspection may take some time to complete. You can continue to work and access inspection results after some time.",
    "LABEL_NO_INSPECT_ERRORS": "No errors found in the App. Click on refresh to inspect again.",
    "LABEL_ADD_ACCORDION_PANE": "Add Accordion Pane",
    "LABEL_ADD_TAB_PANE": "Add Tab Pane",
    "LABEL_ADD_STEP": "Add Step",
    "LABEL_ADD_CAROUSEL": "Add Carousel",
    "LABEL_ADD_BUTTON": "Add Button",
    "LABEL_EXPAND_NODE":"Expand Node",
    "LABEL_DO_NOTHING": "Do Nothing",
    "LABEL_RE_IMPORT": "Re-Import",
    "LEBEL_REMOVE_TOOLBAR": "Remove Toolbar",
    "MESSAGE_PREVIEW_BARCODE": "Mobile native features will not work in browsers.",
    "LABEL_DEVICE_CATEGORY_WEB": "Web",
    "LABEL_DEVICE_CATEGORY_TAB": "Tab",
    "LABEL_DEVICE_CATEGORY_SMARTPHONE": "SmartPhone",
    "LABEL_DEVICE_FULL_SCREEN": "Full Screen",
    "LABEL_DEVICE_LAPTOP_WITH_HIDPI_SCREEN": "Laptop with HiDPI Screen",
    "LABEL_DEVICE_LAPTOP_WITH_MDPI_SCREEN": "Laptop with MDPI Screen",
    "LABEL_DEVICE_LAPTOP_WITH_TOUCH": "Laptop with Touch",
    "LABEL_DEVICE_APPLE_IPAD": "Apple iPad",
    "LABEL_DEVICE_APPLE_IPAD_MINI": "Apple iPad Mini",
    "LABEL_DEVICE_APPLE_IPHONE_X": "Apple iPhone X",
    "LABEL_DEVICE_APPLE_IPHONE_15_PRO": "Apple iphone 15 Pro",
    "LABEL_DEVICE_APPLE_IPHONE_15_PLUS": "Apple iphone 15 Plus",
    "LABEL_DEVICE_APPLE_IPHONE_16": "Apple iphone 16",
    "LABEL_DEVICE_APPLE_IPHONE_16_PRO_MAX": "Apple iphone 16 Pro Max",
    "LABEL_DEVICE_GOOGLE_PIXEL_8": "Google Pixel 8",
    "LABEL_DEVICE_SAMSUNG_GALAXY_S20": "Samsung Galaxy S20",
    "LABEL_DEVICE_SAMSUNG_GALAXY_S21": "Samsung Galaxy S21",
    "LABEL_DEVICE_SAMSUNG_GALAXY_S24_ULTRA": "Samsung Galaxy S24 Ultra",
    "LABEL_DEVICE_IPAD_AIR_11_M2": "Apple iPad Air 11\" (M2)",
    "LABEL_DEVICE_IPAD_PRO_11_M4": "Apple iPad Pro 11\" (M4)",
    "LABEL_DEVICE_GOOGLE_NEXUS_10": "Google Nexus 10",
    "LABEL_DEVICE_GOOGLE_NEXUS_7": "Google Nexus 7",
    "LABEL_DEVICE_APPLE_IPHONE_5": "Apple iPhone 5",
    "LABEL_DEVICE_APPLE_IPHONE_6": "Apple iPhone 6",
    "LABEL_DEVICE_APPLE_IPHONE_6_PLUS": "Apple iPhone 6 Plus",
    "LABEL_DEVICE_APPLE_IPHONE_6_7_8": "Apple iPhone 6/7/8",
    "LABEL_DEVICE_APPLE_IPHONE_6_7_8_PLUS": "Apple iPhone 6/7/8 Plus",
    "LABEL_DEVICE_APPLE_IPHONE_7": "Apple iPhone 7",
    "LABEL_DEVICE_APPLE_IPHONE_7_PLUS": "Apple iPhone 7 Plus",
    "LABEL_DEVICE_APPLE_IPHONE_8": "Apple iPhone 8",
    "LABEL_DEVICE_APPLE_IPHONE_8_PLUS": "Apple iPhone 8 Plus",
    "LABEL_DEVICE_SAMSUNG_GALAXY_NOTE_III": "Samsung Galaxy Note III",
    "LABEL_PREFAB_TAB_IN_BOUND_PPROPERTIES": "Inputs",
    "LABEL_PREFAB_TAB_OUT_BOUND_PPROPERTIES":"Output",
    "LABEL_PREFAB_TAB_METHODS": "Methods",
    "LABEL_PREFAB_TAB_EVENTS": "Event Logs",
    "LABEL_PREFAB_NO_METHODS": "There are no methods.",
    "LABEL_PREFAB_NO_IN_BOUND_PROPS": "There are no in-bound properties.",
    "LABEL_PREFAB_NO_OUT_BOUND_PROPS": "There are no outbound properties.",
    "LABEL_PREFAB_NO_EVENT_LOGS": "There are no event logs.",
    "LABEL_WAVELENSE_HEADING": "WaveLens",
    "MESSAGE_PREVIEW_WAVELENCE": "To preview the mobile app in your device use <b>WaveLens</b>. For more details ",
    "LABEL_UPDATE_OUT_BOUND_PPROPERTIES": "Update outbound properties",
    "LABEL_CLEAR_LOGS":"Clear logs",
    "LABEL_PREVIEW_PROPERTY": "Property: ",
    "LABEL_REFERENCE" : "Reference",
    "LABEL_ATTRIBUTE_TYPE_PRIMITIVE": "Primitive",
    "LABEL_ATTRIBUTE_TYPE_ENTITY": "Entity",
    "LABEL_ATTRIBUTE_TYPE_LOOKUPDATA": "LookUpData",
    "LABEL_DATABASE_GENERATORS_ASSIGNED": "assigned",
    "LABEL_DATABASE_GENERATORS_IDENTITY": "auto increment",
    "LABEL_DATABASE_GENERATORS_UNIQUEID": "unique id",
    "LABEL_DATABASE_GENERATORS_SEQUENCE": "sequence",
    "LABEL_ROW_DETAIL": "Row Detail",
    "LABEL_ENABLE_ROW_EXPANSION": "Enable Row Expansion",
    "LABEL_EXPAND_ICON": "Expand icon",
    "LABEL_COLLAPSE_ICON": "Collapse icon",
    "LABEL_PLACE_AFTER_COLUMN": "Place after column",
    "LABEL_ONROWEXPAND": "On Row Expand",
    "LABEL_ONROWCOLLAPSE": "On Row Collapse",
    "LABEL_ONBEFOREROWEXPAND": "On Before Row Expand",
    "LABEL_ONBEFOREROWCOLLAPSE": "On Before Row Collapse",
    "HELP_MESSAGE_WIDGET_DESIGNER_CONTENT": "Content(Partial) to be loaded when row is expanded",
    "HELP_MESSAGE_WIDGET_DESIGNER_ROWICONPOSITION": "This property determines the position of the expand/collapse icon column",
    "HELP_MESSAGE_WIDGET_DESIGNER_EXPANDICON": "Icon class for expand action",
    "HELP_MESSAGE_WIDGET_DESIGNER_COLLAPSEICON": "Icon class for collapse action",
    "HELP_MESSAGE_WIDGET_DESIGNER_CLOSEOTHERS": "This property specifies whether on clicking of a row, should other rows close",
    "HELP_MESSAGE_WIDGET_DESIGNER_HEIGHT": "The height of partial content can be specified in px or % (i.e 50px, 75%)",
    "HELP_MESSAGE_WIDGET_DESIGNER_ONROWEXPAND": "The action to invoke when row is expanded",
    "HELP_MESSAGE_WIDGET_DESIGNER_ONROWCOLLAPSE": "The action to invoke when row is collapsed",
    "HELP_MESSAGE_WIDGET_DESIGNER_ONBEFOREROWEXPAND": "The action to invoke before row is expanded",
    "HELP_MESSAGE_WIDGET_DESIGNER_ONBEFOREROWCOLLAPSE": "The action to invoke before row is collapsed",
    "HELP_MESSAGE_WIDGET_DESIGNER_ENABLEROWEXPANSION": "This property is used to enable row expansion feature",
    "HELP_MESSAGE_WIDGET_DESIGNER_TABLE_WIDGET": "Select a component from the list of available components. The selected component will be displayed in the table column.",
    "PLACEHOLDER_DESIGNER_TITLE": "Title for the component",
    "PLACEHOLDER_DESIGNER_CAPTION": "Caption for the component",
    "PLACEHOLDER_DESIGNER_CLASS": "Class for the component",
    "MESSAGE_UPGRADE_OVERLAY_PROJECT_PAGE": "You are working in an older platform version that will no longer be supported. Upgrade your app now.",
    "MESSAGE_UPGRADE_OVERLAY_PROJECTS_LIST_PAGE": "One or more projects are running on older WM version. Start upgrading your projects to WM10.0.",
    "MESSAGE_UPGRADE_OVERLAY_MIGRATION": "Migration period ends in",
    "LABEL_LEARN_MORE_ABOUT_WM_10": "Learn More about WM 10.0",
    "WN_WELCOME_TO_WAVEMAKER": "Welcome To WaveMaker 10.0",
    "WN_WAVEMAKER_DESCRIPTION": "Take modernization efforts to a whole new level with the new WaveMaker 10.0. It lets you accelerate to a modern stack, boost developer productivity and improve app performance out-of-the-box. Secure, stable and no lock-in as always.",
    "WN_ANGULAR": "Powerful UI with Angular 7",
    "WN_SYNC_CODE": "Sync code with your favorite IDEs",
    "WN_PUBLISH_ARTIFACT": "Publish to enterprise artifact repository",
    "WN_S1_DESC1": "You can work on both the version of projects",
    "WN_S1_DESC1_VERSIONS": "(WM 9.x & WM 10.0)",
    "WN_S1_DESC1_SEAMLESSLY": "seamlessly.",
    "WN_S1_DESC2_1": "Go to",
    "WN_S1_DESC2_2": "'Next slide'",
    "WN_S1_DESC2_3": "to see how to upgrade your projects to WaveMaker 10.0 and continue using 9.x alongside.",
    "WN_S2_H1_1": "Power packed WaveMaker",
    "WN_S2_H1_2": "10.0 comes with enhanced interactions.",
    "WN_S2_B1": "Redesigned project card",
    "WN_S2_B2": "Upgrade alert indicator",
    "WN_S2_B4": "Platform version indicator",
    "WN_S2_B5": "Updated contextual menu",
    "WN_S3_H1_1": "Understanding the new",
    "WN_S3_H1_2": "project card",
    "WN_S3_B1": "Indicates upgrade pending",
    "WN_S3_B2": "You can initiate upgrade from contextual menu",
    "WN_S3_B3": "Platform version of the project",
    "WN_S3_B4": "Your role in the project",
    "WN_S3_B5": "Manage individual versions here",
    "LABEL_LEARN_DOC_LINK": "https://www.wavemaker.com/learn/how-tos/guide-to-upgrade-an-app-wavemaker-9x-to-wavemaker-10-0/",
    "LABEL_QUICK_GUIDE": "Quick Guide",
    "MESSAGE_PLACEHOLDER_OPEN_API_SERVICE_ID": "Enter Service ID",
    "LABEL_SWAGGER_FILE": "Swagger File",
    "LABEL_OPEN_API_ENTITY_MSG": "Below is a list of Entities and the CRUD endpoints we have identified. You can modify the CRUD type by clicking on the dropdown for each respective endpoint.",
    "LABEL_CRUD_ENDPOINTS": "CRUD endpoints",
    "LABEL_OTHER_ENDPOINTS": "Other endpoints",
    "LABEL_PROPERTY_UI_TYPE": "UI Type",
    "LABEL_TIMES": "times",
    "LABEL_DEPLOYED_IN": "Deployed in",
    "LABEL_DEPLOYED": "Deployed",
    "MSG_CANNOT_UNDO_ACTION": "You cannot undo this action.",
    "MSG_DIALOG_LEAVE_PROJECT": "If you want to leave the project click on \"Leave Project\".",
    "LABEL_YOU": "You",
    "LABEL_STUDIO_UI_VERSION": "Studio Designer Version",
    "LABEL_APP_RUNTIME_UI_VERSION": "App Runtime UI Version",
    "LABEL_APP_RUNTIME_SERVICES_VERSION": "App Runtime Services Version",
    "MESSAGE_HEADER_RESEND_EMAIL_TEXT" : "Please verify your email ID. Check your email for the activation link.",
    "LABEL_CHOOSE_PLATFORM_TYPE" : "Choose Platform Type",
    "MESSAGE_LOADING_SERVICES": "Loading Services...",
    "LABEL_TOTAL_RECORDS": "Total Records",
    "LABEL_PROPERTY_VIEWLESSMESSAGE":"View Less Button Message",
    "MESSAGE_HELP_PROPERTY_VIEWLESSMESSAGE":"The property can be used to customize the view less button message.",
    "LABEL_PROPERTY_SHOWVIEWLESSBUTTON": "Show View Less Button",
    "MESSAGE_HELP_PROPERTY_SHOWVIEWLESSBUTTON": "This property enables you to compress the data table when it is fully expanded.",
    "PAGE_ADJUSTMENTS": "Page adjustments",
    "FIT_SCREEN": "Fit to Screen",
    "LAPTOP_RESOLUTION": "Laptop (Mdpi)",
    "LABEL_DEPENDENCIES": "Dependencies",
    "LABEL_SEARCH_DEPENDENCY": "Search Dependency",
    "LABEL_ADD_DEPENDENCY_TO_SERVICE": "Add '${0}' dependency to this Java Service",
    "LABEL_SERVICE_ADDED_TO_JAVASERVICE": "'${0}' is added as a dependency to this Java Service.",
    "LABEL_SELF_DEPENDENCY_NOT_SUPPORTED": "Self-dependency is not supported currently.",
    "LABEL_ADDED_SERVICE_SUCCESSFULLY": "'${0}' dependency is imported and autowired successfully.",
    "MSG_UNABLE_TO_LOAD_DEPENDENCIES": "Unable to load dependencies",
    "LABEL_MERGE_CHANGES": "Merge Changes",
    "LABEL_RESULTS": "Results",

    "LABEL_COMPONENT_ALL": "All",
    "LABEL_COMPONENT_I18N": "I18N",
    "LABEL_COMPONENT_PAGE": "Pages",
    "LABEL_COMPONENT_PREFAB": "Prefabs",
    "LABEL_COMPONENT_PROFILE": "Profiles",
    "LABEL_COMPONENT_STATIC_RESOURCE": "Static Resources",
    "LABEL_COMPONENT_SERVICE": "Services",
    "LABEL_COMPONENT_THEME": "Theme",
    "LABEL_COMPONENT_OTHER": "Others",

    "LABEL_CONFLICTS": "Conflicts",
    "LABEL_RESOLVED": "Resolved",

    "LABEL_CHANGE_TYPE": "Change Type",
    "LABEL_DISCARD_SYNC_PLUGIN_CHANGES": "Discard Sync Plugin Changes",
    "LABEL_DISCARD_DRAFT_MERGE": "Discard Draft Merge Changes",
    "LABEL_DISCARD_AUTOCODE_MERGE": "Discard Autocode Merge Changes",
    "LABEL_VIEW_ALL_STEPS": "View all steps",
    "LABEL_FINISH_MERGE": "Finish Merge",
    "LABEL_MERGE_STATUS": "Merge Status",
    "LABEL_INITIALLY": "Initially",

    "LABEL_CHANGE_TYPE_ALL_CHANGES": "All",
    "LABEL_CHANGE_TYPE_COMMON_CHANGES": "Common Changes",
    "LABEL_CHANGE_TYPE_CONFLICTED": "Conflicted",
    "LABEL_CHANGE_TYPE_RESOLVED": "Resolved",
    "LABEL_CHANGE_TYPE_OUR_CHANGES": "Our Changes",
    "LABEL_CHANGE_TYPE_THEIR_CHANGES": "Their Changes",
    "LABEL_CHANGE_TYPE_NEW_CHANGES": "New Changes",
    "LABEL_CHANGE_TYPE_APPLIED_CHANGES": "Updated",

    "MSG_MERGE_FROM_PARENT_SUCCESS_NEXT_STEP": "Please reload the Studio to begin the merge process.",
    "MSG_MERGE_FROM_PARENT_SUCCESS": "Your branch has been successfully updated with '${ref}'",
    "MSG_MERGE_FROM_PARENT_IN_PROGRESS": "Updating your branch with '${ref}'...",
    "MSG_MERGE_TO_PARENT_SUCCESS_NEXT_STEP": "Merge process completed successfully. <br> Go back to project list page to view your project.",
    "MSG_MERGE_TO_PARENT_SUCCESS": "Your branch has been successfully merged to '${ref}'.",
    "MSG_MERGE_TO_PARENT_IN_PROGRESS": "Merging Your Branch to '${ref}'...",
    "MSG_COMPARE_WITH_PARENT_BRANCH": "Comparing Your Branch with Parent Branch",
    "MSG_UPGRADE_BRANCH_UP_TO_DATE_WITH_PARENT_BRANCH": "<strong>Your Branch is up to date with '${ref}'.</strong>",
    "MSG_PROCEED_UPGRADE_BRANCH_UP_TO_DATE_WITH_PARENT_BRANCH": "Please click on Proceed to complete the merge process.",
    "MSG_UPGRADE_BRANCH_BEHIND_PARENT_BRANCH": "<strong>Your branch is behind '${ref}' by ${behindCount} commits</strong>.",
    "MSG_PROCEED_UPGRADE_BRANCH_BEHIND_PARENT_BRANCH": "Please click on Proceed to update your branch with <strong>'${ref}'</strong>. <br> This action will initiate the new Merge process.",

    "LABEL_CHANGES_FROM_CORE_UPGRADE": "Changes From Core",
    "LABEL_CHANGES_FROM_BRANCH_MERGE": "Changes From Branch",

    "LABEL_CORE_UPGRADE_NO_CHANGES": "No Changes",
    "LABEL_CORE_UPGRADE_NO_PATH": "No Path",
    "LABEL_CORE_UPGRADE_ADDED_IN_OURS": "Added in Ours",
    "LABEL_CORE_UPGRADE_MODIFIED_IN_OURS": "Modified in Ours",
    "LABEL_CORE_UPGRADE_DELETED_IN_OURS": "Deleted in Ours",
    "LABEL_CORE_UPGRADE_ADDED_IN_THEIRS": "Added  in Core",
    "LABEL_CORE_UPGRADE_MODIFIED_IN_THEIRS": "Modified in Core",
    "LABEL_CORE_UPGRADE_DELETED_IN_THEIRS": "Deleted in Core",
    "LABEL_CORE_UPGRADE_BOTH_ADDED_SAME": "Both Added Same",
    "LABEL_CORE_UPGRADE_BOTH_MODIFIED_SAME": "Both Modified Same",
    "LABEL_CORE_UPGRADE_BOTH_ADDED": "Both Added",
    "LABEL_CORE_UPGRADE_BOTH_MODIFIED": "Both Modified",
    "LABEL_CORE_UPGRADE_BOTH_DELETED": "Both Deleted",
    "LABEL_CORE_UPGRADE_MODIFIED_IN_OURS_DELETED_IN_THEIRS": "Modified in Ours and Deleted in Core",
    "LABEL_CORE_UPGRADE_MODIFIED_IN_THEIRS_DELETED_IN_OURS": "Modified in Core and Deleted in Ours",

    "LABEL_CORE_UPGRADE_APPLIED_OURS": "Applied Ours",
    "LABEL_CORE_UPGRADE_APPLIED_OURS_DELETED": "Deleted",
    "LABEL_CORE_UPGRADE_APPLIED_THEIRS": "Applied Core",
    "LABEL_CORE_UPGRADE_APPLIED_THEIRS_DELETED": "Deleted",
    "LABEL_CORE_UPGRADE_APPLIED_SAME": "Applied Same",
    "LABEL_CORE_UPGRADE_APPLIED_SAME_DELETED": "Deleted",
    "LABEL_CORE_UPGRADE_EDITED_OURS": "Edited Ours",
    "LABEL_CORE_UPGRADE_EDITED_THEIRS": "Edited Core",
    "LABEL_CORE_UPGRADE_AUTO_RESOLVED_BY_VCS": "Auto Merged by GIT",
    "LABEL_CORE_UPGRADE_AUTO_RESOLVED_BY_VCS_APPLIED_OURS": "Auto Merged to Our Changes by GIT",
    "LABEL_CORE_UPGRADE_AUTO_RESOLVED_BY_VCS_APPLIED_THEIRS": "Auto Merged to Core Changes by GIT",
    "LABEL_CORE_UPGRADE_AUTO_RESOLVED_BY_STUDIO": "Auto Merged by Studio",
    "LABEL_CORE_UPGRADE_AUTO_RESOLVED_BY_STUDIO_APPLIED_OURS": "Auto Merged by Studio, Applied Ours",
    "LABEL_CORE_UPGRADE_AUTO_RESOLVED_BY_STUDIO_APPLIED_THEIRS": "Auto Merged by Studio, Applied Core",
    "LABEL_CORE_UPGRADE_PATH_CONFLICTED": "Conflicted",
    "LABEL_CORE_UPGRADE_CONTENT_CONFLICTED": "Conflicted",
    "LABEL_CORE_UPGRADE_MANUALLY_MERGED": "Merged Manually",
    "LABEL_CORE_UPGRADE_MERGED_INNER_FILES": "Merged Inner Files",
    "LABEL_CORE_UPGRADE_UNRESOLVED_INNER_FILES": "Unresolved Inner Files",
    "LABEL_CORE_UPGRADE_NEWLY_ADDED": "Newly Added",
    "LABEL_CORE_UPGRADE_NEWLY_MODIFIED": "Newly Modified",
    "LABEL_CORE_UPGRADE_NEWLY_DELETED": "Newly Deleted",

    "LABEL_CORE_UPGRADE_APPLY_OURS": "Apply Ours",
    "LABEL_CORE_UPGRADE_APPLY_OURS_DELETE": "Delete",
    "LABEL_CORE_UPGRADE_APPLY_THEIRS": "Apply Core",
    "LABEL_CORE_UPGRADE_APPLY_THEIRS_DELETE": "Delete",
    "LABEL_CORE_UPGRADE_APPLY_SAME": "Apply Same",
    "LABEL_CORE_UPGRADE_APPLY_SAME_DELETE": "Delete",
    "LABEL_CORE_UPGRADE_APPLY_EDITED_OURS": "Apply Edited Ours",
    "LABEL_CORE_UPGRADE_APPLY_EDITED_THEIRS": "Apply Edited Core",
    "LABEL_CORE_UPGRADE_APPLY_AUTO_RESOLVED_CHANGES": "Apply Auto Resolved Changes",
    "LABEL_CORE_UPGRADE_RESOLVE_PATH_CONFLICT": "Resolve Conflict",
    "LABEL_CORE_UPGRADE_RESOLVE_CONFLICTS": "Resolve Conflicts",
    "LABEL_CORE_UPGRADE_RE_RESOLVE_CONFLICTS": "Re Resolve Conflicts",
    "LABEL_CORE_UPGRADE_APPLY_MANUALLY_MERGED_CHANGES": "Apply Manually Merged Changes",
    "LABEL_CORE_UPGRADE_MERGE_INNER_FILES": "Merge Inner Files",
    "LABEL_CORE_UPGRADE_APPLY_NEWLY_ADDED_CHANGES": "Apply Newly Added Changes",
    "LABEL_CORE_UPGRADE_APPLY_NEWLY_MODIFIED_CHANGES": "Apply Newly Modified Changes",
    "LABEL_CORE_UPGRADE_APPLY_NEWLY_DELETED_CHANGES": "Apply Newly Deleted Changes",
    "LABEL_CORE_UPGRADE_REVERT": "Revert",

    "LABEL_BRANCH_MERGE_NO_CHANGES": "No Changes",
    "LABEL_BRANCH_MERGE_NO_PATH": "No Path",
    "LABEL_BRANCH_MERGE_ADDED_IN_OURS": "Added in Ours",
    "LABEL_BRANCH_MERGE_MODIFIED_IN_OURS": "Modified in Ours",
    "LABEL_BRANCH_MERGE_DELETED_IN_OURS": "Deleted in Ours",
    "LABEL_BRANCH_MERGE_ADDED_IN_THEIRS": "Added  in Branch",
    "LABEL_BRANCH_MERGE_MODIFIED_IN_THEIRS": "Modified in Branch",
    "LABEL_BRANCH_MERGE_DELETED_IN_THEIRS": "Deleted in Branch",
    "LABEL_BRANCH_MERGE_BOTH_ADDED_SAME": "Both Added Same",
    "LABEL_BRANCH_MERGE_BOTH_MODIFIED_SAME": "Both Modified Same",
    "LABEL_BRANCH_MERGE_BOTH_ADDED": "Both Added",
    "LABEL_BRANCH_MERGE_BOTH_MODIFIED": "Both Modified",
    "LABEL_BRANCH_MERGE_BOTH_DELETED": "Both Deleted",
    "LABEL_BRANCH_MERGE_MODIFIED_IN_OURS_DELETED_IN_THEIRS": "Modified in Ours and Deleted in Branch",
    "LABEL_BRANCH_MERGE_MODIFIED_IN_THEIRS_DELETED_IN_OURS": "Modified in Branch and Deleted in Ours",

    "LABEL_BRANCH_MERGE_APPLIED_OURS": "Applied Ours",
    "LABEL_BRANCH_MERGE_APPLIED_OURS_DELETED": "Deleted",
    "LABEL_BRANCH_MERGE_APPLIED_THEIRS": "Applied Branch",
    "LABEL_BRANCH_MERGE_APPLIED_THEIRS_DELETED": "Deleted",
    "LABEL_BRANCH_MERGE_APPLIED_SAME": "Applied Same",
    "LABEL_BRANCH_MERGE_APPLIED_SAME_DELETED": "Deleted",
    "LABEL_BRANCH_MERGE_EDITED_OURS": "Edited Ours",
    "LABEL_BRANCH_MERGE_EDITED_THEIRS": "Edited Branch",
    "LABEL_BRANCH_MERGE_AUTO_RESOLVED_BY_VCS": "Auto Merged by GIT",
    "LABEL_BRANCH_MERGE_AUTO_RESOLVED_BY_VCS_APPLIED_OURS": "Auto Merged to ours by GIT",
    "LABEL_BRANCH_MERGE_AUTO_RESOLVED_BY_VCS_APPLIED_THEIRS": "Auto Merged to branch changes by GIT",
    "LABEL_BRANCH_MERGE_AUTO_RESOLVED_BY_STUDIO": "Auto Merged by Studio",
    "LABEL_BRANCH_MERGE_AUTO_RESOLVED_BY_STUDIO_APPLIED_OURS": "Auto Merged by Studio, Applied Ours",
    "LABEL_BRANCH_MERGE_AUTO_RESOLVED_BY_STUDIO_APPLIED_THEIRS": "Auto Merged by Studio, Applied Branch",
    "LABEL_BRANCH_MERGE_PATH_CONFLICTED": "Conflicted",
    "LABEL_BRANCH_MERGE_CONTENT_CONFLICTED": "Conflicted",
    "LABEL_BRANCH_MERGE_MANUALLY_MERGED": "Merged Manually",
    "LABEL_BRANCH_MERGE_MERGED_INNER_FILES": "Merged Inner Files",
    "LABEL_BRANCH_MERGE_UNRESOLVED_INNER_FILES": "Unresolved Inner Files",
    "LABEL_BRANCH_MERGE_NEWLY_ADDED": "Newly Added",
    "LABEL_BRANCH_MERGE_NEWLY_MODIFIED": "Newly Modified",
    "LABEL_BRANCH_MERGE_NEWLY_DELETED": "Newly Deleted",

    "LABEL_BRANCH_MERGE_APPLY_OURS": "Apply Ours",
    "LABEL_BRANCH_MERGE_APPLY_OURS_DELETE": "Delete",
    "LABEL_BRANCH_MERGE_APPLY_THEIRS": "Apply Branch",
    "LABEL_BRANCH_MERGE_APPLY_THEIRS_DELETE": "Delete",
    "LABEL_BRANCH_MERGE_APPLY_SAME": "Apply Same",
    "LABEL_BRANCH_MERGE_APPLY_SAME_DELETE": "Delete",
    "LABEL_BRANCH_MERGE_APPLY_EDITED_OURS": "Apply Edited Ours",
    "LABEL_BRANCH_MERGE_APPLY_EDITED_THEIRS": "Apply Edited Branch",
    "LABEL_BRANCH_MERGE_APPLY_AUTO_RESOLVED_CHANGES": "Apply Auto Resolved Changes",
    "LABEL_BRANCH_MERGE_RESOLVE_PATH_CONFLICT": "Resolve Conflict",
    "LABEL_BRANCH_MERGE_RESOLVE_CONFLICTS": "Resolve Conflicts",
    "LABEL_BRANCH_MERGE_RE_RESOLVE_CONFLICTS": "Re Resolve Conflicts",
    "LABEL_BRANCH_MERGE_APPLY_MANUALLY_MERGED_CHANGES": "Apply Manually Merged Changes",
    "LABEL_BRANCH_MERGE_MERGE_INNER_FILES": "Merge Inner Files",
    "LABEL_BRANCH_MERGE_APPLY_NEWLY_ADDED_CHANGES": "Apply Newly Added Changes",
    "LABEL_BRANCH_MERGE_APPLY_NEWLY_MODIFIED_CHANGES": "Apply Newly Modified Changes",
    "LABEL_BRANCH_MERGE_APPLY_NEWLY_DELETED_CHANGES": "Apply Newly Deleted Changes",
    "LABEL_BRANCH_MERGE_REVERT": "Revert",

    "LABEL_PULL_CHANGES_NO_CHANGES": "No Changes",
    "LABEL_PULL_CHANGES_NO_PATH": "No Path",
    "LABEL_PULL_CHANGES_ADDED_IN_OURS": "Added in Local",
    "LABEL_PULL_CHANGES_MODIFIED_IN_OURS": "Modified in Local",
    "LABEL_PULL_CHANGES_DELETED_IN_OURS": "Deleted in Local",
    "LABEL_PULL_CHANGES_ADDED_IN_THEIRS": "Added in Remote",
    "LABEL_PULL_CHANGES_MODIFIED_IN_THEIRS": "Modified in Remote",
    "LABEL_PULL_CHANGES_DELETED_IN_THEIRS": "Deleted in Remote",
    "LABEL_PULL_CHANGES_BOTH_ADDED_SAME": "Both Added Same",
    "LABEL_PULL_CHANGES_BOTH_MODIFIED_SAME": "Both Modified Same",
    "LABEL_PULL_CHANGES_BOTH_ADDED": "Both Added",
    "LABEL_PULL_CHANGES_BOTH_MODIFIED": "Both Modified",
    "LABEL_PULL_CHANGES_BOTH_DELETED": "Both Deleted",
    "LABEL_PULL_CHANGES_MODIFIED_IN_OURS_DELETED_IN_THEIRS": "Modified in Local and Deleted in Remote",
    "LABEL_PULL_CHANGES_MODIFIED_IN_THEIRS_DELETED_IN_OURS": "Modified in Remote and Deleted in Local",

    "LABEL_PULL_CHANGES_APPLIED_OURS": "Applied Local",
    "LABEL_PULL_CHANGES_APPLIED_OURS_DELETED": "Deleted",
    "LABEL_PULL_CHANGES_APPLIED_THEIRS": "Applied Remote",
    "LABEL_PULL_CHANGES_APPLIED_THEIRS_DELETED": "Deleted",
    "LABEL_PULL_CHANGES_APPLIED_SAME": "Applied Same",
    "LABEL_PULL_CHANGES_APPLIED_SAME_DELETED": "Deleted",
    "LABEL_PULL_CHANGES_EDITED_OURS": "Edited Local",
    "LABEL_PULL_CHANGES_EDITED_THEIRS": "Edited Remote",
    "LABEL_PULL_CHANGES_AUTO_RESOLVED_BY_VCS": "Auto Merged by GIT",
    "LABEL_PULL_CHANGES_AUTO_RESOLVED_BY_VCS_APPLIED_OURS": "Auto Merged to Local Changes by GIT",
    "LABEL_PULL_CHANGES_AUTO_RESOLVED_BY_VCS_APPLIED_THEIRS": "Auto Merged to Remote Changes by GIT",
    "LABEL_PULL_CHANGES_AUTO_RESOLVED_BY_STUDIO": "Auto Merged by Studio",
    "LABEL_PULL_CHANGES_AUTO_RESOLVED_BY_STUDIO_APPLIED_OURS": "Auto Merged by Studio, Applied Local",
    "LABEL_PULL_CHANGES_AUTO_RESOLVED_BY_STUDIO_APPLIED_THEIRS": "Auto Merged by Studio, Applied Remote",
    "LABEL_PULL_CHANGES_PATH_CONFLICTED": "Conflicted",
    "LABEL_PULL_CHANGES_CONTENT_CONFLICTED": "Conflicted",
    "LABEL_PULL_CHANGES_MANUALLY_MERGED": "Merged Manually",
    "LABEL_PULL_CHANGES_MERGED_INNER_FILES": "Merged Inner Files",
    "LABEL_PULL_CHANGES_UNRESOLVED_INNER_FILES": "Unresolved Inner Files",
    "LABEL_PULL_CHANGES_NEWLY_ADDED": "Newly Added",
    "LABEL_PULL_CHANGES_NEWLY_MODIFIED": "Newly Modified",
    "LABEL_PULL_CHANGES_NEWLY_DELETED": "Newly Deleted",

    "LABEL_PULL_CHANGES_APPLY_OURS": "Apply Local",
    "LABEL_PULL_CHANGES_APPLY_OURS_DELETE": "Delete",
    "LABEL_PULL_CHANGES_APPLY_THEIRS": "Apply Remote",
    "LABEL_PULL_CHANGES_APPLY_THEIRS_DELETE": "Delete",
    "LABEL_PULL_CHANGES_APPLY_SAME": "Apply Same",
    "LABEL_PULL_CHANGES_APPLY_SAME_DELETE": "Delete",
    "LABEL_PULL_CHANGES_APPLY_EDITED_OURS": "Apply Edited Local",
    "LABEL_PULL_CHANGES_APPLY_EDITED_THEIRS": "Apply Edited Remote",
    "LABEL_PULL_CHANGES_APPLY_AUTO_RESOLVED_CHANGES": "Apply Auto Resolved Changes",
    "LABEL_PULL_CHANGES_RESOLVE_PATH_CONFLICT": "Resolve Conflict",
    "LABEL_PULL_CHANGES_RESOLVE_CONFLICTS": "Resolve Conflicts",
    "LABEL_PULL_CHANGES_RE_RESOLVE_CONFLICTS": "Re Resolve Conflicts",
    "LABEL_PULL_CHANGES_APPLY_MANUALLY_MERGED_CHANGES": "Apply Manually Merged Changes",
    "LABEL_PULL_CHANGES_MERGE_INNER_FILES": "Merge Inner Files",
    "LABEL_PULL_CHANGES_APPLY_NEWLY_ADDED_CHANGES": "Apply Newly Added Changes",
    "LABEL_PULL_CHANGES_APPLY_NEWLY_MODIFIED_CHANGES": "Apply Newly Modified Changes",
    "LABEL_PULL_CHANGES_APPLY_NEWLY_DELETED_CHANGES": "Apply Newly Deleted Changes",
    "LABEL_PULL_CHANGES_REVERT": "Revert",

    "LABEL_SYNC_PLUGIN_PUSH_NO_CHANGES": "No Changes",
    "LABEL_SYNC_PLUGIN_PUSH_NO_PATH": "No Path",
    "LABEL_SYNC_PLUGIN_PUSH_ADDED_IN_OURS": "Added in Studio Workspace",
    "LABEL_SYNC_PLUGIN_PUSH_MODIFIED_IN_OURS": "Modified in Studio Workspace",
    "LABEL_SYNC_PLUGIN_PUSH_DELETED_IN_OURS": "Deleted in Studio Workspace",
    "LABEL_SYNC_PLUGIN_PUSH_ADDED_IN_THEIRS": "Added in Remote Sync Plugin",
    "LABEL_SYNC_PLUGIN_PUSH_MODIFIED_IN_THEIRS": "Modified in Remote Sync Plugin",
    "LABEL_SYNC_PLUGIN_PUSH_DELETED_IN_THEIRS": "Deleted in Remote Sync Plugin",
    "LABEL_SYNC_PLUGIN_PUSH_BOTH_ADDED_SAME": "Both Added Same",
    "LABEL_SYNC_PLUGIN_PUSH_BOTH_MODIFIED_SAME": "Both Modified Same",
    "LABEL_SYNC_PLUGIN_PUSH_BOTH_ADDED": "Both Added",
    "LABEL_SYNC_PLUGIN_PUSH_BOTH_MODIFIED": "Both Modified",
    "LABEL_SYNC_PLUGIN_PUSH_BOTH_DELETED": "Both Deleted",
    "LABEL_SYNC_PLUGIN_PUSH_MODIFIED_IN_OURS_DELETED_IN_THEIRS": "Modified in Studio Workspace and Deleted in Remote Sync Plugin",
    "LABEL_SYNC_PLUGIN_PUSH_MODIFIED_IN_THEIRS_DELETED_IN_OURS": "Modified in Remote Sync Plugin and Deleted in Studio Workspace",

    "LABEL_SYNC_PLUGIN_PUSH_APPLIED_OURS": "Applied Studio Workspace",
    "LABEL_SYNC_PLUGIN_PUSH_APPLIED_OURS_DELETED": "Deleted",
    "LABEL_SYNC_PLUGIN_PUSH_APPLIED_THEIRS": "Applied Remote Sync Plugin",
    "LABEL_SYNC_PLUGIN_PUSH_APPLIED_THEIRS_DELETED": "Deleted",
    "LABEL_SYNC_PLUGIN_PUSH_APPLIED_SAME": "Applied Same",
    "LABEL_SYNC_PLUGIN_PUSH_APPLIED_SAME_DELETED": "Deleted",
    "LABEL_SYNC_PLUGIN_PUSH_EDITED_OURS": "Edited Studio Workspace",
    "LABEL_SYNC_PLUGIN_PUSH_EDITED_THEIRS": "Edited Remote Sync Plugin",
    "LABEL_SYNC_PLUGIN_PUSH_AUTO_RESOLVED_BY_VCS": "Auto Merged by GIT",
    "LABEL_SYNC_PLUGIN_PUSH_AUTO_RESOLVED_BY_VCS_APPLIED_OURS": "Auto Merged to Studio Workspace Changes by GIT",
    "LABEL_SYNC_PLUGIN_PUSH_AUTO_RESOLVED_BY_VCS_APPLIED_THEIRS": "Auto Merged to Remote Sync plugin Changes by GIT",
    "LABEL_SYNC_PLUGIN_PUSH_AUTO_RESOLVED_BY_STUDIO": "Auto Merged by Studio",
    "LABEL_SYNC_PLUGIN_PUSH_AUTO_RESOLVED_BY_STUDIO_APPLIED_OURS": "Auto Merged by Studio, Applied Studio Workspace",
    "LABEL_SYNC_PLUGIN_PUSH_AUTO_RESOLVED_BY_STUDIO_APPLIED_THEIRS": "Auto Merged by Studio, Applied Remote Sync Plugin",
    "LABEL_SYNC_PLUGIN_PATH_CONFLICTED": "Conflicted",
    "LABEL_SYNC_PLUGIN_PUSH_CONTENT_CONFLICTED": "Conflicted",
    "LABEL_SYNC_PLUGIN_PUSH_MANUALLY_MERGED": "Merged Manually",
    "LABEL_SYNC_PLUGIN_PUSH_MERGED_INNER_FILES": "Merged Inner Files",
    "LABEL_SYNC_PLUGIN_PUSH_UNRESOLVED_INNER_FILES": "Unresolved Inner Files",
    "LABEL_SYNC_PLUGIN_PUSH_NEWLY_ADDED": "Newly Added",
    "LABEL_SYNC_PLUGIN_PUSH_NEWLY_MODIFIED": "Newly Modified",
    "LABEL_SYNC_PLUGIN_PUSH_NEWLY_DELETED": "Newly Deleted",

    "LABEL_SYNC_PLUGIN_PUSH_APPLY_OURS": "Apply Studio Workspace",
    "LABEL_SYNC_PLUGIN_PUSH_APPLY_OURS_DELETE": "Delete",
    "LABEL_SYNC_PLUGIN_PUSH_APPLY_THEIRS": "Apply Remote Sync Plugin",
    "LABEL_SYNC_PLUGIN_PUSH_APPLY_THEIRS_DELETE": "Delete",
    "LABEL_SYNC_PLUGIN_PUSH_APPLY_SAME": "Apply Same",
    "LABEL_SYNC_PLUGIN_PUSH_APPLY_SAME_DELETE": "Delete",
    "LABEL_SYNC_PLUGIN_PUSH_APPLY_EDITED_OURS": "Apply Edited Studio Workspace",
    "LABEL_SYNC_PLUGIN_PUSH_APPLY_EDITED_THEIRS": "Apply Edited Remote Sync Plugin",
    "LABEL_SYNC_PLUGIN_PUSH_APPLY_AUTO_RESOLVED_CHANGES": "Apply Auto Resolved Changes",
    "LABEL_SYNC_PLUGIN_PUSH_RESOLVE_PATH_CONFLICT": "Resolve Conflict",
    "LABEL_SYNC_PLUGIN_PUSH_RESOLVE_CONFLICTS": "Resolve Conflicts",
    "LABEL_SYNC_PLUGIN_PUSH_RE_RESOLVE_CONFLICTS": "Re Resolve Conflicts",
    "LABEL_SYNC_PLUGIN_PUSH_APPLY_MANUALLY_MERGED_CHANGES": "Apply Manually Merged Changes",
    "LABEL_SYNC_PLUGIN_PUSH_MERGE_INNER_FILES": "Merge Inner Files",
    "LABEL_SYNC_PLUGIN_PUSH_APPLY_NEWLY_ADDED_CHANGES": "Apply Newly Added Changes",
    "LABEL_SYNC_PLUGIN_PUSH_APPLY_NEWLY_MODIFIED_CHANGES": "Apply Newly Modified Changes",
    "LABEL_SYNC_PLUGIN_PUSH_APPLY_NEWLY_DELETED_CHANGES": "Apply Newly Deleted Changes",
    "LABEL_SYNC_PLUGIN_PUSH_REVERT": "Revert",

    "LABEL_DRAFT_MERGE_NO_CHANGES": "No Changes",
    "LABEL_DRAFT_MERGE_NO_PATH": "No Path",
    "LABEL_DRAFT_MERGE_ADDED_IN_OURS": "Added in Studio Workspace",
    "LABEL_DRAFT_MERGE_MODIFIED_IN_OURS": "Modified in Studio Workspace",
    "LABEL_DRAFT_MERGE_DELETED_IN_OURS": "Deleted in Studio Workspace",
    "LABEL_DRAFT_MERGE_ADDED_IN_THEIRS": "Added in AIRA Workspace",
    "LABEL_DRAFT_MERGE_MODIFIED_IN_THEIRS": "Modified in AIRA Workspace",
    "LABEL_DRAFT_MERGE_DELETED_IN_THEIRS": "Deleted in AIRA Workspace",
    "LABEL_DRAFT_MERGE_BOTH_ADDED_SAME": "Both Added Same",
    "LABEL_DRAFT_MERGE_BOTH_MODIFIED_SAME": "Both Modified Same",
    "LABEL_DRAFT_MERGE_BOTH_ADDED": "Both Added",
    "LABEL_DRAFT_MERGE_BOTH_MODIFIED": "Both Modified",
    "LABEL_DRAFT_MERGE_BOTH_DELETED": "Both Deleted",
    "LABEL_DRAFT_MERGE_MODIFIED_IN_OURS_DELETED_IN_THEIRS": "Modified in Studio Workspace and Deleted in AIRA Workspace",
    "LABEL_DRAFT_MERGE_MODIFIED_IN_THEIRS_DELETED_IN_OURS": "Modified in AIRA Workspace and Deleted in Studio Workspace",
    "LABEL_DRAFT_MERGE_APPLIED_OURS": "Applied Studio Workspace",
    "LABEL_DRAFT_MERGE_APPLIED_OURS_DELETED": "Deleted",
    "LABEL_DRAFT_MERGE_APPLIED_THEIRS": "Applied AIRA Workspace",
    "LABEL_DRAFT_MERGE_APPLIED_THEIRS_DELETED": "Deleted",
    "LABEL_DRAFT_MERGE_APPLIED_SAME": "Applied Same",
    "LABEL_DRAFT_MERGE_APPLIED_SAME_DELETED": "Deleted",
    "LABEL_DRAFT_MERGE_EDITED_OURS": "Edited Studio Workspace",
    "LABEL_DRAFT_MERGE_EDITED_THEIRS": "Edited AIRA Workspace",
    "LABEL_DRAFT_MERGE_AUTO_RESOLVED_BY_VCS": "Auto Merged by GIT",
    "LABEL_DRAFT_MERGE_AUTO_RESOLVED_BY_VCS_APPLIED_OURS": "Auto Merged to Studio Workspace Changes by GIT",
    "LABEL_DRAFT_MERGE_AUTO_RESOLVED_BY_VCS_APPLIED_THEIRS": "Auto Merged to AIRA Workspace Changes by GIT",
    "LABEL_DRAFT_MERGE_AUTO_RESOLVED_BY_STUDIO": "Auto Merged by Studio",
    "LABEL_DRAFT_MERGE_AUTO_RESOLVED_BY_STUDIO_APPLIED_OURS": "Auto Merged by Studio, Applied Studio Workspace",
    "LABEL_DRAFT_MERGE_AUTO_RESOLVED_BY_STUDIO_APPLIED_THEIRS": "Auto Merged by Studio, Applied AIRA Workspace",
    "LABEL_DRAFT_MERGE_PATH_CONFLICTED": "Conflicted",
    "LABEL_DRAFT_MERGE_CONTENT_CONFLICTED": "Conflicted",
    "LABEL_DRAFT_MERGE_MANUALLY_MERGED": "Merged Manually",
    "LABEL_DRAFT_MERGE_MERGED_INNER_FILES": "Merged Inner Files",
    "LABEL_DRAFT_MERGE_UNRESOLVED_INNER_FILES": "Unresolved Inner Files",
    "LABEL_DRAFT_MERGE_NEWLY_ADDED": "Newly Added",
    "LABEL_DRAFT_MERGE_NEWLY_MODIFIED": "Newly Modified",
    "LABEL_DRAFT_MERGE_NEWLY_DELETED": "Newly Deleted",
    "LABEL_DRAFT_MERGE_APPLY_OURS": "Apply Studio Workspace",
    "LABEL_DRAFT_MERGE_APPLY_OURS_DELETE": "Delete",
    "LABEL_DRAFT_MERGE_APPLY_THEIRS": "Apply AIRA Workspace",
    "LABEL_DRAFT_MERGE_APPLY_THEIRS_DELETE": "Delete",
    "LABEL_DRAFT_MERGE_APPLY_SAME": "Apply Same",
    "LABEL_DRAFT_MERGE_APPLY_SAME_DELETE": "Delete",
    "LABEL_DRAFT_MERGE_APPLY_EDITED_OURS": "Apply Edited Studio Workspace",
    "LABEL_DRAFT_MERGE_APPLY_EDITED_THEIRS": "Apply Edited AIRA Workspace",
    "LABEL_DRAFT_MERGE_APPLY_AUTO_RESOLVED_CHANGES": "Apply Auto Resolved Changes",
    "LABEL_DRAFT_MERGE_RESOLVE_PATH_CONFLICT": "Resolve Conflict",
    "LABEL_DRAFT_MERGE_RESOLVE_CONFLICTS": "Resolve Conflicts",
    "LABEL_DRAFT_MERGE_RE_RESOLVE_CONFLICTS": "Re Resolve Conflicts",
    "LABEL_DRAFT_MERGE_APPLY_MANUALLY_MERGED_CHANGES": "Apply Manually Merged Changes",
    "LABEL_DRAFT_MERGE_MERGE_INNER_FILES": "Merge Inner Files",
    "LABEL_DRAFT_MERGE_APPLY_NEWLY_ADDED_CHANGES": "Apply Newly Added Changes",
    "LABEL_DRAFT_MERGE_APPLY_NEWLY_MODIFIED_CHANGES": "Apply Newly Modified Changes",
    "LABEL_DRAFT_MERGE_APPLY_NEWLY_DELETED_CHANGES": "Apply Newly Deleted Changes",
    "LABEL_DRAFT_MERGE_REVERT": "Revert",

    "LABEL_THEIRS_CORE_UPGRADE": "Core",
    "LABEL_OURS_CORE_UPGRADE": "Ours",
    "LABEL_THEIRS_BRANCH_MERGE": "Merge Branch",
    "LABEL_OURS_BRANCH_MERGE": "Ours",
    "LABEL_THEIRS_PULL_CHANGES": "Remote",
    "LABEL_OURS_PULL_CHANGES": "Ours",
    "LABEL_THEIRS_SYNC_PLUGIN_PUSH": "Remote",
    "LABEL_OURS_SYNC_PLUGIN_PUSH": "Ours",
    "LABEL_THEIRS_DRAFT_MERGE": "Merge AIRA Changes",
    "LABEL_OURS_DRAFT_MERGE": "Ours",
    "LABEL_THEIRS_AUTOCODE_MERGE": "Autocode",
    "LABEL_OURS_AUTOCODE_MERGE": "Ours",

    "LABEL_AUTOCODE_MERGE_NO_CHANGES": "No Changes",
    "LABEL_AUTOCODE_MERGE_NO_PATH": "No Path",
    "LABEL_AUTOCODE_MERGE_ADDED_IN_OURS": "Added in Ours",
    "LABEL_AUTOCODE_MERGE_MODIFIED_IN_OURS": "Modified in Ours",
    "LABEL_AUTOCODE_MERGE_DELETED_IN_OURS": "Deleted in Ours",
    "LABEL_AUTOCODE_MERGE_ADDED_IN_THEIRS": "Added  in Branch",
    "LABEL_AUTOCODE_MERGE_MODIFIED_IN_THEIRS": "Modified in Branch",
    "LABEL_AUTOCODE_MERGE_DELETED_IN_THEIRS": "Deleted in Branch",
    "LABEL_AUTOCODE_MERGE_BOTH_ADDED_SAME": "Both Added Same",
    "LABEL_AUTOCODE_MERGE_BOTH_MODIFIED_SAME": "Both Modified Same",
    "LABEL_AUTOCODE_MERGE_BOTH_ADDED": "Both Added",
    "LABEL_AUTOCODE_MERGE_BOTH_MODIFIED": "Both Modified",
    "LABEL_AUTOCODE_MERGE_BOTH_DELETED": "Both Deleted",
    "LABEL_AUTOCODE_MERGE_MODIFIED_IN_OURS_DELETED_IN_THEIRS": "Modified in Ours and Deleted in Autocode",
    "LABEL_AUTOCODE_MERGE_MODIFIED_IN_THEIRS_DELETED_IN_OURS": "Modified in Autocode and Deleted in Ours",

    "LABEL_AUTOCODE_MERGE_APPLIED_OURS": "Applied Ours",
    "LABEL_AUTOCODE_MERGE_APPLIED_OURS_DELETED": "Deleted",
    "LABEL_AUTOCODE_MERGE_APPLIED_THEIRS": "Applied Autocode",
    "LABEL_AUTOCODE_MERGE_APPLIED_THEIRS_DELETED": "Deleted",
    "LABEL_AUTOCODE_MERGE_APPLIED_SAME": "Applied Same",
    "LABEL_AUTOCODE_MERGE_APPLIED_SAME_DELETED": "Deleted",
    "LABEL_AUTOCODE_MERGE_EDITED_OURS": "Edited Ours",
    "LABEL_AUTOCODE_MERGE_EDITED_THEIRS": "Edited Branch",
    "LABEL_AUTOCODE_MERGE_AUTO_RESOLVED_BY_VCS": "Auto Merged by GIT",
    "LABEL_AUTOCODE_MERGE_AUTO_RESOLVED_BY_VCS_APPLIED_OURS": "Auto Merged to ours by GIT",
    "LABEL_AUTOCODE_MERGE_AUTO_RESOLVED_BY_VCS_APPLIED_THEIRS": "Auto Merged to autocode changes by GIT",
    "LABEL_AUTOCODE_MERGE_AUTO_RESOLVED_BY_STUDIO": "Auto Merged by Studio",
    "LABEL_AUTOCODE_MERGE_AUTO_RESOLVED_BY_STUDIO_APPLIED_OURS": "Auto Merged by Studio, Applied Ours",
    "LABEL_AUTOCODE_MERGE_AUTO_RESOLVED_BY_STUDIO_APPLIED_THEIRS": "Auto Merged by Studio, Applied Autocode",
    "LABEL_AUTOCODE_MERGE_PATH_CONFLICTED": "Conflicted",
    "LABEL_AUTOCODE_MERGE_CONTENT_CONFLICTED": "Conflicted",
    "LABEL_AUTOCODE_MERGE_MANUALLY_MERGED": "Merged Manually",
    "LABEL_AUTOCODE_MERGE_MERGED_INNER_FILES": "Merged Inner Files",
    "LABEL_AUTOCODE_MERGE_UNRESOLVED_INNER_FILES": "Unresolved Inner Files",
    "LABEL_AUTOCODE_MERGE_NEWLY_ADDED": "Newly Added",
    "LABEL_AUTOCODE_MERGE_NEWLY_MODIFIED": "Newly Modified",
    "LABEL_AUTOCODE_MERGE_NEWLY_DELETED": "Newly Deleted",

    "LABEL_AUTOCODE_MERGE_APPLY_OURS": "Apply Ours",
    "LABEL_AUTOCODE_MERGE_APPLY_OURS_DELETE": "Delete",
    "LABEL_AUTOCODE_MERGE_APPLY_THEIRS": "Apply Autocode",
    "LABEL_AUTOCODE_MERGE_APPLY_THEIRS_DELETE": "Delete",
    "LABEL_AUTOCODE_MERGE_APPLY_SAME": "Apply Same",
    "LABEL_AUTOCODE_MERGE_APPLY_SAME_DELETE": "Delete",
    "LABEL_AUTOCODE_MERGE_APPLY_EDITED_OURS": "Apply Edited Ours",
    "LABEL_AUTOCODE_MERGE_APPLY_EDITED_THEIRS": "Apply Edited Autocode",
    "LABEL_AUTOCODE_MERGE_APPLY_AUTO_RESOLVED_CHANGES": "Apply Auto Resolved Changes",
    "LABEL_AUTOCODE_MERGE_RESOLVE_PATH_CONFLICT": "Resolve Conflict",
    "LABEL_AUTOCODE_MERGE_RESOLVE_CONFLICTS": "Resolve Conflicts",
    "LABEL_AUTOCODE_MERGE_RE_RESOLVE_CONFLICTS": "Re Resolve Conflicts",
    "LABEL_AUTOCODE_MERGE_APPLY_MANUALLY_MERGED_CHANGES": "Apply Manually Merged Changes",
    "LABEL_AUTOCODE_MERGE_MERGE_INNER_FILES": "Merge Inner Files",
    "LABEL_AUTOCODE_MERGE_APPLY_NEWLY_ADDED_CHANGES": "Apply Newly Added Changes",
    "LABEL_AUTOCODE_MERGE_APPLY_NEWLY_MODIFIED_CHANGES": "Apply Newly Modified Changes",
    "LABEL_AUTOCODE_MERGE_APPLY_NEWLY_DELETED_CHANGES": "Apply Newly Deleted Changes",
    "LABEL_AUTOCODE_MERGE_REVERT": "Revert",

    "LABEL_REVIEW_MERGE": "Review Merge",
    "LABEL_RESOLVE_CONFLICTS": "Resolve Conflicts",
    "LABEL_PREVIOUS_CONFLICT": "Previous Conflict",
    "LABEL_NEXT_CONFLICT": "Next Conflict",

    "MSG_FINISH_MERGE": "Preview the application and run full test on deployed application before clicking on \"Finish Merge\"",
    "MSG_RESOLVE_CONFLICTS": "Resolve all the conflicts and preview application before merging",

    "LABEL_PULL_CHANGES_ACCEPT_THEIRS": "Accept Remote",
    "LABEL_PULL_CHANGES_ACCEPT_YOURS": "Accept Ours",

    "LABEL_CORE_UPGRADE_ACCEPT_THEIRS": "Accept Core",
    "LABEL_CORE_UPGRADE_ACCEPT_YOURS": "Accept Ours",

    "LABEL_BRANCH_MERGE_ACCEPT_THEIRS": "Accept Merge Branch",
    "LABEL_BRANCH_MERGE_ACCEPT_YOURS": "Accept Ours",

    "LABEL_SYNC_PLUGIN_PUSH_ACCEPT_THEIRS": "Apply Remote",
    "LABEL_SYNC_PLUGIN_PUSH_ACCEPT_YOURS": "Accept Ours",

    "LABEL_DRAFT_MERGE_ACCEPT_THEIRS": "Accept AIRA Changes",
    "LABEL_DRAFT_MERGE_ACCEPT_YOURS": "Accept Ours",

    "LABEL_AUTOCODE_MERGE_ACCEPT_THEIRS": "Accept Autocode",
    "LABEL_AUTOCODE_MERGE_ACCEPT_YOURS": "Accept Ours",

    "LABEL_KEY_NAME": "Key Name",
    "LABEL_FINAL_VALUE": "Final Value",
    "MSG_PROPERTY_EDITOR_HEADER": "Choose the final value for all property types, either from the ${0} or ${1} value",

    "LABEL_PROPERTY_EDITOR_CORE_UPGRADE_THEIR": "Core",
    "LABEL_PROPERTY_EDITOR_CORE_UPGRADE_OUR": "Local",
    "LABEL_PROPERTY_EDITOR_CORE_UPGRADE_APPLY_THEIRS": "Core Value",
    "LABEL_PROPERTY_EDITOR_CORE_UPGRADE_APPLY_OURS": "Local Value",

    "LABEL_PROPERTY_EDITOR_BRANCH_MERGE_THEIR": "Merge Branch",
    "LABEL_PROPERTY_EDITOR_BRANCH_MERGE_OUR": "Local",
    "LABEL_PROPERTY_EDITOR_BRANCH_MERGE_APPLY_THEIRS": "Merge Branch Value",
    "LABEL_PROPERTY_EDITOR_BRANCH_MERGE_APPLY_OURS": "Local Value",

    "LABEL_PROPERTY_EDITOR_PULL_CHANGES_THEIR": "Remote",
    "LABEL_PROPERTY_EDITOR_PULL_CHANGES_OUR": "Local",
    "LABEL_PROPERTY_EDITOR_PULL_CHANGES_APPLY_THEIRS": "Remote Value",
    "LABEL_PROPERTY_EDITOR_PULL_CHANGES_APPLY_OURS": "Local Value",

    "LABEL_PROPERTY_EDITOR_SYNC_PLUGIN_PUSH_THEIR": "Remote",
    "LABEL_PROPERTY_EDITOR_SYNC_PLUGIN_PUSH_OUR": "Local",
    "LABEL_PROPERTY_EDITOR_SYNC_PLUGIN_PUSH_APPLY_THEIRS": "Remote Value",
    "LABEL_PROPERTY_EDITOR_SYNC_PLUGIN_PUSH_APPLY_OURS": "Local Value",

    "LABEL_PROPERTY_EDITOR_DRAFT_MERGE_THEIR": "AIRA",
    "LABEL_PROPERTY_EDITOR_DRAFT_MERGE_OUR": "Local",
    "LABEL_PROPERTY_EDITOR_DRAFT_MERGE_APPLY_THEIRS": "AIRA Value",
    "LABEL_PROPERTY_EDITOR_DRAFT_MERGE_APPLY_OURS": "Local Value",

    "LABEL_PROPERTY_EDITOR_AUTOCODE_MERGE_THEIR": "Autocode",
    "LABEL_PROPERTY_EDITOR_AUTOCODE_MERGE_OUR": "Local",
    "LABEL_PROPERTY_EDITOR_AUTOCODE_MERGE_APPLY_THEIRS": "Autocode Value",
    "LABEL_PROPERTY_EDITOR_AUTOCODE_MERGE_APPLY_OURS": "Local Value",

    "LABEL_UPGRADE_CORE_PROJECT": "Upgrade Core Project",
    "LABEL_CORE_PROJECT": "Core Project",
    "LABEL_DATA_TAB":"Go to Data Tab",
    "LABEL_GOTO_WIDGET":"Go to component",

    "MSG_MERGE_REMOTE_INTO_LOCAL": "<strong>All conflicts are resolved.</strong>",
    "MSG_PROCEED_MERGE_REMOTE_INTO_LOCAL": "Please click on Proceed to complete the merge process.",
    "MSG_MERGE_REMOTE_INTO_LOCAL_IN_PROGRESS": "Merging remote branch into your local branch",
    "MSG_MERGE_REMOTE_INTO_LOCAL_SUCCESS": "Remote branch merged into your local branch successfully",
    "MSG_MERGE_REMOTE_INTO_LOCAL_SUCCESS_NEXT_STEP": "Please reload the project to see the latest changes",
    "MSG_UNEXPECTED_ERROR":"An unexpected error occured, please try again.",

    "TITLE_RELOAD_PROJECT": "Reload Project",
    "MESSAGE_RELOAD_PROJECT_ON_MERGE_CONFLICTS_RESOLVED": "All conflicts resolved, Please reload the Studio to test project thoroughly and fix any errors",
    "FILE" : "file",
    "MSG_REPLACE_NEW_PUBLISHER_PREFAB_CONFIRM":"This action replaces ${0} Team's  ${1} prefab v${2} with ${3} Team's ${4} prefab v${5}. Are you sure you want to import?",
    "TITLE_SOURCE_CODE_UPDATES":"Source Code Updates",
    "MSG_LOADING_EDITOR": "Loading editor ...",
    "LABEL_PROFILE_NAME_VALIDATION": "only alphanumberic characters and underscore are allowed",
    "MESSAGE_MONGODB_HOST_NOT_SET": "Please provide MONGODB host",
    "MESSAGE_MONGODB_PORT_NOT_SET": "Please provide MONGODB port",
    "MESSAGE_MONGODB_USERNAME_NOT_SET": "Please provide MONGODB username",
    "MESSAGE_MONGODB_PASSWORD_NOT_SET": "Please provide MONGODB password",
    "MESSAGE_MONGODB_DBNAME_NOT_SET": "Please provide MONGODB Database",
    "MESSAGE_APP_LOGIN_PAGE_NOT_SET": "Please provide enable app Login configuration",

    "MESSAGE_APPNAME_NOT_SET": "Please provide application name",
    "MESSAGE_BASEURL_NOT_SET": "Please provide baseUrl",
    "MESSAGE_APPID_NOT_SET" : "Please provide Application id",
    "MESSAGE_APP_VERSION_NOT_SET": "Please provide Application version",
    "MESSAGE_DEVELOPER_NAME_NOT_SET": "Please provide developer name",
    "MESSAGE_DEVELOPER_EMAIL_NOT_SET": "Please provide developer email",

    "MESSAGE_ERROR_CONNECTION_URL": "Please enter connection url in database configuration",
    "MESSAGE_ERROR_USERNAME": "Please enter username in database configuration",
    "MESSAGE_ERROR_PASSWORD": "Please enter password in database configuration",
    "MESSAGE_ERROR_DEFAULT_SCHEMA_NAME": "Please enter default schema name in database configuration",
    "MESSAGE_ERROR_JNDI_NAME": "Please enter JNDI name in database configuration",
    "MESSAGE_REST_HOST_NOT_SET":"Please enter host value",
    "MESSAGE_REST_PROTOCOL_NOT_SET":"Please enter protocol value",
    "MESSAGE_REST_BASEPATH_NOT_SET": "Please enter application bath value",
    "MSG_IMPACT_ANALYSIS_REPORT":"The impact analysis report will be displayed here every time you re-import APIs. ",

    "LABEL_PUBLISH_PROJECT_AS_CORE":"Publish to Teams as Core",
    "LABEL_PUBLISH_APPLICATION_TO_TEAMS": "Publish application to teams as Core",

    "LABEL_COMPARE": "Compare",
    "LABEL_WS_CHANGES": "workspace changes",
    "LABEL_WITH": "with",

    "MSG_CHANGES_PUSHED_TO_BRANCH": "Changes pushed to branch",
    "MSG_BRANCH_BEHIND_REMOTE_BRANCH": "Your branch is behind remote \"${0}\" branch by ${1} commits.",
    "TITLE_MERGE_REQUEST_BITBUCKET": "Pull Request Submission",
    "TITLE_MERGE_REQUEST_AZURE": "Pull Request Submission",
    "TITLE_MERGE_REQUEST_GIT_HUB": "Pull Request Submission",
    "TITLE_MERGE_REQUEST_GIT_LAB": "Merge Request Submission",
    "TITLE_MERGE_REQUEST_DEFAULT": "Pull Request Submission",
    "LABEL_MERGE_REQUEST_BITBUCKET": "pull request",
    "LABEL_MERGE_REQUEST_AZURE": "pull request",
    "LABEL_MERGE_REQUEST_GIT_HUB": "pull request",
    "LABEL_MERGE_REQUEST_GIT_LAB": "merge request",
    "LABEL_MERGE_REQUEST_DEFAULT": "pull request",
    "MSG_MERGE_REQUEST_NOTE_BITBUCKET": "<strong>Note: </strong>Upon clicking the proceed button, it will open a new tab with details pre-filled where you need to submit Pull Request. Please review and submit it there.",
    "MSG_MERGE_REQUEST_NOTE_AZURE": "<strong>Note: </strong>Upon clicking the proceed button, it will open a new tab with details pre-filled where you need to submit Pull Request. Please review and submit it there.",
    "MSG_MERGE_REQUEST_NOTE_GIT_HUB": "<strong>Note: </strong>Upon clicking the proceed button, it will open a new tab with details pre-filled where you need to submit Pull Request. Please review and submit it there.",
    "MSG_MERGE_REQUEST_NOTE_GIT_LAB": "<strong>Note: </strong>Upon clicking the proceed button, it will open a new tab with details pre-filled where you need to submit Merge Request. Please review and submit it there.",
    "MSG_MERGE_REQUEST_NOTE_DEFAULT": "<strong>Note: </strong>Upon clicking the proceed button, it will open a new tab with details pre-filled where you need to submit Pull Request. Please review and submit it there.",
    "MSG_CREATE_MERGE_REQUEST_BITBUCKET": "Create a pull request to get your changes reviewed and merged to the branch ",
    "MSG_CREATE_MERGE_REQUEST_AZURE": "Create a pull request to get your changes reviewed and merged to the branch ",
    "MSG_CREATE_MERGE_REQUEST_GIT_HUB": "Create a pull request to get your changes reviewed and merged to the branch ",
    "MSG_CREATE_MERGE_REQUEST_GIT_LAB": "Create a merge request to get your changes reviewed and merged to the branch ",
    "MSG_CREATE_MERGE_REQUEST_DEFAULT": "Create a pull request to get your changes reviewed and merged to the branch ",
    "LABEL_MERGE_REQUESTS_BITBUCKET": "Pull Requests",
    "LABEL_MERGE_REQUESTS_AZURE": "Pull Requests",
    "LABEL_MERGE_REQUESTS_GIT_HUB": "Pull Requests",
    "LABEL_MERGE_REQUESTS_GIT_LAB": "Merge Requests",
    "LABEL_MERGE_REQUESTS_DEFAULT": "Pull Requests",

    "LABEL_PENDING_MERGE_REQUEST_CHANGES_BITBUCKET":"Pending Pull Request Changes",
    "LABEL_PENDING_MERGE_REQUEST_CHANGES_AZURE":"Pending Pull Request Changes",
    "LABEL_PENDING_MERGE_REQUEST_CHANGES_GIT_HUB":"Pending Pull Request Changes",
    "LABEL_PENDING_MERGE_REQUEST_CHANGES_GIT_LAB":"Pending Merge Request Changes",
    "LABEL_PENDING_MERGE_REQUEST_CHANGES_DEFAULT":"Pending Pull Request Changes",
    "LABEL_MERGED_CHANGES":"Merged Changes",

    "MSG_COMMIT_STATUS": "This commit contains your last pushed changes which are not yet merged to the remote ${remoteBranch} branch. <br>Create a ${pullRequest} to get your changes reviewed and merged to ${devBranch}.",
    "MSG_ERROR_UNMERGED_CHANGES": "Your changes are not merged into the remote branch. Try again after your changes have been merged",
    "MSG_ERROR_UNPUSHED_CHANGES": "Your workspace has some unpushed changes. Please push your changes and merge them into the remote branch before trying again",
    "LABEL_RESTORE_TO_REMOTE_BRANCH": "Restore to remote branch",
    "MSG_RESTORE_TO_REMOTE_BRANCH": "This action will erase all your local and pending ${0}(unmerged changes) and sync with the remote \"<strong>${1}</strong>\" branch.<br><br>This action cannot be undone. Are you sure you want to proceed?",
    "MESSAGE_ERROR_ENTER_VALID_URL_X_FRAME": "Enter a valid URL for x-frame configuration in Settings -> Security",
    "MSG_FINAL_MERGE_COMMIT": "Final commit message for merge",
    "LABEL_LAST_PUSHED_CHANGES": "Last Pushed Changes",
    "LABEL_LANGUAGE_BUNDLES": "Language Bundle Sources",
    "MSSAGE_HELP_LANGUAGE_BUNDLE_SOURCES": "Static: The i18n file is preloaded as a static resource. Dynamic: The i18n file is retrieved dynamically through an API call.",
    "LABEL_PROPERTY_NAVTYPE": "Navigation Type",
    "LABEL_PROPERTY_SHEET": "Sheet",
    "LABEL_PROPERTY_SHEETPOSITION": "Sheet Position",

    "LABEL_COPILOT": "Copilot",
    "LABEL_COPILOT_HELP_MSG": "How can I help you today?",
    "LABEL_COPILOT_GENERATE": "Generate",
    "LABEL_EDIT_PROMPT": "Edit prompt",
    "LABEL_PROMPT_INFO_MSG": "Cannot generate results for the given prompt",
    "LABEL_PROMPT_ERROR_MSG": "Error while generating results",
    "LABEL_ADD_TO_PROJECT": "Add to Project",
    "LABEL_NO_COPILOT_SUPPORT": "Copilot support is not available for the selected component",
    "LABEL_CHOOSE_DATASOURCE": "Which data source would you like to connect to?",
    "LABEL_CHOOSE_OPERATION": "What operation would you like to perform?",
    "LABEL_COPILOT_GENERATION_SUCCESS": "The generation is complete!",
    "LABEL_COPILOT_RESULT_MSG": "Would you like to add this component to your project?",
    "LABEL_DARK":"Dark",
    "LABEL_LIGHT":"Light",
    "LABEL_STYLE_GLOBAL_TOKENS":"Global",
    "LABEL_STYLE_DERIVED_TOKENS":"Derived Tokens",
    "LABEL_STYLE_WIDGETS":"Components",
    "LABEL_SPACING":"Spacing",
    "LABEL_ICON_LIBRARY":"Icon Libraries",
    "LABEL_FONT":"Font",
    "LABEL_STYLE_WORKSPACE_SUBHEADING":"Select your theme’s",
    "LABEL_LINK_TOKEN":"Link To Global Instance",
    "LABEL_DELINK_TOKEN":"Detach Token Instance",
    "LABEL_FONT_PREVIEW_TEXT":"The dog jumps over the fox",
    "LABEL_MODE_SWITCH_DISABLED_INFO": "Save or Discard changes to enable mode switching",
    "LABEL_PROPERTY_NAVHEIGHT": "Navigation Height",
    "LABEL_SERVICE_DEFINITION_SOURCES": "Service Definition Sources",
    "MSSAGE_HELP_SERVICE_DEFINITION_SOURCES": "Static: The service definition file is preloaded as a static resource. Dynamic: The service definition file is retrieved dynamically through an API call.",
    "LABEL_OVERVIEW": "Overview",
    "LABEL_COMMON_TOKENS_INFO": "These tokens are used across variants, changing these may affect other variants and components",
    "LABEL_NO_TOKENS_FOUND": "No tokens found",
    "LABEL_VARIANT": "Variant",
    "LABEL_PROPERTY_DISABLEITEMSELECT": "Disable item selection",
    "MESSAGE_HELP_PROPERTY_DISABLEITEMSELECT": "Enables or disables the ability to select list items. Set to true to prevent user interaction.",
    "LABEL_ENABLE_SKIP_TO_MAIN_CONTENT": "Enable Skip to Main Content",
    "MESSAGE_HELP_SKIP_TO_MAIN_CONTENT": "Adds a \"Skip to Main Content\" link for better keyboard and screen reader accessibility",
    "LABEL_ITEMS_PER_PAGE": "Items per page:",
    "LABEL_PROPERTY_PAGESIZEOPTIONS":"Page size options",
    "MESSAGE_HELP_PROPERTY_PAGESIZEOPTIONS":"This property allows users to customize the page size options. For example: 3, 7, 10.",
    "LABEL_ENABLE_PRETTIFY": "Enable Prettify",
    "MESSAGE_HELP_ENABLE_PRETTIFY": "Enable to format code automatically before saving.",
    "LABEL_FOCUS_ON_NAVIGATION": "Focus Element on Navigation",
    "LABEL_PRETTIFY": "Prettify",
    "LABEL_PAGE_CONTENT": "Page Content",
    "LABEL_ENTER_GLOBALS": "Enter the globals",
    "LABEL_GLOBALS": "Globals",
    "GLOBALS_HELP_MESSAGE": "Type a global variable and press Enter to add it (e.g. React, process, $).",
    "LABEL_ADD_PLUGINS": "Plugins",
    "LABEL_CUSTOM_LINTING": "Custom Linting",
    "MESSAGE_HELP_CUSTOM_LINTING": "Enable this to apply the custom ESLint config from src/main/webapp/eslintrc.js. Errors will be shown in the Issues tab based on eslintrc.js",
    "LABEL_ESLINT_CONFIGURATION": "Configuration",
    "LABEL_TRUSTSTORE": "Truststore",
    "LABEL_TRUSTSTORE_CONFIGURATION": 'Truststore Configuration',
    "MESSAGE_HELP_LABEL_TRUSTSTORE_CONFIGURATION": 'Truststore that holds the trusted certificates (CAs) used to validate server certificates for external API calls',
    "LABEL_TRUSTSTORE_CONFIGURATION_TYPE" : "Truststore Type",
    "LABEL_TRUSTSTORE_NO_CHECK":"Disable",
    "LABEL_TRUSTSTORE_SYSTEM_ONLY":"System Truststore",
    "LABEL_TRUSTSTORE_APPLICATION_ONLY":"Custom Truststore",
    "LABEL_TRUSTSTORE_APPLICATION_AND_SYSTEM":"Custom And System Truststore",
    "MESSAGE_HELP_TRUSTSTORE_NO_CHECK":"Disable validation of server certificates",
    "MESSAGE_HELP_TRUSTSTORE_SYSTEM_ONLY":"Uses default java truststore",
    "MESSAGE_HELP_TRUSTSTORE_APPLICATION_ONLY":"Uses custom truststore provided",
    "MESSAGE_HELP_TRUSTSTORE_APPLICATION_AND_SYSTEM":"Uses both system and custom truststore",
    "LABEL_TRUSTSTORE_FILE" : "App Truststore File",
    "LABEL_TRUSTSTORE_FILE_TYPE" : "App Truststore File Type",
    "MESSAGE_HELP_TRUSTSTORE_FILE_HELP" : "Truststore file containing trusted CA certificates",
    "LABEL_TRUSTSTORE_PASSWORD" : "App Truststore Password",
    "MESSAGE_HELP_TRUSTSTORE_PASSWORD_HELP" : "Password of the truststore file",
    "LABEL_TRUSTSTORE_UPLOAD": "Upload file",
    "LABEL_TRUSTSTORE_REUPLOAD":"Reupload file",
    "LABEL_TRUSTSTORE_FILE_ERROR": "Please select a valid .jks, .p12, .pfx or .jceks keystore file",
    "MESSAGE_ERROR_FILE_IMPORT_DESC":"File import failed",
    "MESSAGE_SUCCESS_FILE_IMPORT_DESC":"File imported successfully",
    "LABEL_MTLS_CONFIGURATION": "Mutual TLS (mTLS) Configuration",
    "MESSAGE_HELP_MTLS_CONFIGURATION": "Keystore containing the client certificate that is presented to the server during SSL handshake",
    "LABEL_MTLS_ENABLE" : "Enable",
    "LABEL_MTLS_KEYSTORE_FILE": "Keystore File",
    "LABEL_MTLS_KEYSTORE_PASSWORD": "Keystore Password",
    "MESSAGE_HELP_MTLS_KEYSTORE_FILE": "Keystore with client certificate",
    "MESSAGE_HELP_MTLS_KEYSTORE_PASSWORD": "Password of the Keystore File",
    "MESSAGE_ERROR_TRUSTSTORE_UPLOAD_FILE_TYPE":"Please select app truststore file type",
    "MESSAGE_ERROR_TRUSTSTORE_UPLOAD_FILE":"Please upload app truststore file",
    "MESSAGE_ERROR_TRUSTSTORE_PASSWORD":"Please provide app truststore password",
    "MESSAGE_ERROR_MTLS_UPLOAD_FILE":"Please upload app keystore file",
    "MESSAGE_ERROR_MTLS_FILE_TYPE":"Please select keystore file type",
    "MESSAGE_ERROR_MTLS_PASSWORD":"Please provide keystore password",
    "MESSAGE_ERROR_MAXFILESIZE_EXCEEDED":"Max File Size exceeded. Max file size limit is 1MB.",
    "LABEL_HOST_VERIFICAION":"Hostname Verification",
    "MESSAGE_HELP_HOST_VERIFICAION":"Ensures that the hostname in the server’s certificate matches the hostname of the external API being invoked",
    "MESSAGE_ERROR_FILETYPE": "Please upload a valid '${0}' file",
    "MESSAGE_HELP_KEYSTORE_FILE":'If the Keystore  is in the classpath prefix classpath: or if it is in a system file directory prefix file:',
    "MESSAGE_HELP_TRUSTSTORE_FILE":'If the Truststore is in the classpath prefix classpath: or if it is in a system file directory prefix file:',
    "MESSAGE_ERROR_TRUSTSTORE_FILE":"Please provide app truststore file",
    "MESSAGE_ERROR_MTLS_FILE":"Please provide app keystore file",
    "MESSAGE_ERROR_TRUSTSTORE_FILETYPE": "Please provide a valid '${0}' file",
    "LABEL_ALL_INSTANCES": "All instances",
    "LABEL_ADD_VARIANT_PLACEHOLDER":"Enter a variant name",
    "LABEL_VARIANT_PROPERTIES_NAME":"Name: ",
    "LABEL_ADD_VARIANT":"Add Variant",
    "LABEL_PROPERTY_ALIGNMENT":"Alignment",
    "MESSAGE_HELP_PROPERTY_ALIGNMENT":"This property specifies how the elements should be aligned.",
    "LABEL_PROPERTYGROUP_AUTOLAYOUT":"Auto Layout",
    "LABEL_PROPERTY_GAP":"Gap",
    "MESSAGE_HELP_PROPERTY_GAP":"This property specifies the spacing between items in a flex container",
    "LABEL_PROPERTY_COLUMN_Gap" : "Column Gap",
    "LABEL_ELEVATION":"Elevation",
    "MESSAGE_SUCCESS_INSPECTION_RESULTS_UPDATED": "Inspection results updated",
    "MESSAGE_INSPECT_REFRESH_PENDING_STATUS": "Inspection In Progress",
    "MESSAGE_INSPECTION_ERROR_USING_OVERRIDE_CONFIG": "The inspection results were updated based only on the Wavemaker configurations because the eslintrc-override.js configuration has an error:\n",
    "MESSAGE_INSPECTION_WARN_USING_OVERRIDE_CONFIG": "Inspection using eslintrc-override.js may fail due to following error in configuration: \n",
    "MESSAGE_INVALID_SCRIPT": "Syntax error detected in eslintrc-override.js. Kindly review and correct it\n",
    "MESSAGE_PREFAB_FILES_RESTRICT": "This file is from prefab, It can't be accessed from the project.",
    "MESSAGE_SUCCESS_ADD_VARIANT_DESC":"Variant created successfully",
    "MESSAGE_HELP_PROPERTY_VARIANT":"A variant lets you apply predefined styles to a component. By choosing a variant, you can quickly switch between different visual appearances and functional states (e.g., primary vs. secondary, filled vs. outline) without creating a separate component",
    "MESSAGE_DUPLICATE_FROM":"Duplicate from",
    "MESSAGE_VARIANT_ALREADY_EXISTS":"Variant already exists! Enter another name.",
    "SELECT_VARIANT_ZERO" : "Select a variant to see associated tokens",
    "LABEL_STYLES_STYLE_WORKSPACE" : "Styles",
    "LABEL_ENTER_NEW_PAGE_NAME" : "Enter ${0} Name",
    "LABEL_PROPERTY_POSITION":"Position",
    "MESSAGE_HELP_PROPERTY_POSITION":"Position: sticky acts like relative until scrolling reaches the threshold, then it sticks to the top or left edge of its parent (if scrollable) or the nearest scrolling ancestor (closest parent enabling scroll). Z-index sets its stacking order.",
    "LABEL_PROPERTY_CLIPCONTENT":"Clip Content",
    "MESSAGE_HELP_PROPERTY_CLIPCONTENT":"Hides any content within the container that extend beyond the container’s bounds.",
    "LABEL_PROPERTY_OVERFLOWTYPE":"Overflow Type",
    "MESSAGE_HELP_PROPERTY_OVERFLOWTYPE":"Defines how content behaves when it extends beyond a container's boundaries, allowing you to create scrollable areas (horizontal, vertical, both or none).",
    "LABEL_IMPORT_DESIGN_TOKENS": "Import Styles",
    "LABEL_EXPORT_DESIGN_TOKENS": "Export Styles",
    "LABEL_AUTOCODE_IMPORT_DESIGN_TOKENS" : "How to import styles from Figma AutoCode?",
    "LABEL_WMPROJECT_IMPORT_DESIGN_TOKENS" : "How to import styles from a WaveMaker Project?",
    "LABEL_IMPORT_DESIGN_TOKENS_FROM_WM_PROJECT" : "Import from another Project",
    "LABEL_IMPORT_DESIGN_TOKENS_FROM_WM_AUTOCODE" : "Import from Figma",
    "LABEL_OPEN_FIGMA" : "Open your Figma file",
    "LABEL_LAUNCH_AUTOCODE" : "Launch the AutoCode plugin",
    "LABEL_EXPORT_ZIP_FILE_TOKENS" : "Export the styles as a ZIP file",
    "LABEL_UPLOAD_ZIP_FILE_TOKENS": "Upload that ZIP here",
    "LABEL_UPLOAD_ZIP" : "Upload Zip",
    "LABEL_GO_TO_WAVEMAKER_PROJECT" : "Go to your WaveMaker project",
    "LABEL_OPEN_STYLE_WS" : "Open the Design workspace",
    "LABEL_EXPORT_TOKENS_ZIP" : 'Click “Export Styles” and save the ZIP file',
    "LABEL_RETURN_UPLOAD_ZIP" : "Return here and upload that ZIP file",
    "LABEL_ONBOARD_STYLES" : `"Onboard Styles"`, 
    "MESSAGE_INVALID_VARIANT_NAME": "Variant name must start with a letter and contain only letters (a–z, A–Z), numbers (0–9), hyphens (-), or underscores (_)",
    "LABEL_PROPERTYGROUP_DESIGNSYSTEMPROPERTY":"Design System Properties",
    "LABEL_PROPERTY_LEADINGICONCLASS":"Leading Icon Class",
    "MESSAGE_HELP_PROPERTY_LEADINGICONCLASS":"Allows to specify the icon for the Leading Icon/Button from wm icon library.",
    "LABEL_PROPERTY_TRAILINGICONCLASS":"Trailing Icon Class",
    "MESSAGE_HELP_PROPERTY_TRAILINGICONCLASS":"Allows to specify the icon for the Trailing Icon/Button from wm icon library.",
    "LABEL_PROPERTY_SUPPORTINGTEXT":"Supporting Text",
    "MESSAGE_HELP_PROPERTY_SUPPORTINGTEXT":"Specifies the supporting text(helper text) value of the TextField.",
    "LABEL_PROPERTY_ONTRAILINGICONCLICK":"On Trailing Icon Click",
    "MESSAGE_HELP_PROPERTY_ONTRAILINGICONCLICK":"This event handler is called whenever the click event is triggered on a trailing icon.",
    "LABEL_PROPERTY_ONLEADINGICONCLICK":"On Leading Icon Click",
    "MESSAGE_HELP_PROPERTY_ONLEADINGICONCLICK":"This event handler is called whenever the click event is triggered on a leading icon.",
    "LABEL_PROPERTY_SHOWICONS":"Show Icons",
    "MESSAGE_HELP_PROPERTY_SHOWICONS":"Determines whether icons should be displayed on the widget. When set to true, icons will be shown. When false, icons will be hidden.",
     "LABEL_PROPERTY_STARTICON":"Start Icon",
    "MESSAGE_HELP_PROPERTY_STARTICON":"The icon to be displayed at the start of the widget. Select an appropriate icon from the available options.",
    "LABEL_PROPERTY_ENDICON":"End Icon",
    "MESSAGE_HELP_PROPERTY_ENDICON":"The icon to be displayed at the end of the widget. Select an appropriate icon from the available options.",
    "LABEL_PROPERTY_SELECTEDICON":"Selected Icon",
    "MESSAGE_HELP_PROPERTY_SELECTEDICON":"Specifies the icon to use when the switch is in the selected state.",
    "LABEL_PROPERTY_UNSELECTEDICON":"Unselected Icon",
    "MESSAGE_HELP_PROPERTY_UNSELECTEDICON":"Specifies the icon to use when the switch is in the unselected state.",
    "LABEL_WIDGET_ICON_BUTTON_TOGGLE":"Icon Button Toggleable",
    "LABEL_PROPERTYGROUP_DESIGNSYSTEMEVENTS":"Design System Events",
    "MESSAGE_HELP_PROPERTY_RANGELABELPOSITION":"Specifies the position of the minimum and maximum value labels on the slider (top, bottom, or at the ends).",
    "LABEL_PROPERTY_RANGELABELPOSITION":"Range Label Position",
}
